var makes = Object();
makes['Alfa Romeo'] = 'Giulia|Giulietta|Stelvio';
makes['Audi'] = 'A1|A3|A3 Cabriolet|A4|A5|A6|Q2|Q3|Q5|Q7|RS Q3|RS3|S1|S3|S3 Cabriolet|S4|S5|S6|SQ5|SQ7|TT';
makes['BMW'] = '1 Series|2 Series|3 Series|4 Series|5 Series|6 Series|7 Series|X1|X3|X4|X5|X6|Z3|Z4';
makes['Bus'] = 'Coaster';
makes['BYD'] = 'Atto 3';
makes['Chevrolet'] = 'C10 - c30';
makes['Chrysler'] = '300C|Neon|PT Cruiser|Sebring|Voyager';
makes['Citroen'] = 'Berlingo|C3|C4|Xsara';
makes['Daewoo'] = '1.5|Cielo|Espero|Kalos|Korando|Lacetti|Lanos|Leganza|Matiz|Musso|Nubira|Tacuma';
makes['DAF'] = 'DAF Truck';
makes['Daihatsu'] = 'Applause|Charade|Daihatsu Truck|Delta|Handivan|Mira|Move|Pyzar|Rocky|Sirion|Terios|Yrv';
makes['Dodge'] = 'Caliber|Journey|Nitro';
makes['Eunos'] = '30X|500|800';
makes['Fiat'] = 'Ducato|Fiat 500';
makes['Ford'] = 'Capri|Corsair|Cortina|Courier|Econovan/Maxivan/Spectron/Cab|Ecosport|Endura|Escape|Everest|Explorer|Fairlane|Fairmont|Falcon|Falcon Ute|Festiva|Fiesta|Focus|F-series|Ka|Kuga|Laser|Maverick|Meteor|Mondeo|Mustang|Probe|Puma|Ranger|Ranger 4X2|Ranger 4X4|Taurus|Telstar|Territory|Transit|Transit Custom';
makes['Generic'] = 'Generic';
makes['Great Wall'] = 'SA220|V240';
makes['Hino'] = '300|700|Dutro|FC|Hawk/Raven/Eagle/Griffon/Kestr|Ranger';
makes['Holden'] = 'Acadia|Apollo|Astra|Barina|Barina Spark |Berlina|Calais|Calibra|Camira|Captiva|Captiva 7|Cascada|Colorado|Colorado 7|Commodore|Crewman|Cruze|EJ/EH|Epica|Equinox|Frontera|Gemini|HD / HR|HK / HG / HT|HQ / HJ / HX / HZ|Insignia|Jackaroo|Malibu|Monaro|Nova|Rodeo|Shuttle|Spark|Statesman/Caprice|Tigra|Torana|Trailblazer|Trax|Ute|Vectra|Viva|Zafira';
makes['Honda'] = 'Accord|Accord Euro|City|Civic|CR-V|CRX|CR-Z|HR-V|Insight|Integra|Jazz|Legend|Mdx|Odyssey|Prelude|S2000|ZR-V';
makes['Hyundai'] = 'Accent|Elantra|Excel|FX coupe|Genesis|Getz|Grandeur|i20|i30|i40|i45|iLoad|iMax|IONIQ|ix35|Kona|Lantra|Palisade|S coupe|Santa Fe|Sonata|Staria|Staria Load|Terracan|Tiburon|Trajet|Tucson|Veloster|Venue';
makes['Industrial'] = 'Plant / Equipment';
makes['Isuzu'] = 'D-Max';
makes['Isuzu Truck'] = 'F Series|N Series';
makes['Isuzu Ute'] = 'D-Max|MU-X';
makes['Iveco'] = 'Daily|Eurocargo|Stralis';
makes['Jeep'] = 'Cherokee|Commander|Compass|Gladiator|Grand cherokee|Patriot|Renegade|Wrangler';
makes['Kia'] = 'Carens|Carnival|Cerato|Credos|EV6|K2700 / 2900|Magnetis|Mentor|Niro|Optima|Picanto|Pregio|Proceed|Rio|Rondo|Seltos|Shuma|Sorento|Soul|Spectra|Sportage|Stinger|Stonic';
makes['Land Rover'] = 'Defender|Discovery|Freelander|Range Rover';
makes['Lexus'] = 'CT200H|ES250|ES300 / ES300H / ES350|ES300H|ES350|GS F|GS200T|GS250/GS350/GS450|GS300 / GS430 / GS460|GS300H|GS350|GS450H|IS 200T /IS 300H /IS 350|IS F|IS200 / IS300|IS250|IS250C|IS300H|IS350|LC500 / LC500H|LS400|LS430|LS460|LS500|LS500h|LS600 / LS600HL|LX|NX200t / NX300h|NX300|RC350|RX200T|RX270|RX330|RX350|RX350H|RX400H|RX450H|RX500H|SC400|SC430';
makes['Mack'] = 'Mack Truck';
makes['Mazda'] = '121 DA; DB|121 Metro Dw|2|3|323|6|626|929|B Series|BT50|BT-50|BT50 4x2|BT-50 4x2|BT50 4x4|BT-50 4x4|CX-3|CX-30|CX-5|CX-60|CX-7|CX-8|CX-9|CX-90|E Series|Mazda Truck|MPV|MX-30|MX-5|Premacy|RX-8|Tribute';
makes['Mercedes-benz'] = '190 Series|A Class|B Class|C Class|CLA Class|CLC-Class|CLK|CLS Class|E Class|GL Class|GLA Class|GLC Class|GLE|M Class|MB100/140|R Class|S Class|SLK Class|Sprinter|Vito';
makes['MG'] = 'HS|MG3|ZS|ZST';
makes['Mini'] = 'Cabrio|Clubman|Convertible|Countryman|Coupe|Hardtop|Hatch|Paceman|Roadster';
makes['Mitsubishi'] = '3000 GT|ASX|Challenger|Colt|Cordia|Eclipse cross|Express|Express/starwagon|FTO|Galant|Grandis|L200|Lancer|Magna|Mcfa Mitsubishi / Cat Forklift|Mirage|Mitsubishi/Fuso Truck|Nimbus|Outlander|Pajero|Pajero Sport|Sigma|Starwagon|Triton';
makes['Nissan'] = '1200|120Y|200SX|280ZX|300ZX|350Z / 370Z|720|Almera|Altima|Dualis|Juke|Leaf|Maxima|Micra|Murano|Navara|Navara 4x2|Navara 4x4|Nissan Forklifts|Nissan Truck|NX / NXR|Pathfinder|Patrol|Pulsar|Qashqai|Skyline|Skyline / Pintara|Sunny|Terrano|Tiida|Urvan|Vanette / Nomad|X-trail';
makes['Peugeot'] = '2008|206|207|208|3008|306|307|308|4007|4008|407|5008|508';
makes['Polestar'] = '2';
makes['Porsche'] = 'Macan';
makes['Proton'] = 'Gen II|M21|Satria|Waja|Wira / Persona';
makes['Renault'] = 'Clio|Kangoo|Koleos|Master|Megane|Scenic|Trafic';
makes['Saab'] = '9000|9-3';
makes['Scania'] = 'Scania Truck';
makes['Seat'] = 'Cordoba';
makes['Skoda'] = 'Fabia|Kamiq|Karoq|Kodiaq|Kodiaq Sportline|Octavia|Rapid|Superb|Yeti';
makes['Ssangyong'] = 'Kyron';
makes['Subaru'] = 'BRZ|Crosstrek|Forester|Impreza|Leone|Levorg|Liberty|Outback|Tribeca|WRX|XV';
makes['Suzuki'] = 'Alto|APV|Baleno|Carry|Grand Vitara|Ignis|Jimny|Kizashi|Liana|S-Cross|Sierra|Swift|SX4|Vitara|X90|XL-7';
makes['Toyota'] = '4 Runner / Surf|86|Aurion|Avalon|Avensis Verso|Camry|Camry Hybrid|Celica|C-HR|Corolla|Corolla Cross|Corolla Cross Hybrid|Corolla Hybrid|Corona|Cressida|Dyna|Echo|FJ Cruiser|Fortuner|GR86|Granvia|Hiace|Hilux|Kluger|Landcruiser|Landcruiser Prado|Lexcen|Liteace|MR2|Paseo|Prius|Prius-C|Prius-V|RAV4|Rukus|Sprinter|Starlet|Supra|Tarago|Townace|Toyota Forklift|Toyota Truck|Yaris|Yaris Cross';
makes['Volkswagen'] = 'Amarok|Arteon|Beetle|Bora|Caddy|Caravelle|Crafter|Eos|Golf|Golf Alltrack|Jetta|LT|Multivan|Passat|Passat Alltrack|Passat CC|Polo|Scirocco|T-Cross|Tiguan|Tiguan Allspace|Touareg|Transporter|T-Roc|Up!';
makes['Volvo'] = '240 / 242 / 244 / 245|740 / 760|850|940 / 960 / S90|C30|S40|S60|S70 / V70 / C70|S80|V40|V40 Cross Country|V50|V60|Volvo Truck|XC40|XC60|XC70|XC90';

                                var model_years = Object();
model_years['Giulia'] = '2023|2022|2021|2020|2019|2018|2017';
model_years['Giulietta'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['Stelvio'] = '2023|2022|2021|2020|2019|2018';
model_years['A1'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010';
model_years['A3'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['A3 Cabriolet'] = '2021|2020|2019|2018|2017|2016|2015|2014';
model_years['A4'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995';
model_years['A5'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['A6'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2001|2000|1999|1998|1997';
model_years['Q2'] = '2019|2018|2017';
model_years['Q3'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['Q5'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['Q7'] = '2021|2020|2019|2018|2017|2016|2015|2014|2012|2011|2010|2009|2008|2007|2006';
model_years['RS Q3'] = '2019|2018|2017|2016|2015|2014';
model_years['RS3'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['S1'] = '2018|2017|2016|2015|2014';
model_years['S3'] = '2019|2018|2017|2016|2015|2014|2013|2010|2009|2008|2007|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['S3 Cabriolet'] = '2021|2020|2019|2018|2017|2016|2015|2014';
model_years['S4'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2003|2002|2001|2000|1999';
model_years['S5'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['S6'] = '2019|2018|2017|2016|2015|2014|2013|2012';
model_years['SQ5'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['SQ7'] = '2018|2017|2016';
model_years['TT'] = '2025|2024|2023|2022|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999';
model_years['1 Series'] = '2025|2024|2023|2022|2021|2020|2019|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['2 Series'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014';
model_years['3 Series'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['4 Series'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['5 Series'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988';
model_years['6 Series'] = '2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['7 Series'] = '2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['X1'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010';
model_years['X3'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['X4'] = '2018|2017|2016|2015|2014';
model_years['X5'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['X6'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['Z3'] = '2002|2001|2000|1999|1998|1997';
model_years['Z4'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['Coaster'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982';
model_years['Atto 3'] = '2025|2024|2023|2022';
model_years['C10 - c30'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['300C'] = '2011|2010|2009|2008|2007|2006|2005';
model_years['Neon'] = '2002|2001|2000|1999';
model_years['PT Cruiser'] = '2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Sebring'] = '2009|2008|2007';
model_years['Voyager'] = '2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['Berlingo'] = '2009|2008|2007|2006|2005|2004|2003';
model_years['C3'] = '2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['C4'] = '2010|2009|2008|2007|2006|2005';
model_years['Xsara'] = '2005|2004|2003|2002|2001|2000|1999|1998';
model_years['1.5'] = '1995|1994';
model_years['Cielo'] = '1998|1997|1996|1995';
model_years['Espero'] = '1997|1996|1995';
model_years['Kalos'] = '2004|2003';
model_years['Korando'] = '2000|1999|1998';
model_years['Lacetti'] = '2004|2003';
model_years['Lanos'] = '2003|2002|2001|2000|1999|1998|1997';
model_years['Leganza'] = '2002|2001|2000|1999|1998|1997';
model_years['Matiz'] = '2001|2000|1999';
model_years['Musso'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2002|2001|2000|1999|1998';
model_years['Nubira'] = '2003|2002|2001|2000|1999|1998|1997';
model_years['Tacuma'] = '2004|2003|2002|2001|2000';
model_years['DAF Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['Applause'] = '1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Charade'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['Daihatsu Truck'] = '1984|1983|1982|1981|1980|1979|1978|1977';
model_years['Delta'] = '2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985';
model_years['Handivan'] = '2003|2002|2001|2000|1999|1998';
model_years['Mira'] = '1995|1994|1993|1992|1991|1990';
model_years['Move'] = '1999|1998|1997';
model_years['Pyzar'] = '2000|1999|1998|1997';
model_years['Rocky'] = '1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['Sirion'] = '2004|2003|2002|2001|2000|1999|1998';
model_years['Terios'] = '2000|1999|1998|1997';
model_years['Yrv'] = '2004|2003|2002|2001';
model_years['Caliber'] = '2012|2011|2010|2009|2008|2007|2006';
model_years['Journey'] = '2011|2010|2009|2008';
model_years['Nitro'] = '2011|2010|2009|2008|2007';
model_years['30X'] = '1997|1996|1995|1994|1993|1992';
model_years['500'] = '1999|1998|1997|1996';
model_years['800'] = '2000|1999|1998|1997|1996';
model_years['Ducato'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Fiat 500'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['Capri'] = '1994|1993|1992|1991|1990|1989';
model_years['Corsair'] = '1991|1990|1989';
model_years['Cortina'] = '1982|1981|1980|1979|1978|1977';
model_years['Courier'] = '2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985';
model_years['Econovan/Maxivan/Spectron/Cab'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['Ecosport'] = '2018|2017|2016|2015|2014|2013';
model_years['Endura'] = '2019|2018';
model_years['Escape'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['Everest'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['Explorer'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['Fairlane'] = '2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976';
model_years['Fairmont'] = '2008|2007|2006|2005|2004|2003|2002';
model_years['Falcon'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966';
model_years['Falcon Ute'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2006|2005|2004|2003|2002';
model_years['Festiva'] = '2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991';
model_years['Fiesta'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Focus'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['F-series'] = '2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973';
model_years['Ka'] = '2002|2001|2000|1999';
model_years['Kuga'] = '2016|2015|2014|2013|2012';
model_years['Laser'] = '2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981';
model_years['Maverick'] = '1994|1993|1992|1991|1990|1989|1988';
model_years['Meteor'] = '1987|1986|1985';
model_years['Mondeo'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2000|1999|1998|1997|1996|1995';
model_years['Mustang'] = '2019|2018|2017|2016|2015';
model_years['Probe'] = '1998|1997|1996|1995|1994';
model_years['Puma'] = '2025|2024|2023|2022|2021|2020';
model_years['Ranger'] = '2024|2023|2018|2017|2016|2015|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Ranger 4X2'] = '2025|2024|2023|2022|2021|2020|2019|2018|2015|2014|2013|2012|2011';
model_years['Ranger 4X4'] = '2025|2024|2023|2022|2021|2020|2019|2018|2015|2014|2013|2012|2011';
model_years['Taurus'] = '1998|1997|1996';
model_years['Telstar'] = '1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['Territory'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Transit'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Transit Custom'] = '2022|2021|2020|2019|2018';
model_years['Generic'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['SA220'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['V240'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['300'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['700'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Dutro'] = '2007|2006|2005|2004|2003|2002|2001';
model_years['FC'] = '1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['Hawk/Raven/Eagle/Griffon/Kestr'] = '1999|1998|1997|1996|1995|1994|1993|1992|1991';
model_years['Ranger'] = '2024|2023|2018|2017|2016|2015|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Acadia'] = '2025|2024|2023|2022|2021|2020|2019|2018';
model_years['Apollo'] = '1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Astra'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1987|1986|1985|1984';
model_years['Barina'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985';
model_years['Barina Spark '] = '2015|2014|2013|2012|2011|2010';
model_years['Berlina'] = '2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Calais'] = '2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Calibra'] = '1997|1996|1995|1994|1993|1992|1991';
model_years['Camira'] = '1989|1988|1987|1986|1985|1984';
model_years['Captiva'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['Captiva 7'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['Cascada'] = '2017|2016|2015';
model_years['Colorado'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['Colorado 7'] = '2016|2015|2014|2013|2012';
model_years['Commodore'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979';
model_years['Crewman'] = '2007|2006|2005|2004|2003';
model_years['Cruze'] = '2016|2015|2014|2013|2012|2011|2010|2009|2006|2005|2004|2003|2002';
model_years['EJ/EH'] = '1965|1964|1963|1962';
model_years['Epica'] = '2011|2010|2009|2008|2007';
model_years['Equinox'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['Frontera'] = '2003|2002|2001|2000|1999|1998|1997|1996|1995';
model_years['Gemini'] = '1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975';
model_years['HD / HR'] = '1967|1966';
model_years['HK / HG / HT'] = '1971|1970|1969|1968';
model_years['HQ / HJ / HX / HZ'] = '1980|1979|1978|1977|1976|1975|1974|1973|1972|1971';
model_years['Insignia'] = '2016|2015';
model_years['Jackaroo'] = '2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981';
model_years['Malibu'] = '2016|2015|2014|2013';
model_years['Monaro'] = '2005|2004|2003|2002|2001';
model_years['Nova'] = '1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Rodeo'] = '2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981';
model_years['Shuttle'] = '1991|1990|1989|1988|1987|1986|1985|1984|1983|1982';
model_years['Spark'] = '2018|2017|2016|2015';
model_years['Statesman/Caprice'] = '2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990';
model_years['Tigra'] = '2007|2006|2005';
model_years['Torana'] = '1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969';
model_years['Trailblazer'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016';
model_years['Trax'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['Ute'] = '2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Vectra'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['Viva'] = '2009|2008|2007|2006|2005';
model_years['Zafira'] = '2005|2004|2003|2002|2001';
model_years['Accord'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Accord Euro'] = '2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['City'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['Civic'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['CR-V'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['CRX'] = '1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['CR-Z'] = '2017|2016|2015|2014|2013|2012|2011';
model_years['HR-V'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2001|2000|1999|1998';
model_years['Insight'] = '2014|2013|2012|2011|2010';
model_years['Integra'] = '2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993';
model_years['Jazz'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Legend'] = '2013|2012|2011|2010|2009|2008|2007|2006|2004|2003|2002|2001|2000|1999|1998|1997|1996|1991|1990|1989|1988|1987|1986';
model_years['Mdx'] = '2006|2005|2004|2003';
model_years['Odyssey'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995';
model_years['Prelude'] = '2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991';
model_years['S2000'] = '2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999';
model_years['ZR-V'] = '2025|2024|2023';
model_years['Accent'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Elantra'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Excel'] = '2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['FX coupe'] = '2002|2001|2000|1999|1998|1997|1996';
model_years['Genesis'] = '2017|2016|2015|2014';
model_years['Getz'] = '2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Grandeur'] = '2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999';
model_years['i20'] = '2025|2024|2023|2022|2021|2015|2014|2013|2012|2011|2010';
model_years['i30'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['i40'] = '2018|2017|2016|2015|2014|2013|2012|2011';
model_years['i45'] = '2013|2012|2011|2010';
model_years['iLoad'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['iMax'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['IONIQ'] = '2024|2023|2022|2021';
model_years['ix35'] = '2015|2014|2013|2012|2011|2010';
model_years['Kona'] = '2023|2022|2021|2020|2019|2018|2017';
model_years['Lantra'] = '2000|1999|1998|1997|1996|1995|1994|1993|1992|1991';
model_years['Palisade'] = '2023|2022|2021|2020';
model_years['S coupe'] = '1995|1994|1993|1992|1991|1990';
model_years['Santa Fe'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Sonata'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Staria'] = '2024|2023|2022|2021';
model_years['Staria Load'] = '2024|2023|2022|2021';
model_years['Terracan'] = '2006|2005|2004|2003|2002|2001';
model_years['Tiburon'] = '2010|2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['Trajet'] = '2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Tucson'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2010|2009|2008|2007|2006|2005|2004';
model_years['Veloster'] = '2025|2024|2023|2022|2021|2020|2019|2017|2016|2015|2014|2013|2012|2011';
model_years['Venue'] = '2025|2024|2023|2022|2021|2020|2019';
model_years['Plant / Equipment'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['D-Max'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['F Series'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['N Series'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985';
model_years['D-Max'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['MU-X'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['Daily'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990';
model_years['Eurocargo'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['Stralis'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Cherokee'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Commander'] = '2010|2009|2008|2007|2006';
model_years['Compass'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2010|2009|2008|2007';
model_years['Gladiator'] = '2025|2024|2023|2022|2021|2020';
model_years['Grand cherokee'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['Patriot'] = '2016|2015|2014|2012|2011|2009|2008';
model_years['Renegade'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['Wrangler'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['Carens'] = '2002|2001|2000';
model_years['Carnival'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999';
model_years['Cerato'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Credos'] = '2000|1999|1998';
model_years['EV6'] = '2025|2024|2023|2022|2021';
model_years['K2700 / 2900'] = '2008|2007|2006|2005|2004|2003|2002';
model_years['Magnetis'] = '2009|2008|2007|2006';
model_years['Mentor'] = '2000|1999|1998|1997|1996';
model_years['Niro'] = '2022|2021';
model_years['Optima'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2006|2005|2004|2003|2002|2001';
model_years['Picanto'] = '2023|2022|2021|2020|2019|2018|2017|2016';
model_years['Pregio'] = '2006|2005|2004|2003|2002';
model_years['Proceed'] = '2015|2014|2013';
model_years['Rio'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Rondo'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['Seltos'] = '2025|2024|2023|2022|2021|2020|2019';
model_years['Shuma'] = '2001|2000';
model_years['Sorento'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['Soul'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['Spectra'] = '2003|2002|2001';
model_years['Sportage'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2003|2002|2001|2000|1999|1998|1997';
model_years['Stinger'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['Stonic'] = '2025|2024|2023|2022|2021|2020';
model_years['Defender'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992';
model_years['Discovery'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Freelander'] = '2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Range Rover'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995';
model_years['CT200H'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010';
model_years['ES250'] = '2025|2024|2023|2022|2021';
model_years['ES300 / ES300H / ES350'] = '2015|2014|2013|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992';
model_years['ES300H'] = '2025|2024|2023|2022|2021|2020|2019|2018';
model_years['ES350'] = '2018|2017|2016|2015';
model_years['GS F'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['GS200T'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['GS250/GS350/GS450'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['GS300 / GS430 / GS460'] = '2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['GS300H'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['GS350'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['GS450H'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2012|2011|2010|2009|2008|2007|2006';
model_years['IS 200T /IS 300H /IS 350'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['IS F'] = '2014|2013|2012|2011|2010|2009|2008|2007';
model_years['IS200 / IS300'] = '2005|2004|2003|2002|2001|2000|1999';
model_years['IS250'] = '2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005';
model_years['IS250C'] = '2014|2013|2012|2011|2010|2009';
model_years['IS300H'] = '2016|2015|2014|2013';
model_years['IS350'] = '2016|2015|2014|2013|2012|2011|2010';
model_years['LC500 / LC500H'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['LS400'] = '2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990';
model_years['LS430'] = '2007|2006|2005|2004|2003|2002|2001|2000';
model_years['LS460'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['LS500'] = '2020|2019|2018|2017';
model_years['LS500h'] = '2018|2017';
model_years['LS600 / LS600HL'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['LX'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['NX200t / NX300h'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014';
model_years['NX300'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['RC350'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014';
model_years['RX200T'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['RX270'] = '2015|2014|2013|2012';
model_years['RX330'] = '2006|2005|2004|2003';
model_years['RX350'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['RX350H'] = '2025|2024|2023';
model_years['RX400H'] = '2008|2007|2006|2005';
model_years['RX450H'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['RX500H'] = '2025|2024|2023';
model_years['SC400'] = '1998|1997|1996|1995|1994|1993';
model_years['SC430'] = '2010|2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['Mack Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['121 DA; DB'] = '1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['121 Metro Dw'] = '2002|2001|2000|1999|1998|1997|1996';
model_years['2'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['3'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['323'] = '2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980';
model_years['6'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['626'] = '2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['929'] = '1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982';
model_years['B Series'] = '2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977';
model_years['BT50'] = '2020|2019|2018|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['BT-50'] = '2023|2022|2021';
model_years['BT50 4x2'] = '2018|2017|2016|2015';
model_years['BT-50 4x2'] = '2021|2020';
model_years['BT50 4x4'] = '2018|2017|2016|2015';
model_years['BT-50 4x4'] = '2021|2020';
model_years['CX-3'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['CX-30'] = '2023|2022|2021|2020|2019';
model_years['CX-5'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['CX-60'] = '2025|2024|2023';
model_years['CX-7'] = '2012|2011|2010|2009|2008|2007|2006';
model_years['CX-8'] = '2023|2022|2021|2020|2019|2018';
model_years['CX-9'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['CX-90'] = '2025|2024|2023';
model_years['E Series'] = '2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978';
model_years['Mazda Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['MPV'] = '2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993';
model_years['MX-30'] = '2023|2022|2021';
model_years['MX-5'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Premacy'] = '2003|2002|2001';
model_years['RX-8'] = '2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['Tribute'] = '2007|2006|2005|2004|2003|2002|2001|2000';
model_years['190 Series'] = '1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982';
model_years['A Class'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['B Class'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2007|2006|2005';
model_years['C Class'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['CLA Class'] = '2018|2017|2016|2015|2014|2013';
model_years['CLC-Class'] = '2011|2010|2009|2008';
model_years['CLK'] = '2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['CLS Class'] = '2011|2010|2009|2008|2007|2006|2005';
model_years['E Class'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['GL Class'] = '2015|2014|2013|2012';
model_years['GLA Class'] = '2020|2019|2018|2017|2016|2015|2014';
model_years['GLC Class'] = '2019|2018|2017|2016|2015';
model_years['GLE'] = '2018|2017|2016|2015';
model_years['M Class'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['MB100/140'] = '2004|2003|2002|2001|2000|1999';
model_years['R Class'] = '2013|2012|2011|2010|2009|2008|2007|2006';
model_years['S Class'] = '2006|2005|2004|2003|2002|2001|2000|1999';
model_years['SLK Class'] = '2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['Sprinter'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Vito'] = '2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['HS'] = '2025|2024|2023|2022|2021|2020|2019';
model_years['MG3'] = '2021|2020|2019|2018|2017|2016';
model_years['ZS'] = '2021|2020|2019|2018|2017';
model_years['ZST'] = '2025|2024|2023|2022|2021|2020';
model_years['Cabrio'] = '2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Clubman'] = '2020|2019|2018|2017|2016|2015|2013|2012|2011|2010|2009|2008';
model_years['Convertible'] = '2020|2019|2018|2017|2016|2015';
model_years['Countryman'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['Coupe'] = '2013|2012';
model_years['Hardtop'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Hatch'] = '2025|2024|2023|2022|2021|2020';
model_years['Paceman'] = '2016|2015|2014|2013';
model_years['Roadster'] = '2015|2014|2013|2012';
model_years['3000 GT'] = '1997|1996|1995|1994|1993|1992';
model_years['ASX'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010';
model_years['Challenger'] = '2015|2014|2013|2012|2011|2010|2009|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['Colt'] = '2011|2010|2009|2008|2007|2006|2005|2004|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980';
model_years['Cordia'] = '1989|1988|1987|1986|1985|1984|1983';
model_years['Eclipse cross'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['Express'] = '2022|2021|2020|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980';
model_years['Express/starwagon'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['FTO'] = '2000|1999|1998|1997|1996|1995|1994';
model_years['Galant'] = '1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Grandis'] = '2010|2009|2008|2007|2006|2005|2004';
model_years['L200'] = '1986|1985|1984|1983|1982|1981|1980|1979';
model_years['Lancer'] = '2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988';
model_years['Magna'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985';
model_years['Mcfa Mitsubishi / Cat Forklift'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['Mirage'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['Mitsubishi/Fuso Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979';
model_years['Nimbus'] = '2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['Outlander'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Pajero'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['Pajero Sport'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['Sigma'] = '1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977';
model_years['Starwagon'] = '2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['Triton'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['1200'] = '1985|1984|1983|1982|1981|1980|1979|1978';
model_years['120Y'] = '1979|1978|1977|1976|1975|1974';
model_years['200SX'] = '2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['280ZX'] = '1984|1983|1982|1981|1980|1979';
model_years['300ZX'] = '1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['350Z / 370Z'] = '2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['720'] = '1985|1984|1983|1982|1981|1980';
model_years['Almera'] = '2014|2013|2012';
model_years['Altima'] = '2017|2016|2015|2014|2013';
model_years['Dualis'] = '2014|2013|2012|2011|2010|2009|2008|2007';
model_years['Juke'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['Leaf'] = '2022|2021|2020|2019';
model_years['Maxima'] = '2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990';
model_years['Micra'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['Murano'] = '2014|2013|2012|2011|2010|2009|2008|2007|2006|2005';
model_years['Navara'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['Navara 4x2'] = '2025|2024|2023|2022|2021|2020';
model_years['Navara 4x4'] = '2025|2024|2023|2022|2021|2020';
model_years['Nissan Forklifts'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['Nissan Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['NX / NXR'] = '1996|1995|1994|1993|1992|1991';
model_years['Pathfinder'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986';
model_years['Patrol'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980';
model_years['Pulsar'] = '2017|2016|2015|2014|2013|2012|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982';
model_years['Qashqai'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014';
model_years['Skyline'] = '2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991';
model_years['Skyline / Pintara'] = '1993|1992|1991|1990|1989|1988|1987|1986';
model_years['Sunny'] = '1981|1980|1979';
model_years['Terrano'] = '1999|1998|1997|1996';
model_years['Tiida'] = '2012|2011|2010|2009|2008|2007|2006';
model_years['Urvan'] = '1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['Vanette / Nomad'] = '1993|1992|1991|1990|1989|1988|1987|1986';
model_years['X-trail'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['2008'] = '2018|2017|2016|2015|2014|2013';
model_years['206'] = '2006|2005|2004|2003|2002|2001|2000|1999';
model_years['207'] = '2012|2011|2010|2009|2008|2007';
model_years['208'] = '2019|2018|2017|2016|2015|2014|2013|2012';
model_years['3008'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010';
model_years['306'] = '1997|1996|1995|1994';
model_years['307'] = '2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['308'] = '2021|2020|2019|2018|2017|2016|2015|2014|2011|2010|2009|2008';
model_years['4007'] = '2012|2011|2010|2009';
model_years['4008'] = '2018|2017|2016|2015|2014|2013|2012';
model_years['407'] = '2011|2010|2009|2008|2007|2006|2005|2004';
model_years['5008'] = '2025|2024|2023|2022|2021|2020|2019|2018|2015|2014|2013';
model_years['508'] = '2018|2017|2016|2015|2014|2013|2012|2011';
model_years['2'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002';
model_years['Macan'] = '2018|2017|2016|2015|2014|2013';
model_years['Gen II'] = '2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['M21'] = '1999|1998|1997';
model_years['Satria'] = '2012|2011|2010|2009|2008|2007|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['Waja'] = '2005|2004|2003|2002|2001';
model_years['Wira / Persona'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995';
model_years['Clio'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['Kangoo'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Koleos'] = '2022|2021|2020|2019|2018|2017|2016';
model_years['Master'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['Megane'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['Scenic'] = '2005|2004|2003|2002|2001';
model_years['Trafic'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['9000'] = '1997|1996|1995|1994|1993|1992';
model_years['9-3'] = '2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Scania Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['Cordoba'] = '1999|1998|1997|1996|1995';
model_years['Fabia'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['Kamiq'] = '2025|2024|2023|2022|2021|2020';
model_years['Karoq'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['Kodiaq'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['Kodiaq Sportline'] = '2021|2020|2019|2018|2017';
model_years['Octavia'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['Rapid'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['Superb'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['Yeti'] = '2017|2016|2015|2014|2013|2012|2011';
model_years['Kyron'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014';
model_years['BRZ'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['Crosstrek'] = '2025|2024|2023';
model_years['Forester'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['Impreza'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993';
model_years['Leone'] = '1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979';
model_years['Levorg'] = '2021|2020|2019|2018|2017|2016';
model_years['Liberty'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Outback'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['Tribeca'] = '2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['WRX'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014';
model_years['XV'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['Alto'] = '2014|2013|2012|2011|2010|2009|1998|1997|1996|1995';
model_years['APV'] = '2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005';
model_years['Baleno'] = '2022|2021|2020|2019|2018|2017|2016|2001|2000|1999|1998|1997|1996|1995';
model_years['Carry'] = '2005|2004|2003|2002|2001|2000|1999';
model_years['Grand Vitara'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Ignis'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2005|2004|2003|2002|2001|2000';
model_years['Jimny'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Kizashi'] = '2017|2016|2015|2014|2013|2012|2011|2010';
model_years['Liana'] = '2007|2006|2005|2004|2003|2002|2001';
model_years['S-Cross'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013';
model_years['Sierra'] = '1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981';
model_years['Swift'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['SX4'] = '2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['Vitara'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988';
model_years['X90'] = '1998|1997|1996';
model_years['XL-7'] = '2005|2004|2003|2002|2001';
model_years['4 Runner / Surf'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['86'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['Aurion'] = '2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['Avalon'] = '2005|2004|2003|2002|2001|2000';
model_years['Avensis Verso'] = '2009|2008|2007|2006|2005|2004|2003|2002|2001';
model_years['Camry'] = '2100|2099|2098|2097|2096|2095|2094|2093|2092|2091|2090|2089|2088|2087|2086|2085|2084|2083|2082|2081|2080|2079|2078|2077|2076|2075|2074|2073|2072|2071|2070|2069|2068|2067|2066|2065|2064|2063|2062|2061|2060|2059|2058|2057|2056|2055|2054|2053|2052|2051|2050|2049|2048|2047|2046|2045|2044|2043|2042|2041|2040|2039|2038|2037|2036|2035|2034|2033|2032|2031|2030|2029|2028|2027|2026|2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983';
model_years['Camry Hybrid'] = '2017|2016|2015|2014|2013|2012';
model_years['Celica'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981';
model_years['C-HR'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016';
model_years['Corolla'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1978|1977|1976|1975|1974';
model_years['Corolla Cross'] = '2024|2023|2022';
model_years['Corolla Cross Hybrid'] = '2024|2023|2022';
model_years['Corolla Hybrid'] = '2025|2024|2023|2022|2021|2020|2019|2018';
model_years['Corona'] = '1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974';
model_years['Cressida'] = '1993|1992|1991|1990|1989|1988|1987|1986|1985|1984';
model_years['Dyna'] = '2002|2001|2000|1999|1998|1997|1996';
model_years['Echo'] = '2005|2004|2003|2002|2001|2000|1999';
model_years['FJ Cruiser'] = '2016|2015|2014|2013|2012|2011|2010';
model_years['Fortuner'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015';
model_years['GR86'] = '2024|2023|2022';
model_years['Granvia'] = '2021|2020|2019';
model_years['Hiace'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977';
model_years['Hilux'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975';
model_years['Kluger'] = '2025|2024|2023|2022|2021|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['Landcruiser'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['Landcruiser Prado'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['Lexcen'] = '1997|1996|1995|1994|1993|1992|1991|1990|1989';
model_years['Liteace'] = '1992|1991|1990|1989|1988|1987|1986';
model_years['MR2'] = '2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987';
model_years['Paseo'] = '1999|1998|1997|1996|1995|1994|1993|1992|1991';
model_years['Prius'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Prius-C'] = '2017|2016|2015|2014|2013|2012|2011';
model_years['Prius-V'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012';
model_years['RAV4'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Rukus'] = '2015|2014|2013|2012|2011|2010';
model_years['Sprinter'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Starlet'] = '1999|1998|1997|1996';
model_years['Supra'] = '2025|2024|2023|2022|2021|2020|2019|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976';
model_years['Tarago'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1988|1987|1986|1985|1984|1983|1982';
model_years['Townace'] = '2001|2000|1999|1998|1997|1996|1995|1994|1993|1992';
model_years['Toyota Forklift'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['Toyota Truck'] = '1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979';
model_years['Yaris'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005';
model_years['Yaris Cross'] = '2025|2024|2023|2022|2021|2020';
model_years['Amarok'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['Arteon'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017';
model_years['Beetle'] = '2016|2015|2014|2013|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['Bora'] = '2005|2004|2003|2002|2001|2000|1999';
model_years['Caddy'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005';
model_years['Caravelle'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993';
model_years['Crafter'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007';
model_years['Eos'] = '2014|2013|2012|2011|2010|2009|2008|2007';
model_years['Golf'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994';
model_years['Golf Alltrack'] = '2021|2020|2019|2018|2017|2016|2015';
model_years['Jetta'] = '2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006';
model_years['LT'] = '2006|2005|2004|2003';
model_years['Multivan'] = '2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Passat'] = '2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998';
model_years['Passat Alltrack'] = '2024|2023|2022|2021|2019|2018|2017|2016';
model_years['Passat CC'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['Polo'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996';
model_years['Scirocco'] = '2017|2016|2015|2014|2013|2012|2011';
model_years['T-Cross'] = '2025|2024|2023|2022|2021|2020';
model_years['Tiguan'] = '2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008';
model_years['Tiguan Allspace'] = '2023|2022|2021|2020|2019|2018';
model_years['Touareg'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['Transporter'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992';
model_years['T-Roc'] = '2023|2022|2021|2020';
model_years['Up!'] = '2014|2013|2012';
model_years['240 / 242 / 244 / 245'] = '1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979';
model_years['740 / 760'] = '1990|1989|1988|1987|1986|1985|1984|1983';
model_years['850'] = '1997|1996|1995|1994|1993|1992';
model_years['940 / 960 / S90'] = '1994|1993|1992|1991|1990';
model_years['C30'] = '2013|2012|2011|2010|2009|2008|2007';
model_years['S40'] = '2013|2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['S60'] = '2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000';
model_years['S70 / V70 / C70'] = '2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['S80'] = '2005|2004|2003|2002|2001|2000|1999|1998';
model_years['V40'] = '2018|2017|2016|2015|2014|2013|2004|2003|2002|2001|2000|1999|1998|1997';
model_years['V40 Cross Country'] = '2018|2017|2016|2015|2014|2013';
model_years['V50'] = '2012|2011|2010|2009|2008|2007|2006|2005|2004';
model_years['V60'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011';
model_years['Volvo Truck'] = '2025|2024|2023|2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003|2002|2001|2000|1999|1998|1997|1996|1995|1994|1993|1992|1991|1990|1989|1988|1987|1986|1985|1984|1983|1982|1981|1980|1979|1978|1977|1976|1975|1974|1973|1972|1971|1970|1969|1968|1967|1966|1965|1964|1963|1962|1961|1960';
model_years['XC40'] = '2025|2024|2023|2022|2021|2020|2019|2018';
model_years['XC60'] = '2022|2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009';
model_years['XC70'] = '2011|2010|2009|2008|2007|2006|2005|2004|2003';
model_years['XC90'] = '2021|2020|2019|2018|2017|2016|2015|2014|2013|2012|2011|2010|2009|2008|2007|2006|2005|2004|2003';

								var series_years = Object();
series_years['Giulia_2021'] = 'ZAR';
series_years['Giulia_2022'] = 'ZAR';
series_years['Giulia_2023'] = 'ZAR';
series_years['Giulia_2020'] = 'ZAR';
series_years['Giulia_2017'] = 'ZAR';
series_years['Giulia_2018'] = 'ZAR';
series_years['Giulia_2019'] = 'ZAR';
series_years['Giulietta_2019'] = 'Giulietta';
series_years['Giulietta_2020'] = 'Giulietta';
series_years['Giulietta_2021'] = 'Giulietta';
series_years['Giulietta_2015'] = 'Giulietta';
series_years['Giulietta_2016'] = 'Giulietta';
series_years['Giulietta_2017'] = 'Giulietta';
series_years['Giulietta_2011'] = 'Giulietta';
series_years['Giulietta_2012'] = 'Giulietta';
series_years['Giulietta_2013'] = 'Giulietta';
series_years['Giulietta_2014'] = 'Giulietta';
series_years['Giulietta_2018'] = 'Giulietta';
series_years['Stelvio_2021'] = 'Stelvio';
series_years['Stelvio_2022'] = 'Stelvio';
series_years['Stelvio_2018'] = 'Stelvio';
series_years['Stelvio_2019'] = 'Stelvio';
series_years['Stelvio_2020'] = 'Stelvio';
series_years['Stelvio_2023'] = 'Stelvio';
series_years['A1_2012'] = '8X';
series_years['A1_2015'] = '8X';
series_years['A1_2016'] = '8X';
series_years['A1_2017'] = '8X';
series_years['A1_2018'] = '8X';
series_years['A1_2019'] = '8X|GB';
series_years['A1_2013'] = '8X';
series_years['A1_2021'] = 'GB';
series_years['A1_2022'] = 'GB';
series_years['A1_2011'] = '8X';
series_years['A1_2020'] = 'GB';
series_years['A1_2014'] = '8X';
series_years['A1_2023'] = 'GB';
series_years['A1_2010'] = '8X';
series_years['A3_2017'] = '8V';
series_years['A3_2018'] = '8V';
series_years['A3_2019'] = '8V';
series_years['A3_2011'] = '8P';
series_years['A3_2012'] = '8P';
series_years['A3_1997'] = '8L';
series_years['A3_1998'] = '8L';
series_years['A3_1999'] = '8L';
series_years['A3_2000'] = '8L';
series_years['A3_2001'] = '8L';
series_years['A3_2002'] = '8L';
series_years['A3_2003'] = '8L';
series_years['A3_2004'] = '8L|8P';
series_years['A3_2013'] = '8V';
series_years['A3_2014'] = '8V';
series_years['A3_2015'] = '8V';
series_years['A3_2016'] = '8V';
series_years['A3_2007'] = '8P';
series_years['A3_2008'] = '8P';
series_years['A3_2005'] = '8P';
series_years['A3_2006'] = '8P';
series_years['A3_2020'] = '8V';
series_years['A3_2021'] = '8V|8Y';
series_years['A3_2022'] = '8Y';
series_years['A3_2023'] = '8Y';
series_years['A3_2009'] = '8P';
series_years['A3_2010'] = '8P';
series_years['A3 Cabriolet_2014'] = '8V';
series_years['A3 Cabriolet_2015'] = '8V';
series_years['A3 Cabriolet_2016'] = '8V';
series_years['A3 Cabriolet_2017'] = '8V';
series_years['A3 Cabriolet_2018'] = '8V';
series_years['A3 Cabriolet_2019'] = '8V';
series_years['A3 Cabriolet_2020'] = '8V';
series_years['A3 Cabriolet_2021'] = '8V';
series_years['A4_2014'] = 'B8';
series_years['A4_2015'] = 'B8';
series_years['A4_2016'] = 'B8|B9';
series_years['A4_2009'] = 'B7|B8';
series_years['A4_2010'] = 'B8';
series_years['A4_2021'] = 'B9';
series_years['A4_2022'] = 'B9';
series_years['A4_2023'] = 'B9';
series_years['A4_2001'] = 'B5|B6';
series_years['A4_2002'] = 'B6';
series_years['A4_2003'] = 'B6';
series_years['A4_2004'] = 'B6';
series_years['A4_2005'] = 'B6|B7';
series_years['A4_2008'] = 'B7|B8';
series_years['A4_2017'] = 'B9';
series_years['A4_2018'] = 'B9';
series_years['A4_2019'] = 'B9';
series_years['A4_2020'] = 'B9';
series_years['A4_1995'] = 'B5';
series_years['A4_1996'] = 'B5';
series_years['A4_1997'] = 'B5';
series_years['A4_1998'] = 'B5';
series_years['A4_1999'] = 'B5';
series_years['A4_2000'] = 'B5';
series_years['A4_2006'] = 'B7';
series_years['A4_2007'] = 'B7';
series_years['A4_2013'] = 'B8';
series_years['A4_2012'] = 'B8';
series_years['A4_2011'] = 'B8';
series_years['A5_2019'] = 'F5';
series_years['A5_2007'] = '8T';
series_years['A5_2008'] = '8T';
series_years['A5_2009'] = '8T';
series_years['A5_2010'] = '8T';
series_years['A5_2011'] = '8T';
series_years['A5_2012'] = '8T';
series_years['A5_2022'] = 'F5';
series_years['A5_2023'] = 'F5';
series_years['A5_2017'] = 'F5';
series_years['A5_2018'] = 'F5';
series_years['A5_2020'] = 'F5';
series_years['A5_2021'] = 'F5';
series_years['A5_2013'] = '8T';
series_years['A5_2014'] = '8T';
series_years['A5_2015'] = '8T';
series_years['A5_2016'] = '8T';
series_years['A6_1997'] = 'C5';
series_years['A6_1998'] = 'C5';
series_years['A6_1999'] = 'C5';
series_years['A6_2000'] = 'C5';
series_years['A6_2001'] = 'C5';
series_years['A6_2015'] = 'C7';
series_years['A6_2016'] = 'C7';
series_years['A6_2011'] = 'C6|C7';
series_years['A6_2022'] = 'C8';
series_years['A6_2023'] = 'C8';
series_years['A6_2021'] = 'C8';
series_years['A6_2012'] = 'C7';
series_years['A6_2008'] = 'C6';
series_years['A6_2009'] = 'C6';
series_years['A6_2010'] = 'C6';
series_years['A6_2020'] = 'C8';
series_years['A6_2017'] = 'C7';
series_years['A6_2018'] = 'C7';
series_years['A6_2019'] = 'C7|C8';
series_years['A6_2013'] = 'C7';
series_years['A6_2014'] = 'C7';
series_years['Q2_2017'] = 'GA';
series_years['Q2_2018'] = 'GA';
series_years['Q2_2019'] = 'GA';
series_years['Q3_2012'] = '8U';
series_years['Q3_2020'] = 'F3';
series_years['Q3_2014'] = '8U';
series_years['Q3_2015'] = '8U';
series_years['Q3_2016'] = '8U';
series_years['Q3_2017'] = '8U';
series_years['Q3_2018'] = '8U';
series_years['Q3_2019'] = '8U';
series_years['Q3_2023'] = 'F3';
series_years['Q3_2024'] = 'F3';
series_years['Q3_2025'] = 'F3';
series_years['Q3_2021'] = 'F3';
series_years['Q3_2022'] = 'F3';
series_years['Q3_2013'] = '8U';
series_years['Q5_2021'] = 'FY';
series_years['Q5_2022'] = 'FY';
series_years['Q5_2023'] = 'FY';
series_years['Q5_2009'] = '8R';
series_years['Q5_2010'] = '8R';
series_years['Q5_2011'] = '8R';
series_years['Q5_2012'] = '8R';
series_years['Q5_2018'] = 'FY';
series_years['Q5_2019'] = 'FY';
series_years['Q5_2013'] = '8R';
series_years['Q5_2014'] = '8R';
series_years['Q5_2015'] = '8R';
series_years['Q5_2016'] = '8R';
series_years['Q5_2017'] = '8R';
series_years['Q5_2020'] = 'FY';
series_years['Q7_2010'] = '4L';
series_years['Q7_2011'] = '4L';
series_years['Q7_2020'] = '4M';
series_years['Q7_2014'] = '4L';
series_years['Q7_2015'] = '4L|4M';
series_years['Q7_2016'] = '4M';
series_years['Q7_2021'] = '4M';
series_years['Q7_2017'] = '4M';
series_years['Q7_2018'] = '4M';
series_years['Q7_2019'] = '4M';
series_years['Q7_2006'] = '4L';
series_years['Q7_2007'] = '4L';
series_years['Q7_2008'] = '4L';
series_years['Q7_2009'] = '4L';
series_years['Q7_2012'] = '4L';
series_years['RS Q3_2016'] = '8U';
series_years['RS Q3_2017'] = '8U';
series_years['RS Q3_2018'] = '8U';
series_years['RS Q3_2019'] = '8U';
series_years['RS Q3_2014'] = '8U';
series_years['RS Q3_2015'] = '8U';
series_years['RS3_2020'] = '8V';
series_years['RS3_2021'] = '8V|GY';
series_years['RS3_2017'] = '8V';
series_years['RS3_2018'] = '8V';
series_years['RS3_2019'] = '8V';
series_years['RS3_2023'] = 'GY';
series_years['RS3_2024'] = 'GY';
series_years['RS3_2025'] = 'GY';
series_years['RS3_2022'] = 'GY';
series_years['RS3_2015'] = '8V';
series_years['RS3_2016'] = '8V';
series_years['S1_2014'] = '8X';
series_years['S1_2015'] = '8X';
series_years['S1_2016'] = '8X';
series_years['S1_2017'] = '8X';
series_years['S1_2018'] = '8X';
series_years['S3_2016'] = '8V';
series_years['S3_2017'] = '8V';
series_years['S3_2018'] = '8V';
series_years['S3_2019'] = '8V';
series_years['S3_2009'] = '8P';
series_years['S3_2010'] = '8P';
series_years['S3_2014'] = '8V';
series_years['S3_2013'] = '8V';
series_years['S3_2015'] = '8V';
series_years['S3_2007'] = '8P';
series_years['S3_2008'] = '8P';
series_years['S3_1998'] = '8L';
series_years['S3_1999'] = '8L';
series_years['S3_2000'] = '8L';
series_years['S3_2001'] = '8L';
series_years['S3_2002'] = '8L';
series_years['S3_2003'] = '8L';
series_years['S3_2004'] = '8L';
series_years['S3_2005'] = '8L';
series_years['S3 Cabriolet_2019'] = '8V';
series_years['S3 Cabriolet_2020'] = '8V';
series_years['S3 Cabriolet_2021'] = '8V';
series_years['S3 Cabriolet_2014'] = '8V';
series_years['S3 Cabriolet_2015'] = '8V';
series_years['S3 Cabriolet_2016'] = '8V';
series_years['S3 Cabriolet_2017'] = '8V';
series_years['S3 Cabriolet_2018'] = '8V';
series_years['S4_2005'] = 'B7';
series_years['S4_2006'] = 'B7';
series_years['S4_2007'] = 'B7';
series_years['S4_2008'] = 'B7';
series_years['S4_2013'] = 'B8';
series_years['S4_2014'] = 'B8';
series_years['S4_2012'] = 'B8';
series_years['S4_2009'] = 'B8';
series_years['S4_2010'] = 'B8';
series_years['S4_2011'] = 'B8';
series_years['S4_2020'] = 'B9';
series_years['S4_1999'] = 'B5';
series_years['S4_2000'] = 'B5';
series_years['S4_2001'] = 'B5';
series_years['S4_2002'] = 'B5';
series_years['S4_2003'] = 'B5';
series_years['S4_2017'] = 'B9';
series_years['S4_2018'] = 'B9';
series_years['S4_2019'] = 'B9';
series_years['S4_2021'] = 'B9';
series_years['S4_2022'] = 'B9';
series_years['S4_2015'] = 'B8';
series_years['S4_2016'] = 'B8';
series_years['S5_2017'] = 'F5';
series_years['S5_2018'] = 'F5';
series_years['S5_2019'] = 'F5';
series_years['S5_2022'] = 'F5';
series_years['S5_2023'] = 'F5';
series_years['S5_2024'] = 'F5';
series_years['S5_2025'] = 'F5';
series_years['S5_2020'] = 'F5';
series_years['S5_2012'] = '8T';
series_years['S5_2013'] = '8T';
series_years['S5_2014'] = '8T';
series_years['S5_2015'] = '8T';
series_years['S5_2016'] = '8T';
series_years['S5_2021'] = 'F5';
series_years['S5_2007'] = '8T';
series_years['S5_2008'] = '8T';
series_years['S5_2009'] = '8T';
series_years['S5_2010'] = '8T';
series_years['S5_2011'] = '8T';
series_years['S6_2015'] = 'C7';
series_years['S6_2016'] = 'C7';
series_years['S6_2017'] = 'C7';
series_years['S6_2018'] = 'C7';
series_years['S6_2019'] = 'C7';
series_years['S6_2012'] = 'C7';
series_years['S6_2013'] = 'C7';
series_years['S6_2014'] = 'C7';
series_years['SQ5_2013'] = '8R';
series_years['SQ5_2015'] = '8R';
series_years['SQ5_2016'] = '8R';
series_years['SQ5_2014'] = '8R';
series_years['SQ5_2022'] = 'FY';
series_years['SQ5_2023'] = 'FY';
series_years['SQ5_2017'] = '8R|FY';
series_years['SQ5_2018'] = '8R|FY';
series_years['SQ5_2019'] = '8R|FY';
series_years['SQ5_2021'] = 'FY';
series_years['SQ5_2020'] = 'FY';
series_years['SQ7_2016'] = '4M';
series_years['SQ7_2017'] = '4M';
series_years['SQ7_2018'] = '4M';
series_years['TT_2008'] = '8J';
series_years['TT_2009'] = '8J';
series_years['TT_2010'] = '8J';
series_years['TT_2011'] = '8J';
series_years['TT_2006'] = '8J|8N';
series_years['TT_2007'] = '8J';
series_years['TT_2015'] = '8J|FV';
series_years['TT_2016'] = 'FV';
series_years['TT_2017'] = 'FV';
series_years['TT_2018'] = 'FV';
series_years['TT_2019'] = 'FV';
series_years['TT_1999'] = '8N';
series_years['TT_2000'] = '8N';
series_years['TT_2001'] = '8N';
series_years['TT_2002'] = '8N';
series_years['TT_2003'] = '8N';
series_years['TT_2004'] = '8N';
series_years['TT_2005'] = '8N';
series_years['TT_2022'] = 'FV';
series_years['TT_2023'] = 'FV';
series_years['TT_2024'] = 'FV';
series_years['TT_2025'] = 'FV';
series_years['TT_2020'] = 'FV';
series_years['TT_2012'] = '8J';
series_years['TT_2013'] = '8J';
series_years['TT_2014'] = '8J';
series_years['1 Series_2004'] = 'E87';
series_years['1 Series_2005'] = 'E87';
series_years['1 Series_2006'] = 'E87';
series_years['1 Series_2020'] = 'F40';
series_years['1 Series_2021'] = 'F40';
series_years['1 Series_2022'] = 'F40';
series_years['1 Series_2023'] = 'F40';
series_years['1 Series_2024'] = 'F40';
series_years['1 Series_2025'] = 'F40';
series_years['1 Series_2008'] = 'E82|E87|E88';
series_years['1 Series_2009'] = 'E82|E87|E88';
series_years['1 Series_2007'] = 'E87';
series_years['1 Series_2019'] = 'F40';
series_years['1 Series_2016'] = 'F20';
series_years['1 Series_2017'] = 'F20';
series_years['1 Series_2012'] = 'E82 LCI|E88 LCI|F20';
series_years['1 Series_2013'] = 'E82 LCI|E88 LCI|F20';
series_years['1 Series_2014'] = 'F20';
series_years['1 Series_2015'] = 'F20';
series_years['1 Series_2011'] = 'E82 LCI|E88 LCI|F20';
series_years['1 Series_2010'] = 'E82|E87|E88';
series_years['2 Series_2014'] = 'F22|F45';
series_years['2 Series_2015'] = 'F22|F23|F45';
series_years['2 Series_2016'] = 'F22|F22 LCI|F23 LCI|F45';
series_years['2 Series_2017'] = 'F22 LCI|F23 LCI|F45';
series_years['2 Series_2018'] = 'F22 LCI|F23 LCI|F45';
series_years['2 Series_2019'] = 'F22 LCI|F23 LCI|F45';
series_years['2 Series_2020'] = 'F22 LCI|F23 LCI|F44|F45';
series_years['2 Series_2021'] = 'F22 LCI|F23 LCI|F44';
series_years['2 Series_2022'] = 'F44';
series_years['2 Series_2023'] = 'F44';
series_years['2 Series_2024'] = 'F44';
series_years['2 Series_2025'] = 'F44';
series_years['3 Series_2005'] = 'E46|E90';
series_years['3 Series_2006'] = 'E90|E91|E92/E93';
series_years['3 Series_2007'] = 'E90|E91|E92/E93';
series_years['3 Series_2013'] = 'E92/E93|F30|F31|F34';
series_years['3 Series_2014'] = 'F31|F34';
series_years['3 Series_2015'] = 'F30 LCI|F31|F31 LCI|F34';
series_years['3 Series_1983'] = 'E30';
series_years['3 Series_1984'] = 'E30';
series_years['3 Series_1985'] = 'E30';
series_years['3 Series_1986'] = 'E30';
series_years['3 Series_1987'] = 'E30';
series_years['3 Series_1988'] = 'E30';
series_years['3 Series_1989'] = 'E30';
series_years['3 Series_1990'] = 'E30';
series_years['3 Series_1991'] = 'E30|E36';
series_years['3 Series_2010'] = 'E90|E91|E92/E93';
series_years['3 Series_2009'] = 'E90|E91|E92/E93';
series_years['3 Series_2016'] = 'F30 LCI|F31 LCI|F34';
series_years['3 Series_2008'] = 'E90|E91|E92/E93';
series_years['3 Series_2020'] = 'G20|G21';
series_years['3 Series_2021'] = 'G20|G21';
series_years['3 Series_2022'] = 'G20|G20 LCI|G21';
series_years['3 Series_2011'] = 'E90|E92/E93|F30';
series_years['3 Series_2012'] = 'E92/E93|F30|F31';
series_years['3 Series_2018'] = 'F30 LCI|G20';
series_years['3 Series_2019'] = 'G20';
series_years['3 Series_2017'] = 'F30 LCI|F31 LCI';
series_years['3 Series_1992'] = 'E36';
series_years['3 Series_1993'] = 'E36';
series_years['3 Series_1994'] = 'E36';
series_years['3 Series_1995'] = 'E36';
series_years['3 Series_1996'] = 'E36';
series_years['3 Series_1997'] = 'E36';
series_years['3 Series_1998'] = 'E36|E46';
series_years['3 Series_1999'] = 'E36|E46';
series_years['3 Series_2000'] = 'E36|E46';
series_years['3 Series_2001'] = 'E46';
series_years['3 Series_2002'] = 'E46';
series_years['3 Series_2003'] = 'E46';
series_years['3 Series_2004'] = 'E46';
series_years['3 Series_2023'] = 'G20 LCI';
series_years['3 Series_2024'] = 'G20 LCI';
series_years['3 Series_2025'] = 'G20 LCI';
series_years['4 Series_2017'] = 'F32|F33|F36';
series_years['4 Series_2018'] = 'F32|F33|F36';
series_years['4 Series_2019'] = 'F32|F33|F36';
series_years['4 Series_2020'] = 'F32|F33|F36';
series_years['4 Series_2021'] = 'F32';
series_years['4 Series_2022'] = 'F32';
series_years['4 Series_2023'] = 'F32';
series_years['4 Series_2024'] = 'F32';
series_years['4 Series_2025'] = 'F32';
series_years['4 Series_2013'] = 'F32';
series_years['4 Series_2014'] = 'F32|F33|F36';
series_years['4 Series_2015'] = 'F32|F33|F36';
series_years['4 Series_2016'] = 'F32|F33|F36';
series_years['5 Series_2014'] = 'F07 LCI|F10 LCI|F11 LCI';
series_years['5 Series_2015'] = 'F07 LCI|F10 LCI|F11 LCI';
series_years['5 Series_2016'] = 'F07 LCI|F10 LCI|F11 LCI';
series_years['5 Series_2017'] = 'F07 LCI|F10 LCI|F11 LCI|G30';
series_years['5 Series_2010'] = 'E60 |E60/E61|F07|F10';
series_years['5 Series_2003'] = 'E39|E60 |E60/E61';
series_years['5 Series_2004'] = 'E60 |E60/E61';
series_years['5 Series_2005'] = 'E60 |E60/E61';
series_years['5 Series_2006'] = 'E60 |E60/E61';
series_years['5 Series_2007'] = 'E60 |E60/E61';
series_years['5 Series_2011'] = 'F07|F10|F11';
series_years['5 Series_2012'] = 'F07|F10|F11';
series_years['5 Series_2013'] = 'F07|F07 LCI|F10|F10 LCI|F11|F11 LCI';
series_years['5 Series_1988'] = 'E34';
series_years['5 Series_1989'] = 'E34';
series_years['5 Series_1990'] = 'E34';
series_years['5 Series_1991'] = 'E34';
series_years['5 Series_1992'] = 'E34';
series_years['5 Series_1993'] = 'E34';
series_years['5 Series_1994'] = 'E34';
series_years['5 Series_1995'] = 'E34';
series_years['5 Series_1996'] = 'E34|E39';
series_years['5 Series_2018'] = 'G30';
series_years['5 Series_2019'] = 'G30';
series_years['5 Series_2020'] = 'G30';
series_years['5 Series_2008'] = 'E60 |E60/E61';
series_years['5 Series_2009'] = 'E60 |E60/E61';
series_years['5 Series_1997'] = 'E39';
series_years['5 Series_1998'] = 'E39';
series_years['5 Series_1999'] = 'E39';
series_years['5 Series_2000'] = 'E39';
series_years['5 Series_2001'] = 'E39';
series_years['5 Series_2002'] = 'E39';
series_years['6 Series_2012'] = 'F06/F13|F12';
series_years['6 Series_2013'] = 'F06/F13|F12';
series_years['6 Series_2014'] = 'F06/F13|F12';
series_years['6 Series_2015'] = 'F06/F13|F12';
series_years['6 Series_2016'] = 'F06/F13|F12';
series_years['6 Series_2017'] = 'F06/F13|F12';
series_years['6 Series_2007'] = 'E63/E64';
series_years['6 Series_2008'] = 'E63/E64';
series_years['6 Series_2009'] = 'E63/E64';
series_years['6 Series_2010'] = 'E63/E64';
series_years['6 Series_2011'] = 'E63/E64|F12';
series_years['7 Series_2002'] = 'E65/E66';
series_years['7 Series_2003'] = 'E65/E66';
series_years['7 Series_2004'] = 'E65/E66';
series_years['7 Series_2005'] = 'E65/E66';
series_years['7 Series_2006'] = 'E65/E66';
series_years['7 Series_2007'] = 'E65/E66';
series_years['7 Series_2008'] = 'E65/E66';
series_years['7 Series_2009'] = 'E65/E66|F01';
series_years['7 Series_1995'] = 'E38';
series_years['7 Series_1996'] = 'E38';
series_years['7 Series_1997'] = 'E38';
series_years['7 Series_1998'] = 'E38';
series_years['7 Series_1999'] = 'E38';
series_years['7 Series_2000'] = 'E38';
series_years['7 Series_2001'] = 'E38';
series_years['7 Series_2010'] = 'F01';
series_years['7 Series_2011'] = 'F01';
series_years['7 Series_2012'] = 'F01';
series_years['7 Series_1987'] = 'E32';
series_years['7 Series_1988'] = 'E32';
series_years['7 Series_1989'] = 'E32';
series_years['7 Series_1990'] = 'E32';
series_years['7 Series_1991'] = 'E32';
series_years['7 Series_1992'] = 'E32';
series_years['7 Series_1993'] = 'E32';
series_years['7 Series_1994'] = 'E32';
series_years['X1_2015'] = 'E84|F48';
series_years['X1_2016'] = 'F48';
series_years['X1_2017'] = 'F48';
series_years['X1_2018'] = 'F48';
series_years['X1_2019'] = 'F48';
series_years['X1_2012'] = 'E84';
series_years['X1_2013'] = 'E84';
series_years['X1_2014'] = 'E84';
series_years['X1_2010'] = 'E84';
series_years['X1_2011'] = 'E84';
series_years['X1_2020'] = 'F48';
series_years['X1_2021'] = 'F48';
series_years['X1_2022'] = 'F48|U11';
series_years['X1_2023'] = 'U11';
series_years['X1_2024'] = 'U11';
series_years['X1_2025'] = 'U11';
series_years['X3_2011'] = 'F25';
series_years['X3_2012'] = 'F25';
series_years['X3_2020'] = 'G01';
series_years['X3_2021'] = 'G01|G01 LCI';
series_years['X3_2013'] = 'F25';
series_years['X3_2014'] = 'F25';
series_years['X3_2006'] = 'E83';
series_years['X3_2007'] = 'E83';
series_years['X3_2008'] = 'E83';
series_years['X3_2009'] = 'E83';
series_years['X3_2010'] = 'E83';
series_years['X3_2004'] = 'E83';
series_years['X3_2005'] = 'E83';
series_years['X3_2015'] = 'F25';
series_years['X3_2016'] = 'F25';
series_years['X3_2017'] = 'F25|G01';
series_years['X3_2022'] = 'G01 LCI';
series_years['X3_2023'] = 'G01 LCI';
series_years['X3_2024'] = 'G01 LCI';
series_years['X3_2025'] = 'G01 LCI';
series_years['X3_2018'] = 'G01';
series_years['X3_2019'] = 'G01';
series_years['X4_2014'] = 'F26';
series_years['X4_2015'] = 'F26';
series_years['X4_2016'] = 'F26';
series_years['X4_2017'] = 'F26';
series_years['X4_2018'] = 'F26';
series_years['X5_2019'] = 'G05';
series_years['X5_2020'] = 'G05';
series_years['X5_2021'] = 'G05';
series_years['X5_2022'] = 'G05';
series_years['X5_2023'] = 'G05';
series_years['X5_2018'] = 'F15|F85|G05';
series_years['X5_2007'] = 'E53|E70';
series_years['X5_2008'] = 'E70';
series_years['X5_2009'] = 'E70';
series_years['X5_2010'] = 'E70';
series_years['X5_2011'] = 'E70';
series_years['X5_2012'] = 'E70';
series_years['X5_2013'] = 'E70|F15';
series_years['X5_2014'] = 'F15';
series_years['X5_2015'] = 'F15|F85';
series_years['X5_2016'] = 'F15|F85';
series_years['X5_2017'] = 'F15|F85';
series_years['X5_2000'] = 'E53';
series_years['X5_2001'] = 'E53';
series_years['X5_2002'] = 'E53';
series_years['X5_2003'] = 'E53';
series_years['X5_2004'] = 'E53';
series_years['X5_2005'] = 'E53';
series_years['X5_2006'] = 'E53';
series_years['X6_2009'] = 'E71';
series_years['X6_2010'] = 'E71';
series_years['X6_2011'] = 'E71';
series_years['X6_2012'] = 'E71';
series_years['X6_2008'] = 'E71';
series_years['X6_2013'] = 'E71';
series_years['X6_2014'] = 'E71';
series_years['X6_2015'] = 'F16';
series_years['X6_2016'] = 'F16';
series_years['X6_2017'] = 'F16';
series_years['X6_2018'] = 'F16';
series_years['X6_2019'] = 'F16';
series_years['Z3_1997'] = 'E36/E46';
series_years['Z3_1998'] = 'E36/E46';
series_years['Z3_1999'] = 'E36/E46';
series_years['Z3_2000'] = 'E36/E46';
series_years['Z3_2001'] = 'E36/E46';
series_years['Z3_2002'] = 'E36/E46';
series_years['Z4_2013'] = 'E89';
series_years['Z4_2014'] = 'E89';
series_years['Z4_2015'] = 'E89';
series_years['Z4_2016'] = 'E89';
series_years['Z4_2011'] = 'E89';
series_years['Z4_2012'] = 'E89';
series_years['Z4_2003'] = 'E85';
series_years['Z4_2004'] = 'E85';
series_years['Z4_2005'] = 'E85';
series_years['Z4_2006'] = 'E85|E86';
series_years['Z4_2009'] = 'E85|E86|E89';
series_years['Z4_2010'] = 'E89';
series_years['Z4_2007'] = 'E85|E86';
series_years['Z4_2008'] = 'E85|E86';
series_years['Coaster_1993'] = 'BB20/RB20/HB30/HZB30|BB40/HZB50/BB50/XZB50';
series_years['Coaster_1994'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_1995'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_1996'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_1997'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_1998'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_1999'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2000'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2001'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2002'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2003'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2004'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2005'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2006'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2007'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2008'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2009'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2010'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2011'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2012'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2013'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2014'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2015'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2016'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2017'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2018'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2019'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2020'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2021'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2022'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2023'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2024'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_2025'] = 'BB40/HZB50/BB50/XZB50';
series_years['Coaster_1982'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1983'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1984'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1985'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1986'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1987'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1988'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1989'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1990'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1991'] = 'BB20/RB20/HB30/HZB30';
series_years['Coaster_1992'] = 'BB20/RB20/HB30/HZB30';
series_years['Atto 3_2022'] = '0';
series_years['Atto 3_2023'] = '0';
series_years['Atto 3_2024'] = '0';
series_years['Atto 3_2025'] = '0';
series_years['C10 - c30_1960'] = 'C10-C30';
series_years['C10 - c30_1961'] = 'C10-C30';
series_years['C10 - c30_1962'] = 'C10-C30';
series_years['C10 - c30_1963'] = 'C10-C30';
series_years['C10 - c30_1964'] = 'C10-C30';
series_years['C10 - c30_1965'] = 'C10-C30';
series_years['C10 - c30_1966'] = 'C10-C30';
series_years['C10 - c30_1967'] = 'C10-C30';
series_years['C10 - c30_1968'] = 'C10-C30';
series_years['C10 - c30_1969'] = 'C10-C30';
series_years['C10 - c30_1970'] = 'C10-C30';
series_years['C10 - c30_1971'] = 'C10-C30';
series_years['C10 - c30_1972'] = 'C10-C30';
series_years['C10 - c30_1973'] = 'C10-C30';
series_years['C10 - c30_1974'] = 'C10-C30';
series_years['C10 - c30_1975'] = 'C10-C30';
series_years['C10 - c30_1976'] = 'C10-C30';
series_years['C10 - c30_1977'] = 'C10-C30';
series_years['C10 - c30_1978'] = 'C10-C30';
series_years['C10 - c30_1979'] = 'C10-C30';
series_years['C10 - c30_1980'] = 'C10-C30';
series_years['C10 - c30_1981'] = 'C10-C30';
series_years['C10 - c30_1982'] = 'C10-C30';
series_years['C10 - c30_1983'] = 'C10-C30';
series_years['C10 - c30_1984'] = 'C10-C30';
series_years['C10 - c30_1985'] = 'C10-C30';
series_years['C10 - c30_1986'] = 'C10-C30';
series_years['C10 - c30_1987'] = 'C10-C30';
series_years['C10 - c30_1988'] = 'C10-C30';
series_years['C10 - c30_1989'] = 'C10-C30';
series_years['C10 - c30_1990'] = 'C10-C30';
series_years['C10 - c30_1991'] = 'C10-C30';
series_years['C10 - c30_1992'] = 'C10-C30';
series_years['C10 - c30_1993'] = 'C10-C30';
series_years['C10 - c30_1994'] = 'C10-C30';
series_years['C10 - c30_1995'] = 'C10-C30';
series_years['C10 - c30_1996'] = 'C10-C30';
series_years['C10 - c30_1997'] = 'C10-C30';
series_years['C10 - c30_1998'] = 'C10-C30';
series_years['C10 - c30_1999'] = 'C10-C30';
series_years['C10 - c30_2000'] = 'C10-C30';
series_years['C10 - c30_2001'] = 'C10-C30';
series_years['C10 - c30_2002'] = 'C10-C30';
series_years['C10 - c30_2003'] = 'C10-C30';
series_years['C10 - c30_2004'] = 'C10-C30';
series_years['C10 - c30_2005'] = 'C10-C30';
series_years['C10 - c30_2006'] = 'C10-C30';
series_years['C10 - c30_2007'] = 'C10-C30';
series_years['C10 - c30_2008'] = 'C10-C30';
series_years['C10 - c30_2009'] = 'C10-C30';
series_years['C10 - c30_2010'] = 'C10-C30';
series_years['C10 - c30_2011'] = 'C10-C30';
series_years['C10 - c30_2012'] = 'C10-C30';
series_years['C10 - c30_2013'] = 'C10-C30';
series_years['C10 - c30_2014'] = 'C10-C30';
series_years['C10 - c30_2015'] = 'C10-C30';
series_years['C10 - c30_2016'] = 'C10-C30';
series_years['C10 - c30_2017'] = 'C10-C30';
series_years['C10 - c30_2018'] = 'C10-C30';
series_years['C10 - c30_2019'] = 'C10-C30';
series_years['C10 - c30_2020'] = 'C10-C30';
series_years['C10 - c30_2021'] = 'C10-C30';
series_years['C10 - c30_2022'] = 'C10-C30';
series_years['C10 - c30_2023'] = 'C10-C30';
series_years['C10 - c30_2024'] = 'C10-C30';
series_years['C10 - c30_2025'] = 'C10-C30';
series_years['300C_2009'] = '300C';
series_years['300C_2010'] = '300C';
series_years['300C_2011'] = '300C';
series_years['300C_2008'] = '300C';
series_years['300C_2005'] = '300C';
series_years['300C_2006'] = '300C';
series_years['300C_2007'] = '300C';
series_years['Neon_1999'] = 'JB';
series_years['Neon_2000'] = 'JB';
series_years['Neon_2001'] = 'JB';
series_years['Neon_2002'] = 'JB';
series_years['PT Cruiser_2005'] = 'PG';
series_years['PT Cruiser_2006'] = 'PG';
series_years['PT Cruiser_2007'] = 'PG';
series_years['PT Cruiser_2008'] = 'PG';
series_years['PT Cruiser_2009'] = 'PG';
series_years['PT Cruiser_2010'] = 'PG';
series_years['PT Cruiser_2000'] = 'PG';
series_years['PT Cruiser_2001'] = 'PG';
series_years['PT Cruiser_2002'] = 'PG';
series_years['PT Cruiser_2003'] = 'PG';
series_years['PT Cruiser_2004'] = 'PG';
series_years['Sebring_2007'] = 'JS';
series_years['Sebring_2008'] = 'JS';
series_years['Sebring_2009'] = 'JS';
series_years['Voyager_1997'] = 'GS';
series_years['Voyager_1998'] = 'GS';
series_years['Voyager_1999'] = 'GS';
series_years['Voyager_2000'] = 'GS';
series_years['Voyager_2001'] = 'GS|RG';
series_years['Voyager_2004'] = 'RG';
series_years['Voyager_2005'] = 'RG';
series_years['Voyager_2006'] = 'RG';
series_years['Voyager_2007'] = 'RG';
series_years['Voyager_2008'] = 'RG|RT';
series_years['Voyager_2009'] = 'RG|RT';
series_years['Voyager_2010'] = 'RG|RT';
series_years['Voyager_2002'] = 'RG';
series_years['Voyager_2003'] = 'RG';
series_years['Voyager_2011'] = 'RT';
series_years['Voyager_2012'] = 'RT';
series_years['Voyager_2013'] = 'RT';
series_years['Voyager_2014'] = 'RT';
series_years['Berlingo_2003'] = 'BERLINGO';
series_years['Berlingo_2004'] = 'BERLINGO';
series_years['Berlingo_2005'] = 'BERLINGO';
series_years['Berlingo_2006'] = 'BERLINGO';
series_years['Berlingo_2007'] = 'BERLINGO';
series_years['Berlingo_2008'] = 'BERLINGO';
series_years['Berlingo_2009'] = 'BERLINGO';
series_years['C3_2002'] = 'C3';
series_years['C3_2003'] = 'C3';
series_years['C3_2004'] = 'C3';
series_years['C3_2005'] = 'C3';
series_years['C3_2006'] = 'C3';
series_years['C3_2007'] = 'C3';
series_years['C3_2008'] = 'C3';
series_years['C3_2009'] = 'C3';
series_years['C3_2010'] = 'C3';
series_years['C4_2005'] = 'B7/E3';
series_years['C4_2006'] = 'B7/E3';
series_years['C4_2007'] = 'B7/E3';
series_years['C4_2008'] = 'B7/E3';
series_years['C4_2009'] = 'B7/E3';
series_years['C4_2010'] = 'B7/E3';
series_years['Xsara_1998'] = 'XSARA';
series_years['Xsara_1999'] = 'XSARA';
series_years['Xsara_2000'] = 'XSARA';
series_years['Xsara_2001'] = 'XSARA';
series_years['Xsara_2002'] = 'XSARA';
series_years['Xsara_2003'] = 'XSARA';
series_years['Xsara_2004'] = 'XSARA';
series_years['Xsara_2005'] = 'XSARA';
series_years['1.5_1994'] = '1.5';
series_years['1.5_1995'] = '1.5';
series_years['Cielo_1995'] = 'CIELO';
series_years['Cielo_1996'] = 'CIELO';
series_years['Cielo_1997'] = 'CIELO';
series_years['Cielo_1998'] = 'CIELO';
series_years['Espero_1995'] = 'ESPERO';
series_years['Espero_1996'] = 'ESPERO';
series_years['Espero_1997'] = 'ESPERO';
series_years['Kalos_2003'] = 'T200';
series_years['Kalos_2004'] = 'T200';
series_years['Korando_1998'] = 'KORANDO';
series_years['Korando_1999'] = 'KORANDO';
series_years['Korando_2000'] = 'KORANDO';
series_years['Lacetti_2003'] = 'J200';
series_years['Lacetti_2004'] = 'J200';
series_years['Lanos_1997'] = 'T100/T150';
series_years['Lanos_1998'] = 'T100/T150';
series_years['Lanos_1999'] = 'T100/T150';
series_years['Lanos_2000'] = 'T100/T150';
series_years['Lanos_2001'] = 'T100/T150';
series_years['Lanos_2002'] = 'T100/T150';
series_years['Lanos_2003'] = 'T100/T150';
series_years['Leganza_1997'] = 'V100';
series_years['Leganza_1998'] = 'V100';
series_years['Leganza_1999'] = 'V100';
series_years['Leganza_2000'] = 'V100';
series_years['Leganza_2001'] = 'V100';
series_years['Leganza_2002'] = 'V100';
series_years['Matiz_1999'] = 'M100/M150';
series_years['Matiz_2000'] = 'M100/M150';
series_years['Matiz_2001'] = 'M100/M150';
series_years['Musso_1998'] = 'MUSSO';
series_years['Musso_1999'] = 'MUSSO';
series_years['Musso_2000'] = 'MUSSO';
series_years['Musso_2001'] = 'MUSSO';
series_years['Musso_2002'] = 'MUSSO';
series_years['Musso_2004'] = 'MUSSO';
series_years['Musso_2005'] = 'MUSSO';
series_years['Musso_2006'] = 'MUSSO';
series_years['Musso_2007'] = 'MUSSO';
series_years['Musso_2008'] = 'MUSSO';
series_years['Musso_2009'] = 'MUSSO';
series_years['Musso_2010'] = 'MUSSO';
series_years['Musso_2011'] = 'MUSSO';
series_years['Musso_2012'] = 'MUSSO';
series_years['Musso_2013'] = 'MUSSO';
series_years['Musso_2014'] = 'MUSSO';
series_years['Musso_2015'] = 'MUSSO';
series_years['Musso_2016'] = 'MUSSO';
series_years['Musso_2017'] = 'MUSSO';
series_years['Musso_2018'] = 'MUSSO';
series_years['Musso_2019'] = 'MUSSO';
series_years['Musso_2020'] = 'MUSSO';
series_years['Musso_2021'] = 'MUSSO';
series_years['Musso_2022'] = 'MUSSO';
series_years['Musso_2023'] = 'MUSSO';
series_years['Musso_2024'] = 'MUSSO';
series_years['Musso_2025'] = 'MUSSO';
series_years['Nubira_1997'] = 'J100/J150';
series_years['Nubira_1998'] = 'J100/J150';
series_years['Nubira_1999'] = 'J100/J150';
series_years['Nubira_2000'] = 'J100/J150';
series_years['Nubira_2001'] = 'J100/J150';
series_years['Nubira_2002'] = 'J100/J150';
series_years['Nubira_2003'] = 'J100/J150';
series_years['Tacuma_2000'] = 'TACUMA';
series_years['Tacuma_2001'] = 'TACUMA';
series_years['Tacuma_2002'] = 'TACUMA';
series_years['Tacuma_2003'] = 'TACUMA';
series_years['Tacuma_2004'] = 'TACUMA';
series_years['DAF Truck_1960'] = 'DAF';
series_years['DAF Truck_1961'] = 'DAF';
series_years['DAF Truck_1962'] = 'DAF';
series_years['DAF Truck_1963'] = 'DAF';
series_years['DAF Truck_1964'] = 'DAF';
series_years['DAF Truck_1965'] = 'DAF';
series_years['DAF Truck_1966'] = 'DAF';
series_years['DAF Truck_1967'] = 'DAF';
series_years['DAF Truck_1968'] = 'DAF';
series_years['DAF Truck_1969'] = 'DAF';
series_years['DAF Truck_1970'] = 'DAF';
series_years['DAF Truck_1971'] = 'DAF';
series_years['DAF Truck_1972'] = 'DAF';
series_years['DAF Truck_1973'] = 'DAF';
series_years['DAF Truck_1974'] = 'DAF';
series_years['DAF Truck_1975'] = 'DAF';
series_years['DAF Truck_1976'] = 'DAF';
series_years['DAF Truck_1977'] = 'DAF';
series_years['DAF Truck_1978'] = 'DAF';
series_years['DAF Truck_1979'] = 'DAF';
series_years['DAF Truck_1980'] = 'DAF';
series_years['DAF Truck_1981'] = 'DAF';
series_years['DAF Truck_1982'] = 'DAF';
series_years['DAF Truck_1983'] = 'DAF';
series_years['DAF Truck_1984'] = 'DAF';
series_years['DAF Truck_1985'] = 'DAF';
series_years['DAF Truck_1986'] = 'DAF';
series_years['DAF Truck_1987'] = 'DAF';
series_years['DAF Truck_1988'] = 'DAF';
series_years['DAF Truck_1989'] = 'DAF';
series_years['DAF Truck_1990'] = 'DAF';
series_years['DAF Truck_1991'] = 'DAF';
series_years['DAF Truck_1992'] = 'DAF';
series_years['DAF Truck_1993'] = 'DAF';
series_years['DAF Truck_1994'] = 'DAF';
series_years['DAF Truck_1995'] = 'DAF';
series_years['DAF Truck_1996'] = 'DAF';
series_years['DAF Truck_1997'] = 'DAF';
series_years['DAF Truck_1998'] = 'DAF';
series_years['DAF Truck_1999'] = 'DAF';
series_years['DAF Truck_2000'] = 'DAF';
series_years['DAF Truck_2001'] = 'DAF';
series_years['DAF Truck_2002'] = 'DAF';
series_years['DAF Truck_2003'] = 'DAF';
series_years['DAF Truck_2004'] = 'DAF';
series_years['DAF Truck_2005'] = 'DAF';
series_years['DAF Truck_2006'] = 'DAF';
series_years['DAF Truck_2007'] = 'DAF';
series_years['DAF Truck_2008'] = 'DAF';
series_years['DAF Truck_2009'] = 'DAF';
series_years['DAF Truck_2010'] = 'DAF';
series_years['DAF Truck_2011'] = 'DAF';
series_years['DAF Truck_2012'] = 'DAF';
series_years['DAF Truck_2013'] = 'DAF';
series_years['DAF Truck_2014'] = 'DAF';
series_years['DAF Truck_2015'] = 'DAF';
series_years['DAF Truck_2016'] = 'DAF';
series_years['DAF Truck_2017'] = 'DAF';
series_years['DAF Truck_2018'] = 'DAF';
series_years['DAF Truck_2019'] = 'DAF';
series_years['DAF Truck_2020'] = 'DAF';
series_years['DAF Truck_2021'] = 'DAF';
series_years['DAF Truck_2022'] = 'DAF';
series_years['DAF Truck_2023'] = 'DAF';
series_years['DAF Truck_2024'] = 'DAF';
series_years['DAF Truck_2025'] = 'DAF';
series_years['Applause_1989'] = 'A101';
series_years['Applause_1990'] = 'A101';
series_years['Applause_1991'] = 'A101';
series_years['Applause_1992'] = 'A101';
series_years['Applause_1993'] = 'A101';
series_years['Applause_1994'] = 'A101';
series_years['Applause_1995'] = 'A101';
series_years['Applause_1996'] = 'A101';
series_years['Applause_1997'] = 'A101';
series_years['Applause_1998'] = 'A101';
series_years['Applause_1999'] = 'A101';
series_years['Charade_1987'] = 'G100/G102';
series_years['Charade_1988'] = 'G100/G102';
series_years['Charade_1989'] = 'G100/G102';
series_years['Charade_1990'] = 'G100/G102';
series_years['Charade_1991'] = 'G100/G102';
series_years['Charade_1992'] = 'G100/G102';
series_years['Charade_1993'] = 'G100/G102|G200';
series_years['Charade_1994'] = 'G200';
series_years['Charade_1995'] = 'G200';
series_years['Charade_1996'] = 'G200|G202/G203';
series_years['Charade_2003'] = 'L251';
series_years['Charade_2004'] = 'L251';
series_years['Charade_2005'] = 'L251';
series_years['Charade_2006'] = 'L251';
series_years['Charade_2007'] = 'L251';
series_years['Charade_2008'] = 'L251';
series_years['Charade_2009'] = 'L251';
series_years['Charade_2010'] = 'L251';
series_years['Charade_2011'] = 'L251';
series_years['Charade_2012'] = 'L251';
series_years['Charade_2013'] = 'L251';
series_years['Charade_2014'] = 'L251';
series_years['Charade_2015'] = 'L251';
series_years['Charade_2016'] = 'L251';
series_years['Charade_2017'] = 'L251';
series_years['Charade_2018'] = 'L251';
series_years['Charade_2019'] = 'L251';
series_years['Charade_2020'] = 'L251';
series_years['Charade_2021'] = 'L251';
series_years['Charade_2022'] = 'L251';
series_years['Charade_2023'] = 'L251';
series_years['Charade_2024'] = 'L251';
series_years['Charade_2025'] = 'L251';
series_years['Charade_1997'] = 'G202/G203';
series_years['Charade_1998'] = 'G202/G203';
series_years['Charade_1999'] = 'G202/G203';
series_years['Charade_2000'] = 'G202/G203';
series_years['Daihatsu Truck_1977'] = 'Delta';
series_years['Daihatsu Truck_1978'] = 'Delta';
series_years['Daihatsu Truck_1979'] = 'Delta';
series_years['Daihatsu Truck_1980'] = 'Delta';
series_years['Daihatsu Truck_1981'] = 'Delta';
series_years['Daihatsu Truck_1982'] = 'Delta';
series_years['Daihatsu Truck_1983'] = 'Delta';
series_years['Daihatsu Truck_1984'] = 'Delta';
series_years['Delta_1985'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1986'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1987'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1988'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1989'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1990'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1991'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1992'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1993'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1994'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1995'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1996'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1997'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1998'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_1999'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2000'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2001'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2002'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2003'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2004'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2005'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2006'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2007'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2008'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2009'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Delta_2010'] = 'V5#/ V7#/ V8#/ V9#/ V1##';
series_years['Handivan_1998'] = 'L701';
series_years['Handivan_1999'] = 'L701';
series_years['Handivan_2000'] = 'L701';
series_years['Handivan_2001'] = 'L701';
series_years['Handivan_2002'] = 'L701';
series_years['Handivan_2003'] = 'L701';
series_years['Mira_1990'] = 'L200';
series_years['Mira_1991'] = 'L200';
series_years['Mira_1992'] = 'L200';
series_years['Mira_1993'] = 'L200';
series_years['Mira_1994'] = 'L200';
series_years['Mira_1995'] = 'L200';
series_years['Move_1997'] = 'L601';
series_years['Move_1998'] = 'L601';
series_years['Move_1999'] = 'L601';
series_years['Pyzar_1997'] = 'G301/G303';
series_years['Pyzar_1998'] = 'G301/G303';
series_years['Pyzar_1999'] = 'G301/G303';
series_years['Pyzar_2000'] = 'G301/G303';
series_years['Rocky_1987'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1988'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1989'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1990'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1991'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1992'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1993'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1994'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1995'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1996'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1997'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1998'] = 'F70/F75/F77/F80/F85/F87';
series_years['Rocky_1999'] = 'F70/F75/F77/F80/F85/F87';
series_years['Sirion_1998'] = 'M100';
series_years['Sirion_1999'] = 'M100';
series_years['Sirion_2000'] = 'M100';
series_years['Sirion_2001'] = 'M100|M100/M101';
series_years['Sirion_2002'] = 'M100/M101';
series_years['Sirion_2003'] = 'M100/M101';
series_years['Sirion_2004'] = 'M100/M101';
series_years['Terios_1997'] = 'J100G/J102G';
series_years['Terios_1998'] = 'J100G/J102G';
series_years['Terios_1999'] = 'J100G/J102G';
series_years['Terios_2000'] = 'J100G/J102G';
series_years['Yrv_2001'] = 'M201G';
series_years['Yrv_2002'] = 'M201G';
series_years['Yrv_2003'] = 'M201G';
series_years['Yrv_2004'] = 'M201G';
series_years['Caliber_2006'] = 'PM';
series_years['Caliber_2007'] = 'PM';
series_years['Caliber_2008'] = 'PM';
series_years['Caliber_2009'] = 'PM';
series_years['Caliber_2010'] = 'PM';
series_years['Caliber_2011'] = 'PM';
series_years['Caliber_2012'] = 'PM';
series_years['Journey_2008'] = 'JC';
series_years['Journey_2009'] = 'JC';
series_years['Journey_2010'] = 'JC';
series_years['Journey_2011'] = 'JC';
series_years['Nitro_2007'] = 'KA';
series_years['Nitro_2008'] = 'KA';
series_years['Nitro_2009'] = 'KA';
series_years['Nitro_2010'] = 'KA';
series_years['Nitro_2011'] = 'KA';
series_years['30X_1992'] = '30X';
series_years['30X_1993'] = '30X';
series_years['30X_1994'] = '30X';
series_years['30X_1995'] = '30X';
series_years['30X_1996'] = '30X';
series_years['30X_1997'] = '30X';
series_years['500_1996'] = '500';
series_years['500_1997'] = '500';
series_years['500_1998'] = '500';
series_years['500_1999'] = '500';
series_years['800_1996'] = '800';
series_years['800_1997'] = '800';
series_years['800_1998'] = '800';
series_years['800_1999'] = '800';
series_years['800_2000'] = '800';
series_years['Ducato_2007'] = 'JTD|JTD SERIES 2';
series_years['Ducato_2008'] = 'JTD SERIES 2';
series_years['Ducato_2009'] = 'JTD SERIES 2';
series_years['Ducato_2010'] = 'JTD SERIES 2';
series_years['Ducato_2011'] = 'JTD SERIES 2';
series_years['Ducato_2012'] = 'JTD SERIES 2';
series_years['Ducato_2013'] = 'JTD SERIES 2';
series_years['Ducato_2014'] = 'JTD SERIES 2';
series_years['Ducato_2015'] = 'JTD SERIES 2';
series_years['Ducato_2016'] = 'JTD SERIES 2';
series_years['Ducato_2017'] = 'JTD SERIES 2';
series_years['Ducato_2018'] = 'JTD SERIES 2';
series_years['Ducato_2019'] = 'JTD SERIES 2';
series_years['Ducato_2020'] = 'JTD SERIES 2';
series_years['Ducato_2021'] = 'JTD SERIES 2';
series_years['Ducato_2022'] = 'JTD SERIES 2';
series_years['Ducato_2023'] = 'JTD SERIES 2';
series_years['Ducato_2024'] = 'JTD SERIES 2';
series_years['Ducato_2025'] = 'JTD SERIES 2';
series_years['Ducato_2002'] = 'JTD';
series_years['Ducato_2003'] = 'JTD';
series_years['Ducato_2004'] = 'JTD';
series_years['Ducato_2005'] = 'JTD';
series_years['Ducato_2006'] = 'JTD';
series_years['Fiat 500_2015'] = '500';
series_years['Fiat 500_2016'] = '500';
series_years['Fiat 500_2017'] = '500';
series_years['Fiat 500_2018'] = '500';
series_years['Fiat 500_2019'] = '500';
series_years['Fiat 500_2020'] = '500';
series_years['Fiat 500_2021'] = '500';
series_years['Fiat 500_2022'] = '500';
series_years['Fiat 500_2023'] = '500';
series_years['Fiat 500_2024'] = '500';
series_years['Fiat 500_2025'] = '500';
series_years['Capri_1989'] = 'SA/SB ';
series_years['Capri_1990'] = 'SA/SB ';
series_years['Capri_1991'] = 'SA/SB ';
series_years['Capri_1992'] = 'SA/SB |SC';
series_years['Capri_1993'] = 'SA/SB |SC';
series_years['Capri_1994'] = 'SA/SB ';
series_years['Corsair_1989'] = 'UA ';
series_years['Corsair_1990'] = 'UA ';
series_years['Corsair_1991'] = 'UA ';
series_years['Cortina_1977'] = 'TE/TF';
series_years['Cortina_1978'] = 'TE/TF';
series_years['Cortina_1979'] = 'TE/TF';
series_years['Cortina_1980'] = 'TE/TF';
series_years['Cortina_1981'] = 'TE/TF';
series_years['Cortina_1982'] = 'TE/TF';
series_years['Courier_1999'] = 'PE';
series_years['Courier_2000'] = 'PE';
series_years['Courier_2001'] = 'PE';
series_years['Courier_2002'] = 'PE|PG/PH';
series_years['Courier_1996'] = 'PC|PD';
series_years['Courier_1997'] = 'PD';
series_years['Courier_1998'] = 'PD';
series_years['Courier_2003'] = 'PG/PH';
series_years['Courier_2004'] = 'PG/PH';
series_years['Courier_2005'] = 'PG/PH';
series_years['Courier_2006'] = 'PG/PH';
series_years['Courier_1985'] = 'PC';
series_years['Courier_1986'] = 'PC';
series_years['Courier_1987'] = 'PC';
series_years['Courier_1988'] = 'PC';
series_years['Courier_1989'] = 'PC';
series_years['Courier_1990'] = 'PC';
series_years['Courier_1991'] = 'PC';
series_years['Courier_1992'] = 'PC';
series_years['Courier_1993'] = 'PC';
series_years['Courier_1994'] = 'PC';
series_years['Courier_1995'] = 'PC';
series_years['Econovan/Maxivan/Spectron/Cab_1999'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB|JH';
series_years['Econovan/Maxivan/Spectron/Cab_2000'] = 'JH';
series_years['Econovan/Maxivan/Spectron/Cab_2001'] = 'JH';
series_years['Econovan/Maxivan/Spectron/Cab_2002'] = 'JH';
series_years['Econovan/Maxivan/Spectron/Cab_2003'] = 'JH';
series_years['Econovan/Maxivan/Spectron/Cab_2004'] = 'JH';
series_years['Econovan/Maxivan/Spectron/Cab_2005'] = 'JH';
series_years['Econovan/Maxivan/Spectron/Cab_1984'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1985'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1986'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1987'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1988'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1989'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1990'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1991'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1992'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1993'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1994'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1995'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1996'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1997'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Econovan/Maxivan/Spectron/Cab_1998'] = 'ECONOVAN/MAXIVAN/SPECTRON/CAB';
series_years['Ecosport_2017'] = 'BK|BL';
series_years['Ecosport_2018'] = 'BL';
series_years['Ecosport_2013'] = 'BK';
series_years['Ecosport_2014'] = 'BK';
series_years['Ecosport_2015'] = 'BK';
series_years['Ecosport_2016'] = 'BK';
series_years['Endura_2018'] = 'CA';
series_years['Endura_2019'] = 'CA';
series_years['Escape_2016'] = 'ZG';
series_years['Escape_2017'] = 'ZG';
series_years['Escape_2018'] = 'ZG';
series_years['Escape_2019'] = 'ZG';
series_years['Escape_2020'] = 'ZG|ZH';
series_years['Escape_2001'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2002'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2003'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2004'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2005'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2006'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2007'] = 'BA/ZA/ZB/ZC';
series_years['Escape_2008'] = 'BA/ZA/ZB/ZC|ZD';
series_years['Escape_2021'] = 'ZH';
series_years['Escape_2022'] = 'ZH';
series_years['Escape_2023'] = 'ZH';
series_years['Escape_2024'] = 'ZH';
series_years['Escape_2025'] = 'ZH';
series_years['Escape_2009'] = 'ZD';
series_years['Escape_2010'] = 'ZD';
series_years['Escape_2011'] = 'ZD';
series_years['Escape_2012'] = 'ZD';
series_years['Everest_2024'] = 'UB';
series_years['Everest_2025'] = 'UB';
series_years['Everest_2023'] = 'UB';
series_years['Everest_2022'] = 'UAII|UB';
series_years['Everest_2020'] = 'UAII';
series_years['Everest_2021'] = 'UAII';
series_years['Everest_2018'] = 'UA|UAII';
series_years['Everest_2019'] = 'UAII';
series_years['Everest_2015'] = 'UA';
series_years['Everest_2016'] = 'UA';
series_years['Everest_2017'] = 'UA';
series_years['Explorer_2001'] = 'UN/UP/UQ|UT/UX/UZ';
series_years['Explorer_2002'] = 'UT/UX/UZ';
series_years['Explorer_2003'] = 'UT/UX/UZ';
series_years['Explorer_2004'] = 'UT/UX/UZ';
series_years['Explorer_2005'] = 'UT/UX/UZ';
series_years['Explorer_1996'] = 'UN/UP/UQ';
series_years['Explorer_1997'] = 'UN/UP/UQ';
series_years['Explorer_1998'] = 'UN/UP/UQ';
series_years['Explorer_1999'] = 'UN/UP/UQ';
series_years['Explorer_2000'] = 'UN/UP/UQ';
series_years['Fairlane_1999'] = 'AU';
series_years['Fairlane_2000'] = 'AU';
series_years['Fairlane_2001'] = 'AU';
series_years['Fairlane_2002'] = 'AU';
series_years['Fairlane_2003'] = 'AU|BA|BA/BF';
series_years['Fairlane_1976'] = 'ZH';
series_years['Fairlane_1977'] = 'ZH';
series_years['Fairlane_1978'] = 'ZH';
series_years['Fairlane_1979'] = 'ZH|ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1995'] = 'BA/BF/NF/NL|NC';
series_years['Fairlane_1996'] = 'BA/BF/NF/NL';
series_years['Fairlane_1997'] = 'BA/BF/NF/NL';
series_years['Fairlane_1998'] = 'BA/BF/NF/NL';
series_years['Fairlane_1987'] = 'NC|ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1988'] = 'NC|ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1989'] = 'NC';
series_years['Fairlane_1990'] = 'NC';
series_years['Fairlane_1991'] = 'NC';
series_years['Fairlane_1992'] = 'NC';
series_years['Fairlane_1993'] = 'NC';
series_years['Fairlane_1994'] = 'NC';
series_years['Fairlane_1980'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1981'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1982'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1983'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1984'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1985'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_1986'] = 'ZJ/ZK/ZL/FC/FD/FE';
series_years['Fairlane_2005'] = 'BA|BA II|BA/BF|BF';
series_years['Fairlane_2006'] = 'BA/BF|BF';
series_years['Fairlane_2007'] = 'BA/BF|BF';
series_years['Fairlane_2004'] = 'BA|BA II|BA/BF';
series_years['Fairmont_2006'] = 'BF|BF II';
series_years['Fairmont_2007'] = 'BF II';
series_years['Fairmont_2008'] = 'BF II';
series_years['Fairmont_2005'] = 'BF';
series_years['Fairmont_2002'] = 'BA';
series_years['Fairmont_2003'] = 'BA';
series_years['Fairmont_2004'] = 'BA';
series_years['Falcon_2010'] = 'BF III|FG';
series_years['Falcon_2011'] = 'FG|FG II';
series_years['Falcon_1998'] = 'AU|DF/DL/EF/EL/XH';
series_years['Falcon_1999'] = 'AU|DF/DL/EF/EL/XH';
series_years['Falcon_2000'] = 'AU';
series_years['Falcon_2001'] = 'AU';
series_years['Falcon_2002'] = 'AU|BA';
series_years['Falcon_2003'] = 'BA';
series_years['Falcon_2004'] = 'BA|BA II';
series_years['Falcon_2012'] = 'FG II';
series_years['Falcon_2013'] = 'FG II';
series_years['Falcon_2014'] = 'FG II|FG X';
series_years['Falcon_2005'] = 'BA II|BF';
series_years['Falcon_2008'] = 'BF II|BF III|FG';
series_years['Falcon_2006'] = 'BF|BF II';
series_years['Falcon_2007'] = 'BF II';
series_years['Falcon_2015'] = 'FG X';
series_years['Falcon_2016'] = 'FG X';
series_years['Falcon_1994'] = 'DC/XG|DF/DL/EF/EL/XH|XG';
series_years['Falcon_1995'] = 'DC/XG|DF/DL/EF/EL/XH|XG';
series_years['Falcon_1996'] = 'DC/XG|DF/DL/EF/EL/XH|XG';
series_years['Falcon_1997'] = 'DF/DL/EF/EL/XH';
series_years['Falcon_1972'] = 'XA/XB/XC';
series_years['Falcon_1973'] = 'XA/XB/XC';
series_years['Falcon_1974'] = 'XA/XB/XC';
series_years['Falcon_1975'] = 'XA/XB/XC';
series_years['Falcon_1976'] = 'XA/XB/XC';
series_years['Falcon_1977'] = 'XA/XB/XC';
series_years['Falcon_1978'] = 'XA/XB/XC';
series_years['Falcon_1979'] = 'XA/XB/XC|XD';
series_years['Falcon_1980'] = 'XA/XB/XC|XD';
series_years['Falcon_2009'] = 'BF III|FG';
series_years['Falcon_1966'] = 'XR/XT/XW/XY';
series_years['Falcon_1967'] = 'XR/XT/XW/XY';
series_years['Falcon_1968'] = 'XR/XT/XW/XY';
series_years['Falcon_1969'] = 'XR/XT/XW/XY';
series_years['Falcon_1970'] = 'XR/XT/XW/XY';
series_years['Falcon_1971'] = 'XR/XT/XW/XY';
series_years['Falcon_1982'] = 'XD|XE';
series_years['Falcon_1983'] = 'XE';
series_years['Falcon_1984'] = 'XE|XG';
series_years['Falcon_1981'] = 'XD';
series_years['Falcon_1988'] = 'DC/XG|XG';
series_years['Falcon_1989'] = 'DC/XG|XG';
series_years['Falcon_1990'] = 'DC/XG|XG';
series_years['Falcon_1991'] = 'DC/XG|XG';
series_years['Falcon_1992'] = 'DC/XG|XG';
series_years['Falcon_1993'] = 'DC/XG|XG';
series_years['Falcon_1985'] = 'XG';
series_years['Falcon_1986'] = 'XG';
series_years['Falcon_1987'] = 'XG';
series_years['Falcon Ute_2011'] = 'FG|FG II';
series_years['Falcon Ute_2014'] = 'FG II|FG X';
series_years['Falcon Ute_2015'] = 'FG X';
series_years['Falcon Ute_2016'] = 'FG X';
series_years['Falcon Ute_2004'] = 'BA|BA II|BA MKII';
series_years['Falcon Ute_2005'] = 'BA II|BA MKII|BF';
series_years['Falcon Ute_2012'] = 'FG II';
series_years['Falcon Ute_2013'] = 'FG II';
series_years['Falcon Ute_2010'] = 'FG';
series_years['Falcon Ute_2002'] = 'BA';
series_years['Falcon Ute_2003'] = 'BA';
series_years['Falcon Ute_2006'] = 'BF';
series_years['Falcon Ute_2008'] = 'FG';
series_years['Falcon Ute_2009'] = 'FG';
series_years['Festiva_1994'] = 'WA|WB/WD/WF';
series_years['Festiva_1995'] = 'WB/WD/WF';
series_years['Festiva_1996'] = 'WB/WD/WF';
series_years['Festiva_1997'] = 'WB/WD/WF';
series_years['Festiva_1998'] = 'WB/WD/WF';
series_years['Festiva_1999'] = 'WB/WD/WF';
series_years['Festiva_2000'] = 'WB/WD/WF';
series_years['Festiva_2001'] = 'WB/WD/WF';
series_years['Festiva_1991'] = 'WA';
series_years['Festiva_1992'] = 'WA';
series_years['Festiva_1993'] = 'WA';
series_years['Fiesta_2020'] = 'WG|WZ';
series_years['Fiesta_2021'] = 'WG';
series_years['Fiesta_2022'] = 'WG';
series_years['Fiesta_2010'] = 'WS|WT';
series_years['Fiesta_2011'] = 'WT';
series_years['Fiesta_2012'] = 'WT';
series_years['Fiesta_2013'] = 'WT|WZ';
series_years['Fiesta_2023'] = 'WG';
series_years['Fiesta_2024'] = 'WG';
series_years['Fiesta_2025'] = 'WG';
series_years['Fiesta_2004'] = 'WP/WQ';
series_years['Fiesta_2005'] = 'WP/WQ';
series_years['Fiesta_2006'] = 'WP/WQ';
series_years['Fiesta_2007'] = 'WP/WQ';
series_years['Fiesta_2008'] = 'WP/WQ';
series_years['Fiesta_2014'] = 'WZ';
series_years['Fiesta_2015'] = 'WZ';
series_years['Fiesta_2016'] = 'WZ';
series_years['Fiesta_2017'] = 'WZ';
series_years['Fiesta_2018'] = 'WZ';
series_years['Fiesta_2019'] = 'WZ';
series_years['Fiesta_2009'] = 'WS';
series_years['Focus_2019'] = 'SA';
series_years['Focus_2020'] = 'SA';
series_years['Focus_2018'] = 'LZ|SA';
series_years['Focus_2021'] = 'SA';
series_years['Focus_2022'] = 'SA';
series_years['Focus_2023'] = 'SA';
series_years['Focus_2024'] = 'SA';
series_years['Focus_2025'] = 'SA';
series_years['Focus_2011'] = 'LV|LW';
series_years['Focus_2012'] = 'LW';
series_years['Focus_2009'] = 'LS/LT|LV';
series_years['Focus_2010'] = 'LV';
series_years['Focus_2002'] = 'LR';
series_years['Focus_2003'] = 'LR';
series_years['Focus_2004'] = 'LR';
series_years['Focus_2005'] = 'LS/LT';
series_years['Focus_2006'] = 'LS/LT';
series_years['Focus_2007'] = 'LS/LT';
series_years['Focus_2008'] = 'LS/LT';
series_years['Focus_2013'] = 'LW';
series_years['Focus_2014'] = 'LW';
series_years['Focus_2015'] = 'LW|LZ';
series_years['Focus_2016'] = 'LZ';
series_years['Focus_2017'] = 'LZ';
series_years['F-series_1997'] = 'F150/F250 |F150/F250/F350';
series_years['F-series_1998'] = 'F150/F250 ';
series_years['F-series_1999'] = 'F150/F250 ';
series_years['F-series_2000'] = 'F150/F250 ';
series_years['F-series_2001'] = 'F150/F250 |RM/RN';
series_years['F-series_1993'] = 'F150/F250/F350|F150/F350';
series_years['F-series_1994'] = 'F150/F250/F350';
series_years['F-series_1995'] = 'F150/F250/F350';
series_years['F-series_1996'] = 'F150/F250/F350';
series_years['F-series_1973'] = 'F100/F250/F350';
series_years['F-series_1974'] = 'F100/F250/F350';
series_years['F-series_1975'] = 'F100/F250/F350';
series_years['F-series_1976'] = 'F100/F250/F350';
series_years['F-series_1977'] = 'F100/F250/F350';
series_years['F-series_1978'] = 'F100/F250/F350';
series_years['F-series_1979'] = 'F100/F250/F350';
series_years['F-series_1980'] = 'F100/F250/F350';
series_years['F-series_1981'] = 'F100/F250/F350|F150/F250/F350';
series_years['F-series_1982'] = 'F150/F250/F350';
series_years['F-series_1983'] = 'F150/F250/F350';
series_years['F-series_1984'] = 'F150/F250/F350';
series_years['F-series_1985'] = 'F150/F250/F350';
series_years['F-series_1987'] = 'F150/F350';
series_years['F-series_1988'] = 'F150/F350';
series_years['F-series_1989'] = 'F150/F350';
series_years['F-series_1990'] = 'F150/F350';
series_years['F-series_1991'] = 'F150/F350';
series_years['F-series_1992'] = 'F150/F350';
series_years['F-series_2002'] = 'RM/RN';
series_years['F-series_2003'] = 'RM/RN';
series_years['F-series_2004'] = 'RM/RN';
series_years['F-series_2005'] = 'RM/RN';
series_years['F-series_2006'] = 'RM/RN';
series_years['Ka_1999'] = 'TA/TB';
series_years['Ka_2000'] = 'TA/TB';
series_years['Ka_2001'] = 'TA/TB';
series_years['Ka_2002'] = 'TA/TB';
series_years['Kuga_2013'] = 'TE|TF';
series_years['Kuga_2014'] = 'TF|TF II';
series_years['Kuga_2015'] = 'TF II';
series_years['Kuga_2016'] = 'TF II';
series_years['Kuga_2012'] = 'TE';
series_years['Laser_2001'] = 'KN|KQ';
series_years['Laser_2002'] = 'KQ';
series_years['Laser_1994'] = 'KF/KH|KJ';
series_years['Laser_1995'] = 'KJ';
series_years['Laser_1996'] = 'KJ';
series_years['Laser_1997'] = 'KJ';
series_years['Laser_1998'] = 'KJ';
series_years['Laser_1981'] = 'KA';
series_years['Laser_1982'] = 'KA|KB';
series_years['Laser_1983'] = 'KB';
series_years['Laser_1984'] = 'KB';
series_years['Laser_1985'] = 'KB|KC';
series_years['Laser_1999'] = 'KN';
series_years['Laser_2000'] = 'KN';
series_years['Laser_1986'] = 'KC';
series_years['Laser_1987'] = 'KC|KE';
series_years['Laser_1988'] = 'KE';
series_years['Laser_1989'] = 'KE|KF/KH';
series_years['Laser_1990'] = 'KF/KH';
series_years['Laser_1991'] = 'KF/KH';
series_years['Laser_1992'] = 'KF/KH';
series_years['Laser_1993'] = 'KF/KH';
series_years['Maverick_1988'] = 'Maverick';
series_years['Maverick_1989'] = 'Maverick';
series_years['Maverick_1990'] = 'Maverick';
series_years['Maverick_1991'] = 'Maverick';
series_years['Maverick_1992'] = 'Maverick';
series_years['Maverick_1993'] = 'Maverick';
series_years['Maverick_1994'] = 'Maverick';
series_years['Meteor_1985'] = 'GC';
series_years['Meteor_1986'] = 'GC';
series_years['Meteor_1987'] = 'GC';
series_years['Mondeo_2010'] = 'MA/MB|MC';
series_years['Mondeo_2011'] = 'MC';
series_years['Mondeo_2012'] = 'MC';
series_years['Mondeo_2013'] = 'MC';
series_years['Mondeo_2014'] = 'MC';
series_years['Mondeo_2015'] = 'MC|MD';
series_years['Mondeo_2007'] = 'MA/MB';
series_years['Mondeo_2008'] = 'MA/MB';
series_years['Mondeo_2009'] = 'MA/MB';
series_years['Mondeo_1999'] = 'HC/HD|HE';
series_years['Mondeo_2000'] = 'HE';
series_years['Mondeo_1995'] = 'HA/HB';
series_years['Mondeo_1996'] = 'HA/HB|HC/HD';
series_years['Mondeo_1997'] = 'HC/HD';
series_years['Mondeo_1998'] = 'HC/HD';
series_years['Mondeo_2016'] = 'MD';
series_years['Mondeo_2017'] = 'MD';
series_years['Mondeo_2018'] = 'MD';
series_years['Mondeo_2019'] = 'MD';
series_years['Mondeo_2020'] = 'MD';
series_years['Mondeo_2021'] = 'MD';
series_years['Mondeo_2022'] = 'MD';
series_years['Mondeo_2023'] = 'MD';
series_years['Mondeo_2024'] = 'MD';
series_years['Mondeo_2025'] = 'MD';
series_years['Mustang_2015'] = 'FM';
series_years['Mustang_2016'] = 'FM';
series_years['Mustang_2017'] = 'FM';
series_years['Mustang_2018'] = 'FM|FN';
series_years['Mustang_2019'] = 'FN';
series_years['Probe_1994'] = 'ST/SU/SV';
series_years['Probe_1995'] = 'ST/SU/SV';
series_years['Probe_1996'] = 'ST/SU/SV';
series_years['Probe_1997'] = 'ST/SU/SV';
series_years['Probe_1998'] = 'ST/SU/SV';
series_years['Puma_2022'] = 'JK';
series_years['Puma_2023'] = 'JK';
series_years['Puma_2024'] = 'JK';
series_years['Puma_2025'] = 'JK';
series_years['Puma_2020'] = 'JK';
series_years['Puma_2021'] = 'JK';
series_years['Ranger_2006'] = 'FC/FD/GD/FF/FG/GH/FM/FS|PJ';
series_years['Ranger_2007'] = 'FC/FD/GD/FF/FG/GH/FM/FS|PJ';
series_years['Ranger_2008'] = 'FC/FD/GD/FF/FG/GH/FM/FS|PJ';
series_years['Ranger_2009'] = 'PJ|PK';
series_years['Ranger_1998'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_1999'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2000'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2001'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2002'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2003'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2004'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2005'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2023'] = 'P703';
series_years['Ranger_2024'] = 'P703';
series_years['Ranger_2010'] = 'PK';
series_years['Ranger_2011'] = 'PK';
series_years['Ranger_2015'] = 'PX II';
series_years['Ranger_2016'] = 'PX II';
series_years['Ranger_2017'] = 'PX II';
series_years['Ranger_2018'] = 'PX II';
series_years['Ranger 4X2_2018'] = 'PX III';
series_years['Ranger 4X2_2019'] = 'PX III';
series_years['Ranger 4X2_2020'] = 'PX III';
series_years['Ranger 4X2_2021'] = 'PX III';
series_years['Ranger 4X2_2022'] = 'P703|PX III';
series_years['Ranger 4X2_2011'] = 'PX';
series_years['Ranger 4X2_2012'] = 'PX';
series_years['Ranger 4X2_2013'] = 'PX';
series_years['Ranger 4X2_2014'] = 'PX';
series_years['Ranger 4X2_2015'] = 'PX';
series_years['Ranger 4X2_2023'] = 'P703';
series_years['Ranger 4X2_2024'] = 'P703';
series_years['Ranger 4X2_2025'] = 'P703';
series_years['Ranger 4X4_2022'] = 'P703|PX III';
series_years['Ranger 4X4_2023'] = 'P703';
series_years['Ranger 4X4_2024'] = 'P703';
series_years['Ranger 4X4_2018'] = 'PX III';
series_years['Ranger 4X4_2019'] = 'PX III';
series_years['Ranger 4X4_2020'] = 'PX III';
series_years['Ranger 4X4_2021'] = 'PX III';
series_years['Ranger 4X4_2025'] = 'P703';
series_years['Ranger 4X4_2014'] = 'PX';
series_years['Ranger 4X4_2015'] = 'PX';
series_years['Ranger 4X4_2011'] = 'PX';
series_years['Ranger 4X4_2012'] = 'PX';
series_years['Ranger 4X4_2013'] = 'PX';
series_years['Taurus_1996'] = 'DN/DP';
series_years['Taurus_1997'] = 'DN/DP';
series_years['Taurus_1998'] = 'DN/DP';
series_years['Telstar_1983'] = 'AR';
series_years['Telstar_1984'] = 'AR';
series_years['Telstar_1985'] = 'AR|AS';
series_years['Telstar_1992'] = 'AX/AY';
series_years['Telstar_1993'] = 'AX/AY';
series_years['Telstar_1994'] = 'AX/AY';
series_years['Telstar_1995'] = 'AX/AY';
series_years['Telstar_1996'] = 'AX/AY';
series_years['Telstar_1986'] = 'AS';
series_years['Telstar_1987'] = 'AS|AT';
series_years['Telstar_1988'] = 'AT';
series_years['Telstar_1989'] = 'AT';
series_years['Telstar_1990'] = 'AT';
series_years['Telstar_1991'] = 'AT';
series_years['Territory_2011'] = 'SX/SY|SZ';
series_years['Territory_2012'] = 'SZ';
series_years['Territory_2013'] = 'SZ';
series_years['Territory_2014'] = 'SZ';
series_years['Territory_2015'] = 'SZ';
series_years['Territory_2016'] = 'SZ';
series_years['Territory_2004'] = 'SX/SY';
series_years['Territory_2005'] = 'SX/SY';
series_years['Territory_2006'] = 'SX/SY';
series_years['Territory_2007'] = 'SX/SY';
series_years['Territory_2008'] = 'SX/SY';
series_years['Territory_2009'] = 'SX/SY';
series_years['Territory_2010'] = 'SX/SY';
series_years['Transit_1994'] = 'VE';
series_years['Transit_1995'] = 'VE|VF / VG';
series_years['Transit_2006'] = 'VH/VJ|VM';
series_years['Transit_2007'] = 'VM';
series_years['Transit_2008'] = 'VM';
series_years['Transit_2009'] = 'VM';
series_years['Transit_2010'] = 'VM';
series_years['Transit_2011'] = 'VM';
series_years['Transit_2012'] = 'VM';
series_years['Transit_2013'] = 'VM|VN';
series_years['Transit_2014'] = 'VN|VO';
series_years['Transit_2015'] = 'VN|VO';
series_years['Transit_2016'] = 'VN|VO';
series_years['Transit_2017'] = 'VN|VO';
series_years['Transit_2018'] = 'VN|VO';
series_years['Transit_2019'] = 'VO';
series_years['Transit_2020'] = 'VO';
series_years['Transit_2021'] = 'VO';
series_years['Transit_2022'] = 'VO';
series_years['Transit_2000'] = 'VF / VG|VH/VJ';
series_years['Transit_2001'] = 'VH/VJ';
series_years['Transit_2002'] = 'VH/VJ';
series_years['Transit_2003'] = 'VH/VJ';
series_years['Transit_2004'] = 'VH/VJ';
series_years['Transit_2005'] = 'VH/VJ';
series_years['Transit_2023'] = 'VO';
series_years['Transit_2024'] = 'VO';
series_years['Transit_2025'] = 'VO';
series_years['Transit_1996'] = 'VF / VG';
series_years['Transit_1997'] = 'VF / VG';
series_years['Transit_1998'] = 'VF / VG';
series_years['Transit_1999'] = 'VF / VG';
series_years['Transit Custom_2019'] = 'VN';
series_years['Transit Custom_2020'] = 'VN';
series_years['Transit Custom_2021'] = 'VN';
series_years['Transit Custom_2022'] = 'VN';
series_years['Transit Custom_2018'] = 'VN';
series_years['Generic_1960'] = 'Generic';
series_years['Generic_1961'] = 'Generic';
series_years['Generic_1962'] = 'Generic';
series_years['Generic_1963'] = 'Generic';
series_years['Generic_1964'] = 'Generic';
series_years['Generic_1965'] = 'Generic';
series_years['Generic_1966'] = 'Generic';
series_years['Generic_1967'] = 'Generic';
series_years['Generic_1968'] = 'Generic';
series_years['Generic_1969'] = 'Generic';
series_years['Generic_1970'] = 'Generic';
series_years['Generic_1971'] = 'Generic';
series_years['Generic_1972'] = 'Generic';
series_years['Generic_1973'] = 'Generic';
series_years['Generic_1974'] = 'Generic';
series_years['Generic_1975'] = 'Generic';
series_years['Generic_1976'] = 'Generic';
series_years['Generic_1977'] = 'Generic';
series_years['Generic_1978'] = 'Generic';
series_years['Generic_1979'] = 'Generic';
series_years['Generic_1980'] = 'Generic';
series_years['Generic_1981'] = 'Generic';
series_years['Generic_1982'] = 'Generic';
series_years['Generic_1983'] = 'Generic';
series_years['Generic_1984'] = 'Generic';
series_years['Generic_1985'] = 'Generic';
series_years['Generic_1986'] = 'Generic';
series_years['Generic_1987'] = 'Generic';
series_years['Generic_1988'] = 'Generic';
series_years['Generic_1989'] = 'Generic';
series_years['Generic_1990'] = 'Generic';
series_years['Generic_1991'] = 'Generic';
series_years['Generic_1992'] = 'Generic';
series_years['Generic_1993'] = 'Generic';
series_years['Generic_1994'] = 'Generic';
series_years['Generic_1995'] = 'Generic';
series_years['Generic_1996'] = 'Generic';
series_years['Generic_1997'] = 'Generic';
series_years['Generic_1998'] = 'Generic';
series_years['Generic_1999'] = 'Generic';
series_years['Generic_2000'] = 'Generic';
series_years['Generic_2001'] = 'Generic';
series_years['Generic_2002'] = 'Generic';
series_years['Generic_2003'] = 'Generic';
series_years['Generic_2004'] = 'Generic';
series_years['Generic_2005'] = 'Generic';
series_years['Generic_2006'] = 'Generic';
series_years['Generic_2007'] = 'Generic';
series_years['Generic_2008'] = 'Generic';
series_years['Generic_2009'] = 'Generic';
series_years['Generic_2010'] = 'Generic';
series_years['Generic_2011'] = 'Generic';
series_years['Generic_2012'] = 'Generic';
series_years['Generic_2013'] = 'Generic';
series_years['Generic_2014'] = 'Generic';
series_years['Generic_2015'] = 'Generic';
series_years['Generic_2016'] = 'Generic';
series_years['Generic_2017'] = 'Generic';
series_years['Generic_2018'] = 'Generic';
series_years['Generic_2019'] = 'Generic';
series_years['Generic_2020'] = 'Generic';
series_years['Generic_2021'] = 'Generic';
series_years['Generic_2022'] = 'Generic';
series_years['Generic_2023'] = 'Generic';
series_years['Generic_2024'] = 'Generic';
series_years['Generic_2025'] = 'Generic';
series_years['SA220_2009'] = 'CC';
series_years['SA220_2010'] = 'CC';
series_years['SA220_2011'] = 'CC';
series_years['SA220_2012'] = 'CC';
series_years['SA220_2013'] = 'CC';
series_years['SA220_2014'] = 'CC';
series_years['SA220_2015'] = 'CC';
series_years['SA220_2016'] = 'CC';
series_years['SA220_2017'] = 'CC';
series_years['SA220_2018'] = 'CC';
series_years['SA220_2019'] = 'CC';
series_years['SA220_2020'] = 'CC';
series_years['SA220_2021'] = 'CC';
series_years['SA220_2022'] = 'CC';
series_years['SA220_2023'] = 'CC';
series_years['SA220_2024'] = 'CC';
series_years['SA220_2025'] = 'CC';
series_years['V240_2009'] = 'K2';
series_years['V240_2010'] = 'K2';
series_years['V240_2011'] = 'K2';
series_years['V240_2012'] = 'K2';
series_years['V240_2013'] = 'K2';
series_years['V240_2014'] = 'K2';
series_years['V240_2015'] = 'K2';
series_years['V240_2016'] = 'K2';
series_years['V240_2017'] = 'K2';
series_years['V240_2018'] = 'K2';
series_years['V240_2019'] = 'K2';
series_years['V240_2020'] = 'K2';
series_years['V240_2021'] = 'K2';
series_years['V240_2022'] = 'K2';
series_years['V240_2023'] = 'K2';
series_years['V240_2024'] = 'K2';
series_years['V240_2025'] = 'K2';
series_years['300_2011'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2012'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2013'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2014'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2015'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2016'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2017'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2018'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2019'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2020'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2021'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2022'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2023'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2024'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['300_2025'] = 'XJC710|XJC720|XJC740|XKU645|XKU655|XKU710|XKU720|XZC810|XZU605|XZU655|XZU700|XZU710|XZU720|XZU730';
series_years['700_2004'] = '4562/4568';
series_years['700_2005'] = '4562/4568';
series_years['700_2006'] = '4562/4568';
series_years['700_2007'] = '4562/4568';
series_years['700_2008'] = '4562/4568';
series_years['700_2009'] = '4562/4568';
series_years['700_2010'] = '4562/4568';
series_years['700_2011'] = '4562/4568';
series_years['700_2012'] = '4562/4568';
series_years['700_2013'] = '4562/4568';
series_years['700_2014'] = '4562/4568';
series_years['700_2015'] = '4562/4568';
series_years['700_2016'] = '4562/4568';
series_years['700_2017'] = '4562/4568';
series_years['700_2018'] = '4562/4568';
series_years['700_2019'] = '4562/4568';
series_years['700_2020'] = '4562/4568';
series_years['700_2021'] = '4562/4568';
series_years['700_2022'] = '4562/4568';
series_years['700_2023'] = '4562/4568';
series_years['700_2024'] = '4562/4568';
series_years['700_2025'] = '4562/4568';
series_years['Dutro_2001'] = '2/3/4/5';
series_years['Dutro_2002'] = '2/3/4/5';
series_years['Dutro_2003'] = '2/3/4/5';
series_years['Dutro_2004'] = '2/3/4/5';
series_years['Dutro_2005'] = '2/3/4/5';
series_years['Dutro_2006'] = '2/3/4/5';
series_years['Dutro_2007'] = '2/3/4/5';
series_years['FC_1986'] = '144';
series_years['FC_1987'] = '144';
series_years['FC_1988'] = '144';
series_years['FC_1989'] = '144';
series_years['FC_1990'] = '144';
series_years['FC_1991'] = '144';
series_years['FC_1992'] = '144';
series_years['FC_1993'] = '144';
series_years['FC_1994'] = '144';
series_years['FC_1995'] = '144';
series_years['FC_1996'] = '144';
series_years['FC_1997'] = '144';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1991'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1992'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1993'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1994'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1995'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1996'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1997'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1998'] = 'FD/FE/FF';
series_years['Hawk/Raven/Eagle/Griffon/Kestr_1999'] = 'FD/FE/FF';
series_years['Ranger_2006'] = 'FC/FD/GD/FF/FG/GH/FM/FS|PJ';
series_years['Ranger_2007'] = 'FC/FD/GD/FF/FG/GH/FM/FS|PJ';
series_years['Ranger_2008'] = 'FC/FD/GD/FF/FG/GH/FM/FS|PJ';
series_years['Ranger_2009'] = 'PJ|PK';
series_years['Ranger_1998'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_1999'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2000'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2001'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2002'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2003'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2004'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2005'] = 'FC/FD/GD/FF/FG/GH/FM/FS';
series_years['Ranger_2023'] = 'P703';
series_years['Ranger_2024'] = 'P703';
series_years['Ranger_2010'] = 'PK';
series_years['Ranger_2011'] = 'PK';
series_years['Ranger_2015'] = 'PX II';
series_years['Ranger_2016'] = 'PX II';
series_years['Ranger_2017'] = 'PX II';
series_years['Ranger_2018'] = 'PX II';
series_years['Acadia_2018'] = 'AC';
series_years['Acadia_2019'] = 'AC';
series_years['Acadia_2020'] = 'AC';
series_years['Acadia_2021'] = 'AC';
series_years['Acadia_2022'] = 'AC';
series_years['Acadia_2023'] = 'AC';
series_years['Acadia_2024'] = 'AC';
series_years['Acadia_2025'] = 'AC';
series_years['Apollo_1989'] = 'JK/JL';
series_years['Apollo_1990'] = 'JK/JL';
series_years['Apollo_1991'] = 'JK/JL';
series_years['Apollo_1992'] = 'JK/JL';
series_years['Apollo_1993'] = 'JK/JL|JM/JP';
series_years['Apollo_1994'] = 'JM/JP';
series_years['Apollo_1995'] = 'JM/JP';
series_years['Apollo_1996'] = 'JM/JP';
series_years['Apollo_1997'] = 'JM/JP';
series_years['Astra_2016'] = 'BK|PJ';
series_years['Astra_2017'] = 'BK|BL|PJ';
series_years['Astra_2018'] = 'BK|BL';
series_years['Astra_2019'] = 'BK|BL';
series_years['Astra_2020'] = 'BK|BL';
series_years['Astra_2021'] = 'BK|BL';
series_years['Astra_2022'] = 'BK|BL';
series_years['Astra_2023'] = 'BK|BL';
series_years['Astra_2024'] = 'BK|BL';
series_years['Astra_2025'] = 'BK|BL';
series_years['Astra_2014'] = 'PJ';
series_years['Astra_2015'] = 'PJ';
series_years['Astra_2013'] = 'PJ';
series_years['Astra_1984'] = 'AH';
series_years['Astra_1985'] = 'AH';
series_years['Astra_1986'] = 'AH';
series_years['Astra_1987'] = 'AH';
series_years['Astra_1996'] = 'TR';
series_years['Astra_1997'] = 'TR';
series_years['Astra_1998'] = 'TR|TS';
series_years['Astra_2012'] = 'PJ';
series_years['Astra_1999'] = 'TS';
series_years['Astra_2000'] = 'TS';
series_years['Astra_2001'] = 'TS';
series_years['Astra_2002'] = 'TS';
series_years['Astra_2003'] = 'TS';
series_years['Astra_2004'] = 'AH|TS';
series_years['Astra_2005'] = 'AH|TS';
series_years['Astra_2006'] = 'AH|TS';
series_years['Astra_2007'] = 'AH';
series_years['Astra_2008'] = 'AH';
series_years['Astra_2009'] = 'AH';
series_years['Barina_2015'] = 'TM';
series_years['Barina_2016'] = 'TM';
series_years['Barina_2013'] = 'TM';
series_years['Barina_2014'] = 'TM';
series_years['Barina_2012'] = 'TK|TM';
series_years['Barina_1985'] = 'MB';
series_years['Barina_1986'] = 'MB|ML';
series_years['Barina_2001'] = 'SB|XC';
series_years['Barina_2002'] = 'XC';
series_years['Barina_2003'] = 'XC';
series_years['Barina_2004'] = 'XC';
series_years['Barina_2005'] = 'TK|XC';
series_years['Barina_2006'] = 'TK|XC';
series_years['Barina_2007'] = 'TK|XC';
series_years['Barina_2008'] = 'TK|XC';
series_years['Barina_2009'] = 'TK|XC';
series_years['Barina_2010'] = 'TK|XC';
series_years['Barina_2011'] = 'TK|TM|XC';
series_years['Barina_1989'] = 'MF/MH|ML';
series_years['Barina_1990'] = 'MF/MH';
series_years['Barina_1991'] = 'MF/MH';
series_years['Barina_1992'] = 'MF/MH';
series_years['Barina_1993'] = 'MF/MH';
series_years['Barina_1994'] = 'MF/MH|SB';
series_years['Barina_1995'] = 'MF/MH|SB';
series_years['Barina_1996'] = 'MF/MH|SB';
series_years['Barina_1997'] = 'MF/MH|SB';
series_years['Barina_1998'] = 'MF/MH|SB';
series_years['Barina_1999'] = 'MF/MH|SB';
series_years['Barina_2017'] = 'TM';
series_years['Barina_2018'] = 'TM';
series_years['Barina_2000'] = 'SB';
series_years['Barina_1987'] = 'ML';
series_years['Barina_1988'] = 'ML';
series_years['Barina Spark _2013'] = 'MJ';
series_years['Barina Spark _2014'] = 'MJ';
series_years['Barina Spark _2015'] = 'MJ';
series_years['Barina Spark _2010'] = 'MJ';
series_years['Barina Spark _2011'] = 'MJ';
series_years['Barina Spark _2012'] = 'MJ';
series_years['Berlina_2006'] = 'VE|VZ';
series_years['Berlina_2007'] = 'VE|VZ';
series_years['Berlina_2010'] = 'VE|VE II';
series_years['Berlina_2011'] = 'VE II';
series_years['Berlina_2012'] = 'VE II';
series_years['Berlina_2013'] = 'VE II';
series_years['Berlina_2002'] = 'VY';
series_years['Berlina_2003'] = 'VY|VY II';
series_years['Berlina_2004'] = 'VY II|VZ';
series_years['Berlina_2008'] = 'VE';
series_years['Berlina_2009'] = 'VE';
series_years['Berlina_2005'] = 'VZ';
series_years['Calais_2006'] = 'VE|VZ';
series_years['Calais_2007'] = 'VE';
series_years['Calais_2008'] = 'VE';
series_years['Calais_2009'] = 'VE';
series_years['Calais_2010'] = 'VE|VE II';
series_years['Calais_2011'] = 'VE II';
series_years['Calais_2012'] = 'VE II';
series_years['Calais_2013'] = 'VE II';
series_years['Calais_2004'] = 'VY II|VZ';
series_years['Calais_2005'] = 'VZ';
series_years['Calais_2002'] = 'VY';
series_years['Calais_2003'] = 'VY|VY II';
series_years['Calibra_1991'] = 'YE';
series_years['Calibra_1992'] = 'YE';
series_years['Calibra_1993'] = 'YE';
series_years['Calibra_1994'] = 'YE';
series_years['Calibra_1995'] = 'YE';
series_years['Calibra_1996'] = 'YE';
series_years['Calibra_1997'] = 'YE';
series_years['Camira_1984'] = 'JD/JE';
series_years['Camira_1985'] = 'JD/JE';
series_years['Camira_1986'] = 'JD/JE';
series_years['Camira_1987'] = 'JD/JE';
series_years['Camira_1988'] = 'JD/JE';
series_years['Camira_1989'] = 'JD/JE';
series_years['Captiva_2008'] = 'CG';
series_years['Captiva_2009'] = 'CG';
series_years['Captiva_2007'] = 'CG';
series_years['Captiva_2006'] = 'CG';
series_years['Captiva_2013'] = 'CG II';
series_years['Captiva_2014'] = 'CG II';
series_years['Captiva_2015'] = 'CG II';
series_years['Captiva_2010'] = 'CG';
series_years['Captiva_2011'] = 'CG|CG II';
series_years['Captiva_2012'] = 'CG II';
series_years['Captiva_2016'] = 'CG II';
series_years['Captiva_2017'] = 'CG II';
series_years['Captiva_2018'] = 'CG II';
series_years['Captiva 7_2011'] = 'CG|CG II';
series_years['Captiva 7_2012'] = 'CG II';
series_years['Captiva 7_2013'] = 'CG II';
series_years['Captiva 7_2007'] = 'CG';
series_years['Captiva 7_2008'] = 'CG';
series_years['Captiva 7_2009'] = 'CG';
series_years['Captiva 7_2010'] = 'CG';
series_years['Captiva 7_2006'] = 'CG';
series_years['Captiva 7_2014'] = 'CG II';
series_years['Captiva 7_2015'] = 'CG II';
series_years['Captiva 7_2016'] = 'CG II';
series_years['Captiva 7_2017'] = 'CG II';
series_years['Captiva 7_2018'] = 'CG II';
series_years['Cascada_2015'] = 'CJ';
series_years['Cascada_2016'] = 'CJ';
series_years['Cascada_2017'] = 'CJ';
series_years['Colorado_2008'] = 'RC';
series_years['Colorado_2009'] = 'RC';
series_years['Colorado_2010'] = 'RC';
series_years['Colorado_2016'] = 'RG';
series_years['Colorado_2017'] = 'RG';
series_years['Colorado_2018'] = 'RG';
series_years['Colorado_2019'] = 'RG';
series_years['Colorado_2020'] = 'RG';
series_years['Colorado_2021'] = 'RG';
series_years['Colorado_2022'] = 'RG';
series_years['Colorado_2023'] = 'RG';
series_years['Colorado_2024'] = 'RG';
series_years['Colorado_2025'] = 'RG';
series_years['Colorado_2011'] = 'RC';
series_years['Colorado_2012'] = 'RC|RG';
series_years['Colorado_2015'] = 'RG';
series_years['Colorado_2013'] = 'RG';
series_years['Colorado_2014'] = 'RG';
series_years['Colorado 7_2012'] = 'RG';
series_years['Colorado 7_2013'] = 'RG';
series_years['Colorado 7_2014'] = 'RG';
series_years['Colorado 7_2015'] = 'RG';
series_years['Colorado 7_2016'] = 'RG';
series_years['Commodore_2008'] = 'VE';
series_years['Commodore_2009'] = 'VE';
series_years['Commodore_1979'] = 'VB/VC';
series_years['Commodore_1980'] = 'VB/VC';
series_years['Commodore_1981'] = 'VB/VC|VH/VK';
series_years['Commodore_1993'] = 'VN|VP|VR/VS';
series_years['Commodore_1994'] = 'VN|VR/VS';
series_years['Commodore_1995'] = 'VN|VR/VS';
series_years['Commodore_1996'] = 'VN|VR/VS';
series_years['Commodore_1997'] = 'VN|VR/VS|VT';
series_years['Commodore_1991'] = 'VN|VP';
series_years['Commodore_1992'] = 'VN|VP';
series_years['Commodore_2004'] = 'VY II|VZ';
series_years['Commodore_2005'] = 'VZ';
series_years['Commodore_2006'] = 'VE|VZ';
series_years['Commodore_2003'] = 'VY|VY II';
series_years['Commodore_2000'] = 'VT|VU/VX';
series_years['Commodore_2001'] = 'VU/VX';
series_years['Commodore_2002'] = 'VU/VX|VY';
series_years['Commodore_1986'] = 'VH/VK|VL|VN';
series_years['Commodore_1987'] = 'VL|VN';
series_years['Commodore_1988'] = 'VL|VN';
series_years['Commodore_1989'] = 'VN';
series_years['Commodore_1990'] = 'VN';
series_years['Commodore_2015'] = 'VF|VF II';
series_years['Commodore_2016'] = 'VF II';
series_years['Commodore_2017'] = 'VF II|ZB';
series_years['Commodore_2014'] = 'VF';
series_years['Commodore_2010'] = 'VE|VE II';
series_years['Commodore_2011'] = 'VE|VE II';
series_years['Commodore_2012'] = 'VE|VE II';
series_years['Commodore_2013'] = 'VE|VE II|VF';
series_years['Commodore_2007'] = 'VE';
series_years['Commodore_1982'] = 'VH/VK';
series_years['Commodore_1983'] = 'VH/VK';
series_years['Commodore_1984'] = 'VH/VK';
series_years['Commodore_1985'] = 'VH/VK';
series_years['Commodore_2018'] = 'ZB';
series_years['Commodore_2019'] = 'ZB';
series_years['Commodore_2020'] = 'ZB';
series_years['Commodore_2021'] = 'ZB';
series_years['Commodore_2022'] = 'ZB';
series_years['Commodore_2023'] = 'ZB';
series_years['Commodore_2024'] = 'ZB';
series_years['Commodore_2025'] = 'ZB';
series_years['Commodore_1998'] = 'VT';
series_years['Commodore_1999'] = 'VT';
series_years['Crewman_2005'] = 'VZ';
series_years['Crewman_2006'] = 'VZ';
series_years['Crewman_2007'] = 'VZ';
series_years['Crewman_2003'] = 'VY II';
series_years['Crewman_2004'] = 'VY II|VZ';
series_years['Cruze_2009'] = 'JG';
series_years['Cruze_2010'] = 'JG';
series_years['Cruze_2011'] = 'JG|JH|JH II';
series_years['Cruze_2012'] = 'JH|JH II';
series_years['Cruze_2013'] = 'JH|JH II';
series_years['Cruze_2014'] = 'JH|JH II';
series_years['Cruze_2015'] = 'JH|JH II';
series_years['Cruze_2016'] = 'JH II';
series_years['Cruze_2002'] = 'YG';
series_years['Cruze_2003'] = 'YG';
series_years['Cruze_2004'] = 'YG';
series_years['Cruze_2005'] = 'YG';
series_years['Cruze_2006'] = 'YG';
series_years['EJ/EH_1962'] = 'EJ/EH';
series_years['EJ/EH_1963'] = 'EJ/EH';
series_years['EJ/EH_1964'] = 'EJ/EH';
series_years['EJ/EH_1965'] = 'EJ/EH';
series_years['Epica_2007'] = 'EP';
series_years['Epica_2008'] = 'EP';
series_years['Epica_2009'] = 'EP';
series_years['Epica_2010'] = 'EP';
series_years['Epica_2011'] = 'EP';
series_years['Equinox_2018'] = 'EQ';
series_years['Equinox_2019'] = 'EQ';
series_years['Equinox_2020'] = 'EQ';
series_years['Equinox_2021'] = 'EQ';
series_years['Equinox_2022'] = 'EQ';
series_years['Equinox_2023'] = 'EQ';
series_years['Equinox_2024'] = 'EQ';
series_years['Equinox_2025'] = 'EQ';
series_years['Equinox_2017'] = 'EQ';
series_years['Frontera_1999'] = 'MX';
series_years['Frontera_2000'] = 'MX';
series_years['Frontera_2001'] = 'MX';
series_years['Frontera_2002'] = 'MX';
series_years['Frontera_2003'] = 'MX';
series_years['Frontera_1995'] = 'UT';
series_years['Frontera_1996'] = 'UT';
series_years['Frontera_1997'] = 'UT';
series_years['Frontera_1998'] = 'UT';
series_years['Gemini_1975'] = 'TX/TC/TD';
series_years['Gemini_1976'] = 'TX/TC/TD';
series_years['Gemini_1977'] = 'TX/TC/TD';
series_years['Gemini_1978'] = 'TX/TC/TD';
series_years['Gemini_1979'] = 'TE |TX/TC/TD';
series_years['Gemini_1982'] = 'TE |TF/TG';
series_years['Gemini_1983'] = 'TF/TG';
series_years['Gemini_1984'] = 'TF/TG';
series_years['Gemini_1985'] = 'TF/TG';
series_years['Gemini_1980'] = 'TE ';
series_years['Gemini_1981'] = 'TE ';
series_years['HD / HR_1966'] = 'HD/HR';
series_years['HD / HR_1967'] = 'HD/HR';
series_years['HK / HG / HT_1968'] = 'HK/HG/HT';
series_years['HK / HG / HT_1969'] = 'HK/HG/HT';
series_years['HK / HG / HT_1970'] = 'HK/HG/HT';
series_years['HK / HG / HT_1971'] = 'HK/HG/HT';
series_years['HQ / HJ / HX / HZ_1971'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1972'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1973'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1974'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1975'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1976'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1977'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1978'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1979'] = 'HQ/HJ/HX/HZ/WB';
series_years['HQ / HJ / HX / HZ_1980'] = 'HQ/HJ/HX/HZ/WB';
series_years['Insignia_2015'] = 'GA';
series_years['Insignia_2016'] = 'GA';
series_years['Jackaroo_1998'] = 'L2/L5|U8';
series_years['Jackaroo_1999'] = 'U8';
series_years['Jackaroo_2000'] = 'U8';
series_years['Jackaroo_2001'] = 'U8';
series_years['Jackaroo_2002'] = 'U8';
series_years['Jackaroo_2003'] = 'U8';
series_years['Jackaroo_1992'] = 'JACKAROO|L2/L5';
series_years['Jackaroo_1993'] = 'L2/L5';
series_years['Jackaroo_1994'] = 'L2/L5';
series_years['Jackaroo_1995'] = 'L2/L5';
series_years['Jackaroo_1996'] = 'L2/L5';
series_years['Jackaroo_1997'] = 'L2/L5';
series_years['Jackaroo_1981'] = 'JACKAROO';
series_years['Jackaroo_1982'] = 'JACKAROO';
series_years['Jackaroo_1983'] = 'JACKAROO';
series_years['Jackaroo_1984'] = 'JACKAROO';
series_years['Jackaroo_1985'] = 'JACKAROO';
series_years['Jackaroo_1986'] = 'JACKAROO';
series_years['Jackaroo_1987'] = 'JACKAROO';
series_years['Jackaroo_1988'] = 'JACKAROO';
series_years['Jackaroo_1989'] = 'JACKAROO';
series_years['Jackaroo_1990'] = 'JACKAROO';
series_years['Jackaroo_1991'] = 'JACKAROO';
series_years['Malibu_2013'] = 'EM';
series_years['Malibu_2014'] = 'EM';
series_years['Malibu_2015'] = 'EM';
series_years['Malibu_2016'] = 'EM';
series_years['Monaro_2001'] = 'V2/VZ';
series_years['Monaro_2002'] = 'V2/VZ';
series_years['Monaro_2003'] = 'V2/VZ';
series_years['Monaro_2004'] = 'V2/VZ';
series_years['Monaro_2005'] = 'V2/VZ';
series_years['Nova_1994'] = 'LE/LF|LG';
series_years['Nova_1995'] = 'LG';
series_years['Nova_1996'] = 'LG';
series_years['Nova_1989'] = 'LE/LF';
series_years['Nova_1990'] = 'LE/LF';
series_years['Nova_1991'] = 'LE/LF';
series_years['Nova_1992'] = 'LE/LF';
series_years['Nova_1993'] = 'LE/LF';
series_years['Rodeo_2003'] = 'RA|TF';
series_years['Rodeo_2004'] = 'RA';
series_years['Rodeo_2005'] = 'RA';
series_years['Rodeo_2006'] = 'RA';
series_years['Rodeo_2007'] = 'RA';
series_years['Rodeo_2008'] = 'RA';
series_years['Rodeo_1997'] = 'TF';
series_years['Rodeo_1998'] = 'TF';
series_years['Rodeo_1999'] = 'TF';
series_years['Rodeo_2000'] = 'TF';
series_years['Rodeo_2001'] = 'TF';
series_years['Rodeo_2002'] = 'TF';
series_years['Rodeo_1993'] = 'TF';
series_years['Rodeo_1994'] = 'TF';
series_years['Rodeo_1995'] = 'TF';
series_years['Rodeo_1996'] = 'TF';
series_years['Rodeo_1981'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1982'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1983'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1984'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1985'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1986'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1987'] = 'KB26/KB28/KB41/KB42/KB48';
series_years['Rodeo_1988'] = 'KB26/KB28/KB41/KB42/KB48|TF';
series_years['Rodeo_1989'] = 'TF';
series_years['Rodeo_1990'] = 'TF';
series_years['Rodeo_1991'] = 'TF';
series_years['Rodeo_1992'] = 'TF';
series_years['Shuttle_1982'] = 'SHUTTLE';
series_years['Shuttle_1983'] = 'SHUTTLE';
series_years['Shuttle_1984'] = 'SHUTTLE';
series_years['Shuttle_1985'] = 'SHUTTLE';
series_years['Shuttle_1986'] = 'SHUTTLE';
series_years['Shuttle_1987'] = 'SHUTTLE';
series_years['Shuttle_1988'] = 'SHUTTLE';
series_years['Shuttle_1989'] = 'SHUTTLE';
series_years['Shuttle_1990'] = 'SHUTTLE';
series_years['Shuttle_1991'] = 'SHUTTLE';
series_years['Spark_2015'] = 'MP';
series_years['Spark_2016'] = 'MP';
series_years['Spark_2017'] = 'MP';
series_years['Spark_2018'] = 'MP';
series_years['Statesman/Caprice_2013'] = 'WM';
series_years['Statesman/Caprice_2014'] = 'WM';
series_years['Statesman/Caprice_2010'] = 'WM';
series_years['Statesman/Caprice_2011'] = 'WM';
series_years['Statesman/Caprice_2012'] = 'WM';
series_years['Statesman/Caprice_1999'] = 'VR/VS|WH';
series_years['Statesman/Caprice_2000'] = 'WH';
series_years['Statesman/Caprice_2001'] = 'WH';
series_years['Statesman/Caprice_2002'] = 'WH';
series_years['Statesman/Caprice_2003'] = 'WH|WK/WL';
series_years['Statesman/Caprice_1993'] = 'VQ|VR/VS';
series_years['Statesman/Caprice_1994'] = 'VQ|VR/VS';
series_years['Statesman/Caprice_1995'] = 'VR/VS';
series_years['Statesman/Caprice_1996'] = 'VR/VS';
series_years['Statesman/Caprice_1997'] = 'VR/VS';
series_years['Statesman/Caprice_1998'] = 'VR/VS';
series_years['Statesman/Caprice_2004'] = 'WK/WL';
series_years['Statesman/Caprice_2005'] = 'WK/WL';
series_years['Statesman/Caprice_2006'] = 'WK/WL|WM';
series_years['Statesman/Caprice_2007'] = 'WM';
series_years['Statesman/Caprice_2008'] = 'WM';
series_years['Statesman/Caprice_2009'] = 'WM';
series_years['Statesman/Caprice_1990'] = 'VQ';
series_years['Statesman/Caprice_1991'] = 'VQ';
series_years['Statesman/Caprice_1992'] = 'VQ';
series_years['Tigra_2005'] = 'XC';
series_years['Tigra_2006'] = 'XC';
series_years['Tigra_2007'] = 'XC';
series_years['Torana_1974'] = 'LC/LJ|TA/LH/LX/UC';
series_years['Torana_1975'] = 'TA/LH/LX/UC';
series_years['Torana_1976'] = 'TA/LH/LX/UC';
series_years['Torana_1977'] = 'TA/LH/LX/UC';
series_years['Torana_1978'] = 'TA/LH/LX/UC';
series_years['Torana_1979'] = 'TA/LH/LX/UC';
series_years['Torana_1969'] = 'LC/LJ';
series_years['Torana_1970'] = 'LC/LJ';
series_years['Torana_1971'] = 'LC/LJ';
series_years['Torana_1972'] = 'LC/LJ';
series_years['Torana_1973'] = 'LC/LJ';
series_years['Trailblazer_2017'] = 'RG';
series_years['Trailblazer_2018'] = 'RG';
series_years['Trailblazer_2019'] = 'RG';
series_years['Trailblazer_2020'] = 'RG';
series_years['Trailblazer_2021'] = 'RG';
series_years['Trailblazer_2022'] = 'RG';
series_years['Trailblazer_2023'] = 'RG';
series_years['Trailblazer_2024'] = 'RG';
series_years['Trailblazer_2025'] = 'RG';
series_years['Trailblazer_2016'] = 'RG';
series_years['Trax_2016'] = 'TJ';
series_years['Trax_2017'] = 'TJ';
series_years['Trax_2018'] = 'TJ';
series_years['Trax_2019'] = 'TJ';
series_years['Trax_2020'] = 'TJ';
series_years['Trax_2021'] = 'TJ';
series_years['Trax_2022'] = 'TJ';
series_years['Trax_2023'] = 'TJ';
series_years['Trax_2024'] = 'TJ';
series_years['Trax_2025'] = 'TJ';
series_years['Trax_2014'] = 'TJ';
series_years['Trax_2015'] = 'TJ';
series_years['Trax_2013'] = 'TJ';
series_years['Ute_2017'] = 'VF II';
series_years['Ute_2011'] = 'VE II';
series_years['Ute_2012'] = 'VE II';
series_years['Ute_2013'] = 'VE II|VF';
series_years['Ute_2008'] = 'VE';
series_years['Ute_2009'] = 'VE';
series_years['Ute_2010'] = 'VE|VE II';
series_years['Ute_2007'] = 'VE|VZ';
series_years['Ute_2015'] = 'VF|VF II';
series_years['Ute_2016'] = 'VF II';
series_years['Ute_2002'] = 'VY';
series_years['Ute_2003'] = 'VY|VY II';
series_years['Ute_2014'] = 'VF';
series_years['Ute_2005'] = 'VZ';
series_years['Ute_2006'] = 'VZ';
series_years['Ute_2004'] = 'VY II|VZ';
series_years['Vectra_1997'] = 'JR/JS/JSII';
series_years['Vectra_1998'] = 'JR/JS/JSII';
series_years['Vectra_1999'] = 'JR/JS/JSII';
series_years['Vectra_2000'] = 'JR/JS/JSII';
series_years['Vectra_2001'] = 'JR/JS/JSII';
series_years['Vectra_2002'] = 'JR/JS/JSII';
series_years['Vectra_2003'] = 'JR/JS/JSII|ZC';
series_years['Vectra_2004'] = 'ZC';
series_years['Vectra_2005'] = 'ZC';
series_years['Viva_2005'] = 'JF';
series_years['Viva_2006'] = 'JF';
series_years['Viva_2007'] = 'JF';
series_years['Viva_2008'] = 'JF';
series_years['Viva_2009'] = 'JF';
series_years['Zafira_2001'] = 'TT';
series_years['Zafira_2002'] = 'TT';
series_years['Zafira_2003'] = 'TT';
series_years['Zafira_2004'] = 'TT';
series_years['Zafira_2005'] = 'TT';
series_years['Accord_2015'] = '9th Gen';
series_years['Accord_2016'] = '9th Gen';
series_years['Accord_2006'] = '7th Gen';
series_years['Accord_2012'] = '8th Gen';
series_years['Accord_2013'] = '8th Gen|9th Gen';
series_years['Accord_2014'] = '9th Gen';
series_years['Accord_1997'] = 'CD|CG/CK';
series_years['Accord_1998'] = 'CG/CK';
series_years['Accord_1999'] = 'CG/CK';
series_years['Accord_2000'] = 'CG/CK';
series_years['Accord_2001'] = 'CG/CK';
series_years['Accord_2002'] = 'CG/CK';
series_years['Accord_2003'] = '7th Gen|CG/CK';
series_years['Accord_2004'] = '7th Gen';
series_years['Accord_2005'] = '7th Gen';
series_years['Accord_1993'] = 'CB|CD';
series_years['Accord_1994'] = 'CD';
series_years['Accord_1995'] = 'CD';
series_years['Accord_1996'] = 'CD';
series_years['Accord_2007'] = '7th Gen';
series_years['Accord_2008'] = '7th Gen|8th Gen';
series_years['Accord_2009'] = '8th Gen';
series_years['Accord_2010'] = '8th Gen';
series_years['Accord_2011'] = '8th Gen';
series_years['Accord_1989'] = 'CB';
series_years['Accord_1990'] = 'CB';
series_years['Accord_1991'] = 'CB';
series_years['Accord_1992'] = 'CB';
series_years['Accord_2017'] = '9th Gen';
series_years['Accord_2018'] = '9th Gen';
series_years['Accord_2019'] = '9th Gen';
series_years['Accord Euro_2008'] = '7th Gen|8th Gen';
series_years['Accord Euro_2009'] = '8th Gen';
series_years['Accord Euro_2006'] = '7th Gen';
series_years['Accord Euro_2007'] = '7th Gen';
series_years['Accord Euro_2011'] = '8th Gen';
series_years['Accord Euro_2012'] = '8th Gen';
series_years['Accord Euro_2013'] = '8th Gen';
series_years['Accord Euro_2014'] = '8th Gen';
series_years['Accord Euro_2015'] = '8th Gen';
series_years['Accord Euro_2005'] = '7th Gen';
series_years['Accord Euro_2003'] = '7th Gen';
series_years['Accord Euro_2004'] = '7th Gen';
series_years['Accord Euro_2010'] = '8th Gen';
series_years['City_2017'] = 'GM';
series_years['City_2018'] = 'GM';
series_years['City_2019'] = 'GM';
series_years['City_2020'] = 'GM';
series_years['City_2021'] = 'GM';
series_years['City_2022'] = 'GM';
series_years['City_2023'] = 'GM';
series_years['City_2024'] = 'GM';
series_years['City_2025'] = 'GM';
series_years['City_2014'] = 'GM';
series_years['City_2015'] = 'GM';
series_years['City_2016'] = 'GM';
series_years['City_2009'] = 'GM';
series_years['City_2010'] = 'GM';
series_years['City_2011'] = 'GM';
series_years['City_2012'] = 'GM';
series_years['City_2013'] = 'GM';
series_years['Civic_2012'] = '8th Gen|9th Gen';
series_years['Civic_2017'] = '10th Gen';
series_years['Civic_2018'] = '10th Gen';
series_years['Civic_2019'] = '10th Gen';
series_years['Civic_2020'] = '10th Gen';
series_years['Civic_2009'] = '8th Gen';
series_years['Civic_2010'] = '8th Gen';
series_years['Civic_2000'] = '7th Gen|EK';
series_years['Civic_2001'] = '7th Gen';
series_years['Civic_2002'] = '7th Gen';
series_years['Civic_2011'] = '8th Gen';
series_years['Civic_2003'] = '7th Gen';
series_years['Civic_2004'] = '7th Gen';
series_years['Civic_2005'] = '7th Gen';
series_years['Civic_2006'] = '7th Gen|8th Gen';
series_years['Civic_2013'] = '9th Gen';
series_years['Civic_2015'] = '9th Gen';
series_years['Civic_2016'] = '10th Gen|9th Gen';
series_years['Civic_2007'] = '8th Gen';
series_years['Civic_2008'] = '8th Gen';
series_years['Civic_2021'] = '10th Gen';
series_years['Civic_1987'] = 'ED';
series_years['Civic_1988'] = 'ED';
series_years['Civic_1989'] = 'ED';
series_years['Civic_1990'] = 'ED';
series_years['Civic_1991'] = 'ED|EG/EH';
series_years['Civic_2014'] = '9th Gen';
series_years['Civic_1992'] = 'EG/EH';
series_years['Civic_1993'] = 'EG/EH';
series_years['Civic_1994'] = 'EG/EH';
series_years['Civic_1995'] = 'EG/EH|EK';
series_years['Civic_1996'] = 'EK';
series_years['Civic_1997'] = 'EK';
series_years['Civic_1998'] = 'EK';
series_years['Civic_1999'] = 'EK';
series_years['CR-V_2015'] = 'RM|RM Series II';
series_years['CR-V_2014'] = 'RM|RM Series II';
series_years['CR-V_2022'] = 'RW';
series_years['CR-V_2023'] = 'RW';
series_years['CR-V_2012'] = 'RE|RM';
series_years['CR-V_2013'] = 'RM';
series_years['CR-V_2001'] = 'RD';
series_years['CR-V_2002'] = 'RD';
series_years['CR-V_2003'] = 'RD';
series_years['CR-V_2004'] = 'RD';
series_years['CR-V_2006'] = 'RD';
series_years['CR-V_2020'] = 'RW';
series_years['CR-V_2021'] = 'RW';
series_years['CR-V_2005'] = 'RD';
series_years['CR-V_2007'] = 'RD|RE';
series_years['CR-V_2016'] = 'RM|RM Series II';
series_years['CR-V_2017'] = 'RM|RM Series II|RW';
series_years['CR-V_2010'] = 'RE';
series_years['CR-V_2011'] = 'RE';
series_years['CR-V_2008'] = 'RE';
series_years['CR-V_2009'] = 'RE';
series_years['CR-V_2018'] = 'RW';
series_years['CR-V_2019'] = 'RW';
series_years['CR-V_1997'] = 'RD';
series_years['CR-V_1998'] = 'RD';
series_years['CR-V_1999'] = 'RD';
series_years['CR-V_2000'] = 'RD';
series_years['CRX_1987'] = 'ED';
series_years['CRX_1988'] = 'ED';
series_years['CRX_1989'] = 'ED';
series_years['CRX_1990'] = 'ED';
series_years['CRX_1991'] = 'ED';
series_years['CRX_1992'] = 'ED|EG';
series_years['CRX_1993'] = 'EG';
series_years['CRX_1994'] = 'EG';
series_years['CRX_1995'] = 'EG';
series_years['CRX_1996'] = 'EG';
series_years['CRX_1997'] = 'EG';
series_years['CRX_1998'] = 'EG';
series_years['CR-Z_2013'] = 'ZF';
series_years['CR-Z_2014'] = 'ZF';
series_years['CR-Z_2015'] = 'ZF';
series_years['CR-Z_2016'] = 'ZF';
series_years['CR-Z_2017'] = 'ZF';
series_years['CR-Z_2011'] = 'ZF';
series_years['CR-Z_2012'] = 'ZF';
series_years['HR-V_2020'] = 'RU';
series_years['HR-V_2021'] = 'RU';
series_years['HR-V_2022'] = 'RU|RV';
series_years['HR-V_2016'] = 'RU';
series_years['HR-V_2017'] = 'RU';
series_years['HR-V_2023'] = 'RV';
series_years['HR-V_2024'] = 'RV';
series_years['HR-V_2018'] = 'RU';
series_years['HR-V_2019'] = 'RU';
series_years['HR-V_2015'] = 'RU';
series_years['HR-V_1998'] = 'GH';
series_years['HR-V_1999'] = 'GH';
series_years['HR-V_2000'] = 'GH';
series_years['HR-V_2001'] = 'GH';
series_years['Insight_2010'] = 'ZE';
series_years['Insight_2011'] = 'ZE';
series_years['Insight_2012'] = 'ZE';
series_years['Insight_2013'] = 'ZE';
series_years['Insight_2014'] = 'ZE';
series_years['Integra_2001'] = 'DC|DC5';
series_years['Integra_2002'] = 'DC5';
series_years['Integra_2003'] = 'DC5';
series_years['Integra_2004'] = 'DC5';
series_years['Integra_2005'] = 'DC5';
series_years['Integra_2006'] = 'DC5';
series_years['Integra_2007'] = 'DC5';
series_years['Integra_1993'] = 'DC';
series_years['Integra_1994'] = 'DC';
series_years['Integra_1995'] = 'DC';
series_years['Integra_1996'] = 'DC';
series_years['Integra_1997'] = 'DC';
series_years['Integra_1998'] = 'DC';
series_years['Integra_1999'] = 'DC';
series_years['Integra_2000'] = 'DC';
series_years['Jazz_2016'] = 'GK';
series_years['Jazz_2017'] = 'GK';
series_years['Jazz_2011'] = 'GE';
series_years['Jazz_2012'] = 'GE';
series_years['Jazz_2013'] = 'GE';
series_years['Jazz_2014'] = 'GE|GK';
series_years['Jazz_2002'] = 'GD';
series_years['Jazz_2003'] = 'GD';
series_years['Jazz_2004'] = 'GD';
series_years['Jazz_2015'] = 'GE|GK';
series_years['Jazz_2018'] = 'GK';
series_years['Jazz_2008'] = 'GD|GE';
series_years['Jazz_2009'] = 'GE';
series_years['Jazz_2010'] = 'GE';
series_years['Jazz_2020'] = 'GK';
series_years['Jazz_2021'] = 'GK';
series_years['Jazz_2005'] = 'GD';
series_years['Jazz_2006'] = 'GD';
series_years['Jazz_2007'] = 'GD';
series_years['Jazz_2019'] = 'GK';
series_years['Legend_2006'] = 'KB';
series_years['Legend_2007'] = 'KB';
series_years['Legend_2008'] = 'KB';
series_years['Legend_2009'] = 'KB';
series_years['Legend_2010'] = 'KB';
series_years['Legend_2011'] = 'KB';
series_years['Legend_2012'] = 'KB';
series_years['Legend_2013'] = 'KB';
series_years['Legend_1996'] = 'KA';
series_years['Legend_1997'] = 'KA';
series_years['Legend_1998'] = 'KA';
series_years['Legend_1999'] = 'KA';
series_years['Legend_2000'] = 'KA';
series_years['Legend_2001'] = 'KA';
series_years['Legend_2002'] = 'KA';
series_years['Legend_2003'] = 'KA';
series_years['Legend_2004'] = 'KA';
series_years['Legend_1986'] = 'KA2';
series_years['Legend_1987'] = 'KA2';
series_years['Legend_1988'] = 'KA2';
series_years['Legend_1989'] = 'KA2';
series_years['Legend_1990'] = 'KA2';
series_years['Legend_1991'] = 'KA2';
series_years['Mdx_2003'] = 'YD';
series_years['Mdx_2004'] = 'YD';
series_years['Mdx_2005'] = 'YD';
series_years['Mdx_2006'] = 'YD';
series_years['Odyssey_2017'] = '5th Gen';
series_years['Odyssey_2018'] = '5th Gen';
series_years['Odyssey_2019'] = '5th Gen';
series_years['Odyssey_2020'] = '5th Gen|RC';
series_years['Odyssey_2021'] = '5th Gen|RC';
series_years['Odyssey_2011'] = '4th Gen';
series_years['Odyssey_2012'] = '4th Gen';
series_years['Odyssey_2013'] = '4th Gen';
series_years['Odyssey_2014'] = '4th Gen|5th Gen';
series_years['Odyssey_1995'] = 'RA';
series_years['Odyssey_1996'] = 'RA';
series_years['Odyssey_1997'] = 'RA';
series_years['Odyssey_1998'] = 'RA';
series_years['Odyssey_1999'] = 'RA';
series_years['Odyssey_2000'] = 'RA';
series_years['Odyssey_2022'] = '5th Gen';
series_years['Odyssey_2015'] = '5th Gen';
series_years['Odyssey_2006'] = '3rd Gen';
series_years['Odyssey_2007'] = '3rd Gen';
series_years['Odyssey_2008'] = '3rd Gen';
series_years['Odyssey_2009'] = '3rd Gen|4th Gen';
series_years['Odyssey_2010'] = '4th Gen';
series_years['Odyssey_2016'] = '5th Gen';
series_years['Odyssey_2004'] = '3rd Gen|RA';
series_years['Odyssey_2005'] = '3rd Gen';
series_years['Odyssey_2001'] = 'RA';
series_years['Odyssey_2002'] = 'RA';
series_years['Odyssey_2003'] = 'RA';
series_years['Prelude_1991'] = 'BA';
series_years['Prelude_1992'] = 'BA';
series_years['Prelude_1993'] = 'BA';
series_years['Prelude_1994'] = 'BA';
series_years['Prelude_1995'] = 'BA';
series_years['Prelude_1996'] = 'BA';
series_years['Prelude_1997'] = 'BB';
series_years['Prelude_1998'] = 'BB';
series_years['Prelude_1999'] = 'BB';
series_years['Prelude_2000'] = 'BB';
series_years['Prelude_2001'] = 'BB';
series_years['S2000_2006'] = 'AP';
series_years['S2000_2007'] = 'AP';
series_years['S2000_2008'] = 'AP';
series_years['S2000_2009'] = 'AP';
series_years['S2000_2002'] = 'AP';
series_years['S2000_2003'] = 'AP';
series_years['S2000_2004'] = 'AP';
series_years['S2000_1999'] = 'AP';
series_years['S2000_2000'] = 'AP';
series_years['S2000_2001'] = 'AP';
series_years['S2000_2005'] = 'AP';
series_years['ZR-V_2023'] = 'RZ';
series_years['ZR-V_2024'] = 'RZ';
series_years['ZR-V_2025'] = 'RZ';
series_years['Accent_2000'] = 'LC';
series_years['Accent_2001'] = 'LC';
series_years['Accent_2002'] = 'LC';
series_years['Accent_2003'] = 'LC';
series_years['Accent_2017'] = 'RB';
series_years['Accent_2018'] = 'RB';
series_years['Accent_2019'] = 'RB';
series_years['Accent_2013'] = 'RB';
series_years['Accent_2014'] = 'RB';
series_years['Accent_2015'] = 'RB';
series_years['Accent_2016'] = 'RB';
series_years['Accent_2004'] = 'LC';
series_years['Accent_2005'] = 'LC';
series_years['Accent_2006'] = 'LC|MC';
series_years['Accent_2011'] = 'RB';
series_years['Accent_2012'] = 'RB';
series_years['Accent_2007'] = 'MC';
series_years['Accent_2008'] = 'MC';
series_years['Accent_2009'] = 'MC';
series_years['Elantra_2014'] = 'MD';
series_years['Elantra_2015'] = 'AD|MD';
series_years['Elantra_2018'] = 'AD|AD II';
series_years['Elantra_2019'] = 'AD II';
series_years['Elantra_2020'] = 'AD II';
series_years['Elantra_2021'] = 'AD II';
series_years['Elantra_2022'] = 'AD II';
series_years['Elantra_2023'] = 'AD II';
series_years['Elantra_2024'] = 'AD II';
series_years['Elantra_2025'] = 'AD II';
series_years['Elantra_2013'] = 'MD';
series_years['Elantra_2016'] = 'AD';
series_years['Elantra_2017'] = 'AD';
series_years['Elantra_2003'] = 'FC|XD';
series_years['Elantra_2004'] = 'XD';
series_years['Elantra_2005'] = 'XD';
series_years['Elantra_2006'] = 'HD|XD';
series_years['Elantra_2001'] = 'FC|XD';
series_years['Elantra_2002'] = 'FC|XD';
series_years['Elantra_2011'] = 'HD|MD';
series_years['Elantra_2012'] = 'MD';
series_years['Elantra_2007'] = 'HD';
series_years['Elantra_2008'] = 'HD';
series_years['Elantra_2009'] = 'HD';
series_years['Elantra_2010'] = 'HD';
series_years['Elantra_2000'] = 'XD';
series_years['Excel_1986'] = 'X1';
series_years['Excel_1987'] = 'X1';
series_years['Excel_1988'] = 'X1';
series_years['Excel_1989'] = 'X1|X2';
series_years['Excel_1990'] = 'X2';
series_years['Excel_1991'] = 'X2';
series_years['Excel_1994'] = 'X2|X3';
series_years['Excel_1995'] = 'X3';
series_years['Excel_1996'] = 'X3';
series_years['Excel_1997'] = 'X3';
series_years['Excel_1998'] = 'X3';
series_years['Excel_1999'] = 'X3';
series_years['Excel_2000'] = 'X3';
series_years['Excel_1992'] = 'X2';
series_years['Excel_1993'] = 'X2';
series_years['FX coupe_1996'] = 'RD';
series_years['FX coupe_1997'] = 'RD';
series_years['FX coupe_1998'] = 'RD';
series_years['FX coupe_1999'] = 'RD';
series_years['FX coupe_2000'] = 'RD';
series_years['FX coupe_2001'] = 'RD';
series_years['FX coupe_2002'] = 'RD';
series_years['Genesis_2014'] = 'DH';
series_years['Genesis_2015'] = 'DH';
series_years['Genesis_2016'] = 'DH';
series_years['Genesis_2017'] = 'DH';
series_years['Getz_2005'] = 'TB';
series_years['Getz_2006'] = 'TB';
series_years['Getz_2007'] = 'TB';
series_years['Getz_2008'] = 'TB';
series_years['Getz_2009'] = 'TB';
series_years['Getz_2010'] = 'TB';
series_years['Getz_2011'] = 'TB';
series_years['Getz_2002'] = 'TB';
series_years['Getz_2003'] = 'TB';
series_years['Getz_2004'] = 'TB';
series_years['Grandeur_2005'] = 'TG|XG';
series_years['Grandeur_2006'] = 'TG';
series_years['Grandeur_2007'] = 'TG';
series_years['Grandeur_2008'] = 'TG';
series_years['Grandeur_2009'] = 'TG';
series_years['Grandeur_2010'] = 'TG';
series_years['Grandeur_2011'] = 'TG';
series_years['Grandeur_1999'] = 'XG';
series_years['Grandeur_2000'] = 'XG';
series_years['Grandeur_2001'] = 'XG';
series_years['Grandeur_2002'] = 'XG';
series_years['Grandeur_2003'] = 'XG';
series_years['Grandeur_2004'] = 'XG';
series_years['i20_2010'] = 'PB';
series_years['i20_2011'] = 'PB';
series_years['i20_2012'] = 'PB';
series_years['i20_2013'] = 'PB';
series_years['i20_2014'] = 'PB';
series_years['i20_2015'] = 'PB';
series_years['i20_2021'] = 'BC3';
series_years['i20_2022'] = 'BC3';
series_years['i20_2023'] = 'BC3';
series_years['i20_2024'] = 'BC3';
series_years['i20_2025'] = 'BC3';
series_years['i30_2020'] = 'CN7.V1|PD';
series_years['i30_2021'] = 'CN7.V1|PD';
series_years['i30_2022'] = 'CN7|CN7.V1|PD';
series_years['i30_2017'] = 'GD|GD II|PD';
series_years['i30_2018'] = 'PD';
series_years['i30_2019'] = 'PD';
series_years['i30_2023'] = 'CN7|CN7.V1|PD';
series_years['i30_2024'] = 'CN7|PD';
series_years['i30_2025'] = 'CN7|PD';
series_years['i30_2008'] = 'FD';
series_years['i30_2009'] = 'FD';
series_years['i30_2010'] = 'FD';
series_years['i30_2011'] = 'FD';
series_years['i30_2012'] = 'FD|GD';
series_years['i30_2014'] = 'GD|GD II';
series_years['i30_2015'] = 'GD|GD II';
series_years['i30_2013'] = 'GD';
series_years['i30_2016'] = 'GD|GD II';
series_years['i30_2007'] = 'FD';
series_years['i40_2015'] = 'VF';
series_years['i40_2016'] = 'VF';
series_years['i40_2017'] = 'VF';
series_years['i40_2018'] = 'VF';
series_years['i40_2011'] = 'VF';
series_years['i40_2012'] = 'VF';
series_years['i40_2013'] = 'VF';
series_years['i40_2014'] = 'VF';
series_years['i45_2010'] = 'YF';
series_years['i45_2011'] = 'YF';
series_years['i45_2012'] = 'YF';
series_years['i45_2013'] = 'YF';
series_years['iLoad_2016'] = 'TQ-V';
series_years['iLoad_2017'] = 'TQ-V';
series_years['iLoad_2018'] = 'TQ-V';
series_years['iLoad_2015'] = 'TQ-V';
series_years['iLoad_2008'] = 'TQ-V';
series_years['iLoad_2009'] = 'TQ-V';
series_years['iLoad_2010'] = 'TQ-V';
series_years['iLoad_2011'] = 'TQ-V';
series_years['iLoad_2012'] = 'TQ-V';
series_years['iLoad_2019'] = 'TQ-V';
series_years['iLoad_2020'] = 'TQ-V';
series_years['iLoad_2021'] = 'TQ-V';
series_years['iLoad_2013'] = 'TQ-V';
series_years['iLoad_2014'] = 'TQ-V';
series_years['iMax_2008'] = 'TQ-W';
series_years['iMax_2009'] = 'TQ-W';
series_years['iMax_2010'] = 'TQ-W';
series_years['iMax_2011'] = 'TQ-W';
series_years['iMax_2012'] = 'TQ-W';
series_years['iMax_2013'] = 'TQ-W';
series_years['iMax_2014'] = 'TQ-W';
series_years['iMax_2015'] = 'TQ-W';
series_years['iMax_2016'] = 'TQ-W';
series_years['iMax_2018'] = 'TQ-W';
series_years['iMax_2019'] = 'TQ-W';
series_years['iMax_2020'] = 'TQ-W';
series_years['iMax_2021'] = 'TQ-W';
series_years['iMax_2022'] = 'TQ-W';
series_years['iMax_2023'] = 'TQ-W';
series_years['iMax_2024'] = 'TQ-W';
series_years['iMax_2025'] = 'TQ-W';
series_years['iMax_2017'] = 'TQ-W';
series_years['IONIQ_2021'] = 'AE.V4';
series_years['IONIQ_2022'] = 'AE.V4';
series_years['IONIQ_2023'] = 'AE.V4';
series_years['IONIQ_2024'] = 'AE.V4';
series_years['ix35_2010'] = 'LM';
series_years['ix35_2011'] = 'LM';
series_years['ix35_2012'] = 'LM';
series_years['ix35_2013'] = 'LM';
series_years['ix35_2014'] = 'LM';
series_years['ix35_2015'] = 'LM';
series_years['Kona_2020'] = 'OS';
series_years['Kona_2021'] = 'OS';
series_years['Kona_2022'] = 'OS';
series_years['Kona_2023'] = 'OS';
series_years['Kona_2017'] = 'OS';
series_years['Kona_2018'] = 'OS';
series_years['Kona_2019'] = 'OS';
series_years['Lantra_1995'] = 'J1|J2/J3';
series_years['Lantra_1996'] = 'J2/J3';
series_years['Lantra_1997'] = 'J2/J3';
series_years['Lantra_1998'] = 'J2/J3';
series_years['Lantra_1999'] = 'J2/J3';
series_years['Lantra_2000'] = 'J2/J3';
series_years['Lantra_1993'] = 'J1';
series_years['Lantra_1994'] = 'J1';
series_years['Lantra_1991'] = 'J1';
series_years['Lantra_1992'] = 'J1';
series_years['Palisade_2020'] = 'LX';
series_years['Palisade_2021'] = 'LX|LX2.V2';
series_years['Palisade_2022'] = 'LX|LX2.V2|LX2.V3';
series_years['Palisade_2023'] = 'LX2.V3';
series_years['S coupe_1992'] = '1N|S Coupe';
series_years['S coupe_1993'] = '1N';
series_years['S coupe_1994'] = '1N';
series_years['S coupe_1995'] = '1N';
series_years['S coupe_1990'] = 'S Coupe';
series_years['S coupe_1991'] = 'S Coupe';
series_years['Santa Fe_2018'] = 'DM|TM';
series_years['Santa Fe_2019'] = 'TM';
series_years['Santa Fe_2020'] = 'TM';
series_years['Santa Fe_2015'] = 'DM';
series_years['Santa Fe_2016'] = 'DM';
series_years['Santa Fe_2017'] = 'DM';
series_years['Santa Fe_2021'] = 'TM';
series_years['Santa Fe_2022'] = 'TM';
series_years['Santa Fe_2023'] = 'TM';
series_years['Santa Fe_2024'] = 'TM';
series_years['Santa Fe_2012'] = 'CM|DM';
series_years['Santa Fe_2013'] = 'DM';
series_years['Santa Fe_2014'] = 'DM';
series_years['Santa Fe_2009'] = 'CM';
series_years['Santa Fe_2010'] = 'CM';
series_years['Santa Fe_2011'] = 'CM';
series_years['Santa Fe_2000'] = 'SM';
series_years['Santa Fe_2001'] = 'SM';
series_years['Santa Fe_2002'] = 'SM';
series_years['Santa Fe_2003'] = 'SM';
series_years['Santa Fe_2004'] = 'SM';
series_years['Santa Fe_2005'] = 'SM';
series_years['Santa Fe_2006'] = 'CM|SM';
series_years['Santa Fe_2007'] = 'CM';
series_years['Santa Fe_2008'] = 'CM';
series_years['Sonata_2005'] = 'EF-B|NF';
series_years['Sonata_2006'] = 'NF';
series_years['Sonata_2007'] = 'NF';
series_years['Sonata_2008'] = 'NF';
series_years['Sonata_2009'] = 'NF';
series_years['Sonata_2010'] = 'NF';
series_years['Sonata_2015'] = 'LF';
series_years['Sonata_2016'] = 'LF';
series_years['Sonata_2017'] = 'LF';
series_years['Sonata_2020'] = 'DN8|LF';
series_years['Sonata_2021'] = 'DN8|LF';
series_years['Sonata_2022'] = 'DN8|LF';
series_years['Sonata_2023'] = 'DN8|LF';
series_years['Sonata_2024'] = 'DN8|LF';
series_years['Sonata_2025'] = 'DN8|LF';
series_years['Sonata_1996'] = 'Y3';
series_years['Sonata_1997'] = 'Y3';
series_years['Sonata_1998'] = 'EF|Y3';
series_years['Sonata_1993'] = 'SONATA|Y3';
series_years['Sonata_1994'] = 'Y3';
series_years['Sonata_1995'] = 'Y3';
series_years['Sonata_1989'] = 'SONATA';
series_years['Sonata_1990'] = 'SONATA';
series_years['Sonata_1991'] = 'SONATA';
series_years['Sonata_2001'] = 'EF|EF-B';
series_years['Sonata_2002'] = 'EF-B';
series_years['Sonata_2003'] = 'EF-B';
series_years['Sonata_2004'] = 'EF-B';
series_years['Sonata_1992'] = 'SONATA';
series_years['Sonata_2018'] = 'LF';
series_years['Sonata_2019'] = 'LF';
series_years['Sonata_1999'] = 'EF';
series_years['Sonata_2000'] = 'EF';
series_years['Staria_2021'] = 'US4.V1';
series_years['Staria_2022'] = 'US4.V1';
series_years['Staria_2023'] = 'US4.V1';
series_years['Staria_2024'] = 'US4.V1';
series_years['Staria Load_2021'] = 'US4';
series_years['Staria Load_2022'] = 'US4';
series_years['Staria Load_2023'] = 'US4';
series_years['Staria Load_2024'] = 'US4';
series_years['Terracan_2001'] = 'HP';
series_years['Terracan_2002'] = 'HP';
series_years['Terracan_2003'] = 'HP';
series_years['Terracan_2004'] = 'HP';
series_years['Terracan_2005'] = 'HP';
series_years['Terracan_2006'] = 'HP';
series_years['Tiburon_2001'] = 'GK';
series_years['Tiburon_2002'] = 'GK';
series_years['Tiburon_2003'] = 'GK';
series_years['Tiburon_2004'] = 'GK';
series_years['Tiburon_2005'] = 'GK';
series_years['Tiburon_2006'] = 'GK';
series_years['Tiburon_2007'] = 'GK';
series_years['Tiburon_2008'] = 'GK';
series_years['Tiburon_2009'] = 'GK';
series_years['Tiburon_2010'] = 'GK';
series_years['Trajet_2000'] = 'FO';
series_years['Trajet_2001'] = 'FO';
series_years['Trajet_2002'] = 'FO';
series_years['Trajet_2003'] = 'FO';
series_years['Trajet_2004'] = 'FO';
series_years['Trajet_2005'] = 'FO';
series_years['Trajet_2006'] = 'FO';
series_years['Trajet_2007'] = 'FO';
series_years['Tucson_2015'] = 'TL';
series_years['Tucson_2016'] = 'TL';
series_years['Tucson_2017'] = 'TL';
series_years['Tucson_2018'] = 'TL';
series_years['Tucson_2021'] = 'NX4';
series_years['Tucson_2022'] = 'NX4';
series_years['Tucson_2023'] = 'NX4';
series_years['Tucson_2024'] = 'NX4';
series_years['Tucson_2025'] = 'NX4';
series_years['Tucson_2004'] = 'JM';
series_years['Tucson_2005'] = 'JM';
series_years['Tucson_2006'] = 'JM';
series_years['Tucson_2007'] = 'JM';
series_years['Tucson_2008'] = 'JM';
series_years['Tucson_2009'] = 'JM';
series_years['Tucson_2010'] = 'JM';
series_years['Tucson_2019'] = 'TL';
series_years['Tucson_2020'] = 'TL';
series_years['Veloster_2019'] = 'JS';
series_years['Veloster_2020'] = 'JS';
series_years['Veloster_2021'] = 'JS';
series_years['Veloster_2022'] = 'JS';
series_years['Veloster_2023'] = 'JS';
series_years['Veloster_2024'] = 'JS';
series_years['Veloster_2025'] = 'JS';
series_years['Veloster_2011'] = 'FS';
series_years['Veloster_2012'] = 'FS';
series_years['Veloster_2013'] = 'FS';
series_years['Veloster_2014'] = 'FS';
series_years['Veloster_2015'] = 'FS';
series_years['Veloster_2016'] = 'FS';
series_years['Veloster_2017'] = 'FS';
series_years['Venue_2019'] = 'QX';
series_years['Venue_2020'] = 'QX';
series_years['Venue_2021'] = 'QX';
series_years['Venue_2022'] = 'QX';
series_years['Venue_2023'] = 'QX';
series_years['Venue_2024'] = 'QX';
series_years['Venue_2025'] = 'QX';
series_years['Plant / Equipment_1960'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1961'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1962'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1963'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1964'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1965'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1966'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1967'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1968'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1969'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1970'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1971'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1972'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1973'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1974'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1975'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1976'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1977'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1978'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1979'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1980'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1981'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1982'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1983'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1984'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1985'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1986'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1987'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1988'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1989'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1990'] = 'KUBOTA|PERKINS';
series_years['Plant / Equipment_1991'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1992'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1993'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1994'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1995'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1996'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1997'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1998'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_1999'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2000'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2001'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2002'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2003'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2004'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2005'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2006'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2007'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2008'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2009'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2010'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2011'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2012'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2013'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2014'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2015'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2016'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2017'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2018'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2019'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2020'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2021'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2022'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2023'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2024'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['Plant / Equipment_2025'] = 'KOMATSU|KUBOTA|PERKINS';
series_years['D-Max_2009'] = 'D-Max';
series_years['D-Max_2010'] = 'D-Max';
series_years['D-Max_2017'] = '12DM|TFS';
series_years['D-Max_2018'] = '12DM|TFS';
series_years['D-Max_2019'] = '12DM|TFS';
series_years['D-Max_2020'] = '12DM|RG|TFS';
series_years['D-Max_2012'] = '12DM|D-Max|TFS';
series_years['D-Max_2013'] = '12DM|TFS';
series_years['D-Max_2014'] = '12DM|TFS';
series_years['D-Max_2015'] = '12DM|TFS';
series_years['D-Max_2016'] = '12DM|TFS';
series_years['D-Max_2021'] = 'RG';
series_years['D-Max_2022'] = 'RG';
series_years['D-Max_2023'] = 'RG';
series_years['D-Max_2024'] = 'RG';
series_years['D-Max_2025'] = 'RG';
series_years['D-Max_2011'] = 'D-Max';
series_years['D-Max_2008'] = 'D-Max';
series_years['F Series_1984'] = 'CXZ/CVR/EXR';
series_years['F Series_1985'] = 'CXZ/CVR/EXR';
series_years['F Series_1986'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1987'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1988'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1989'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1990'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1991'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1992'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1993'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1994'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1995'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1996'] = 'CXZ/CVR/EXR|FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1997'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1998'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_1999'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2000'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2001'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2002'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2003'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2004'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2005'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2006'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2007'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2008'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2009'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2010'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2011'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2012'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2013'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2014'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2015'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2016'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2017'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2018'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2019'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2020'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2021'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2022'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2023'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2024'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['F Series_2025'] = 'FSR/FTR/FVR/FTS/FTR/FSS';
series_years['N Series_2007'] = 'NKR/NPR/NPS|NLR|NNR|NPR|NPS|NQR';
series_years['N Series_2008'] = 'NLR|NNR|NPR|NPS|NQR';
series_years['N Series_2009'] = 'NLR|NNR|NPR|NPS|NQR';
series_years['N Series_2010'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2011'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2012'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2013'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2014'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2015'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_1985'] = 'NKR/NPR/NPS';
series_years['N Series_1986'] = 'NKR/NPR/NPS';
series_years['N Series_1987'] = 'NKR/NPR/NPS';
series_years['N Series_1988'] = 'NKR/NPR/NPS';
series_years['N Series_1989'] = 'NKR/NPR/NPS';
series_years['N Series_1990'] = 'NKR/NPR/NPS';
series_years['N Series_1991'] = 'NKR/NPR/NPS';
series_years['N Series_1992'] = 'NKR/NPR/NPS';
series_years['N Series_1993'] = 'NKR/NPR/NPS';
series_years['N Series_1994'] = 'NKR/NPR/NPS';
series_years['N Series_2016'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2017'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2018'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2019'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2020'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2021'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2022'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2023'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2024'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_2025'] = 'NLR|NLS|NNR|NPR|NPS|NQR';
series_years['N Series_1995'] = 'NKR/NPR/NPS';
series_years['N Series_1996'] = 'NKR/NPR/NPS';
series_years['N Series_1997'] = 'NKR/NPR/NPS';
series_years['N Series_1998'] = 'NKR/NPR/NPS';
series_years['N Series_1999'] = 'NKR/NPR/NPS';
series_years['N Series_2000'] = 'NKR/NPR/NPS';
series_years['N Series_2001'] = 'NKR/NPR/NPS';
series_years['N Series_2002'] = 'NKR/NPR/NPS';
series_years['N Series_2003'] = 'NKR/NPR/NPS';
series_years['N Series_2004'] = 'NKR/NPR/NPS';
series_years['N Series_2005'] = 'NKR/NPR/NPS';
series_years['N Series_2006'] = 'NKR/NPR/NPS';
series_years['D-Max_2009'] = 'D-Max';
series_years['D-Max_2010'] = 'D-Max';
series_years['D-Max_2017'] = '12DM|TFS';
series_years['D-Max_2018'] = '12DM|TFS';
series_years['D-Max_2019'] = '12DM|TFS';
series_years['D-Max_2020'] = '12DM|RG|TFS';
series_years['D-Max_2012'] = '12DM|D-Max|TFS';
series_years['D-Max_2013'] = '12DM|TFS';
series_years['D-Max_2014'] = '12DM|TFS';
series_years['D-Max_2015'] = '12DM|TFS';
series_years['D-Max_2016'] = '12DM|TFS';
series_years['D-Max_2021'] = 'RG';
series_years['D-Max_2022'] = 'RG';
series_years['D-Max_2023'] = 'RG';
series_years['D-Max_2024'] = 'RG';
series_years['D-Max_2025'] = 'RG';
series_years['D-Max_2011'] = 'D-Max';
series_years['D-Max_2008'] = 'D-Max';
series_years['MU-X_2017'] = 'Series 1|Series 2';
series_years['MU-X_2018'] = 'Series 2';
series_years['MU-X_2019'] = 'Series 2';
series_years['MU-X_2020'] = 'Series 2';
series_years['MU-X_2021'] = 'Series 2';
series_years['MU-X_2013'] = 'Series 1';
series_years['MU-X_2014'] = 'Series 1';
series_years['MU-X_2015'] = 'Series 1';
series_years['MU-X_2016'] = 'Series 1';
series_years['Daily_1990'] = 'Daily';
series_years['Daily_1991'] = 'Daily';
series_years['Daily_1992'] = 'Daily';
series_years['Daily_1993'] = 'Daily';
series_years['Daily_1994'] = 'Daily';
series_years['Daily_1995'] = 'Daily';
series_years['Daily_1996'] = 'Daily';
series_years['Daily_1997'] = 'Daily';
series_years['Daily_1998'] = 'Daily';
series_years['Daily_1999'] = 'Daily';
series_years['Daily_2000'] = 'Daily';
series_years['Daily_2001'] = 'Daily';
series_years['Daily_2002'] = 'Daily';
series_years['Daily_2003'] = 'Daily';
series_years['Daily_2004'] = 'Daily';
series_years['Daily_2005'] = 'Daily';
series_years['Daily_2006'] = 'Daily';
series_years['Daily_2007'] = 'Daily';
series_years['Daily_2008'] = 'Daily';
series_years['Daily_2009'] = 'Daily';
series_years['Daily_2010'] = 'Daily';
series_years['Daily_2011'] = 'Daily';
series_years['Daily_2012'] = 'Daily';
series_years['Daily_2013'] = 'Daily';
series_years['Daily_2014'] = 'Daily';
series_years['Daily_2015'] = 'Daily';
series_years['Daily_2016'] = 'Daily';
series_years['Daily_2017'] = 'Daily';
series_years['Daily_2018'] = 'Daily';
series_years['Daily_2019'] = 'Daily';
series_years['Daily_2020'] = 'Daily';
series_years['Daily_2021'] = 'Daily';
series_years['Daily_2022'] = 'Daily';
series_years['Daily_2023'] = 'Daily';
series_years['Daily_2024'] = 'Daily';
series_years['Daily_2025'] = 'Daily';
series_years['Eurocargo_2003'] = 'Eurocargo';
series_years['Eurocargo_2004'] = 'Eurocargo';
series_years['Eurocargo_2005'] = 'Eurocargo';
series_years['Eurocargo_2006'] = 'Eurocargo';
series_years['Eurocargo_2007'] = 'Eurocargo';
series_years['Eurocargo_2008'] = 'Eurocargo';
series_years['Eurocargo_2009'] = 'Eurocargo';
series_years['Eurocargo_2010'] = 'Eurocargo';
series_years['Eurocargo_2011'] = 'Eurocargo';
series_years['Eurocargo_2012'] = 'Eurocargo';
series_years['Eurocargo_2013'] = 'Eurocargo';
series_years['Eurocargo_2014'] = 'Eurocargo';
series_years['Eurocargo_2015'] = 'Eurocargo';
series_years['Eurocargo_2016'] = 'Eurocargo';
series_years['Eurocargo_2017'] = 'Eurocargo';
series_years['Eurocargo_2018'] = 'Eurocargo';
series_years['Eurocargo_2019'] = 'Eurocargo';
series_years['Eurocargo_2020'] = 'Eurocargo';
series_years['Eurocargo_2021'] = 'Eurocargo';
series_years['Eurocargo_2022'] = 'Eurocargo';
series_years['Eurocargo_2023'] = 'Eurocargo';
series_years['Eurocargo_2024'] = 'Eurocargo';
series_years['Eurocargo_2025'] = 'Eurocargo';
series_years['Stralis_2002'] = 'Stralis';
series_years['Stralis_2003'] = 'Stralis';
series_years['Stralis_2004'] = 'Stralis';
series_years['Stralis_2005'] = 'Stralis';
series_years['Stralis_2006'] = 'Stralis';
series_years['Stralis_2007'] = 'Stralis';
series_years['Stralis_2008'] = 'Stralis';
series_years['Stralis_2009'] = 'Stralis';
series_years['Stralis_2010'] = 'Stralis';
series_years['Stralis_2011'] = 'Stralis';
series_years['Stralis_2012'] = 'Stralis';
series_years['Stralis_2013'] = 'Stralis';
series_years['Stralis_2014'] = 'Stralis';
series_years['Stralis_2015'] = 'Stralis';
series_years['Stralis_2016'] = 'Stralis';
series_years['Stralis_2017'] = 'Stralis';
series_years['Stralis_2018'] = 'Stralis';
series_years['Stralis_2019'] = 'Stralis';
series_years['Stralis_2020'] = 'Stralis';
series_years['Stralis_2021'] = 'Stralis';
series_years['Stralis_2022'] = 'Stralis';
series_years['Stralis_2023'] = 'Stralis';
series_years['Stralis_2024'] = 'Stralis';
series_years['Stralis_2025'] = 'Stralis';
series_years['Cherokee_2015'] = 'KL';
series_years['Cherokee_2016'] = 'KL';
series_years['Cherokee_2001'] = 'KJ|XJ';
series_years['Cherokee_2002'] = 'KJ';
series_years['Cherokee_2003'] = 'KJ';
series_years['Cherokee_2004'] = 'KJ';
series_years['Cherokee_2011'] = 'KK';
series_years['Cherokee_2014'] = 'KL';
series_years['Cherokee_2017'] = 'KL';
series_years['Cherokee_2018'] = 'KL';
series_years['Cherokee_2005'] = 'KJ';
series_years['Cherokee_2006'] = 'KJ';
series_years['Cherokee_2007'] = 'KJ';
series_years['Cherokee_2008'] = 'KJ|KK';
series_years['Cherokee_2019'] = 'KL';
series_years['Cherokee_2020'] = 'KL';
series_years['Cherokee_2021'] = 'KL';
series_years['Cherokee_2022'] = 'KL';
series_years['Cherokee_2023'] = 'KL';
series_years['Cherokee_2024'] = 'KL';
series_years['Cherokee_2025'] = 'KL';
series_years['Cherokee_2009'] = 'KK';
series_years['Cherokee_2010'] = 'KK';
series_years['Cherokee_1994'] = 'XJ';
series_years['Cherokee_1995'] = 'XJ';
series_years['Cherokee_1996'] = 'XJ';
series_years['Cherokee_1997'] = 'XJ';
series_years['Cherokee_1998'] = 'XJ';
series_years['Cherokee_1999'] = 'XJ';
series_years['Cherokee_2000'] = 'XJ';
series_years['Cherokee_2012'] = 'KK';
series_years['Cherokee_2013'] = 'KK';
series_years['Commander_2006'] = 'XH';
series_years['Commander_2007'] = 'XH';
series_years['Commander_2008'] = 'XH';
series_years['Commander_2009'] = 'XH';
series_years['Commander_2010'] = 'XH';
series_years['Compass_2012'] = 'MK';
series_years['Compass_2017'] = 'BG';
series_years['Compass_2018'] = 'BG';
series_years['Compass_2019'] = 'BG';
series_years['Compass_2020'] = 'BG';
series_years['Compass_2014'] = 'MK';
series_years['Compass_2013'] = 'MK';
series_years['Compass_2015'] = 'MK';
series_years['Compass_2016'] = 'MK';
series_years['Compass_2007'] = 'MK';
series_years['Compass_2008'] = 'MK';
series_years['Compass_2009'] = 'MK';
series_years['Compass_2010'] = 'MK';
series_years['Gladiator_2020'] = 'JT';
series_years['Gladiator_2021'] = 'JT';
series_years['Gladiator_2022'] = 'JT';
series_years['Gladiator_2023'] = 'JT';
series_years['Gladiator_2024'] = 'JT';
series_years['Gladiator_2025'] = 'JT';
series_years['Grand cherokee_1999'] = 'WJ|ZG';
series_years['Grand cherokee_2000'] = 'WG|WJ';
series_years['Grand cherokee_2012'] = 'WK';
series_years['Grand cherokee_2013'] = 'WK';
series_years['Grand cherokee_2019'] = 'WK';
series_years['Grand cherokee_2001'] = 'WG';
series_years['Grand cherokee_2002'] = 'WG';
series_years['Grand cherokee_2003'] = 'WG';
series_years['Grand cherokee_2004'] = 'WG';
series_years['Grand cherokee_2005'] = 'WG|WH';
series_years['Grand cherokee_2020'] = 'WK';
series_years['Grand cherokee_2017'] = 'WK';
series_years['Grand cherokee_2018'] = 'WK';
series_years['Grand cherokee_2021'] = 'WK';
series_years['Grand cherokee_2022'] = 'WK';
series_years['Grand cherokee_2006'] = 'WH';
series_years['Grand cherokee_2007'] = 'WH';
series_years['Grand cherokee_2008'] = 'WH';
series_years['Grand cherokee_2009'] = 'WH';
series_years['Grand cherokee_2010'] = 'WH';
series_years['Grand cherokee_2011'] = 'WH|WK';
series_years['Grand cherokee_2014'] = 'WK';
series_years['Grand cherokee_2015'] = 'WK';
series_years['Grand cherokee_1996'] = 'ZG';
series_years['Grand cherokee_1997'] = 'ZG';
series_years['Grand cherokee_1998'] = 'ZG';
series_years['Grand cherokee_2016'] = 'WK';
series_years['Patriot_2012'] = 'MK';
series_years['Patriot_2011'] = 'MK';
series_years['Patriot_2008'] = 'MK';
series_years['Patriot_2009'] = 'MK';
series_years['Patriot_2014'] = 'MK';
series_years['Patriot_2015'] = 'MK';
series_years['Patriot_2016'] = 'MK';
series_years['Renegade_2015'] = 'BU';
series_years['Renegade_2016'] = 'BU';
series_years['Renegade_2017'] = 'BU';
series_years['Renegade_2018'] = 'BU';
series_years['Renegade_2019'] = 'BU';
series_years['Renegade_2020'] = 'BU';
series_years['Renegade_2021'] = 'BU';
series_years['Renegade_2022'] = 'BU';
series_years['Renegade_2023'] = 'BU';
series_years['Renegade_2024'] = 'BU';
series_years['Renegade_2025'] = 'BU';
series_years['Wrangler_2012'] = 'JK';
series_years['Wrangler_2020'] = 'JL';
series_years['Wrangler_2021'] = 'JL';
series_years['Wrangler_2022'] = 'JL';
series_years['Wrangler_2014'] = 'JK';
series_years['Wrangler_2015'] = 'JK';
series_years['Wrangler_2007'] = 'JK|TJ';
series_years['Wrangler_2008'] = 'JK';
series_years['Wrangler_2009'] = 'JK';
series_years['Wrangler_2010'] = 'JK';
series_years['Wrangler_1996'] = 'TJ';
series_years['Wrangler_1997'] = 'TJ';
series_years['Wrangler_1998'] = 'TJ';
series_years['Wrangler_1999'] = 'TJ';
series_years['Wrangler_2000'] = 'TJ';
series_years['Wrangler_2001'] = 'TJ';
series_years['Wrangler_2002'] = 'TJ';
series_years['Wrangler_2003'] = 'TJ';
series_years['Wrangler_2004'] = 'TJ';
series_years['Wrangler_2005'] = 'TJ';
series_years['Wrangler_2006'] = 'TJ';
series_years['Wrangler_2018'] = 'JK';
series_years['Wrangler_2019'] = 'JL';
series_years['Wrangler_2016'] = 'JK';
series_years['Wrangler_2017'] = 'JK';
series_years['Wrangler_2013'] = 'JK';
series_years['Wrangler_2011'] = 'JK';
series_years['Wrangler_1986'] = 'YJ';
series_years['Wrangler_1987'] = 'YJ';
series_years['Wrangler_1988'] = 'YJ';
series_years['Wrangler_1989'] = 'YJ';
series_years['Wrangler_1990'] = 'YJ';
series_years['Wrangler_1991'] = 'YJ';
series_years['Wrangler_1992'] = 'YJ';
series_years['Wrangler_1993'] = 'YJ';
series_years['Wrangler_1994'] = 'YJ';
series_years['Wrangler_1995'] = 'YJ';
series_years['Carens_2000'] = 'CARENS';
series_years['Carens_2001'] = 'CARENS';
series_years['Carens_2002'] = 'CARENS';
series_years['Carnival_2006'] = 'KV11|VQ';
series_years['Carnival_2007'] = 'VQ';
series_years['Carnival_2008'] = 'VQ';
series_years['Carnival_2009'] = 'VQ';
series_years['Carnival_2010'] = 'VQ';
series_years['Carnival_2011'] = 'VQ';
series_years['Carnival_2012'] = 'VQ';
series_years['Carnival_2013'] = 'VQ';
series_years['Carnival_2014'] = 'VQ';
series_years['Carnival_2015'] = 'VQ|YP';
series_years['Carnival_2016'] = 'YP';
series_years['Carnival_2017'] = 'YP';
series_years['Carnival_2018'] = 'YP';
series_years['Carnival_2022'] = 'KA4';
series_years['Carnival_2023'] = 'KA4';
series_years['Carnival_1999'] = 'KV11';
series_years['Carnival_2000'] = 'KV11';
series_years['Carnival_2001'] = 'KV11';
series_years['Carnival_2002'] = 'KV11';
series_years['Carnival_2003'] = 'KV11';
series_years['Carnival_2004'] = 'KV11';
series_years['Carnival_2005'] = 'KV11';
series_years['Carnival_2020'] = 'KA4|YP';
series_years['Carnival_2021'] = 'KA4';
series_years['Carnival_2019'] = 'YP';
series_years['Cerato_2009'] = 'TD';
series_years['Cerato_2010'] = 'TD';
series_years['Cerato_2011'] = 'TD';
series_years['Cerato_2012'] = 'TD';
series_years['Cerato_2013'] = 'TD|YD';
series_years['Cerato_2018'] = 'BD|YD';
series_years['Cerato_2019'] = 'BD';
series_years['Cerato_2020'] = 'BD';
series_years['Cerato_2021'] = 'BD';
series_years['Cerato_2014'] = 'YD';
series_years['Cerato_2015'] = 'YD';
series_years['Cerato_2016'] = 'YD';
series_years['Cerato_2017'] = 'YD';
series_years['Cerato_2004'] = 'LD';
series_years['Cerato_2005'] = 'LD';
series_years['Cerato_2006'] = 'LD';
series_years['Cerato_2007'] = 'LD';
series_years['Cerato_2008'] = 'LD';
series_years['Cerato_2022'] = 'BD';
series_years['Cerato_2023'] = 'BD';
series_years['Cerato_2024'] = 'BD';
series_years['Cerato_2025'] = 'BD';
series_years['Credos_1998'] = 'G11';
series_years['Credos_1999'] = 'G11';
series_years['Credos_2000'] = 'G11';
series_years['EV6_2021'] = 'CV';
series_years['EV6_2022'] = 'CV';
series_years['EV6_2023'] = 'CV';
series_years['EV6_2024'] = 'CV';
series_years['EV6_2025'] = 'CV';
series_years['K2700 / 2900_2002'] = 'TU';
series_years['K2700 / 2900_2003'] = 'TU';
series_years['K2700 / 2900_2004'] = 'TU';
series_years['K2700 / 2900_2005'] = 'PU/PU3|TU';
series_years['K2700 / 2900_2006'] = 'PU/PU3';
series_years['K2700 / 2900_2007'] = 'PU/PU3';
series_years['K2700 / 2900_2008'] = 'PU/PU3';
series_years['Magnetis_2006'] = 'MG';
series_years['Magnetis_2007'] = 'MG';
series_years['Magnetis_2008'] = 'MG';
series_years['Magnetis_2009'] = 'MG';
series_years['Mentor_1996'] = 'MENTOR';
series_years['Mentor_1997'] = 'MENTOR';
series_years['Mentor_1998'] = 'MENTOR';
series_years['Mentor_1999'] = 'MENTOR';
series_years['Mentor_2000'] = 'MENTOR';
series_years['Niro_2021'] = 'DE';
series_years['Niro_2022'] = 'DE';
series_years['Optima_2011'] = 'TF';
series_years['Optima_2012'] = 'TF';
series_years['Optima_2013'] = 'TF';
series_years['Optima_2001'] = 'GD';
series_years['Optima_2002'] = 'GD';
series_years['Optima_2003'] = 'GD';
series_years['Optima_2004'] = 'GD';
series_years['Optima_2005'] = 'GD';
series_years['Optima_2006'] = 'GD';
series_years['Optima_2015'] = 'JF|TF';
series_years['Optima_2016'] = 'JF|TF';
series_years['Optima_2017'] = 'JF|TF';
series_years['Optima_2018'] = 'JF|TF';
series_years['Optima_2014'] = 'TF';
series_years['Optima_2019'] = 'JF|TF';
series_years['Optima_2020'] = 'JF|TF';
series_years['Optima_2021'] = 'JF|TF';
series_years['Optima_2022'] = 'JF|TF';
series_years['Optima_2023'] = 'JF|TF';
series_years['Optima_2024'] = 'JF|TF';
series_years['Optima_2025'] = 'JF|TF';
series_years['Picanto_2020'] = 'JA';
series_years['Picanto_2021'] = 'JA';
series_years['Picanto_2022'] = 'JA';
series_years['Picanto_2023'] = 'JA';
series_years['Picanto_2018'] = 'JA';
series_years['Picanto_2019'] = 'JA';
series_years['Picanto_2016'] = 'TA';
series_years['Picanto_2017'] = 'JA|TA';
series_years['Pregio_2004'] = '3VRS/CT';
series_years['Pregio_2005'] = '3VRS/CT';
series_years['Pregio_2006'] = '3VRS/CT';
series_years['Pregio_2002'] = '3VRS/CT';
series_years['Pregio_2003'] = '3VRS/CT';
series_years['Proceed_2013'] = 'JD';
series_years['Proceed_2014'] = 'JD';
series_years['Proceed_2015'] = 'JD';
series_years['Rio_2011'] = 'JB|UB';
series_years['Rio_2012'] = 'UB';
series_years['Rio_2013'] = 'UB';
series_years['Rio_2014'] = 'UB';
series_years['Rio_2017'] = 'UB|YB';
series_years['Rio_2018'] = 'YB';
series_years['Rio_2000'] = 'BC';
series_years['Rio_2001'] = 'BC';
series_years['Rio_2002'] = 'BC';
series_years['Rio_2005'] = 'BC|JB';
series_years['Rio_2006'] = 'JB';
series_years['Rio_2007'] = 'JB';
series_years['Rio_2008'] = 'JB';
series_years['Rio_2009'] = 'JB';
series_years['Rio_2010'] = 'JB';
series_years['Rio_2020'] = 'YB';
series_years['Rio_2021'] = 'YB';
series_years['Rio_2019'] = 'YB';
series_years['Rio_2022'] = 'YB';
series_years['Rio_2015'] = 'UB';
series_years['Rio_2016'] = 'UB';
series_years['Rio_2003'] = 'BC';
series_years['Rio_2004'] = 'BC';
series_years['Rondo_2013'] = 'RP|UN';
series_years['Rondo_2014'] = 'RP';
series_years['Rondo_2015'] = 'RP';
series_years['Rondo_2016'] = 'RP';
series_years['Rondo_2017'] = 'RP';
series_years['Rondo_2018'] = 'RP';
series_years['Rondo_2019'] = 'RP';
series_years['Rondo_2020'] = 'RP';
series_years['Rondo_2021'] = 'RP';
series_years['Rondo_2022'] = 'RP';
series_years['Rondo_2023'] = 'RP';
series_years['Rondo_2024'] = 'RP';
series_years['Rondo_2025'] = 'RP';
series_years['Rondo_2008'] = 'UN';
series_years['Rondo_2009'] = 'UN';
series_years['Rondo_2010'] = 'UN';
series_years['Rondo_2011'] = 'UN';
series_years['Rondo_2012'] = 'UN';
series_years['Seltos_2022'] = 'SP2';
series_years['Seltos_2023'] = 'SP2';
series_years['Seltos_2024'] = 'SP2';
series_years['Seltos_2021'] = 'SP2';
series_years['Seltos_2020'] = 'SP2';
series_years['Seltos_2019'] = 'SP2';
series_years['Seltos_2025'] = 'SP2';
series_years['Shuma_2000'] = 'SHUMA';
series_years['Shuma_2001'] = 'SHUMA';
series_years['Sorento_2016'] = 'UM';
series_years['Sorento_2017'] = 'UM';
series_years['Sorento_2019'] = 'UM';
series_years['Sorento_2020'] = 'MQ4|UM';
series_years['Sorento_2009'] = 'BL|XM';
series_years['Sorento_2010'] = 'XM';
series_years['Sorento_2011'] = 'XM';
series_years['Sorento_2012'] = 'XM';
series_years['Sorento_2018'] = 'UM';
series_years['Sorento_2021'] = 'MQ4|UM';
series_years['Sorento_2022'] = 'MQ4|UM';
series_years['Sorento_2023'] = 'MQ4|UM';
series_years['Sorento_2024'] = 'MQ4|UM';
series_years['Sorento_2025'] = 'MQ4|UM';
series_years['Sorento_2003'] = 'BL';
series_years['Sorento_2004'] = 'BL';
series_years['Sorento_2005'] = 'BL';
series_years['Sorento_2006'] = 'BL';
series_years['Sorento_2007'] = 'BL';
series_years['Sorento_2008'] = 'BL';
series_years['Sorento_2013'] = 'XM';
series_years['Sorento_2014'] = 'XM';
series_years['Sorento_2015'] = 'UM|XM';
series_years['Soul_2014'] = 'PS';
series_years['Soul_2015'] = 'PS';
series_years['Soul_2016'] = 'PS';
series_years['Soul_2017'] = 'PS';
series_years['Soul_2018'] = 'PS';
series_years['Soul_2019'] = 'PS';
series_years['Soul_2020'] = 'PS';
series_years['Soul_2021'] = 'PS';
series_years['Soul_2022'] = 'PS';
series_years['Soul_2023'] = 'PS';
series_years['Soul_2024'] = 'PS';
series_years['Soul_2025'] = 'PS';
series_years['Soul_2009'] = 'AM';
series_years['Soul_2010'] = 'AM';
series_years['Soul_2011'] = 'AM';
series_years['Soul_2012'] = 'AM';
series_years['Soul_2013'] = 'AM';
series_years['Spectra_2001'] = 'FB';
series_years['Spectra_2002'] = 'FB';
series_years['Spectra_2003'] = 'FB';
series_years['Sportage_2015'] = 'QL|SL II';
series_years['Sportage_2016'] = 'QL';
series_years['Sportage_2014'] = 'SL II';
series_years['Sportage_2019'] = 'QL';
series_years['Sportage_2020'] = 'QL';
series_years['Sportage_2021'] = 'NQ5|QL';
series_years['Sportage_2010'] = 'KM|SL';
series_years['Sportage_2011'] = 'SL';
series_years['Sportage_2012'] = 'SL';
series_years['Sportage_2013'] = 'SL|SL II';
series_years['Sportage_2018'] = 'QL';
series_years['Sportage_2017'] = 'QL';
series_years['Sportage_2005'] = 'KM';
series_years['Sportage_2006'] = 'KM';
series_years['Sportage_2007'] = 'KM';
series_years['Sportage_2008'] = 'KM';
series_years['Sportage_2009'] = 'KM';
series_years['Sportage_1998'] = 'JA';
series_years['Sportage_1999'] = 'JA';
series_years['Sportage_2000'] = 'JA';
series_years['Sportage_2001'] = 'JA';
series_years['Sportage_2002'] = 'JA';
series_years['Sportage_2003'] = 'JA';
series_years['Sportage_1997'] = 'JA';
series_years['Sportage_2022'] = 'NQ5';
series_years['Sportage_2023'] = 'NQ5';
series_years['Sportage_2024'] = 'NQ5';
series_years['Stinger_2020'] = 'CK';
series_years['Stinger_2021'] = 'CK';
series_years['Stinger_2022'] = 'CK';
series_years['Stinger_2023'] = 'CK';
series_years['Stinger_2024'] = 'CK';
series_years['Stinger_2025'] = 'CK';
series_years['Stinger_2017'] = 'CK';
series_years['Stinger_2018'] = 'CK';
series_years['Stinger_2019'] = 'CK';
series_years['Stonic_2020'] = 'YB';
series_years['Stonic_2021'] = 'YB';
series_years['Stonic_2022'] = 'YB';
series_years['Stonic_2023'] = 'YB';
series_years['Stonic_2024'] = 'YB';
series_years['Stonic_2025'] = 'YB';
series_years['Defender_2006'] = '110|90/110';
series_years['Defender_2007'] = '90/110';
series_years['Defender_2008'] = '90/110';
series_years['Defender_2009'] = '90/110';
series_years['Defender_2010'] = '90/110';
series_years['Defender_2011'] = '90/110';
series_years['Defender_2012'] = '90/110';
series_years['Defender_2013'] = '90/110';
series_years['Defender_2014'] = '90/110';
series_years['Defender_2015'] = '90/110';
series_years['Defender_2016'] = '90/110';
series_years['Defender_1992'] = '110';
series_years['Defender_1993'] = '110';
series_years['Defender_1994'] = '110';
series_years['Defender_1995'] = '110';
series_years['Defender_1996'] = '110';
series_years['Defender_1997'] = '110';
series_years['Defender_1998'] = '110';
series_years['Defender_1999'] = '110';
series_years['Defender_2000'] = '110';
series_years['Defender_2001'] = '110';
series_years['Defender_2002'] = '110';
series_years['Defender_2003'] = '110';
series_years['Defender_2004'] = '110';
series_years['Defender_2005'] = '110';
series_years['Discovery_2002'] = 'SERIES 2';
series_years['Discovery_2003'] = 'SERIES 2';
series_years['Discovery_2004'] = 'SERIES 2';
series_years['Discovery_2005'] = 'SERIES 2|SERIES 3';
series_years['Discovery_2012'] = 'SERIES 4';
series_years['Discovery_2006'] = 'SERIES 3';
series_years['Discovery_2007'] = 'SERIES 3';
series_years['Discovery_2008'] = 'SERIES 3';
series_years['Discovery_2009'] = 'SERIES 3|SERIES 4';
series_years['Discovery_2015'] = 'LC|SERIES 4';
series_years['Discovery_2016'] = 'LC|SERIES 4';
series_years['Discovery_2017'] = 'LC|SERIES 4';
series_years['Discovery_2018'] = 'LC';
series_years['Discovery_2019'] = 'LC';
series_years['Discovery_2020'] = 'LC';
series_years['Discovery_2021'] = 'LC';
series_years['Discovery_2022'] = 'LC';
series_years['Discovery_2023'] = 'LC';
series_years['Discovery_2024'] = 'LC';
series_years['Discovery_2025'] = 'LC';
series_years['Discovery_1999'] = 'SERIES 1|SERIES 2';
series_years['Discovery_2000'] = 'SERIES 2';
series_years['Discovery_2001'] = 'SERIES 2';
series_years['Discovery_2011'] = 'SERIES 4';
series_years['Discovery_2014'] = 'SERIES 4';
series_years['Discovery_2010'] = 'SERIES 4';
series_years['Discovery_1994'] = 'SERIES 1';
series_years['Discovery_1995'] = 'SERIES 1';
series_years['Discovery_1996'] = 'SERIES 1';
series_years['Discovery_1997'] = 'SERIES 1';
series_years['Discovery_1998'] = 'SERIES 1';
series_years['Discovery_2013'] = 'SERIES 4';
series_years['Freelander_2013'] = 'Series 2';
series_years['Freelander_2014'] = 'Series 2';
series_years['Freelander_2007'] = 'Series 2';
series_years['Freelander_2012'] = 'Series 2';
series_years['Freelander_2009'] = 'Series 2';
series_years['Freelander_2010'] = 'Series 2';
series_years['Freelander_2011'] = 'Series 2';
series_years['Freelander_2008'] = 'Series 2';
series_years['Freelander_2004'] = 'FREELANDER|XE';
series_years['Freelander_2005'] = 'FREELANDER';
series_years['Freelander_2006'] = 'FREELANDER';
series_years['Freelander_2015'] = 'Series 2';
series_years['Freelander_1998'] = 'XE';
series_years['Freelander_1999'] = 'XE';
series_years['Freelander_2000'] = 'XE';
series_years['Freelander_2001'] = 'XE';
series_years['Freelander_2002'] = 'XE';
series_years['Freelander_2003'] = 'XE';
series_years['Range Rover_1995'] = 'P38A';
series_years['Range Rover_1996'] = 'P38A';
series_years['Range Rover_1997'] = 'P38A';
series_years['Range Rover_1998'] = 'P38A';
series_years['Range Rover_1999'] = 'P38A';
series_years['Range Rover_2000'] = 'P38A';
series_years['Range Rover_2001'] = 'P38A';
series_years['Range Rover_2002'] = 'L322|P38A';
series_years['Range Rover_2005'] = 'L320|L322';
series_years['Range Rover_2006'] = 'L320|L322';
series_years['Range Rover_2007'] = 'L320|L322';
series_years['Range Rover_2008'] = 'L320|L322';
series_years['Range Rover_2009'] = 'L320|L322';
series_years['Range Rover_2010'] = 'L320|L322';
series_years['Range Rover_2011'] = 'L320|L322|LG';
series_years['Range Rover_2012'] = 'L320|L322|LG';
series_years['Range Rover_2013'] = 'L320|LG';
series_years['Range Rover_2014'] = 'LG';
series_years['Range Rover_2015'] = 'LG';
series_years['Range Rover_2016'] = 'LG|LV';
series_years['Range Rover_2017'] = 'LG|LV';
series_years['Range Rover_2018'] = 'LG|LV';
series_years['Range Rover_2019'] = 'LG';
series_years['Range Rover_2020'] = 'LG';
series_years['Range Rover_2021'] = 'LG';
series_years['Range Rover_2022'] = 'LG';
series_years['Range Rover_2003'] = 'L322';
series_years['Range Rover_2004'] = 'L322';
series_years['CT200H_2017'] = 'ZWA10R';
series_years['CT200H_2018'] = 'ZWA10R';
series_years['CT200H_2019'] = 'ZWA10R';
series_years['CT200H_2020'] = 'ZWA10R';
series_years['CT200H_2021'] = 'ZWA10R';
series_years['CT200H_2022'] = 'ZWA10R';
series_years['CT200H_2023'] = 'ZWA10R';
series_years['CT200H_2024'] = 'ZWA10R';
series_years['CT200H_2025'] = 'ZWA10R';
series_years['CT200H_2013'] = 'ZWA10R';
series_years['CT200H_2014'] = 'ZWA10R';
series_years['CT200H_2015'] = 'ZWA10R';
series_years['CT200H_2016'] = 'ZWA10R';
series_years['CT200H_2010'] = 'ZWA10R';
series_years['CT200H_2011'] = 'ZWA10R';
series_years['CT200H_2012'] = 'ZWA10R';
series_years['ES250_2021'] = 'AXZA10R';
series_years['ES250_2022'] = 'AXZA10R';
series_years['ES250_2023'] = 'AXZA10R';
series_years['ES250_2024'] = 'AXZA10R';
series_years['ES250_2025'] = 'AXZA10R';
series_years['ES300 / ES300H / ES350_2013'] = 'AVV60R';
series_years['ES300 / ES300H / ES350_2014'] = 'AVV60R';
series_years['ES300 / ES300H / ES350_2015'] = 'AVV60R';
series_years['ES300 / ES300H / ES350_1992'] = 'VCV10R';
series_years['ES300 / ES300H / ES350_1993'] = 'VCV10R';
series_years['ES300 / ES300H / ES350_1994'] = 'VCV10R';
series_years['ES300 / ES300H / ES350_1995'] = 'VCV10R';
series_years['ES300 / ES300H / ES350_1996'] = 'MCV20R|VCV10R';
series_years['ES300 / ES300H / ES350_2001'] = 'MCV20R|MCV30R';
series_years['ES300 / ES300H / ES350_2002'] = 'MCV30R';
series_years['ES300 / ES300H / ES350_2003'] = 'MCV30R';
series_years['ES300 / ES300H / ES350_2004'] = 'MCV30R';
series_years['ES300 / ES300H / ES350_2005'] = 'MCV30R';
series_years['ES300 / ES300H / ES350_1997'] = 'MCV20R';
series_years['ES300 / ES300H / ES350_1998'] = 'MCV20R';
series_years['ES300 / ES300H / ES350_1999'] = 'MCV20R';
series_years['ES300 / ES300H / ES350_2000'] = 'MCV20R';
series_years['ES300H_2021'] = 'AXZH10R';
series_years['ES300H_2022'] = 'AXZH10R';
series_years['ES300H_2023'] = 'AXZH10R';
series_years['ES300H_2024'] = 'AXZH10R';
series_years['ES300H_2025'] = 'AXZH10R';
series_years['ES300H_2018'] = 'AXZH10R';
series_years['ES300H_2019'] = 'AXZH10R';
series_years['ES300H_2020'] = 'AXZH10R';
series_years['ES350_2015'] = 'GSV60R';
series_years['ES350_2016'] = 'GSV60R';
series_years['ES350_2017'] = 'GSV60R';
series_years['ES350_2018'] = 'GSV60R';
series_years['GS F_2015'] = 'URL10';
series_years['GS F_2016'] = 'URL10';
series_years['GS F_2017'] = 'URL10';
series_years['GS F_2018'] = 'URL10';
series_years['GS F_2019'] = 'URL10';
series_years['GS F_2020'] = 'URL10';
series_years['GS F_2021'] = 'URL10';
series_years['GS F_2022'] = 'URL10';
series_years['GS F_2023'] = 'URL10';
series_years['GS F_2024'] = 'URL10';
series_years['GS F_2025'] = 'URL10';
series_years['GS200T_2015'] = 'ARL10';
series_years['GS200T_2016'] = 'ARL10';
series_years['GS200T_2017'] = 'ARL10';
series_years['GS200T_2018'] = 'ARL10';
series_years['GS200T_2019'] = 'ARL10';
series_years['GS200T_2020'] = 'ARL10';
series_years['GS200T_2021'] = 'ARL10';
series_years['GS200T_2022'] = 'ARL10';
series_years['GS200T_2023'] = 'ARL10';
series_years['GS200T_2024'] = 'ARL10';
series_years['GS200T_2025'] = 'ARL10';
series_years['GS250/GS350/GS450_2012'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2013'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2014'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2015'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2016'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2017'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2018'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2019'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2020'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2021'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2022'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2023'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2024'] = 'GRL11/GRL10/GWS191';
series_years['GS250/GS350/GS450_2025'] = 'GRL11/GRL10/GWS191';
series_years['GS300 / GS430 / GS460_2007'] = 'GRS190R|URS190R|UZS190R';
series_years['GS300 / GS430 / GS460_2008'] = 'GRS190R|URS190R';
series_years['GS300 / GS430 / GS460_2009'] = 'GRS190R|URS190R';
series_years['GS300 / GS430 / GS460_2010'] = 'GRS190R|URS190R';
series_years['GS300 / GS430 / GS460_2011'] = 'GRS190R|URS190R';
series_years['GS300 / GS430 / GS460_1997'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_1998'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_1999'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_2000'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_2001'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_2002'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_2003'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_2004'] = 'JZS160R';
series_years['GS300 / GS430 / GS460_2005'] = 'GRS190R|JZS160R|UZS190R';
series_years['GS300 / GS430 / GS460_2006'] = 'GRS190R|UZS190R';
series_years['GS300H_2015'] = 'AWL10';
series_years['GS300H_2016'] = 'AWL10';
series_years['GS300H_2017'] = 'AWL10';
series_years['GS300H_2018'] = 'AWL10';
series_years['GS300H_2019'] = 'AWL10';
series_years['GS300H_2020'] = 'AWL10';
series_years['GS300H_2021'] = 'AWL10';
series_years['GS300H_2022'] = 'AWL10';
series_years['GS300H_2023'] = 'AWL10';
series_years['GS300H_2024'] = 'AWL10';
series_years['GS300H_2025'] = 'AWL10';
series_years['GS350_2015'] = 'GRL12';
series_years['GS350_2016'] = 'GRL12';
series_years['GS350_2017'] = 'GRL12';
series_years['GS350_2018'] = 'GRL12';
series_years['GS350_2019'] = 'GRL12';
series_years['GS350_2020'] = 'GRL12';
series_years['GS350_2021'] = 'GRL12';
series_years['GS350_2022'] = 'GRL12';
series_years['GS350_2023'] = 'GRL12';
series_years['GS350_2024'] = 'GRL12';
series_years['GS350_2025'] = 'GRL12';
series_years['GS450H_2006'] = 'GWS191';
series_years['GS450H_2007'] = 'GWS191';
series_years['GS450H_2008'] = 'GWS191';
series_years['GS450H_2009'] = 'GWS191';
series_years['GS450H_2010'] = 'GWS191';
series_years['GS450H_2011'] = 'GWS191';
series_years['GS450H_2012'] = 'GWS191';
series_years['GS450H_2015'] = 'GWL10';
series_years['GS450H_2016'] = 'GWL10';
series_years['GS450H_2017'] = 'GWL10';
series_years['GS450H_2018'] = 'GWL10';
series_years['GS450H_2019'] = 'GWL10';
series_years['GS450H_2020'] = 'GWL10';
series_years['GS450H_2021'] = 'GWL10';
series_years['GS450H_2022'] = 'GWL10';
series_years['GS450H_2023'] = 'GWL10';
series_years['GS450H_2024'] = 'GWL10';
series_years['GS450H_2025'] = 'GWL10';
series_years['IS 200T /IS 300H /IS 350_2015'] = 'ASE30R';
series_years['IS 200T /IS 300H /IS 350_2016'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2017'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2018'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2019'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2020'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2021'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2022'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2023'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2024'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS 200T /IS 300H /IS 350_2025'] = 'ASE30R|AVE30R|GSE31R';
series_years['IS F_2007'] = 'USE20R';
series_years['IS F_2008'] = 'USE20R';
series_years['IS F_2009'] = 'USE20R';
series_years['IS F_2010'] = 'USE20R';
series_years['IS F_2011'] = 'USE20R';
series_years['IS F_2012'] = 'USE20R';
series_years['IS F_2013'] = 'USE20R';
series_years['IS F_2014'] = 'USE20R';
series_years['IS200 / IS300_1999'] = 'GXE10/JCE10';
series_years['IS200 / IS300_2000'] = 'GXE10/JCE10';
series_years['IS200 / IS300_2001'] = 'GXE10/JCE10';
series_years['IS200 / IS300_2002'] = 'GXE10/JCE10';
series_years['IS200 / IS300_2003'] = 'GXE10/JCE10';
series_years['IS200 / IS300_2004'] = 'GXE10/JCE10';
series_years['IS200 / IS300_2005'] = 'GXE10/JCE10';
series_years['IS250_2008'] = 'GSE20';
series_years['IS250_2009'] = 'GSE20';
series_years['IS250_2010'] = 'GSE20';
series_years['IS250_2013'] = 'GSE20|GSE30';
series_years['IS250_2014'] = 'GSE30';
series_years['IS250_2015'] = 'GSE30';
series_years['IS250_2005'] = 'GSE20';
series_years['IS250_2006'] = 'GSE20';
series_years['IS250_2007'] = 'GSE20';
series_years['IS250_2011'] = 'GSE20';
series_years['IS250_2012'] = 'GSE20';
series_years['IS250C_2009'] = 'GSE20';
series_years['IS250C_2010'] = 'GSE20';
series_years['IS250C_2011'] = 'GSE20';
series_years['IS250C_2012'] = 'GSE20';
series_years['IS250C_2013'] = 'GSE20';
series_years['IS250C_2014'] = 'GSE20';
series_years['IS300H_2013'] = 'AVE30';
series_years['IS300H_2014'] = 'AVE30';
series_years['IS300H_2015'] = 'AVE30';
series_years['IS300H_2016'] = 'AVE30';
series_years['IS350_2010'] = 'GSE21';
series_years['IS350_2011'] = 'GSE21';
series_years['IS350_2012'] = 'GSE21';
series_years['IS350_2013'] = 'GSE21|GSE31';
series_years['IS350_2014'] = 'GSE31';
series_years['IS350_2015'] = 'GSE31';
series_years['IS350_2016'] = 'GSE31';
series_years['LC500 / LC500H_2017'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2018'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2019'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2020'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2021'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2022'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2023'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2024'] = 'GWZ100/URZ100';
series_years['LC500 / LC500H_2025'] = 'GWZ100/URZ100';
series_years['LS400_1990'] = 'UCF10';
series_years['LS400_1991'] = 'UCF10';
series_years['LS400_1992'] = 'UCF10';
series_years['LS400_1993'] = 'UCF10';
series_years['LS400_1994'] = 'UCF10|UCF20R';
series_years['LS400_1997'] = 'UCF20R';
series_years['LS400_1998'] = 'UCF20R';
series_years['LS400_1999'] = 'UCF20R';
series_years['LS400_2000'] = 'UCF20R';
series_years['LS400_1995'] = 'UCF20R';
series_years['LS400_1996'] = 'UCF20R';
series_years['LS430_2000'] = 'UCF30R';
series_years['LS430_2001'] = 'UCF30R';
series_years['LS430_2002'] = 'UCF30R';
series_years['LS430_2003'] = 'UCF30R';
series_years['LS430_2004'] = 'UCF30R';
series_years['LS430_2005'] = 'UCF30R';
series_years['LS430_2006'] = 'UCF30R';
series_years['LS430_2007'] = 'UCF30R';
series_years['LS460_2009'] = 'USF40R';
series_years['LS460_2010'] = 'USF40R';
series_years['LS460_2011'] = 'USF40R';
series_years['LS460_2012'] = 'USF40R';
series_years['LS460_2013'] = 'USF40R';
series_years['LS460_2014'] = 'USF40R';
series_years['LS460_2015'] = 'USF40R';
series_years['LS460_2016'] = 'USF40R';
series_years['LS460_2017'] = 'USF40R';
series_years['LS460_2018'] = 'USF40R';
series_years['LS460_2019'] = 'USF40R';
series_years['LS460_2020'] = 'USF40R';
series_years['LS460_2021'] = 'USF40R';
series_years['LS460_2022'] = 'USF40R';
series_years['LS460_2023'] = 'USF40R';
series_years['LS460_2024'] = 'USF40R';
series_years['LS460_2025'] = 'USF40R';
series_years['LS460_2006'] = 'USF40R';
series_years['LS460_2007'] = 'USF40R';
series_years['LS460_2008'] = 'USF40R';
series_years['LS500_2017'] = 'VXFA50R';
series_years['LS500_2018'] = 'VXFA50R';
series_years['LS500_2019'] = 'VXFA50R';
series_years['LS500_2020'] = 'VXFA50R';
series_years['LS500h_2017'] = 'GVF50R';
series_years['LS500h_2018'] = 'GVF50R';
series_years['LS600 / LS600HL_2012'] = 'UVF45R|UVF46R';
series_years['LS600 / LS600HL_2013'] = 'UVF45R';
series_years['LS600 / LS600HL_2014'] = 'UVF45R';
series_years['LS600 / LS600HL_2015'] = 'UVF45R';
series_years['LS600 / LS600HL_2016'] = 'UVF45R';
series_years['LS600 / LS600HL_2017'] = 'UVF45R';
series_years['LS600 / LS600HL_2018'] = 'UVF45R';
series_years['LS600 / LS600HL_2019'] = 'UVF45R';
series_years['LS600 / LS600HL_2020'] = 'UVF45R';
series_years['LS600 / LS600HL_2021'] = 'UVF45R';
series_years['LS600 / LS600HL_2022'] = 'UVF45R';
series_years['LS600 / LS600HL_2023'] = 'UVF45R';
series_years['LS600 / LS600HL_2024'] = 'UVF45R';
series_years['LS600 / LS600HL_2025'] = 'UVF45R';
series_years['LS600 / LS600HL_2009'] = 'UVF46R';
series_years['LS600 / LS600HL_2010'] = 'UVF46R';
series_years['LS600 / LS600HL_2011'] = 'UVF46R';
series_years['LS600 / LS600HL_2007'] = 'UVF46R';
series_years['LS600 / LS600HL_2008'] = 'UVF46R';
series_years['LX_1998'] = 'UZJ100R';
series_years['LX_1999'] = 'UZJ100R';
series_years['LX_2000'] = 'UZJ100R';
series_years['LX_2001'] = 'UZJ100R';
series_years['LX_2002'] = 'UZJ100R';
series_years['LX_2003'] = 'UZJ100R';
series_years['LX_2004'] = 'UZJ100R';
series_years['LX_2005'] = 'UZJ100R';
series_years['LX_2006'] = 'UZJ100R';
series_years['LX_2007'] = 'URJ201R|UZJ100R';
series_years['LX_2008'] = 'URJ201R';
series_years['LX_2009'] = 'URJ201R';
series_years['LX_2010'] = 'URJ201R';
series_years['LX_2011'] = 'URJ201R';
series_years['LX_2012'] = 'URJ201R';
series_years['LX_2013'] = 'URJ201R';
series_years['LX_2014'] = 'URJ201R';
series_years['LX_2015'] = 'URJ201R';
series_years['LX_2016'] = 'URJ201R';
series_years['LX_2017'] = 'URJ201R';
series_years['LX_2018'] = 'URJ201R';
series_years['LX_2019'] = 'URJ201R';
series_years['LX_2020'] = 'URJ201R';
series_years['LX_2021'] = 'URJ201R';
series_years['LX_2022'] = 'URJ201R';
series_years['LX_2023'] = 'URJ201R';
series_years['LX_2024'] = 'URJ201R';
series_years['LX_2025'] = 'URJ201R';
series_years['NX200t / NX300h_2014'] = 'AGZ10/AGZ15|AGZ15|AYZ10/AYZ15|AYZ15';
series_years['NX200t / NX300h_2015'] = 'AGZ10/AGZ15|AGZ15|AYZ10/AYZ15|AYZ15';
series_years['NX200t / NX300h_2016'] = 'AGZ10/AGZ15|AGZ15|AYZ10/AYZ15|AYZ15';
series_years['NX200t / NX300h_2017'] = 'AGZ10/AGZ15|AGZ15|AYZ10/AYZ15|AYZ15';
series_years['NX200t / NX300h_2018'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2019'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2020'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2021'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2022'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2023'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2024'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX200t / NX300h_2025'] = 'AGZ10/AGZ15|AGZ15';
series_years['NX300_2017'] = 'AGZ10R|AGZ15R';
series_years['NX300_2018'] = 'AGZ10R|AGZ15R';
series_years['NX300_2019'] = 'AGZ10R|AGZ15R';
series_years['NX300_2020'] = 'AGZ10R|AGZ15R';
series_years['NX300_2021'] = 'AGZ10R|AGZ15R';
series_years['NX300_2022'] = 'AGZ10R|AGZ15R';
series_years['NX300_2023'] = 'AGZ10R|AGZ15R';
series_years['NX300_2024'] = 'AGZ10R|AGZ15R';
series_years['NX300_2025'] = 'AGZ10R|AGZ15R';
series_years['RC350_2014'] = 'GSC10/USC10';
series_years['RC350_2015'] = 'GSC10/USC10';
series_years['RC350_2016'] = 'GSC10/USC10';
series_years['RC350_2017'] = 'GSC10/USC10';
series_years['RC350_2018'] = 'GSC10/USC10';
series_years['RC350_2019'] = 'GSC10/USC10';
series_years['RC350_2020'] = 'GSC10/USC10';
series_years['RC350_2021'] = 'GSC10/USC10';
series_years['RC350_2022'] = 'GSC10/USC10';
series_years['RC350_2023'] = 'GSC10/USC10';
series_years['RC350_2024'] = 'GSC10/USC10';
series_years['RC350_2025'] = 'GSC10/USC10';
series_years['RX200T_2015'] = 'AGL20';
series_years['RX200T_2016'] = 'AGL20';
series_years['RX200T_2017'] = 'AGL20';
series_years['RX200T_2018'] = 'AGL20';
series_years['RX200T_2019'] = 'AGL20';
series_years['RX200T_2020'] = 'AGL20';
series_years['RX200T_2021'] = 'AGL20';
series_years['RX200T_2022'] = 'AGL20';
series_years['RX200T_2023'] = 'AGL20';
series_years['RX200T_2024'] = 'AGL20';
series_years['RX200T_2025'] = 'AGL20';
series_years['RX270_2012'] = 'AGL10';
series_years['RX270_2013'] = 'AGL10';
series_years['RX270_2014'] = 'AGL10';
series_years['RX270_2015'] = 'AGL10';
series_years['RX330_2003'] = 'MCU38';
series_years['RX330_2004'] = 'MCU38';
series_years['RX330_2005'] = 'MCU38';
series_years['RX330_2006'] = 'MCU38';
series_years['RX350_2023'] = 'GGL25R|TALA15R';
series_years['RX350_2024'] = 'TALA15R';
series_years['RX350_2025'] = 'TALA15R';
series_years['RX350_2015'] = 'GGL15|GGL25';
series_years['RX350_2016'] = 'GGL25';
series_years['RX350_2017'] = 'GGL25';
series_years['RX350_2018'] = 'GGL25|GGL25R';
series_years['RX350_2008'] = 'GGL15|GSU35';
series_years['RX350_2009'] = 'GGL15';
series_years['RX350_2010'] = 'GGL15';
series_years['RX350_2011'] = 'GGL15';
series_years['RX350_2012'] = 'GGL15';
series_years['RX350_2006'] = 'GSU35';
series_years['RX350_2007'] = 'GSU35';
series_years['RX350_2019'] = 'GGL25R';
series_years['RX350_2020'] = 'GGL25R';
series_years['RX350_2021'] = 'GGL25R';
series_years['RX350_2022'] = 'GGL25R';
series_years['RX350_2013'] = 'GGL15';
series_years['RX350_2014'] = 'GGL15';
series_years['RX350H_2023'] = 'AALH10R|AALH15R';
series_years['RX350H_2024'] = 'AALH10R|AALH15R';
series_years['RX350H_2025'] = 'AALH10R|AALH15R';
series_years['RX400H_2005'] = 'MHU38';
series_years['RX400H_2006'] = 'MHU38';
series_years['RX400H_2007'] = 'MHU38';
series_years['RX400H_2008'] = 'MHU38';
series_years['RX450H_2012'] = 'GYL15R';
series_years['RX450H_2013'] = 'GYL15R';
series_years['RX450H_2014'] = 'GYL15R';
series_years['RX450H_2015'] = 'GYL15R|GYL25R';
series_years['RX450H_2018'] = 'GYL25R';
series_years['RX450H_2019'] = 'GYL25R';
series_years['RX450H_2020'] = 'GYL25R';
series_years['RX450H_2021'] = 'GYL25R';
series_years['RX450H_2022'] = 'GYL25R';
series_years['RX450H_2023'] = 'GYL25R';
series_years['RX450H_2016'] = 'GYL25R';
series_years['RX450H_2017'] = 'GYL25R';
series_years['RX450H_2009'] = 'GYL15R';
series_years['RX450H_2010'] = 'GYL15R';
series_years['RX450H_2011'] = 'GYL15R';
series_years['RX500H_2023'] = 'TALH17R';
series_years['RX500H_2024'] = 'TALH17R';
series_years['RX500H_2025'] = 'TALH17R';
series_years['SC400_1993'] = 'UZZ31';
series_years['SC400_1994'] = 'UZZ31';
series_years['SC400_1995'] = 'UZZ31';
series_years['SC400_1996'] = 'UZZ31';
series_years['SC400_1997'] = 'UZZ31';
series_years['SC400_1998'] = 'UZZ31';
series_years['SC430_2001'] = 'UZZ40R';
series_years['SC430_2002'] = 'UZZ40R';
series_years['SC430_2003'] = 'UZZ40R';
series_years['SC430_2004'] = 'UZZ40R';
series_years['SC430_2005'] = 'UZZ40R';
series_years['SC430_2006'] = 'UZZ40R';
series_years['SC430_2007'] = 'UZZ40R';
series_years['SC430_2008'] = 'UZZ40R';
series_years['SC430_2009'] = 'UZZ40R';
series_years['SC430_2010'] = 'UZZ40R';
series_years['Mack Truck_1973'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1974'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1975'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1976'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1977'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1978'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1979'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1980'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1981'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1982'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1983'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1984'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1985'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1986'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1987'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1988'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1989'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1990'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1991'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1992'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1993'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1994'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1995'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1996'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1997'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1998'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1999'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2000'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2001'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2002'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2003'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2004'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2005'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2006'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2007'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2008'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2009'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2010'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2011'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2012'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2013'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2014'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2015'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2016'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2017'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2018'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2019'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2020'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2021'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2022'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2023'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2024'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_2025'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1960'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1961'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1962'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1963'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1964'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1965'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1966'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1967'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1968'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1969'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1970'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1971'] = 'GRANITE/TRIDENT|MACK';
series_years['Mack Truck_1972'] = 'GRANITE/TRIDENT|MACK';
series_years['121 DA; DB_1987'] = 'DA';
series_years['121 DA; DB_1988'] = 'DA';
series_years['121 DA; DB_1989'] = 'DA';
series_years['121 DA; DB_1990'] = 'DA|DB';
series_years['121 DA; DB_1991'] = 'DB';
series_years['121 DA; DB_1992'] = 'DB';
series_years['121 DA; DB_1993'] = 'DB';
series_years['121 DA; DB_1994'] = 'DB';
series_years['121 DA; DB_1995'] = 'DB';
series_years['121 DA; DB_1996'] = 'DB';
series_years['121 DA; DB_1997'] = 'DB';
series_years['121 Metro Dw_1996'] = 'DW';
series_years['121 Metro Dw_1997'] = 'DW';
series_years['121 Metro Dw_1998'] = 'DW';
series_years['121 Metro Dw_1999'] = 'DW';
series_years['121 Metro Dw_2000'] = 'DW';
series_years['121 Metro Dw_2001'] = 'DW';
series_years['121 Metro Dw_2002'] = 'DW';
series_years['2_2021'] = '2C|534';
series_years['2_2022'] = '2C|534';
series_years['2_2019'] = '2C';
series_years['2_2020'] = '2C';
series_years['2_2023'] = '2C|DJ';
series_years['2_2007'] = 'DE|DY';
series_years['2_2008'] = 'DE';
series_years['2_2009'] = 'DE';
series_years['2_2010'] = 'DE';
series_years['2_2011'] = 'DE';
series_years['2_2012'] = 'DE';
series_years['2_2013'] = 'DE';
series_years['2_2014'] = 'DE|DJ';
series_years['2_2015'] = 'DJ|DL';
series_years['2_2016'] = 'DJ|DL';
series_years['2_2017'] = '2C|DJ|DL';
series_years['2_2024'] = 'DJ';
series_years['2_2025'] = 'DJ';
series_years['2_2002'] = 'DY';
series_years['2_2003'] = 'DY';
series_years['2_2004'] = 'DY';
series_years['2_2005'] = 'DY';
series_years['2_2006'] = 'DY';
series_years['2_2018'] = '2C';
series_years['3_2016'] = 'BM|BN';
series_years['3_2017'] = 'BN';
series_years['3_2018'] = 'BN';
series_years['3_2021'] = 'BP';
series_years['3_2022'] = 'BP';
series_years['3_2023'] = 'BP';
series_years['3_2011'] = 'BL';
series_years['3_2012'] = 'BL';
series_years['3_2013'] = 'BL|BM';
series_years['3_2004'] = 'BK';
series_years['3_2005'] = 'BK';
series_years['3_2006'] = 'BK';
series_years['3_2019'] = 'BN|BP';
series_years['3_2020'] = 'BP';
series_years['3_2009'] = 'BK|BL';
series_years['3_2010'] = 'BL';
series_years['3_2007'] = 'BK';
series_years['3_2008'] = 'BK';
series_years['3_2015'] = 'BM';
series_years['3_2014'] = 'BM';
series_years['3_2024'] = 'BP';
series_years['3_2025'] = 'BP';
series_years['323_2001'] = 'BJ';
series_years['323_2002'] = 'BJ';
series_years['323_2003'] = 'BJ';
series_years['323_2004'] = 'BJ';
series_years['323_1985'] = 'BD|BF';
series_years['323_1986'] = 'BF';
series_years['323_1987'] = 'BF';
series_years['323_1988'] = 'BF';
series_years['323_1989'] = 'BF|BG';
series_years['323_1994'] = 'BA|BG';
series_years['323_1995'] = 'BA|BG';
series_years['323_1996'] = 'BA|BG';
series_years['323_1997'] = 'BA';
series_years['323_1998'] = 'BA|BJ';
series_years['323_1999'] = 'BJ';
series_years['323_2000'] = 'BJ';
series_years['323_1980'] = 'BD';
series_years['323_1981'] = 'BD';
series_years['323_1982'] = 'BD';
series_years['323_1983'] = 'BD';
series_years['323_1984'] = 'BD';
series_years['323_1990'] = 'BG';
series_years['323_1991'] = 'BG';
series_years['323_1992'] = 'BG';
series_years['323_1993'] = 'BG';
series_years['6_2018'] = 'GL';
series_years['6_2019'] = 'GL';
series_years['6_2008'] = 'GG|GG/GY|GH';
series_years['6_2009'] = 'GH';
series_years['6_2010'] = 'GH';
series_years['6_2011'] = 'GH';
series_years['6_2012'] = 'GH|GJ';
series_years['6_2002'] = 'GG/GY';
series_years['6_2003'] = 'GG/GY';
series_years['6_2004'] = 'GG/GY';
series_years['6_2005'] = 'GG|GG/GY';
series_years['6_2006'] = 'GG|GG/GY';
series_years['6_2007'] = 'GG|GG/GY';
series_years['6_2013'] = 'GJ';
series_years['6_2014'] = 'GJ';
series_years['6_2016'] = 'GJ|GL';
series_years['6_2017'] = 'GL';
series_years['6_2020'] = 'GL';
series_years['6_2021'] = 'GL';
series_years['6_2022'] = 'GL';
series_years['6_2023'] = 'GL';
series_years['6_2024'] = 'GL';
series_years['6_2025'] = 'GL';
series_years['6_2015'] = 'GJ';
series_years['626_1991'] = 'GD/GV|GE';
series_years['626_1992'] = 'GE';
series_years['626_1993'] = 'GE';
series_years['626_1994'] = 'GE';
series_years['626_1995'] = 'GD/GV|GE';
series_years['626_1996'] = 'GD/GV|GE';
series_years['626_1997'] = 'GD/GV|GE|GF';
series_years['626_1998'] = 'GF';
series_years['626_1999'] = 'GF';
series_years['626_2000'] = 'GF';
series_years['626_2001'] = 'GF';
series_years['626_2002'] = 'GF';
series_years['626_1983'] = 'GC';
series_years['626_1984'] = 'GC';
series_years['626_1985'] = 'GC';
series_years['626_1986'] = 'GC';
series_years['626_1987'] = 'GC|GD/GV';
series_years['626_1988'] = 'GD/GV';
series_years['626_1989'] = 'GD/GV';
series_years['626_1990'] = 'GD/GV';
series_years['929_1982'] = 'HBSHE';
series_years['929_1983'] = 'HBSHE';
series_years['929_1984'] = 'HBES|HBSHE';
series_years['929_1985'] = 'HBES';
series_years['929_1986'] = 'HBES';
series_years['929_1987'] = 'HBES|HC ';
series_years['929_1995'] = 'HD|HE';
series_years['929_1996'] = 'HE';
series_years['929_1997'] = 'HE';
series_years['929_1991'] = 'HC |HD';
series_years['929_1992'] = 'HD';
series_years['929_1993'] = 'HD';
series_years['929_1994'] = 'HD';
series_years['929_1988'] = 'HC ';
series_years['929_1989'] = 'HC ';
series_years['929_1990'] = 'HC ';
series_years['B Series_1985'] = 'B SERIES|UF';
series_years['B Series_1986'] = 'UF';
series_years['B Series_1987'] = 'UF';
series_years['B Series_1988'] = 'UF';
series_years['B Series_1989'] = 'UF';
series_years['B Series_1990'] = 'UF';
series_years['B Series_1991'] = 'UF';
series_years['B Series_1992'] = 'UF';
series_years['B Series_1993'] = 'UF';
series_years['B Series_1994'] = 'UF';
series_years['B Series_1995'] = 'UF';
series_years['B Series_1996'] = 'UF';
series_years['B Series_1977'] = 'B SERIES';
series_years['B Series_1978'] = 'B SERIES';
series_years['B Series_1979'] = 'B SERIES';
series_years['B Series_1980'] = 'B SERIES';
series_years['B Series_1981'] = 'B SERIES';
series_years['B Series_1982'] = 'B SERIES';
series_years['B Series_1983'] = 'B SERIES';
series_years['B Series_1984'] = 'B SERIES';
series_years['B Series_1997'] = 'UF';
series_years['B Series_1998'] = 'UF';
series_years['B Series_1999'] = 'UN';
series_years['B Series_2000'] = 'UN';
series_years['B Series_2001'] = 'UN';
series_years['B Series_2002'] = 'UN';
series_years['B Series_2003'] = 'UN';
series_years['B Series_2004'] = 'UN';
series_years['B Series_2005'] = 'UN';
series_years['B Series_2006'] = 'UN';
series_years['BT50_2018'] = 'UR';
series_years['BT50_2019'] = 'UR';
series_years['BT50_2020'] = 'UR';
series_years['BT50_2006'] = 'UN';
series_years['BT50_2007'] = 'UN';
series_years['BT50_2008'] = 'UN';
series_years['BT50_2009'] = 'UN';
series_years['BT50_2010'] = 'UN';
series_years['BT50_2011'] = 'UN|UP';
series_years['BT50_2012'] = 'UP';
series_years['BT50_2013'] = 'UP';
series_years['BT50_2014'] = 'UP';
series_years['BT50_2015'] = 'UP';
series_years['BT-50_2021'] = 'RG04';
series_years['BT-50_2022'] = 'RG04';
series_years['BT-50_2023'] = 'RG04';
series_years['BT50 4x2_2015'] = 'UR';
series_years['BT50 4x2_2016'] = 'UR';
series_years['BT50 4x2_2017'] = 'UR';
series_years['BT50 4x2_2018'] = 'UR';
series_years['BT-50 4x2_2020'] = 'RG04';
series_years['BT-50 4x2_2021'] = 'RG04';
series_years['BT50 4x4_2015'] = 'UR';
series_years['BT50 4x4_2016'] = 'UR';
series_years['BT50 4x4_2017'] = 'UR';
series_years['BT50 4x4_2018'] = 'UR';
series_years['BT-50 4x4_2020'] = 'RG04';
series_years['BT-50 4x4_2021'] = 'RG04';
series_years['CX-3_2023'] = 'DK';
series_years['CX-3_2024'] = 'DK';
series_years['CX-3_2025'] = 'DK';
series_years['CX-3_2021'] = 'DK';
series_years['CX-3_2022'] = 'DK';
series_years['CX-3_2017'] = 'DK';
series_years['CX-3_2018'] = 'DK';
series_years['CX-3_2019'] = 'DK';
series_years['CX-3_2020'] = 'DK';
series_years['CX-3_2015'] = 'DK';
series_years['CX-3_2016'] = 'DK';
series_years['CX-30_2020'] = 'DM';
series_years['CX-30_2021'] = 'DM';
series_years['CX-30_2022'] = 'DM';
series_years['CX-30_2023'] = 'DM';
series_years['CX-30_2019'] = 'DM';
series_years['CX-5_2012'] = 'KE';
series_years['CX-5_2013'] = 'KE';
series_years['CX-5_2018'] = 'KF';
series_years['CX-5_2019'] = 'KF';
series_years['CX-5_2020'] = 'KF';
series_years['CX-5_2022'] = 'KF';
series_years['CX-5_2023'] = 'KF';
series_years['CX-5_2024'] = 'KF';
series_years['CX-5_2025'] = 'KF';
series_years['CX-5_2015'] = 'KE';
series_years['CX-5_2016'] = 'KE';
series_years['CX-5_2017'] = 'KE|KF';
series_years['CX-5_2014'] = 'KE';
series_years['CX-5_2021'] = 'KF';
series_years['CX-60_2023'] = 'KH';
series_years['CX-60_2024'] = 'KH';
series_years['CX-60_2025'] = 'KH';
series_years['CX-7_2006'] = 'ER';
series_years['CX-7_2007'] = 'ER';
series_years['CX-7_2008'] = 'ER';
series_years['CX-7_2009'] = 'ER';
series_years['CX-7_2010'] = 'ER';
series_years['CX-7_2011'] = 'ER';
series_years['CX-7_2012'] = 'ER';
series_years['CX-8_2020'] = 'KG|KG2';
series_years['CX-8_2021'] = 'KG2';
series_years['CX-8_2022'] = 'KG2';
series_years['CX-8_2023'] = 'KG2';
series_years['CX-8_2018'] = 'KG';
series_years['CX-8_2019'] = 'KG';
series_years['CX-9_2016'] = 'TB|TC';
series_years['CX-9_2017'] = 'TC';
series_years['CX-9_2018'] = 'TC';
series_years['CX-9_2009'] = 'TB';
series_years['CX-9_2010'] = 'TB';
series_years['CX-9_2011'] = 'TB';
series_years['CX-9_2012'] = 'TB';
series_years['CX-9_2020'] = 'TC';
series_years['CX-9_2021'] = 'TC';
series_years['CX-9_2022'] = 'TC';
series_years['CX-9_2023'] = 'TC';
series_years['CX-9_2024'] = 'TC';
series_years['CX-9_2025'] = 'TC';
series_years['CX-9_2007'] = 'TB';
series_years['CX-9_2008'] = 'TB';
series_years['CX-9_2013'] = 'TB';
series_years['CX-9_2014'] = 'TB';
series_years['CX-9_2015'] = 'TB';
series_years['CX-9_2019'] = 'TC';
series_years['CX-90_2023'] = 'KK';
series_years['CX-90_2024'] = 'KK';
series_years['CX-90_2025'] = 'KK';
series_years['E Series_1999'] = 'E SERIES';
series_years['E Series_2000'] = 'E SERIES';
series_years['E Series_2001'] = 'E SERIES';
series_years['E Series_2002'] = 'E SERIES';
series_years['E Series_2003'] = 'E SERIES';
series_years['E Series_2004'] = 'E SERIES';
series_years['E Series_2005'] = 'E SERIES';
series_years['E Series_2006'] = 'E SERIES';
series_years['E Series_1984'] = 'E SERIES';
series_years['E Series_1985'] = 'E SERIES';
series_years['E Series_1986'] = 'E SERIES';
series_years['E Series_1987'] = 'E SERIES';
series_years['E Series_1988'] = 'E SERIES';
series_years['E Series_1989'] = 'E SERIES';
series_years['E Series_1990'] = 'E SERIES';
series_years['E Series_1991'] = 'E SERIES';
series_years['E Series_1992'] = 'E SERIES';
series_years['E Series_1993'] = 'E SERIES';
series_years['E Series_1994'] = 'E SERIES';
series_years['E Series_1995'] = 'E SERIES';
series_years['E Series_1996'] = 'E SERIES';
series_years['E Series_1997'] = 'E SERIES';
series_years['E Series_1998'] = 'E SERIES';
series_years['E Series_1978'] = 'E SERIES';
series_years['E Series_1979'] = 'E SERIES';
series_years['E Series_1980'] = 'E SERIES';
series_years['E Series_1981'] = 'E SERIES';
series_years['E Series_1982'] = 'E SERIES';
series_years['E Series_1983'] = 'E SERIES';
series_years['Mazda Truck_1989'] = 'WE|WG';
series_years['Mazda Truck_1990'] = 'WG';
series_years['Mazda Truck_1991'] = 'WG';
series_years['Mazda Truck_1992'] = 'WG';
series_years['Mazda Truck_1993'] = 'WG';
series_years['Mazda Truck_1994'] = 'WG';
series_years['Mazda Truck_1995'] = 'WG';
series_years['Mazda Truck_1996'] = 'WG';
series_years['Mazda Truck_1997'] = 'WG';
series_years['Mazda Truck_1998'] = 'WG';
series_years['Mazda Truck_1999'] = 'WG';
series_years['Mazda Truck_2000'] = 'WG';
series_years['Mazda Truck_2001'] = 'WG';
series_years['Mazda Truck_2002'] = 'WG';
series_years['Mazda Truck_2003'] = 'WG';
series_years['Mazda Truck_2004'] = 'WG';
series_years['Mazda Truck_2005'] = 'WG';
series_years['Mazda Truck_2006'] = 'WG';
series_years['Mazda Truck_2007'] = 'WG';
series_years['Mazda Truck_2008'] = 'WG';
series_years['Mazda Truck_2009'] = 'WG';
series_years['Mazda Truck_2010'] = 'WG';
series_years['Mazda Truck_2011'] = 'WG';
series_years['Mazda Truck_2012'] = 'WG';
series_years['Mazda Truck_2013'] = 'WG';
series_years['Mazda Truck_2014'] = 'WG';
series_years['Mazda Truck_2015'] = 'WG';
series_years['Mazda Truck_2016'] = 'WG';
series_years['Mazda Truck_2017'] = 'WG';
series_years['Mazda Truck_2018'] = 'WG';
series_years['Mazda Truck_2019'] = 'WG';
series_years['Mazda Truck_2020'] = 'WG';
series_years['Mazda Truck_2021'] = 'WG';
series_years['Mazda Truck_2022'] = 'WG';
series_years['Mazda Truck_2023'] = 'WG';
series_years['Mazda Truck_2024'] = 'WG';
series_years['Mazda Truck_2025'] = 'WG';
series_years['Mazda Truck_1984'] = 'WE';
series_years['Mazda Truck_1985'] = 'WE';
series_years['Mazda Truck_1986'] = 'WE';
series_years['Mazda Truck_1987'] = 'WE';
series_years['Mazda Truck_1988'] = 'WE';
series_years['MPV_1999'] = 'LV|LW';
series_years['MPV_2000'] = 'LW';
series_years['MPV_2001'] = 'LW';
series_years['MPV_2002'] = 'LW';
series_years['MPV_2003'] = 'LW';
series_years['MPV_2004'] = 'LW';
series_years['MPV_2005'] = 'LW';
series_years['MPV_2006'] = 'LW';
series_years['MPV_1993'] = 'LV';
series_years['MPV_1994'] = 'LV';
series_years['MPV_1995'] = 'LV';
series_years['MPV_1996'] = 'LV';
series_years['MPV_1997'] = 'LV';
series_years['MPV_1998'] = 'LV';
series_years['MX-30_2021'] = 'DR';
series_years['MX-30_2022'] = 'DR';
series_years['MX-30_2023'] = 'DR';
series_years['MX-5_1998'] = 'NA|NB';
series_years['MX-5_1999'] = 'NB';
series_years['MX-5_2000'] = 'NB';
series_years['MX-5_2001'] = 'NB';
series_years['MX-5_2002'] = 'NB';
series_years['MX-5_2003'] = 'NB';
series_years['MX-5_2004'] = 'NB';
series_years['MX-5_2005'] = 'NB|NC';
series_years['MX-5_2015'] = 'NC|ND';
series_years['MX-5_2016'] = 'ND';
series_years['MX-5_2017'] = 'ND';
series_years['MX-5_2018'] = 'ND';
series_years['MX-5_2019'] = 'ND';
series_years['MX-5_2020'] = 'ND|ND2';
series_years['MX-5_2021'] = 'ND|ND2';
series_years['MX-5_2022'] = 'ND|ND2';
series_years['MX-5_2023'] = 'ND|ND2';
series_years['MX-5_2024'] = 'ND|ND2';
series_years['MX-5_2025'] = 'ND|ND2';
series_years['MX-5_2012'] = 'NC';
series_years['MX-5_2013'] = 'NC';
series_years['MX-5_2014'] = 'NC';
series_years['MX-5_1989'] = 'NA';
series_years['MX-5_1990'] = 'NA';
series_years['MX-5_1991'] = 'NA';
series_years['MX-5_1992'] = 'NA';
series_years['MX-5_1993'] = 'NA';
series_years['MX-5_1994'] = 'NA';
series_years['MX-5_1995'] = 'NA';
series_years['MX-5_1996'] = 'NA';
series_years['MX-5_1997'] = 'NA';
series_years['MX-5_2006'] = 'NC';
series_years['MX-5_2007'] = 'NC';
series_years['MX-5_2008'] = 'NC';
series_years['MX-5_2009'] = 'NC';
series_years['MX-5_2010'] = 'NC';
series_years['MX-5_2011'] = 'NC';
series_years['Premacy_2001'] = 'CP';
series_years['Premacy_2002'] = 'CP';
series_years['Premacy_2003'] = 'CP';
series_years['RX-8_2003'] = 'FE';
series_years['RX-8_2004'] = 'FE';
series_years['RX-8_2005'] = 'FE';
series_years['RX-8_2006'] = 'FE';
series_years['RX-8_2007'] = 'FE';
series_years['RX-8_2008'] = 'FE|FE SERIES';
series_years['RX-8_2009'] = 'FE SERIES';
series_years['RX-8_2010'] = 'FE SERIES';
series_years['RX-8_2011'] = 'FE SERIES';
series_years['Tribute_2006'] = '5Z|CU';
series_years['Tribute_2007'] = '5Z';
series_years['Tribute_2000'] = 'CU';
series_years['Tribute_2001'] = 'CU';
series_years['Tribute_2002'] = 'CU';
series_years['Tribute_2003'] = 'CU';
series_years['Tribute_2004'] = 'CU';
series_years['Tribute_2005'] = 'CU';
series_years['190 Series_1982'] = 'W201';
series_years['190 Series_1983'] = 'W201';
series_years['190 Series_1984'] = 'W201';
series_years['190 Series_1985'] = 'W201';
series_years['190 Series_1986'] = 'W201';
series_years['190 Series_1987'] = 'W201';
series_years['190 Series_1988'] = 'W201';
series_years['190 Series_1989'] = 'W201';
series_years['190 Series_1990'] = 'W201';
series_years['190 Series_1991'] = 'W201';
series_years['190 Series_1992'] = 'W201';
series_years['190 Series_1993'] = 'W201';
series_years['A Class_2009'] = 'W169';
series_years['A Class_2010'] = 'W169';
series_years['A Class_2011'] = 'W169';
series_years['A Class_2012'] = 'W169';
series_years['A Class_2005'] = 'W168|W169';
series_years['A Class_2006'] = 'W169';
series_years['A Class_2007'] = 'W169';
series_years['A Class_2015'] = 'W176';
series_years['A Class_2016'] = 'W176';
series_years['A Class_2017'] = 'W176';
series_years['A Class_2018'] = 'W176';
series_years['A Class_2013'] = 'W176';
series_years['A Class_2014'] = 'W176';
series_years['A Class_1998'] = 'W168';
series_years['A Class_1999'] = 'W168';
series_years['A Class_2000'] = 'W168';
series_years['A Class_2001'] = 'W168';
series_years['A Class_2002'] = 'W168';
series_years['A Class_2003'] = 'W168';
series_years['A Class_2004'] = 'W168';
series_years['A Class_2008'] = 'W169';
series_years['B Class_2012'] = 'W245|W246';
series_years['B Class_2013'] = 'W246';
series_years['B Class_2014'] = 'W246';
series_years['B Class_2015'] = 'W246';
series_years['B Class_2016'] = 'W246';
series_years['B Class_2017'] = 'W246';
series_years['B Class_2018'] = 'W246';
series_years['B Class_2005'] = 'W245';
series_years['B Class_2006'] = 'W245';
series_years['B Class_2007'] = 'W245';
series_years['B Class_2010'] = 'W245';
series_years['B Class_2011'] = 'W245';
series_years['C Class_2017'] = 'C205|S205|W205';
series_years['C Class_2018'] = 'C205|S205|W205';
series_years['C Class_2007'] = 'CL203|S203|W203|W204';
series_years['C Class_2008'] = 'S204|W204';
series_years['C Class_2009'] = 'S204|W204';
series_years['C Class_2016'] = 'C204|C205|S205|W205';
series_years['C Class_1994'] = 'W202';
series_years['C Class_1995'] = 'W202';
series_years['C Class_1996'] = 'W202';
series_years['C Class_1997'] = 'W202';
series_years['C Class_1998'] = 'W202';
series_years['C Class_1999'] = 'W202';
series_years['C Class_2000'] = 'S203|W202|W203';
series_years['C Class_2004'] = 'CL203|S203|W203';
series_years['C Class_2005'] = 'CL203|S203|W203';
series_years['C Class_2006'] = 'CL203|S203|W203';
series_years['C Class_2001'] = 'S203|W203';
series_years['C Class_2002'] = 'S203|W203';
series_years['C Class_2003'] = 'S203|W203';
series_years['C Class_2014'] = 'C204|S205|W204|W205';
series_years['C Class_2015'] = 'C204|S205|W205';
series_years['C Class_2019'] = 'C205|W205';
series_years['C Class_2011'] = 'C204|S204|W204';
series_years['C Class_2012'] = 'C204|S204|W204';
series_years['C Class_2013'] = 'C204|W204';
series_years['C Class_2010'] = 'S204|W204';
series_years['CLA Class_2018'] = 'C117|S117';
series_years['CLA Class_2015'] = 'C117|S117';
series_years['CLA Class_2014'] = 'C117';
series_years['CLA Class_2016'] = 'C117|S117';
series_years['CLA Class_2013'] = 'C117';
series_years['CLA Class_2017'] = 'C117|S117';
series_years['CLC-Class_2008'] = 'CL203';
series_years['CLC-Class_2009'] = 'CL203';
series_years['CLC-Class_2010'] = 'CL203';
series_years['CLC-Class_2011'] = 'CL203';
series_years['CLK_1997'] = 'A208/C208';
series_years['CLK_1998'] = 'A208/C208';
series_years['CLK_1999'] = 'A208/C208';
series_years['CLK_2000'] = 'A208/C208';
series_years['CLK_2001'] = 'A208/C208';
series_years['CLK_2002'] = 'A208/C208|A209/C209';
series_years['CLK_2003'] = 'A208/C208|A209/C209';
series_years['CLK_2004'] = 'A209/C209';
series_years['CLK_2005'] = 'A209/C209';
series_years['CLK_2006'] = 'A209/C209';
series_years['CLK_2007'] = 'A209/C209';
series_years['CLK_2008'] = 'A209/C209';
series_years['CLK_2009'] = 'A209/C209';
series_years['CLS Class_2005'] = 'C219';
series_years['CLS Class_2006'] = 'C219';
series_years['CLS Class_2007'] = 'C219';
series_years['CLS Class_2008'] = 'C219';
series_years['CLS Class_2009'] = 'C219';
series_years['CLS Class_2010'] = 'C219';
series_years['CLS Class_2011'] = 'C219';
series_years['E Class_2011'] = 'C207|S212|W212';
series_years['E Class_2012'] = 'C207|S212|W212';
series_years['E Class_2013'] = 'C207|S212|W212';
series_years['E Class_2016'] = 'W212|W213';
series_years['E Class_2017'] = 'W213';
series_years['E Class_2002'] = 'W210|W211';
series_years['E Class_2003'] = 'W211';
series_years['E Class_2004'] = 'W211';
series_years['E Class_2005'] = 'W211';
series_years['E Class_2006'] = 'W211';
series_years['E Class_2007'] = 'W211';
series_years['E Class_2008'] = 'W211';
series_years['E Class_2009'] = 'C207|W211|W212';
series_years['E Class_2010'] = 'C207|S212|W212';
series_years['E Class_2014'] = 'C207|S212|W212';
series_years['E Class_2015'] = 'C207|W212';
series_years['E Class_2018'] = 'W213';
series_years['E Class_1996'] = 'W210';
series_years['E Class_1997'] = 'W210';
series_years['E Class_1998'] = 'W210';
series_years['E Class_1999'] = 'W210';
series_years['E Class_2000'] = 'W210';
series_years['E Class_2001'] = 'W210';
series_years['GL Class_2012'] = 'X166';
series_years['GL Class_2013'] = 'X166';
series_years['GL Class_2014'] = 'X166';
series_years['GL Class_2015'] = 'X166';
series_years['GLA Class_2016'] = 'X156';
series_years['GLA Class_2017'] = 'X156';
series_years['GLA Class_2014'] = 'X156';
series_years['GLA Class_2015'] = 'X156';
series_years['GLA Class_2018'] = 'X156';
series_years['GLA Class_2019'] = 'X156';
series_years['GLA Class_2020'] = 'X156';
series_years['GLC Class_2017'] = 'C253|X253';
series_years['GLC Class_2018'] = 'C253|X253';
series_years['GLC Class_2019'] = 'C253|X253';
series_years['GLC Class_2015'] = 'X253';
series_years['GLC Class_2016'] = 'C253|X253';
series_years['GLE_2015'] = 'W166';
series_years['GLE_2016'] = 'W166';
series_years['GLE_2017'] = 'W166';
series_years['GLE_2018'] = 'W166';
series_years['M Class_2005'] = 'W163|W164';
series_years['M Class_2006'] = 'W164';
series_years['M Class_2007'] = 'W164';
series_years['M Class_2014'] = 'W166';
series_years['M Class_2015'] = 'W166';
series_years['M Class_2016'] = 'W166';
series_years['M Class_2009'] = 'W164';
series_years['M Class_2010'] = 'W164';
series_years['M Class_2011'] = 'W164';
series_years['M Class_2012'] = 'W164|W166';
series_years['M Class_2013'] = 'W166';
series_years['M Class_1998'] = 'W163';
series_years['M Class_1999'] = 'W163';
series_years['M Class_2000'] = 'W163';
series_years['M Class_2001'] = 'W163';
series_years['M Class_2002'] = 'W163';
series_years['M Class_2003'] = 'W163';
series_years['M Class_2004'] = 'W163';
series_years['M Class_2008'] = 'W164';
series_years['MB100/140_1999'] = '661';
series_years['MB100/140_2000'] = '661';
series_years['MB100/140_2001'] = '661';
series_years['MB100/140_2002'] = '661';
series_years['MB100/140_2003'] = '661';
series_years['MB100/140_2004'] = '661';
series_years['R Class_2006'] = 'W251';
series_years['R Class_2007'] = 'W251';
series_years['R Class_2008'] = 'W251';
series_years['R Class_2009'] = 'W251';
series_years['R Class_2010'] = 'W251';
series_years['R Class_2011'] = 'W251';
series_years['R Class_2012'] = 'W251';
series_years['R Class_2013'] = 'W251';
series_years['S Class_1999'] = 'W220';
series_years['S Class_2000'] = 'W220';
series_years['S Class_2001'] = 'W220';
series_years['S Class_2002'] = 'W220';
series_years['S Class_2003'] = 'W220';
series_years['S Class_2004'] = 'W220';
series_years['S Class_2005'] = 'W220';
series_years['S Class_2006'] = 'W220';
series_years['SLK Class_1997'] = 'R170';
series_years['SLK Class_1998'] = 'R170';
series_years['SLK Class_1999'] = 'R170';
series_years['SLK Class_2000'] = 'R170';
series_years['SLK Class_2001'] = 'R170';
series_years['SLK Class_2002'] = 'R170';
series_years['SLK Class_2003'] = 'R170';
series_years['SLK Class_2004'] = 'R170|R171';
series_years['SLK Class_2005'] = 'R171';
series_years['SLK Class_2006'] = 'R171';
series_years['Sprinter_2022'] = 'WDB907';
series_years['Sprinter_2023'] = 'WDB907';
series_years['Sprinter_2024'] = 'WDB907';
series_years['Sprinter_2025'] = 'WDB907';
series_years['Sprinter_2011'] = 'WDB906';
series_years['Sprinter_2012'] = 'WDB906';
series_years['Sprinter_2013'] = 'WDB906';
series_years['Sprinter_2018'] = 'WDB906|WDB907';
series_years['Sprinter_2019'] = 'WDB906|WDB907';
series_years['Sprinter_2020'] = 'WDB907';
series_years['Sprinter_2006'] = '208/308/311/313/413/316/416/61|WDB906';
series_years['Sprinter_2007'] = 'WDB906';
series_years['Sprinter_1998'] = '308D/312D/412D|AE102R';
series_years['Sprinter_1999'] = '308D/312D/412D|AE102R';
series_years['Sprinter_2000'] = '208/308/311/313/413/316/416/61|308D/312D/412D';
series_years['Sprinter_2010'] = 'WDB906';
series_years['Sprinter_2014'] = 'WDB906';
series_years['Sprinter_2015'] = 'WDB906';
series_years['Sprinter_2016'] = 'WDB906';
series_years['Sprinter_2017'] = 'WDB906';
series_years['Sprinter_2009'] = 'WDB906';
series_years['Sprinter_1994'] = 'AE102R';
series_years['Sprinter_1995'] = 'AE102R';
series_years['Sprinter_1996'] = 'AE102R';
series_years['Sprinter_1997'] = 'AE102R';
series_years['Sprinter_2008'] = 'WDB906';
series_years['Sprinter_2021'] = 'WDB907';
series_years['Sprinter_2001'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2002'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2003'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2004'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2005'] = '208/308/311/313/413/316/416/61';
series_years['Vito_2004'] = '638|WDF639';
series_years['Vito_2005'] = 'WDF639';
series_years['Vito_2006'] = 'WDF639';
series_years['Vito_2007'] = 'WDF639';
series_years['Vito_2008'] = 'WDF639';
series_years['Vito_2009'] = 'WDF639';
series_years['Vito_2010'] = 'WDF639';
series_years['Vito_2011'] = 'WDF639';
series_years['Vito_1998'] = '638';
series_years['Vito_1999'] = '638';
series_years['Vito_2000'] = '638';
series_years['Vito_2001'] = '638';
series_years['Vito_2002'] = '638';
series_years['Vito_2003'] = '638';
series_years['Vito_2012'] = 'WDF639';
series_years['Vito_2013'] = 'WDF639';
series_years['Vito_2014'] = 'WDF639';
series_years['Vito_2015'] = 'WDF639';
series_years['HS_2022'] = 'AS23';
series_years['HS_2023'] = 'AS23';
series_years['HS_2020'] = 'AS23';
series_years['HS_2021'] = 'AS23';
series_years['HS_2024'] = 'AS23';
series_years['HS_2025'] = 'AS23';
series_years['HS_2019'] = 'AS23';
series_years['MG3_2020'] = 'SZP1';
series_years['MG3_2021'] = 'SZP1';
series_years['MG3_2018'] = 'SZP1';
series_years['MG3_2019'] = 'SZP1';
series_years['MG3_2016'] = 'SZP1';
series_years['MG3_2017'] = 'SZP1';
series_years['ZS_2018'] = 'AZS1';
series_years['ZS_2019'] = 'AZS1';
series_years['ZS_2020'] = 'AZS1';
series_years['ZS_2021'] = 'AZS1';
series_years['ZS_2017'] = 'AZS1';
series_years['ZST_2020'] = 'AZS1';
series_years['ZST_2021'] = 'AZS1';
series_years['ZST_2022'] = 'AZS1';
series_years['ZST_2023'] = 'AZS1';
series_years['ZST_2024'] = 'AZS1';
series_years['ZST_2025'] = 'AZS1';
series_years['Cabrio_2012'] = 'R57 LCI';
series_years['Cabrio_2013'] = 'R57 LCI';
series_years['Cabrio_2005'] = 'R52';
series_years['Cabrio_2006'] = 'R52';
series_years['Cabrio_2007'] = 'R52';
series_years['Cabrio_2008'] = 'R52';
series_years['Cabrio_2009'] = 'R52|R57';
series_years['Cabrio_2010'] = 'R57|R57 LCI';
series_years['Cabrio_2004'] = 'R52';
series_years['Cabrio_2011'] = 'R57 LCI';
series_years['Clubman_2019'] = 'F54';
series_years['Clubman_2020'] = 'F54';
series_years['Clubman_2016'] = 'F54';
series_years['Clubman_2017'] = 'F54';
series_years['Clubman_2008'] = 'R55';
series_years['Clubman_2009'] = 'R55';
series_years['Clubman_2010'] = 'R55|R55 LCI';
series_years['Clubman_2015'] = 'F54';
series_years['Clubman_2011'] = 'R55 LCI';
series_years['Clubman_2012'] = 'R55 LCI';
series_years['Clubman_2013'] = 'R55 LCI';
series_years['Clubman_2018'] = 'F54';
series_years['Convertible_2015'] = 'F57';
series_years['Convertible_2016'] = 'F57';
series_years['Convertible_2017'] = 'F57';
series_years['Convertible_2018'] = 'F57';
series_years['Convertible_2019'] = 'F57';
series_years['Convertible_2020'] = 'F57';
series_years['Countryman_2019'] = 'F60';
series_years['Countryman_2020'] = 'F60|F60 LCI';
series_years['Countryman_2021'] = 'F60 LCI';
series_years['Countryman_2016'] = 'F60|R60';
series_years['Countryman_2017'] = 'F60';
series_years['Countryman_2018'] = 'F60';
series_years['Countryman_2011'] = 'R60';
series_years['Countryman_2012'] = 'R60';
series_years['Countryman_2013'] = 'R60';
series_years['Countryman_2014'] = 'R60';
series_years['Countryman_2015'] = 'R60';
series_years['Coupe_2012'] = 'R58';
series_years['Coupe_2013'] = 'R58';
series_years['Hardtop_2019'] = 'F55|F56';
series_years['Hardtop_2020'] = 'F55|F56';
series_years['Hardtop_2021'] = 'F55|F56';
series_years['Hardtop_2015'] = 'F55|F56';
series_years['Hardtop_2016'] = 'F55|F56';
series_years['Hardtop_2017'] = 'F55|F56';
series_years['Hardtop_2018'] = 'F55|F56';
series_years['Hardtop_2007'] = 'R56';
series_years['Hardtop_2008'] = 'R56';
series_years['Hardtop_2009'] = 'R56';
series_years['Hardtop_2010'] = 'R56|R56 LCI';
series_years['Hardtop_2014'] = 'F55|F56';
series_years['Hardtop_2011'] = 'R56 LCI';
series_years['Hardtop_2012'] = 'R56 LCI';
series_years['Hardtop_2013'] = 'R56 LCI';
series_years['Hardtop_2002'] = 'R50|R53';
series_years['Hardtop_2003'] = 'R50|R53';
series_years['Hardtop_2004'] = 'R50|R53';
series_years['Hardtop_2005'] = 'R50|R53';
series_years['Hardtop_2006'] = 'R50|R53';
series_years['Hatch_2020'] = 'F56 LCI';
series_years['Hatch_2021'] = 'F55 LCI|F56 LCI';
series_years['Hatch_2022'] = 'F55 LCI|F56 LCI';
series_years['Hatch_2023'] = 'F55 LCI|F56 LCI';
series_years['Hatch_2024'] = 'F55 LCI|F56 LCI';
series_years['Hatch_2025'] = 'F55 LCI|F56 LCI';
series_years['Paceman_2013'] = 'R61';
series_years['Paceman_2014'] = 'R61';
series_years['Paceman_2015'] = 'R61';
series_years['Paceman_2016'] = 'R61';
series_years['Roadster_2012'] = 'R59';
series_years['Roadster_2013'] = 'R59';
series_years['Roadster_2014'] = 'R59';
series_years['Roadster_2015'] = 'R59';
series_years['3000 GT_1992'] = 'JF';
series_years['3000 GT_1993'] = 'JF';
series_years['3000 GT_1994'] = 'JF';
series_years['3000 GT_1995'] = 'JF';
series_years['3000 GT_1996'] = 'JF';
series_years['3000 GT_1997'] = 'JF';
series_years['ASX_2012'] = 'XA|XB';
series_years['ASX_2013'] = 'XB';
series_years['ASX_2014'] = 'XB';
series_years['ASX_2015'] = 'XB';
series_years['ASX_2016'] = 'XB|XC';
series_years['ASX_2017'] = 'XC';
series_years['ASX_2018'] = 'XC';
series_years['ASX_2019'] = 'XC|XD';
series_years['ASX_2021'] = 'XD';
series_years['ASX_2020'] = 'XD';
series_years['ASX_2022'] = 'XD';
series_years['ASX_2023'] = 'XD';
series_years['ASX_2024'] = 'XD';
series_years['ASX_2025'] = 'XD';
series_years['ASX_2010'] = 'XA';
series_years['ASX_2011'] = 'XA';
series_years['Challenger_1997'] = 'PA';
series_years['Challenger_1998'] = 'PA';
series_years['Challenger_1999'] = 'PA';
series_years['Challenger_2000'] = 'PA';
series_years['Challenger_2001'] = 'PA';
series_years['Challenger_2002'] = 'PA';
series_years['Challenger_2003'] = 'PA';
series_years['Challenger_2004'] = 'PA';
series_years['Challenger_2005'] = 'PA';
series_years['Challenger_2006'] = 'PA';
series_years['Challenger_2013'] = 'PB|PC';
series_years['Challenger_2014'] = 'PC';
series_years['Challenger_2015'] = 'PC';
series_years['Challenger_2009'] = 'PB';
series_years['Challenger_2010'] = 'PB';
series_years['Challenger_2011'] = 'PB';
series_years['Challenger_2012'] = 'PB';
series_years['Colt_2006'] = 'RG|RZ';
series_years['Colt_2007'] = 'RG|RZ';
series_years['Colt_2008'] = 'RG|RZ';
series_years['Colt_2004'] = 'RG';
series_years['Colt_2005'] = 'RG';
series_years['Colt_2009'] = 'RG';
series_years['Colt_2010'] = 'RG';
series_years['Colt_2011'] = 'RG';
series_years['Colt_1982'] = 'RA|RB/RC/RD/RE';
series_years['Colt_1983'] = 'RB/RC/RD/RE';
series_years['Colt_1984'] = 'RB/RC/RD/RE';
series_years['Colt_1985'] = 'RB/RC/RD/RE';
series_years['Colt_1986'] = 'RB/RC/RD/RE';
series_years['Colt_1987'] = 'RB/RC/RD/RE';
series_years['Colt_1988'] = 'RB/RC/RD/RE';
series_years['Colt_1989'] = 'RB/RC/RD/RE';
series_years['Colt_1990'] = 'RB/RC/RD/RE';
series_years['Colt_1980'] = 'RA';
series_years['Colt_1981'] = 'RA';
series_years['Cordia_1983'] = 'AA/AB/AC';
series_years['Cordia_1984'] = 'AA/AB/AC';
series_years['Cordia_1985'] = 'AA/AB/AC';
series_years['Cordia_1986'] = 'AA/AB/AC';
series_years['Cordia_1987'] = 'AA/AB/AC';
series_years['Cordia_1988'] = 'AA/AB/AC';
series_years['Cordia_1989'] = 'AA/AB/AC';
series_years['Eclipse cross_2021'] = 'YB';
series_years['Eclipse cross_2022'] = 'YB';
series_years['Eclipse cross_2023'] = 'YB';
series_years['Eclipse cross_2024'] = 'YB';
series_years['Eclipse cross_2025'] = 'YB';
series_years['Eclipse cross_2019'] = 'YA';
series_years['Eclipse cross_2020'] = 'YA|YB';
series_years['Eclipse cross_2018'] = 'YA';
series_years['Eclipse cross_2017'] = 'YA';
series_years['Express_2020'] = 'SN';
series_years['Express_2021'] = 'SN';
series_years['Express_2022'] = 'SN';
series_years['Express_1980'] = 'SA/SB/SC/SD/SE';
series_years['Express_1981'] = 'SA/SB/SC/SD/SE';
series_years['Express_1982'] = 'SA/SB/SC/SD/SE';
series_years['Express_1983'] = 'SA/SB/SC/SD/SE';
series_years['Express_1984'] = 'SA/SB/SC/SD/SE';
series_years['Express_1985'] = 'SA/SB/SC/SD/SE';
series_years['Express_1986'] = 'SA/SB/SC/SD/SE|SJ';
series_years['Express_1987'] = 'SJ';
series_years['Express_1988'] = 'SJ';
series_years['Express_1989'] = 'SJ';
series_years['Express_1990'] = 'SJ';
series_years['Express_1991'] = 'SJ';
series_years['Express_1992'] = 'SJ';
series_years['Express_1993'] = 'SJ';
series_years['Express_1994'] = 'SJ';
series_years['Express_1995'] = 'SJ';
series_years['Express_1996'] = 'SJ';
series_years['Express_1997'] = 'SJ';
series_years['Express_1998'] = 'SJ';
series_years['Express_1999'] = 'SJ';
series_years['Express_2000'] = 'SJ';
series_years['Express_2001'] = 'SJ';
series_years['Express_2002'] = 'SJ';
series_years['Express_2003'] = 'SJ';
series_years['Express_2004'] = 'SJ';
series_years['Express_2005'] = 'SJ';
series_years['Express_2006'] = 'SJ';
series_years['Express_2007'] = 'SJ';
series_years['Express_2008'] = 'SJ';
series_years['Express_2009'] = 'SJ';
series_years['Express_2010'] = 'SJ';
series_years['Express_2011'] = 'SJ';
series_years['Express_2012'] = 'SJ';
series_years['Express_2013'] = 'SJ';
series_years['Express/starwagon_1994'] = 'WA';
series_years['Express/starwagon_1995'] = 'WA';
series_years['Express/starwagon_1996'] = 'WA';
series_years['Express/starwagon_1997'] = 'WA';
series_years['Express/starwagon_1998'] = 'WA';
series_years['Express/starwagon_1999'] = 'WA';
series_years['Express/starwagon_2000'] = 'WA';
series_years['Express/starwagon_2001'] = 'WA';
series_years['Express/starwagon_2002'] = 'WA';
series_years['Express/starwagon_2003'] = 'WA';
series_years['Express/starwagon_2004'] = 'WA';
series_years['Express/starwagon_2005'] = 'WA';
series_years['FTO_1994'] = 'FTO';
series_years['FTO_1995'] = 'FTO';
series_years['FTO_1996'] = 'FTO';
series_years['FTO_1997'] = 'FTO';
series_years['FTO_1998'] = 'FTO';
series_years['FTO_1999'] = 'FTO';
series_years['FTO_2000'] = 'FTO';
series_years['Galant_1993'] = 'HG/HH|HJ';
series_years['Galant_1994'] = 'HJ';
series_years['Galant_1995'] = 'HJ';
series_years['Galant_1996'] = 'HJ';
series_years['Galant_1989'] = 'HG/HH';
series_years['Galant_1990'] = 'HG/HH';
series_years['Galant_1991'] = 'HG/HH';
series_years['Galant_1992'] = 'HG/HH';
series_years['Grandis_2004'] = 'BA';
series_years['Grandis_2005'] = 'BA';
series_years['Grandis_2006'] = 'BA';
series_years['Grandis_2007'] = 'BA';
series_years['Grandis_2008'] = 'BA';
series_years['Grandis_2009'] = 'BA';
series_years['Grandis_2010'] = 'BA';
series_years['L200_1979'] = 'L200';
series_years['L200_1980'] = 'L200';
series_years['L200_1981'] = 'L200';
series_years['L200_1982'] = 'L200';
series_years['L200_1983'] = 'L200';
series_years['L200_1984'] = 'L200';
series_years['L200_1985'] = 'L200';
series_years['L200_1986'] = 'L200';
series_years['Lancer_1988'] = 'CC';
series_years['Lancer_1989'] = 'CC';
series_years['Lancer_1990'] = 'CC';
series_years['Lancer_1991'] = 'CC';
series_years['Lancer_1992'] = 'CC|CC/CE';
series_years['Lancer_2010'] = 'CJ';
series_years['Lancer_2011'] = 'CJ';
series_years['Lancer_2012'] = 'CJ';
series_years['Lancer_2013'] = 'CJ';
series_years['Lancer_2014'] = 'CJ';
series_years['Lancer_2002'] = 'CC/CE|CE|CG';
series_years['Lancer_2003'] = 'CC/CE|CE|CG|CH';
series_years['Lancer_2007'] = 'CH|CJ';
series_years['Lancer_2008'] = 'CJ';
series_years['Lancer_2009'] = 'CJ';
series_years['Lancer_1996'] = 'CC|CC/CE|CE';
series_years['Lancer_1997'] = 'CC/CE|CE';
series_years['Lancer_1998'] = 'CC/CE|CE';
series_years['Lancer_1999'] = 'CC/CE|CE';
series_years['Lancer_2000'] = 'CC/CE|CE';
series_years['Lancer_2001'] = 'CC/CE|CE';
series_years['Lancer_1993'] = 'CC|CC/CE';
series_years['Lancer_1994'] = 'CC|CC/CE';
series_years['Lancer_1995'] = 'CC|CC/CE';
series_years['Lancer_2015'] = 'CF|CJ';
series_years['Lancer_2016'] = 'CF';
series_years['Lancer_2017'] = 'CF';
series_years['Lancer_2004'] = 'CH';
series_years['Lancer_2005'] = 'CH';
series_years['Lancer_2006'] = 'CH';
series_years['Magna_1985'] = 'TM/TN/TP';
series_years['Magna_1986'] = 'TM/TN/TP';
series_years['Magna_1987'] = 'TM/TN/TP';
series_years['Magna_1988'] = 'TM/TN/TP';
series_years['Magna_1989'] = 'TM/TN/TP';
series_years['Magna_1990'] = 'TM/TN/TP';
series_years['Magna_1991'] = 'KE/KS/TR/TS|TM/TN/TP';
series_years['Magna_1996'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ|KE/KS/TR/TS';
series_years['Magna_1997'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ|KE/KS/TR/TS';
series_years['Magna_1998'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ';
series_years['Magna_1999'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ';
series_years['Magna_2000'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ';
series_years['Magna_2001'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ';
series_years['Magna_2002'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ';
series_years['Magna_2003'] = 'KE/KF/KH/KJ/TE/TF/TH/TJ|KL/KW/TL/TW';
series_years['Magna_1992'] = 'KE/KS/TR/TS';
series_years['Magna_1993'] = 'KE/KS/TR/TS';
series_years['Magna_1994'] = 'KE/KS/TR/TS';
series_years['Magna_1995'] = 'KE/KS/TR/TS';
series_years['Magna_2004'] = 'KL/KW/TL/TW';
series_years['Magna_2005'] = 'KL/KW/TL/TW';
series_years['Mcfa Mitsubishi / Cat Forklift_1960'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1961'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1962'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1963'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1964'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1965'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1966'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1967'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1968'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1969'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1970'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1971'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1972'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1973'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1974'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1975'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1976'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1977'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1978'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1979'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1980'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1981'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1982'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1983'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1984'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1985'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1986'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1987'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1988'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1989'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1990'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1991'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1992'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1993'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1994'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1995'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1996'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1997'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1998'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_1999'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2000'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2001'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2002'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2003'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2004'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2005'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2006'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2007'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2008'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2009'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2010'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2011'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2012'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2013'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2014'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2015'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2016'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2017'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2018'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2019'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2020'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2021'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2022'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2023'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2024'] = 'MCFA';
series_years['Mcfa Mitsubishi / Cat Forklift_2025'] = 'MCFA';
series_years['Mirage_2014'] = 'LA';
series_years['Mirage_2015'] = 'LA';
series_years['Mirage_2016'] = 'LA';
series_years['Mirage_2019'] = 'LA';
series_years['Mirage_2020'] = 'LA|LB';
series_years['Mirage_2021'] = 'LB';
series_years['Mirage_2022'] = 'LB';
series_years['Mirage_2023'] = 'LB';
series_years['Mirage_2024'] = 'LB';
series_years['Mirage_2025'] = 'LB';
series_years['Mirage_2012'] = 'LA';
series_years['Mirage_2013'] = 'LA';
series_years['Mirage_1996'] = 'CE';
series_years['Mirage_1997'] = 'CE';
series_years['Mirage_1998'] = 'CE';
series_years['Mirage_1999'] = 'CE';
series_years['Mirage_2000'] = 'CE';
series_years['Mirage_2001'] = 'CE';
series_years['Mirage_2002'] = 'CE';
series_years['Mirage_2003'] = 'CE';
series_years['Mirage_2004'] = 'CE';
series_years['Mirage_2017'] = 'LA';
series_years['Mirage_2018'] = 'LA';
series_years['Mitsubishi/Fuso Truck_1996'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1997'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1998'] = 'FE|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_1999'] = 'FE|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2000'] = 'FE|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2001'] = 'FE|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2002'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2003'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2004'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2005'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2006'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2007'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2008'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2009'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2010'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2011'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2012'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2013'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2014'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2015'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2016'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2017'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2018'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2019'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2020'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2021'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2022'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2023'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2024'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_2025'] = 'FE|FK/FM/FN|FP5/FS5/FV5';
series_years['Mitsubishi/Fuso Truck_1986'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1987'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1988'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1989'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1990'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1991'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1992'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1993'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1994'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1995'] = 'FE|FP/FS/FV';
series_years['Mitsubishi/Fuso Truck_1979'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1980'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1981'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1982'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1983'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1984'] = 'FE';
series_years['Mitsubishi/Fuso Truck_1985'] = 'FE|FP/FS/FV';
series_years['Nimbus_1998'] = 'UF|UG';
series_years['Nimbus_1999'] = 'UG';
series_years['Nimbus_2000'] = 'UG';
series_years['Nimbus_2001'] = 'UG';
series_years['Nimbus_2002'] = 'UG';
series_years['Nimbus_2003'] = 'UG';
series_years['Nimbus_2004'] = 'UG';
series_years['Nimbus_1992'] = 'UF';
series_years['Nimbus_1993'] = 'UF';
series_years['Nimbus_1994'] = 'UF';
series_years['Nimbus_1995'] = 'UF';
series_years['Nimbus_1996'] = 'UF';
series_years['Nimbus_1997'] = 'UF';
series_years['Nimbus_1984'] = 'UA/UB/UC';
series_years['Nimbus_1985'] = 'UA/UB/UC';
series_years['Nimbus_1986'] = 'UA/UB/UC';
series_years['Nimbus_1987'] = 'UA/UB/UC';
series_years['Nimbus_1988'] = 'UA/UB/UC';
series_years['Nimbus_1989'] = 'UA/UB/UC';
series_years['Nimbus_1990'] = 'UA/UB/UC';
series_years['Nimbus_1991'] = 'UA/UB/UC';
series_years['Outlander_2022'] = 'ZL|ZM';
series_years['Outlander_2023'] = 'ZM';
series_years['Outlander_2024'] = 'ZM';
series_years['Outlander_2025'] = 'ZM';
series_years['Outlander_2017'] = 'ZK|ZL';
series_years['Outlander_2018'] = 'ZK|ZL';
series_years['Outlander_2019'] = 'ZL';
series_years['Outlander_2020'] = 'ZL';
series_years['Outlander_2021'] = 'ZL|ZM';
series_years['Outlander_2009'] = 'ZG|ZH';
series_years['Outlander_2010'] = 'ZH';
series_years['Outlander_2011'] = 'ZH';
series_years['Outlander_2012'] = 'ZH|ZJ';
series_years['Outlander_2006'] = 'ZE/ZF|ZG';
series_years['Outlander_2007'] = 'ZG';
series_years['Outlander_2008'] = 'ZG';
series_years['Outlander_2015'] = 'ZJ|ZK';
series_years['Outlander_2016'] = 'ZK';
series_years['Outlander_2013'] = 'ZJ';
series_years['Outlander_2014'] = 'ZJ';
series_years['Outlander_2002'] = 'ZE/ZF';
series_years['Outlander_2003'] = 'ZE/ZF';
series_years['Outlander_2004'] = 'ZE/ZF';
series_years['Outlander_2005'] = 'ZE/ZF';
series_years['Pajero_2015'] = 'NX';
series_years['Pajero_2016'] = 'NX';
series_years['Pajero_2014'] = 'NW|NX';
series_years['Pajero_2006'] = 'NP|NS|NS/NT';
series_years['Pajero_2007'] = 'NS|NS/NT';
series_years['Pajero_2008'] = 'NS|NS/NT|NT';
series_years['Pajero_2009'] = 'NS/NT|NT';
series_years['Pajero_2010'] = 'NS/NT|NT';
series_years['Pajero_2011'] = 'NS/NT|NT|NW';
series_years['Pajero_2020'] = 'NX';
series_years['Pajero_2021'] = 'NX';
series_years['Pajero_2022'] = 'NX';
series_years['Pajero_2023'] = 'NX';
series_years['Pajero_2024'] = 'NX';
series_years['Pajero_2025'] = 'NX';
series_years['Pajero_2012'] = 'NW';
series_years['Pajero_2013'] = 'NW';
series_years['Pajero_1991'] = 'NA/NB/NC/ND/NE/NF/NG|NH/NJ/NK';
series_years['Pajero_1992'] = 'NH/NJ/NK';
series_years['Pajero_1993'] = 'NH/NJ/NK';
series_years['Pajero_1994'] = 'NH/NJ/NK';
series_years['Pajero_1995'] = 'NH/NJ/NK';
series_years['Pajero_1996'] = 'NH/NJ/NK';
series_years['Pajero_1997'] = 'NH/NJ/NK|NL';
series_years['Pajero_1998'] = 'NL|QA';
series_years['Pajero_1999'] = 'NL|QA';
series_years['Pajero_2000'] = 'NL|NM|QA';
series_years['Pajero_2002'] = 'NM|NP|QA';
series_years['Pajero_2003'] = 'NP';
series_years['Pajero_2004'] = 'NP';
series_years['Pajero_2005'] = 'NP';
series_years['Pajero_2001'] = 'NM|QA';
series_years['Pajero_2019'] = 'NX';
series_years['Pajero_2017'] = 'NX';
series_years['Pajero_2018'] = 'NX';
series_years['Pajero_1983'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1984'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1985'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1986'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1987'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1988'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1989'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero_1990'] = 'NA/NB/NC/ND/NE/NF/NG';
series_years['Pajero Sport_2015'] = 'QE';
series_years['Pajero Sport_2016'] = 'QE';
series_years['Pajero Sport_2017'] = 'QE';
series_years['Pajero Sport_2018'] = 'QE';
series_years['Pajero Sport_2019'] = 'QE|QF';
series_years['Pajero Sport_2020'] = 'QF';
series_years['Pajero Sport_2021'] = 'QF';
series_years['Pajero Sport_2022'] = 'QF';
series_years['Pajero Sport_2023'] = 'QF';
series_years['Pajero Sport_2024'] = 'QF';
series_years['Pajero Sport_2025'] = 'QF';
series_years['Sigma_1977'] = 'GE';
series_years['Sigma_1978'] = 'GE';
series_years['Sigma_1979'] = 'GE';
series_years['Sigma_1980'] = 'GE|GH';
series_years['Sigma_1982'] = 'GH|GJ/GK/GN';
series_years['Sigma_1983'] = 'GJ/GK/GN';
series_years['Sigma_1984'] = 'GJ/GK/GN';
series_years['Sigma_1985'] = 'GJ/GK/GN';
series_years['Sigma_1986'] = 'GJ/GK/GN';
series_years['Sigma_1987'] = 'GJ/GK/GN';
series_years['Sigma_1981'] = 'GH';
series_years['Starwagon_1986'] = 'SJ';
series_years['Starwagon_1987'] = 'SJ';
series_years['Starwagon_1988'] = 'SJ';
series_years['Starwagon_1989'] = 'SJ';
series_years['Starwagon_1990'] = 'SJ';
series_years['Starwagon_1991'] = 'SJ';
series_years['Starwagon_1992'] = 'SJ';
series_years['Starwagon_1993'] = 'SJ';
series_years['Starwagon_1994'] = 'SJ';
series_years['Starwagon_1995'] = 'SJ';
series_years['Starwagon_1996'] = 'SJ';
series_years['Starwagon_1997'] = 'SJ';
series_years['Starwagon_1998'] = 'SJ';
series_years['Starwagon_1999'] = 'SJ';
series_years['Starwagon_2000'] = 'SJ';
series_years['Starwagon_2001'] = 'SJ';
series_years['Triton_2006'] = 'MK|ML';
series_years['Triton_2007'] = 'ML';
series_years['Triton_2008'] = 'ML';
series_years['Triton_2009'] = 'ML|MN';
series_years['Triton_2018'] = 'MQ|MR';
series_years['Triton_2019'] = 'MR';
series_years['Triton_2020'] = 'MR';
series_years['Triton_2021'] = 'MR';
series_years['Triton_2022'] = 'MR';
series_years['Triton_2023'] = 'MR';
series_years['Triton_2024'] = 'MR';
series_years['Triton_2015'] = 'MN|MQ';
series_years['Triton_2016'] = 'MQ';
series_years['Triton_2017'] = 'MQ';
series_years['Triton_1986'] = 'MJ';
series_years['Triton_1987'] = 'MJ';
series_years['Triton_1988'] = 'MJ';
series_years['Triton_1989'] = 'MJ';
series_years['Triton_1990'] = 'MJ';
series_years['Triton_1991'] = 'MJ';
series_years['Triton_1992'] = 'MJ';
series_years['Triton_1993'] = 'MJ';
series_years['Triton_1994'] = 'MJ';
series_years['Triton_1995'] = 'MJ';
series_years['Triton_1996'] = 'MJ|MK';
series_years['Triton_1997'] = 'MK';
series_years['Triton_1998'] = 'MK';
series_years['Triton_1999'] = 'MK';
series_years['Triton_2000'] = 'MK';
series_years['Triton_2001'] = 'MK';
series_years['Triton_2002'] = 'MK';
series_years['Triton_2003'] = 'MK';
series_years['Triton_2004'] = 'MK';
series_years['Triton_2005'] = 'MK';
series_years['Triton_2010'] = 'MN';
series_years['Triton_2011'] = 'MN';
series_years['Triton_2012'] = 'MN';
series_years['Triton_2013'] = 'MN';
series_years['Triton_2014'] = 'MN';
series_years['1200_1978'] = '1200';
series_years['1200_1979'] = '1200';
series_years['1200_1980'] = '1200';
series_years['1200_1981'] = '1200';
series_years['1200_1982'] = '1200';
series_years['1200_1983'] = '1200';
series_years['1200_1984'] = '1200';
series_years['1200_1985'] = '1200';
series_years['120Y_1974'] = '120Y';
series_years['120Y_1975'] = '120Y';
series_years['120Y_1976'] = '120Y';
series_years['120Y_1977'] = '120Y';
series_years['120Y_1978'] = '120Y';
series_years['120Y_1979'] = '120Y';
series_years['200SX_1989'] = '180SX';
series_years['200SX_1990'] = '180SX';
series_years['200SX_1991'] = '180SX';
series_years['200SX_1992'] = '180SX';
series_years['200SX_1993'] = '180SX';
series_years['200SX_1994'] = '180SX|S14';
series_years['200SX_2000'] = 'S14|S15';
series_years['200SX_2001'] = 'S15';
series_years['200SX_2002'] = 'S15';
series_years['200SX_2003'] = 'S15';
series_years['200SX_1995'] = 'S14';
series_years['200SX_1996'] = 'S14';
series_years['200SX_1997'] = 'S14';
series_years['200SX_1998'] = 'S14';
series_years['200SX_1999'] = 'S14';
series_years['280ZX_1979'] = '280ZX';
series_years['280ZX_1980'] = '280ZX';
series_years['280ZX_1981'] = '280ZX';
series_years['280ZX_1982'] = '280ZX';
series_years['280ZX_1983'] = '280ZX';
series_years['280ZX_1984'] = '280ZX';
series_years['300ZX_1984'] = 'Z31';
series_years['300ZX_1985'] = 'Z31';
series_years['300ZX_1986'] = 'Z31';
series_years['300ZX_1987'] = 'Z31';
series_years['300ZX_1988'] = 'Z31';
series_years['300ZX_1989'] = 'Z31|Z32';
series_years['300ZX_1990'] = 'Z32';
series_years['300ZX_1991'] = 'Z32';
series_years['300ZX_1992'] = 'Z32';
series_years['300ZX_1993'] = 'Z32';
series_years['300ZX_1994'] = 'Z32';
series_years['300ZX_1995'] = 'Z32';
series_years['350Z / 370Z_2009'] = 'Z33|Z34';
series_years['350Z / 370Z_2010'] = 'Z34';
series_years['350Z / 370Z_2011'] = 'Z34';
series_years['350Z / 370Z_2012'] = 'Z34';
series_years['350Z / 370Z_2003'] = 'Z33';
series_years['350Z / 370Z_2004'] = 'Z33';
series_years['350Z / 370Z_2005'] = 'Z33';
series_years['350Z / 370Z_2006'] = 'Z33';
series_years['350Z / 370Z_2007'] = 'Z33';
series_years['350Z / 370Z_2008'] = 'Z33';
series_years['720_1980'] = '720';
series_years['720_1981'] = '720';
series_years['720_1982'] = '720';
series_years['720_1983'] = '720';
series_years['720_1984'] = '720';
series_years['720_1985'] = '720';
series_years['Almera_2012'] = 'N17';
series_years['Almera_2013'] = 'N17';
series_years['Almera_2014'] = 'N17';
series_years['Altima_2013'] = 'L33';
series_years['Altima_2014'] = 'L33';
series_years['Altima_2015'] = 'L33';
series_years['Altima_2016'] = 'L33';
series_years['Altima_2017'] = 'L33';
series_years['Dualis_2007'] = 'J10';
series_years['Dualis_2008'] = 'J10';
series_years['Dualis_2009'] = 'J10';
series_years['Dualis_2010'] = 'J10';
series_years['Dualis_2011'] = 'J10';
series_years['Dualis_2012'] = 'J10';
series_years['Dualis_2013'] = 'J10';
series_years['Dualis_2014'] = 'J10';
series_years['Juke_2021'] = 'F16';
series_years['Juke_2022'] = 'F16';
series_years['Juke_2023'] = 'F16';
series_years['Juke_2024'] = 'F16';
series_years['Juke_2025'] = 'F16';
series_years['Juke_2018'] = 'F15 II';
series_years['Juke_2019'] = 'F15 II';
series_years['Juke_2020'] = 'F15 II|F16';
series_years['Juke_2015'] = 'F15|F15 II';
series_years['Juke_2016'] = 'F15 II';
series_years['Juke_2017'] = 'F15 II';
series_years['Juke_2013'] = 'F15';
series_years['Juke_2014'] = 'F15';
series_years['Leaf_2019'] = 'ZE1';
series_years['Leaf_2020'] = 'ZE1';
series_years['Leaf_2021'] = 'ZE1';
series_years['Leaf_2022'] = 'ZE1';
series_years['Maxima_1994'] = 'A32|J30';
series_years['Maxima_1995'] = 'A32';
series_years['Maxima_1996'] = 'A32';
series_years['Maxima_1997'] = 'A32';
series_years['Maxima_1998'] = 'A32';
series_years['Maxima_1999'] = 'A32|A33';
series_years['Maxima_2003'] = 'A33|J31';
series_years['Maxima_2004'] = 'J31';
series_years['Maxima_2005'] = 'J31';
series_years['Maxima_2006'] = 'J31';
series_years['Maxima_2007'] = 'J31';
series_years['Maxima_2008'] = 'J31';
series_years['Maxima_2009'] = 'J31|J32';
series_years['Maxima_2010'] = 'J32';
series_years['Maxima_2011'] = 'J32';
series_years['Maxima_2012'] = 'J32';
series_years['Maxima_2013'] = 'J32';
series_years['Maxima_2000'] = 'A33';
series_years['Maxima_2001'] = 'A33';
series_years['Maxima_2002'] = 'A33';
series_years['Maxima_1990'] = 'J30';
series_years['Maxima_1991'] = 'J30';
series_years['Maxima_1992'] = 'J30';
series_years['Maxima_1993'] = 'J30';
series_years['Micra_2015'] = 'K13';
series_years['Micra_2016'] = 'K13';
series_years['Micra_2007'] = 'K12';
series_years['Micra_2008'] = 'K12';
series_years['Micra_2009'] = 'K12';
series_years['Micra_2010'] = 'K12|K13';
series_years['Micra_2011'] = 'K13';
series_years['Micra_2012'] = 'K13';
series_years['Micra_2013'] = 'K13';
series_years['Micra_2014'] = 'K13';
series_years['Murano_2008'] = 'Z50|Z51';
series_years['Murano_2009'] = 'Z51';
series_years['Murano_2010'] = 'Z51';
series_years['Murano_2011'] = 'Z51';
series_years['Murano_2012'] = 'Z51';
series_years['Murano_2013'] = 'Z51';
series_years['Murano_2014'] = 'Z51';
series_years['Murano_2005'] = 'Z50';
series_years['Murano_2006'] = 'Z50';
series_years['Murano_2007'] = 'Z50';
series_years['Navara_2017'] = 'Series 2|Series 3';
series_years['Navara_2018'] = 'Series 3';
series_years['Navara_2019'] = 'Series 3';
series_years['Navara_2008'] = 'D22|D40';
series_years['Navara_2009'] = 'D22|D40';
series_years['Navara_2010'] = 'D22|D40';
series_years['Navara_2011'] = 'D22|D40';
series_years['Navara_2012'] = 'D22|D40';
series_years['Navara_2013'] = 'D22|D40';
series_years['Navara_2014'] = 'D22|D40';
series_years['Navara_2015'] = 'D22|D40|Series 1';
series_years['Navara_2016'] = 'Series 1|Series 2';
series_years['Navara_2005'] = 'D22|D40';
series_years['Navara_2006'] = 'D22|D40';
series_years['Navara_2007'] = 'D22|D40';
series_years['Navara_2001'] = 'D22';
series_years['Navara_2002'] = 'D22';
series_years['Navara_2003'] = 'D22';
series_years['Navara_2004'] = 'D22';
series_years['Navara_1986'] = 'D21';
series_years['Navara_1987'] = 'D21';
series_years['Navara_1988'] = 'D21';
series_years['Navara_1989'] = 'D21';
series_years['Navara_1990'] = 'D21';
series_years['Navara_1991'] = 'D21';
series_years['Navara_1992'] = 'D21';
series_years['Navara_1997'] = 'D21|D22';
series_years['Navara_1998'] = 'D22';
series_years['Navara_1999'] = 'D22';
series_years['Navara_2000'] = 'D22';
series_years['Navara_1993'] = 'D21';
series_years['Navara_1994'] = 'D21';
series_years['Navara_1995'] = 'D21';
series_years['Navara_1996'] = 'D21';
series_years['Navara 4x2_2020'] = 'D23';
series_years['Navara 4x2_2021'] = 'D23';
series_years['Navara 4x2_2022'] = 'D23';
series_years['Navara 4x2_2023'] = 'D23';
series_years['Navara 4x2_2024'] = 'D23';
series_years['Navara 4x2_2025'] = 'D23';
series_years['Navara 4x4_2020'] = 'D23';
series_years['Navara 4x4_2021'] = 'D23';
series_years['Navara 4x4_2022'] = 'D23';
series_years['Navara 4x4_2023'] = 'D23';
series_years['Navara 4x4_2024'] = 'D23';
series_years['Navara 4x4_2025'] = 'D23';
series_years['Nissan Forklifts_1960'] = 'NISSAN';
series_years['Nissan Forklifts_1961'] = 'NISSAN';
series_years['Nissan Forklifts_1962'] = 'NISSAN';
series_years['Nissan Forklifts_1963'] = 'NISSAN';
series_years['Nissan Forklifts_1964'] = 'NISSAN';
series_years['Nissan Forklifts_1965'] = 'NISSAN';
series_years['Nissan Forklifts_1966'] = 'NISSAN';
series_years['Nissan Forklifts_1967'] = 'NISSAN';
series_years['Nissan Forklifts_1968'] = 'NISSAN';
series_years['Nissan Forklifts_1969'] = 'NISSAN';
series_years['Nissan Forklifts_1970'] = 'NISSAN';
series_years['Nissan Forklifts_1971'] = 'NISSAN';
series_years['Nissan Forklifts_1972'] = 'NISSAN';
series_years['Nissan Forklifts_1973'] = 'NISSAN';
series_years['Nissan Forklifts_1974'] = 'NISSAN';
series_years['Nissan Forklifts_1975'] = 'NISSAN';
series_years['Nissan Forklifts_1976'] = 'NISSAN';
series_years['Nissan Forklifts_1977'] = 'NISSAN';
series_years['Nissan Forklifts_1978'] = 'NISSAN';
series_years['Nissan Forklifts_1979'] = 'NISSAN';
series_years['Nissan Forklifts_1980'] = 'NISSAN';
series_years['Nissan Forklifts_1981'] = 'NISSAN';
series_years['Nissan Forklifts_1982'] = 'NISSAN';
series_years['Nissan Forklifts_1983'] = 'NISSAN';
series_years['Nissan Forklifts_1984'] = 'NISSAN';
series_years['Nissan Forklifts_1985'] = 'NISSAN';
series_years['Nissan Forklifts_1986'] = 'NISSAN';
series_years['Nissan Forklifts_1987'] = 'NISSAN';
series_years['Nissan Forklifts_1988'] = 'NISSAN';
series_years['Nissan Forklifts_1989'] = 'NISSAN';
series_years['Nissan Forklifts_1990'] = 'NISSAN';
series_years['Nissan Forklifts_1991'] = 'NISSAN';
series_years['Nissan Forklifts_1992'] = 'NISSAN';
series_years['Nissan Forklifts_1993'] = 'NISSAN';
series_years['Nissan Forklifts_1994'] = 'NISSAN';
series_years['Nissan Forklifts_1995'] = 'NISSAN';
series_years['Nissan Forklifts_1996'] = 'NISSAN';
series_years['Nissan Forklifts_1997'] = 'NISSAN';
series_years['Nissan Forklifts_1998'] = 'NISSAN';
series_years['Nissan Forklifts_1999'] = 'NISSAN';
series_years['Nissan Forklifts_2000'] = 'NISSAN';
series_years['Nissan Forklifts_2001'] = 'NISSAN';
series_years['Nissan Forklifts_2002'] = 'NISSAN';
series_years['Nissan Forklifts_2003'] = 'NISSAN';
series_years['Nissan Forklifts_2004'] = 'NISSAN';
series_years['Nissan Forklifts_2005'] = 'NISSAN';
series_years['Nissan Forklifts_2006'] = 'NISSAN';
series_years['Nissan Forklifts_2007'] = 'NISSAN';
series_years['Nissan Forklifts_2008'] = 'NISSAN';
series_years['Nissan Forklifts_2009'] = 'NISSAN';
series_years['Nissan Forklifts_2010'] = 'NISSAN';
series_years['Nissan Forklifts_2011'] = 'NISSAN';
series_years['Nissan Forklifts_2012'] = 'NISSAN';
series_years['Nissan Forklifts_2013'] = 'NISSAN';
series_years['Nissan Forklifts_2014'] = 'NISSAN';
series_years['Nissan Forklifts_2015'] = 'NISSAN';
series_years['Nissan Forklifts_2016'] = 'NISSAN';
series_years['Nissan Forklifts_2017'] = 'NISSAN';
series_years['Nissan Forklifts_2018'] = 'NISSAN';
series_years['Nissan Forklifts_2019'] = 'NISSAN';
series_years['Nissan Forklifts_2020'] = 'NISSAN';
series_years['Nissan Forklifts_2021'] = 'NISSAN';
series_years['Nissan Forklifts_2022'] = 'NISSAN';
series_years['Nissan Forklifts_2023'] = 'NISSAN';
series_years['Nissan Forklifts_2024'] = 'NISSAN';
series_years['Nissan Forklifts_2025'] = 'NISSAN';
series_years['Nissan Truck_1993'] = 'CK450/CW520|H40|H41';
series_years['Nissan Truck_1994'] = 'CK450/CW520|H41';
series_years['Nissan Truck_1995'] = 'CK450/CW520|H41';
series_years['Nissan Truck_1996'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_1997'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_1998'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_1999'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2000'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2001'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2002'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2003'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2004'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2005'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2006'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2007'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2008'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2009'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2010'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2011'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2012'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2013'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2014'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2015'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2016'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2017'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2018'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2019'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2020'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2021'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2022'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2023'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2024'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_2025'] = 'CK450/CW520|H41|LK/MK/PK';
series_years['Nissan Truck_1992'] = 'CK450/CW520|H40';
series_years['Nissan Truck_1983'] = 'H40';
series_years['Nissan Truck_1984'] = 'H40';
series_years['Nissan Truck_1985'] = 'H40';
series_years['Nissan Truck_1986'] = 'H40';
series_years['Nissan Truck_1987'] = 'H40';
series_years['Nissan Truck_1988'] = 'H40';
series_years['Nissan Truck_1989'] = 'H40';
series_years['Nissan Truck_1990'] = 'H40';
series_years['Nissan Truck_1991'] = 'H40';
series_years['NX / NXR_1991'] = 'B13';
series_years['NX / NXR_1992'] = 'B13';
series_years['NX / NXR_1993'] = 'B13';
series_years['NX / NXR_1994'] = 'B13';
series_years['NX / NXR_1995'] = 'B13';
series_years['NX / NXR_1996'] = 'B13';
series_years['Pathfinder_2018'] = 'R52';
series_years['Pathfinder_2019'] = 'R52';
series_years['Pathfinder_2020'] = 'R52';
series_years['Pathfinder_2005'] = 'R50|R51';
series_years['Pathfinder_2006'] = 'R51';
series_years['Pathfinder_2007'] = 'R51';
series_years['Pathfinder_2008'] = 'R51';
series_years['Pathfinder_2009'] = 'R51';
series_years['Pathfinder_2010'] = 'R51';
series_years['Pathfinder_2011'] = 'R51';
series_years['Pathfinder_2012'] = 'R51';
series_years['Pathfinder_2013'] = 'R51|R52';
series_years['Pathfinder_2017'] = 'R52';
series_years['Pathfinder_1986'] = 'D21';
series_years['Pathfinder_1987'] = 'D21';
series_years['Pathfinder_1988'] = 'D21';
series_years['Pathfinder_1989'] = 'D21';
series_years['Pathfinder_1990'] = 'D21';
series_years['Pathfinder_1991'] = 'D21';
series_years['Pathfinder_1992'] = 'D21';
series_years['Pathfinder_1993'] = 'D21';
series_years['Pathfinder_1994'] = 'D21';
series_years['Pathfinder_1995'] = 'D21|R50';
series_years['Pathfinder_2014'] = 'R52';
series_years['Pathfinder_2015'] = 'R52';
series_years['Pathfinder_2016'] = 'R52';
series_years['Pathfinder_1996'] = 'R50';
series_years['Pathfinder_1997'] = 'R50';
series_years['Pathfinder_1998'] = 'R50';
series_years['Pathfinder_1999'] = 'R50';
series_years['Pathfinder_2000'] = 'R50';
series_years['Pathfinder_2001'] = 'R50';
series_years['Pathfinder_2002'] = 'R50';
series_years['Pathfinder_2003'] = 'R50';
series_years['Pathfinder_2004'] = 'R50';
series_years['Patrol_2011'] = 'GU';
series_years['Patrol_2012'] = 'GU|Y62';
series_years['Patrol_2013'] = 'GU|Y62';
series_years['Patrol_2014'] = 'GU|Y62';
series_years['Patrol_2015'] = 'GU|Y62';
series_years['Patrol_2016'] = 'GU|Y62';
series_years['Patrol_2023'] = 'Y62';
series_years['Patrol_2024'] = 'Y62';
series_years['Patrol_2025'] = 'Y62';
series_years['Patrol_2017'] = 'Y62';
series_years['Patrol_2008'] = 'GU';
series_years['Patrol_2009'] = 'GU';
series_years['Patrol_2007'] = 'GU';
series_years['Patrol_2010'] = 'GU';
series_years['Patrol_2006'] = 'GU';
series_years['Patrol_1980'] = 'MQ';
series_years['Patrol_1981'] = 'MQ';
series_years['Patrol_1982'] = 'MQ';
series_years['Patrol_1983'] = 'MQ';
series_years['Patrol_1984'] = 'MQ';
series_years['Patrol_1985'] = 'MQ';
series_years['Patrol_1986'] = 'MQ';
series_years['Patrol_1987'] = 'GQ|MQ';
series_years['Patrol_1988'] = 'GQ';
series_years['Patrol_1989'] = 'GQ';
series_years['Patrol_1990'] = 'GQ';
series_years['Patrol_1991'] = 'GQ';
series_years['Patrol_1992'] = 'GQ';
series_years['Patrol_1993'] = 'GQ';
series_years['Patrol_1994'] = 'GQ';
series_years['Patrol_1995'] = 'GQ';
series_years['Patrol_1996'] = 'GQ';
series_years['Patrol_1997'] = 'GQ|GU';
series_years['Patrol_2001'] = 'GU';
series_years['Patrol_2002'] = 'GU';
series_years['Patrol_2003'] = 'GU';
series_years['Patrol_2004'] = 'GU';
series_years['Patrol_2005'] = 'GU';
series_years['Patrol_2019'] = 'Y62';
series_years['Patrol_2020'] = 'Y62';
series_years['Patrol_2021'] = 'Y62';
series_years['Patrol_2022'] = 'Y62';
series_years['Patrol_1998'] = 'GU';
series_years['Patrol_1999'] = 'GU';
series_years['Patrol_2000'] = 'GU';
series_years['Patrol_2018'] = 'Y62';
series_years['Pulsar_2001'] = 'N16';
series_years['Pulsar_2002'] = 'N16';
series_years['Pulsar_2003'] = 'N16';
series_years['Pulsar_2004'] = 'N16';
series_years['Pulsar_2005'] = 'N16';
series_years['Pulsar_2006'] = 'N16';
series_years['Pulsar_1987'] = 'N12|N13';
series_years['Pulsar_1988'] = 'N13';
series_years['Pulsar_1989'] = 'N13';
series_years['Pulsar_1990'] = 'N13';
series_years['Pulsar_1991'] = 'N13|N14';
series_years['Pulsar_2000'] = 'N15|N16';
series_years['Pulsar_1995'] = 'N14|N15';
series_years['Pulsar_1996'] = 'N15';
series_years['Pulsar_1997'] = 'N15';
series_years['Pulsar_1998'] = 'N15';
series_years['Pulsar_1999'] = 'N15';
series_years['Pulsar_2013'] = 'B17|C12';
series_years['Pulsar_2014'] = 'B17|C12';
series_years['Pulsar_2015'] = 'B17|C12';
series_years['Pulsar_2016'] = 'B17|C12';
series_years['Pulsar_1982'] = 'N12';
series_years['Pulsar_1983'] = 'N12';
series_years['Pulsar_1984'] = 'N12';
series_years['Pulsar_1985'] = 'N12';
series_years['Pulsar_1986'] = 'N12';
series_years['Pulsar_2012'] = 'B17';
series_years['Pulsar_2017'] = 'B17';
series_years['Pulsar_1992'] = 'N14';
series_years['Pulsar_1993'] = 'N14';
series_years['Pulsar_1994'] = 'N14';
series_years['Qashqai_2014'] = 'J11';
series_years['Qashqai_2015'] = 'J11';
series_years['Qashqai_2016'] = 'J11';
series_years['Qashqai_2017'] = 'J11';
series_years['Qashqai_2018'] = 'J11';
series_years['Qashqai_2019'] = 'J11';
series_years['Qashqai_2020'] = 'J11';
series_years['Qashqai_2021'] = 'J11';
series_years['Qashqai_2022'] = 'J11|J12';
series_years['Qashqai_2023'] = 'J12';
series_years['Qashqai_2024'] = 'J12';
series_years['Qashqai_2025'] = 'J12';
series_years['Skyline_1998'] = 'R33|R34';
series_years['Skyline_1999'] = 'R34';
series_years['Skyline_2000'] = 'R34';
series_years['Skyline_2001'] = 'R34';
series_years['Skyline_2002'] = 'R34';
series_years['Skyline_1991'] = 'R32';
series_years['Skyline_1992'] = 'R32';
series_years['Skyline_1993'] = 'R32|R33';
series_years['Skyline_1994'] = 'R33';
series_years['Skyline_1995'] = 'R33';
series_years['Skyline_1996'] = 'R33';
series_years['Skyline_1997'] = 'R33';
series_years['Skyline / Pintara_1986'] = 'R31';
series_years['Skyline / Pintara_1987'] = 'R31';
series_years['Skyline / Pintara_1988'] = 'R31';
series_years['Skyline / Pintara_1989'] = 'R31|U12';
series_years['Skyline / Pintara_1990'] = 'R31|U12';
series_years['Skyline / Pintara_1991'] = 'U12';
series_years['Skyline / Pintara_1992'] = 'U12';
series_years['Skyline / Pintara_1993'] = 'U12';
series_years['Sunny_1979'] = 'SUNNY';
series_years['Sunny_1980'] = 'SUNNY';
series_years['Sunny_1981'] = 'SUNNY';
series_years['Terrano_1996'] = 'R20';
series_years['Terrano_1997'] = 'R20';
series_years['Terrano_1998'] = 'R20';
series_years['Terrano_1999'] = 'R20';
series_years['Tiida_2006'] = 'C11';
series_years['Tiida_2007'] = 'C11';
series_years['Tiida_2008'] = 'C11';
series_years['Tiida_2009'] = 'C11';
series_years['Tiida_2010'] = 'C11';
series_years['Tiida_2011'] = 'C11';
series_years['Tiida_2012'] = 'C11';
series_years['Urvan_1986'] = 'E24';
series_years['Urvan_1987'] = 'E24';
series_years['Urvan_1988'] = 'E24';
series_years['Urvan_1989'] = 'E24';
series_years['Urvan_1990'] = 'E24';
series_years['Urvan_1991'] = 'E24';
series_years['Urvan_1992'] = 'E24';
series_years['Urvan_1993'] = 'E24';
series_years['Urvan_1983'] = 'E23';
series_years['Urvan_1984'] = 'E23';
series_years['Urvan_1985'] = 'E23';
series_years['Vanette / Nomad_1986'] = 'C22';
series_years['Vanette / Nomad_1987'] = 'C22';
series_years['Vanette / Nomad_1988'] = 'C22';
series_years['Vanette / Nomad_1989'] = 'C22';
series_years['Vanette / Nomad_1990'] = 'C22';
series_years['Vanette / Nomad_1991'] = 'C22';
series_years['Vanette / Nomad_1992'] = 'C22';
series_years['Vanette / Nomad_1993'] = 'C22';
series_years['X-trail_2015'] = 'T32';
series_years['X-trail_2001'] = 'T30';
series_years['X-trail_2002'] = 'T30';
series_years['X-trail_2003'] = 'T30';
series_years['X-trail_2004'] = 'T30';
series_years['X-trail_2005'] = 'T30';
series_years['X-trail_2006'] = 'T30';
series_years['X-trail_2007'] = 'T30|T31';
series_years['X-trail_2016'] = 'T32';
series_years['X-trail_2017'] = 'T32';
series_years['X-trail_2018'] = 'T32';
series_years['X-trail_2019'] = 'T32';
series_years['X-trail_2020'] = 'T32';
series_years['X-trail_2008'] = 'T31';
series_years['X-trail_2009'] = 'T31';
series_years['X-trail_2010'] = 'T31';
series_years['X-trail_2011'] = 'T31';
series_years['X-trail_2012'] = 'T31';
series_years['X-trail_2013'] = 'T31';
series_years['X-trail_2014'] = 'T31|T32';
series_years['X-trail_2023'] = 'T33';
series_years['X-trail_2024'] = 'T33';
series_years['X-trail_2025'] = 'T33';
series_years['X-trail_2022'] = 'T32|T33';
series_years['X-trail_2021'] = 'T32';
series_years['2008_2017'] = 'A94';
series_years['2008_2018'] = 'A94';
series_years['2008_2013'] = 'A94';
series_years['2008_2014'] = 'A94';
series_years['2008_2015'] = 'A94';
series_years['2008_2016'] = 'A94';
series_years['206_1999'] = 'XR';
series_years['206_2000'] = 'XR';
series_years['206_2001'] = 'XR';
series_years['206_2002'] = 'XR';
series_years['206_2003'] = 'XR';
series_years['206_2004'] = 'XR';
series_years['206_2005'] = 'XR';
series_years['206_2006'] = 'XR';
series_years['207_2009'] = 'A7';
series_years['207_2010'] = 'A7';
series_years['207_2011'] = 'A7';
series_years['207_2012'] = 'A7';
series_years['207_2007'] = 'A7';
series_years['207_2008'] = 'A7';
series_years['208_2013'] = 'A9';
series_years['208_2014'] = 'A9';
series_years['208_2015'] = 'A9';
series_years['208_2016'] = 'A9';
series_years['208_2017'] = 'A9';
series_years['208_2018'] = 'A9';
series_years['208_2019'] = 'A9';
series_years['208_2012'] = 'A9';
series_years['3008_2022'] = 'P84';
series_years['3008_2023'] = 'P84';
series_years['3008_2024'] = 'P84';
series_years['3008_2017'] = 'P84';
series_years['3008_2018'] = 'P84';
series_years['3008_2019'] = 'P84';
series_years['3008_2020'] = 'P84';
series_years['3008_2021'] = 'P84';
series_years['3008_2010'] = 'T8';
series_years['3008_2011'] = 'T8';
series_years['3008_2012'] = 'T8';
series_years['3008_2013'] = 'T8';
series_years['3008_2014'] = 'T8';
series_years['3008_2015'] = 'T8';
series_years['3008_2016'] = 'T8';
series_years['306_1994'] = 'N3';
series_years['306_1995'] = 'N3';
series_years['306_1996'] = 'N3';
series_years['306_1997'] = 'N3';
series_years['307_2001'] = 'T5';
series_years['307_2002'] = 'T5';
series_years['307_2003'] = 'T5';
series_years['307_2004'] = 'T5';
series_years['307_2005'] = 'T5|T6';
series_years['307_2006'] = 'T6';
series_years['307_2007'] = 'T6';
series_years['307_2008'] = 'T6';
series_years['307_2009'] = 'T6';
series_years['308_2016'] = 'T9';
series_years['308_2017'] = 'T9';
series_years['308_2018'] = 'T9';
series_years['308_2014'] = 'T9';
series_years['308_2015'] = 'T9';
series_years['308_2019'] = 'T9';
series_years['308_2020'] = 'T9';
series_years['308_2008'] = 'T7';
series_years['308_2009'] = 'T7';
series_years['308_2010'] = 'T7';
series_years['308_2011'] = 'T7';
series_years['308_2021'] = 'T9';
series_years['4007_2009'] = 'GS';
series_years['4007_2010'] = 'GS';
series_years['4007_2011'] = 'GS';
series_years['4007_2012'] = 'GS';
series_years['4008_2012'] = '3BU';
series_years['4008_2013'] = '3BU';
series_years['4008_2014'] = '3BU';
series_years['4008_2015'] = '3BU';
series_years['4008_2016'] = '3BU';
series_years['4008_2017'] = '3BU';
series_years['4008_2018'] = '3BU';
series_years['407_2004'] = 'SV';
series_years['407_2005'] = 'SV';
series_years['407_2006'] = 'SV';
series_years['407_2007'] = 'SV';
series_years['407_2008'] = 'SV';
series_years['407_2009'] = 'SV';
series_years['407_2010'] = 'SV';
series_years['407_2011'] = 'SV';
series_years['5008_2018'] = 'P87';
series_years['5008_2019'] = 'P87';
series_years['5008_2020'] = 'P87';
series_years['5008_2013'] = '5008';
series_years['5008_2014'] = '5008';
series_years['5008_2015'] = '5008';
series_years['5008_2022'] = 'P87';
series_years['5008_2023'] = 'P87';
series_years['5008_2024'] = 'P87';
series_years['5008_2025'] = 'P87';
series_years['5008_2021'] = 'P87';
series_years['508_2016'] = '38D|38E';
series_years['508_2017'] = '38D|38E';
series_years['508_2013'] = '38D|38E';
series_years['508_2014'] = '38D|38E';
series_years['508_2012'] = '38D|38E';
series_years['508_2015'] = '38D|38E';
series_years['508_2018'] = '38E';
series_years['508_2011'] = '38D|38E';
series_years['2_2021'] = '2C|534';
series_years['2_2022'] = '2C|534';
series_years['2_2019'] = '2C';
series_years['2_2020'] = '2C';
series_years['2_2023'] = '2C|DJ';
series_years['2_2007'] = 'DE|DY';
series_years['2_2008'] = 'DE';
series_years['2_2009'] = 'DE';
series_years['2_2010'] = 'DE';
series_years['2_2011'] = 'DE';
series_years['2_2012'] = 'DE';
series_years['2_2013'] = 'DE';
series_years['2_2014'] = 'DE|DJ';
series_years['2_2015'] = 'DJ|DL';
series_years['2_2016'] = 'DJ|DL';
series_years['2_2017'] = '2C|DJ|DL';
series_years['2_2024'] = 'DJ';
series_years['2_2025'] = 'DJ';
series_years['2_2002'] = 'DY';
series_years['2_2003'] = 'DY';
series_years['2_2004'] = 'DY';
series_years['2_2005'] = 'DY';
series_years['2_2006'] = 'DY';
series_years['2_2018'] = '2C';
series_years['Macan_2013'] = '95B';
series_years['Macan_2014'] = '95B';
series_years['Macan_2015'] = '95B';
series_years['Macan_2016'] = '95B';
series_years['Macan_2017'] = '95B';
series_years['Macan_2018'] = '95B';
series_years['Gen II_2004'] = 'CM';
series_years['Gen II_2005'] = 'CM';
series_years['Gen II_2006'] = 'CM';
series_years['Gen II_2007'] = 'CM';
series_years['Gen II_2008'] = 'CM';
series_years['Gen II_2009'] = 'CM';
series_years['Gen II_2010'] = 'CM';
series_years['Gen II_2011'] = 'CM';
series_years['Gen II_2012'] = 'CM';
series_years['Gen II_2013'] = 'CM';
series_years['M21_1997'] = 'C90';
series_years['M21_1998'] = 'C90';
series_years['M21_1999'] = 'C90';
series_years['Satria_1997'] = 'C90';
series_years['Satria_1998'] = 'C90';
series_years['Satria_1999'] = 'C90';
series_years['Satria_2000'] = 'C90';
series_years['Satria_2001'] = 'C90';
series_years['Satria_2002'] = 'C90';
series_years['Satria_2003'] = 'C90';
series_years['Satria_2004'] = 'C90';
series_years['Satria_2005'] = 'C90';
series_years['Satria_2007'] = 'BS';
series_years['Satria_2008'] = 'BS';
series_years['Satria_2009'] = 'BS';
series_years['Satria_2010'] = 'BS';
series_years['Satria_2011'] = 'BS';
series_years['Satria_2012'] = 'BS';
series_years['Waja_2001'] = 'CF';
series_years['Waja_2002'] = 'CF';
series_years['Waja_2003'] = 'CF';
series_years['Waja_2004'] = 'CF';
series_years['Waja_2005'] = 'CF';
series_years['Wira / Persona_1995'] = 'WIRA/PERSONA';
series_years['Wira / Persona_1996'] = 'WIRA/PERSONA';
series_years['Wira / Persona_1997'] = 'WIRA/PERSONA';
series_years['Wira / Persona_1998'] = 'WIRA/PERSONA';
series_years['Wira / Persona_1999'] = 'WIRA/PERSONA';
series_years['Wira / Persona_2000'] = 'WIRA/PERSONA';
series_years['Wira / Persona_2001'] = 'WIRA/PERSONA';
series_years['Wira / Persona_2002'] = 'WIRA/PERSONA';
series_years['Wira / Persona_2003'] = 'WIRA/PERSONA';
series_years['Wira / Persona_2004'] = 'WIRA/PERSONA';
series_years['Wira / Persona_2005'] = 'WIRA/PERSONA';
series_years['Clio_2017'] = 'IV B98|IV B98 PHASE 2';
series_years['Clio_2018'] = 'IV B98 PHASE 2';
series_years['Clio_2019'] = 'IV B98 PHASE 2';
series_years['Clio_2009'] = 'C85';
series_years['Clio_2010'] = 'C85';
series_years['Clio_2014'] = 'IV B98';
series_years['Clio_2015'] = 'IV B98';
series_years['Clio_2016'] = 'IV B98';
series_years['Clio_2013'] = 'C85|IV B98';
series_years['Clio_2020'] = 'IV B98 PHASE 2';
series_years['Clio_2001'] = 'MKII/MKIII/MKIV';
series_years['Clio_2002'] = 'MKII/MKIII/MKIV';
series_years['Clio_2003'] = 'MKII/MKIII/MKIV';
series_years['Clio_2004'] = 'MKII/MKIII/MKIV';
series_years['Clio_2005'] = 'MKII/MKIII/MKIV';
series_years['Clio_2006'] = 'MKII/MKIII/MKIV';
series_years['Clio_2007'] = 'MKII/MKIII/MKIV';
series_years['Clio_2008'] = 'MKII/MKIII/MKIV';
series_years['Clio_2012'] = 'C85';
series_years['Kangoo_2013'] = 'X61|X76';
series_years['Kangoo_2014'] = 'X61';
series_years['Kangoo_2015'] = 'X61';
series_years['Kangoo_2016'] = 'X61';
series_years['Kangoo_2017'] = 'X61';
series_years['Kangoo_2018'] = 'X61';
series_years['Kangoo_2019'] = 'X61';
series_years['Kangoo_2020'] = 'X61';
series_years['Kangoo_2021'] = 'X61';
series_years['Kangoo_2004'] = 'X76';
series_years['Kangoo_2005'] = 'X76';
series_years['Kangoo_2006'] = 'X76';
series_years['Kangoo_2007'] = 'X76';
series_years['Kangoo_2008'] = 'X76';
series_years['Kangoo_2009'] = 'X76';
series_years['Kangoo_2010'] = 'X76';
series_years['Kangoo_2011'] = 'X76';
series_years['Kangoo_2012'] = 'X76';
series_years['Koleos_2017'] = 'XZG';
series_years['Koleos_2018'] = 'XZG';
series_years['Koleos_2019'] = 'XZG';
series_years['Koleos_2016'] = 'XZG';
series_years['Koleos_2020'] = 'XZG';
series_years['Koleos_2021'] = 'XZG';
series_years['Koleos_2022'] = 'XZG';
series_years['Master_2011'] = 'X62';
series_years['Master_2012'] = 'X62';
series_years['Master_2013'] = 'X62';
series_years['Master_2019'] = 'X62';
series_years['Master_2020'] = 'X62';
series_years['Master_2021'] = 'X62';
series_years['Master_2022'] = 'X62';
series_years['Master_2023'] = 'X62';
series_years['Master_2024'] = 'X62';
series_years['Master_2025'] = 'X62';
series_years['Master_2014'] = 'X62';
series_years['Master_2015'] = 'X62';
series_years['Master_2016'] = 'X62';
series_years['Master_2017'] = 'X62';
series_years['Master_2018'] = 'X62';
series_years['Megane_2016'] = 'Fourth Generation|Third Generation Phase 2';
series_years['Megane_2017'] = 'Fourth Generation|Third Generation Phase 2';
series_years['Megane_2018'] = 'Fourth Generation';
series_years['Megane_2019'] = 'Fourth Generation';
series_years['Megane_2013'] = 'Third Generation|Third Generation (MY12 / MY13)';
series_years['Megane_2014'] = 'Third Generation|Third Generation (MY12 / MY13)|Third Generation Phase 2';
series_years['Megane_2004'] = 'First Generation|Second Generation';
series_years['Megane_2005'] = 'First Generation|Second Generation';
series_years['Megane_2006'] = 'First Generation|Second Generation|Second Generation Phase II';
series_years['Megane_2020'] = 'Fourth Generation';
series_years['Megane_2010'] = 'Second Generation Phase II|Third Generation';
series_years['Megane_2011'] = 'Third Generation';
series_years['Megane_2012'] = 'Third Generation';
series_years['Megane_2015'] = 'Third Generation (MY12 / MY13)|Third Generation Phase 2';
series_years['Megane_2003'] = 'First Generation|Second Generation';
series_years['Megane_2009'] = 'Second Generation Phase II';
series_years['Megane_2008'] = 'Second Generation Phase II';
series_years['Megane_2007'] = 'Second Generation Phase II';
series_years['Megane_2001'] = 'First Generation';
series_years['Megane_2002'] = 'First Generation';
series_years['Scenic_2001'] = 'J84';
series_years['Scenic_2002'] = 'J84';
series_years['Scenic_2003'] = 'J84';
series_years['Scenic_2004'] = 'J84';
series_years['Scenic_2005'] = 'J84';
series_years['Trafic_2016'] = 'X82';
series_years['Trafic_2017'] = 'X82';
series_years['Trafic_2018'] = 'X82';
series_years['Trafic_2019'] = 'X82';
series_years['Trafic_2004'] = 'X83';
series_years['Trafic_2005'] = 'X83';
series_years['Trafic_2006'] = 'X83';
series_years['Trafic_2007'] = 'X83';
series_years['Trafic_2008'] = 'X83';
series_years['Trafic_2009'] = 'X83';
series_years['Trafic_2010'] = 'X83';
series_years['Trafic_2011'] = 'X83';
series_years['Trafic_2012'] = 'X83';
series_years['Trafic_2013'] = 'X83';
series_years['Trafic_2014'] = 'X83';
series_years['Trafic_2022'] = 'X82';
series_years['Trafic_2023'] = 'X82';
series_years['Trafic_2024'] = 'X82';
series_years['Trafic_2025'] = 'X82';
series_years['Trafic_2015'] = 'X82';
series_years['Trafic_2020'] = 'X82';
series_years['Trafic_2021'] = 'X82';
series_years['9000_1992'] = '9000';
series_years['9000_1993'] = '9000';
series_years['9000_1994'] = '9000';
series_years['9000_1995'] = '9000';
series_years['9000_1996'] = '9000';
series_years['9000_1997'] = '9000';
series_years['9-3_2002'] = '9-3';
series_years['9-3_2003'] = '9-3';
series_years['9-3_2004'] = '9-3';
series_years['9-3_2005'] = '9-3';
series_years['9-3_2006'] = '9-3';
series_years['9-3_2007'] = '9-3';
series_years['9-3_2008'] = '9-3';
series_years['9-3_1998'] = '9-3';
series_years['9-3_1999'] = '9-3';
series_years['9-3_2000'] = '9-3';
series_years['9-3_2001'] = '9-3';
series_years['Scania Truck_1988'] = '112/113|SCANIA';
series_years['Scania Truck_1989'] = '112/113|SCANIA';
series_years['Scania Truck_1990'] = '112/113|SCANIA';
series_years['Scania Truck_1991'] = '112/113|SCANIA';
series_years['Scania Truck_1992'] = '112/113|SCANIA';
series_years['Scania Truck_1993'] = '112/113|SCANIA';
series_years['Scania Truck_1994'] = '112/113|SCANIA';
series_years['Scania Truck_1995'] = '112/113|SCANIA';
series_years['Scania Truck_1996'] = '112/113|SCANIA';
series_years['Scania Truck_1997'] = '112/113|SCANIA';
series_years['Scania Truck_1960'] = 'SCANIA';
series_years['Scania Truck_1961'] = 'SCANIA';
series_years['Scania Truck_1962'] = 'SCANIA';
series_years['Scania Truck_1963'] = 'SCANIA';
series_years['Scania Truck_1964'] = 'SCANIA';
series_years['Scania Truck_1965'] = 'SCANIA';
series_years['Scania Truck_1966'] = 'SCANIA';
series_years['Scania Truck_1967'] = 'SCANIA';
series_years['Scania Truck_1968'] = 'SCANIA';
series_years['Scania Truck_1969'] = 'SCANIA';
series_years['Scania Truck_1970'] = 'SCANIA';
series_years['Scania Truck_1971'] = 'SCANIA';
series_years['Scania Truck_1972'] = 'SCANIA';
series_years['Scania Truck_1973'] = 'SCANIA';
series_years['Scania Truck_1974'] = 'SCANIA';
series_years['Scania Truck_1975'] = 'SCANIA';
series_years['Scania Truck_1976'] = 'SCANIA';
series_years['Scania Truck_1977'] = 'SCANIA';
series_years['Scania Truck_1978'] = 'SCANIA';
series_years['Scania Truck_1979'] = 'SCANIA';
series_years['Scania Truck_1980'] = 'SCANIA';
series_years['Scania Truck_1981'] = 'SCANIA';
series_years['Scania Truck_1982'] = 'SCANIA';
series_years['Scania Truck_1983'] = 'SCANIA';
series_years['Scania Truck_1984'] = 'SCANIA';
series_years['Scania Truck_1985'] = 'SCANIA';
series_years['Scania Truck_1986'] = 'SCANIA';
series_years['Scania Truck_1987'] = 'SCANIA';
series_years['Scania Truck_1998'] = 'SCANIA';
series_years['Scania Truck_1999'] = 'SCANIA';
series_years['Scania Truck_2000'] = 'SCANIA';
series_years['Scania Truck_2001'] = 'SCANIA';
series_years['Scania Truck_2002'] = 'SCANIA';
series_years['Scania Truck_2003'] = 'SCANIA';
series_years['Scania Truck_2004'] = 'SCANIA';
series_years['Scania Truck_2005'] = 'SCANIA';
series_years['Scania Truck_2006'] = 'SCANIA';
series_years['Scania Truck_2007'] = 'SCANIA';
series_years['Scania Truck_2008'] = 'SCANIA';
series_years['Scania Truck_2009'] = 'SCANIA';
series_years['Scania Truck_2010'] = 'SCANIA';
series_years['Scania Truck_2011'] = 'SCANIA';
series_years['Scania Truck_2012'] = 'SCANIA';
series_years['Scania Truck_2013'] = 'SCANIA';
series_years['Scania Truck_2014'] = 'SCANIA';
series_years['Scania Truck_2015'] = 'SCANIA';
series_years['Scania Truck_2016'] = 'SCANIA';
series_years['Scania Truck_2017'] = 'SCANIA';
series_years['Scania Truck_2018'] = 'SCANIA';
series_years['Scania Truck_2019'] = 'SCANIA';
series_years['Scania Truck_2020'] = 'SCANIA';
series_years['Scania Truck_2021'] = 'SCANIA';
series_years['Scania Truck_2022'] = 'SCANIA';
series_years['Scania Truck_2023'] = 'SCANIA';
series_years['Scania Truck_2024'] = 'SCANIA';
series_years['Scania Truck_2025'] = 'SCANIA';
series_years['Cordoba_1995'] = '6K';
series_years['Cordoba_1996'] = '6K';
series_years['Cordoba_1997'] = '6K';
series_years['Cordoba_1998'] = '6K';
series_years['Cordoba_1999'] = '6K';
series_years['Fabia_2017'] = 'NJ';
series_years['Fabia_2018'] = 'NJ';
series_years['Fabia_2013'] = '5J';
series_years['Fabia_2014'] = '5J';
series_years['Fabia_2015'] = '5J|NJ';
series_years['Fabia_2012'] = '5J';
series_years['Fabia_2016'] = 'NJ';
series_years['Fabia_2011'] = '5J';
series_years['Fabia_2019'] = 'NJ';
series_years['Fabia_2020'] = 'NJ';
series_years['Fabia_2021'] = 'NJ';
series_years['Fabia_2022'] = 'NJ';
series_years['Kamiq_2020'] = 'NW';
series_years['Kamiq_2021'] = 'NW';
series_years['Kamiq_2022'] = 'NW';
series_years['Kamiq_2023'] = 'NW';
series_years['Kamiq_2024'] = 'NW';
series_years['Kamiq_2025'] = 'NW';
series_years['Karoq_2020'] = 'NU';
series_years['Karoq_2021'] = 'NU';
series_years['Karoq_2022'] = 'NU';
series_years['Karoq_2023'] = 'NU';
series_years['Karoq_2024'] = 'NU';
series_years['Karoq_2025'] = 'NU';
series_years['Karoq_2017'] = 'NU';
series_years['Karoq_2018'] = 'NU';
series_years['Karoq_2019'] = 'NU';
series_years['Kodiaq_2021'] = 'NS';
series_years['Kodiaq_2022'] = 'NS';
series_years['Kodiaq_2023'] = 'NS';
series_years['Kodiaq_2024'] = 'NS';
series_years['Kodiaq_2025'] = 'NS';
series_years['Kodiaq_2017'] = 'NS';
series_years['Kodiaq_2018'] = 'NS';
series_years['Kodiaq_2019'] = 'NS';
series_years['Kodiaq_2020'] = 'NS';
series_years['Kodiaq Sportline_2017'] = 'NS';
series_years['Kodiaq Sportline_2018'] = 'NS';
series_years['Kodiaq Sportline_2019'] = 'NS';
series_years['Kodiaq Sportline_2020'] = 'NS';
series_years['Kodiaq Sportline_2021'] = 'NS';
series_years['Octavia_2013'] = '1Z|NE';
series_years['Octavia_2014'] = 'NE';
series_years['Octavia_2015'] = 'NE';
series_years['Octavia_2016'] = 'NE';
series_years['Octavia_2017'] = 'NE';
series_years['Octavia_2007'] = '1Z';
series_years['Octavia_2008'] = '1Z';
series_years['Octavia_2009'] = '1Z';
series_years['Octavia_2010'] = '1Z';
series_years['Octavia_2011'] = '1Z';
series_years['Octavia_2012'] = '1Z';
series_years['Octavia_2021'] = 'NX';
series_years['Octavia_2022'] = 'NX';
series_years['Octavia_2023'] = 'NX';
series_years['Octavia_2024'] = 'NX';
series_years['Octavia_2025'] = 'NX';
series_years['Octavia_2020'] = 'NE|NX';
series_years['Octavia_2018'] = 'NE';
series_years['Octavia_2019'] = 'NE';
series_years['Rapid_2018'] = 'NH';
series_years['Rapid_2019'] = 'NH';
series_years['Rapid_2020'] = 'NH';
series_years['Rapid_2021'] = 'NH';
series_years['Rapid_2022'] = 'NH';
series_years['Rapid_2023'] = 'NH';
series_years['Rapid_2024'] = 'NH';
series_years['Rapid_2025'] = 'NH';
series_years['Rapid_2014'] = 'NH';
series_years['Rapid_2015'] = 'NH';
series_years['Rapid_2013'] = 'NH';
series_years['Rapid_2016'] = 'NH';
series_years['Rapid_2017'] = 'NH';
series_years['Superb_2014'] = '3T';
series_years['Superb_2015'] = '3T';
series_years['Superb_2016'] = '3T|NP';
series_years['Superb_2020'] = 'NP';
series_years['Superb_2021'] = 'NP';
series_years['Superb_2022'] = 'NP';
series_years['Superb_2017'] = 'NP';
series_years['Superb_2018'] = 'NP';
series_years['Superb_2019'] = 'NP';
series_years['Superb_2023'] = 'NP';
series_years['Superb_2009'] = '3T';
series_years['Superb_2010'] = '3T';
series_years['Superb_2011'] = '3T';
series_years['Superb_2012'] = '3T';
series_years['Superb_2013'] = '3T';
series_years['Yeti_2015'] = '5L';
series_years['Yeti_2016'] = '5L';
series_years['Yeti_2017'] = '5L';
series_years['Yeti_2013'] = '5L';
series_years['Yeti_2014'] = '5L';
series_years['Yeti_2012'] = '5L';
series_years['Yeti_2011'] = '5L';
series_years['Kyron_2014'] = 'D100';
series_years['Kyron_2015'] = 'D100';
series_years['Kyron_2016'] = 'D100';
series_years['Kyron_2017'] = 'D100';
series_years['Kyron_2018'] = 'D100';
series_years['Kyron_2019'] = 'D100';
series_years['Kyron_2020'] = 'D100';
series_years['Kyron_2021'] = 'D100';
series_years['Kyron_2022'] = 'D100';
series_years['Kyron_2023'] = 'D100';
series_years['Kyron_2024'] = 'D100';
series_years['Kyron_2025'] = 'D100';
series_years['BRZ_2017'] = 'Z1';
series_years['BRZ_2018'] = 'Z1';
series_years['BRZ_2019'] = 'Z1';
series_years['BRZ_2020'] = 'Z1';
series_years['BRZ_2021'] = 'Z1|ZD8';
series_years['BRZ_2022'] = 'ZD8';
series_years['BRZ_2023'] = 'ZD8';
series_years['BRZ_2024'] = 'ZD8';
series_years['BRZ_2025'] = 'ZD8';
series_years['BRZ_2013'] = 'Z1';
series_years['BRZ_2014'] = 'Z1';
series_years['BRZ_2015'] = 'Z1';
series_years['BRZ_2016'] = 'Z1';
series_years['BRZ_2012'] = 'Z1';
series_years['Crosstrek_2023'] = 'G6X';
series_years['Crosstrek_2024'] = 'G6X';
series_years['Crosstrek_2025'] = 'G6X';
series_years['Forester_2020'] = 'S5';
series_years['Forester_2010'] = 'S3';
series_years['Forester_2018'] = 'S4|S5';
series_years['Forester_2019'] = 'S5';
series_years['Forester_2003'] = 'SG';
series_years['Forester_2004'] = 'SG';
series_years['Forester_2001'] = 'SF';
series_years['Forester_2002'] = 'SF|SG';
series_years['Forester_1998'] = 'SF';
series_years['Forester_1999'] = 'SF';
series_years['Forester_2000'] = 'SF';
series_years['Forester_2008'] = 'S3|SG';
series_years['Forester_2009'] = 'S3';
series_years['Forester_2022'] = 'S5';
series_years['Forester_2023'] = 'S5';
series_years['Forester_2024'] = 'S5';
series_years['Forester_2011'] = 'S3';
series_years['Forester_2012'] = 'S3|S4';
series_years['Forester_2013'] = 'S4';
series_years['Forester_2014'] = 'S4';
series_years['Forester_2015'] = 'S4';
series_years['Forester_2016'] = 'S4';
series_years['Forester_2021'] = 'S5';
series_years['Forester_2005'] = 'SG';
series_years['Forester_2006'] = 'SG';
series_years['Forester_2007'] = 'SG';
series_years['Forester_1997'] = 'SF';
series_years['Forester_2017'] = 'S4';
series_years['Impreza_2010'] = 'G3';
series_years['Impreza_2011'] = 'G3|G4';
series_years['Impreza_2012'] = 'G3|G4';
series_years['Impreza_2017'] = 'G5';
series_years['Impreza_2018'] = 'G5';
series_years['Impreza_2015'] = 'G4';
series_years['Impreza_2016'] = 'G4|G5';
series_years['Impreza_2000'] = 'GC/GF/GM|GD/GG';
series_years['Impreza_2001'] = 'GD/GG';
series_years['Impreza_2002'] = 'GD/GG';
series_years['Impreza_2008'] = 'G3';
series_years['Impreza_2009'] = 'G3';
series_years['Impreza_2020'] = 'G5';
series_years['Impreza_2021'] = 'G5';
series_years['Impreza_2022'] = 'G5';
series_years['Impreza_2003'] = 'GD/GG';
series_years['Impreza_2004'] = 'GD/GG';
series_years['Impreza_2005'] = 'GD/GG';
series_years['Impreza_2006'] = 'GD/GG';
series_years['Impreza_2007'] = 'G3|GD/GG';
series_years['Impreza_2019'] = 'G5';
series_years['Impreza_2013'] = 'G3|G4';
series_years['Impreza_2014'] = 'G3|G4';
series_years['Impreza_1993'] = 'GC/GF/GM';
series_years['Impreza_1994'] = 'GC/GF/GM';
series_years['Impreza_1995'] = 'GC/GF/GM';
series_years['Impreza_1996'] = 'GC/GF/GM';
series_years['Impreza_1997'] = 'GC/GF/GM';
series_years['Impreza_1998'] = 'GC/GF/GM';
series_years['Impreza_1999'] = 'GC/GF/GM';
series_years['Impreza_2023'] = 'G5';
series_years['Leone_1979'] = 'L SERIES';
series_years['Leone_1980'] = 'L SERIES';
series_years['Leone_1981'] = 'L SERIES';
series_years['Leone_1982'] = 'L SERIES';
series_years['Leone_1983'] = 'L SERIES';
series_years['Leone_1984'] = 'L SERIES';
series_years['Leone_1985'] = 'L SERIES';
series_years['Leone_1986'] = 'L SERIES';
series_years['Leone_1987'] = 'L SERIES';
series_years['Leone_1988'] = 'L SERIES';
series_years['Leone_1989'] = 'L SERIES';
series_years['Leone_1990'] = 'L SERIES';
series_years['Leone_1991'] = 'L SERIES';
series_years['Leone_1992'] = 'L SERIES';
series_years['Leone_1993'] = 'L SERIES';
series_years['Leone_1994'] = 'L SERIES';
series_years['Levorg_2018'] = 'V1';
series_years['Levorg_2019'] = 'V1';
series_years['Levorg_2017'] = 'V1';
series_years['Levorg_2020'] = 'V1';
series_years['Levorg_2021'] = 'V1';
series_years['Levorg_2016'] = 'V1';
series_years['Liberty_1989'] = 'B1';
series_years['Liberty_1990'] = 'B1';
series_years['Liberty_1991'] = 'B1';
series_years['Liberty_1992'] = 'B1';
series_years['Liberty_1993'] = 'B1';
series_years['Liberty_1994'] = 'B1|B2';
series_years['Liberty_2004'] = 'B4';
series_years['Liberty_2005'] = 'B4';
series_years['Liberty_2003'] = 'B3|B4';
series_years['Liberty_2019'] = 'B6';
series_years['Liberty_2020'] = 'B6';
series_years['Liberty_2021'] = 'B6';
series_years['Liberty_2006'] = 'B4';
series_years['Liberty_2007'] = 'B4';
series_years['Liberty_1998'] = 'B2|B3';
series_years['Liberty_1999'] = 'B3';
series_years['Liberty_2000'] = 'B3';
series_years['Liberty_2001'] = 'B3';
series_years['Liberty_2002'] = 'B3';
series_years['Liberty_1995'] = 'B2';
series_years['Liberty_1996'] = 'B2';
series_years['Liberty_1997'] = 'B2';
series_years['Liberty_2018'] = 'B6';
series_years['Liberty_2012'] = 'B5';
series_years['Liberty_2013'] = 'B5';
series_years['Liberty_2016'] = 'B6';
series_years['Liberty_2017'] = 'B6';
series_years['Liberty_2010'] = 'B5';
series_years['Liberty_2011'] = 'B5';
series_years['Liberty_2014'] = 'B5|B6';
series_years['Liberty_2008'] = 'B4';
series_years['Liberty_2015'] = 'B6';
series_years['Liberty_2009'] = 'B5';
series_years['Outback_2013'] = 'B5A';
series_years['Outback_2014'] = 'B5A|B6A';
series_years['Outback_2012'] = 'B5A';
series_years['Outback_2021'] = 'B7A';
series_years['Outback_2022'] = 'B7A';
series_years['Outback_2024'] = 'B7A';
series_years['Outback_2003'] = 'B3A|B4A';
series_years['Outback_2004'] = 'B4A';
series_years['Outback_2005'] = 'B4A';
series_years['Outback_2006'] = 'B4A';
series_years['Outback_2018'] = 'B6A';
series_years['Outback_2019'] = 'B6A';
series_years['Outback_2020'] = 'B6A|B7A';
series_years['Outback_2015'] = 'B6A';
series_years['Outback_1996'] = 'B2A';
series_years['Outback_1997'] = 'B2A';
series_years['Outback_1998'] = 'B2A|B3A';
series_years['Outback_2017'] = 'B6A';
series_years['Outback_1999'] = 'B3A';
series_years['Outback_2000'] = 'B3A';
series_years['Outback_2001'] = 'B3A';
series_years['Outback_2002'] = 'B3A';
series_years['Outback_2010'] = 'B5A';
series_years['Outback_2011'] = 'B5A';
series_years['Outback_2023'] = 'B7A';
series_years['Outback_2009'] = 'B4A|B5A';
series_years['Outback_2007'] = 'B4A';
series_years['Outback_2008'] = 'B4A';
series_years['Outback_2016'] = 'B6A';
series_years['Tribeca_2011'] = 'B9';
series_years['Tribeca_2012'] = 'B9';
series_years['Tribeca_2006'] = 'B9';
series_years['Tribeca_2007'] = 'B9';
series_years['Tribeca_2008'] = 'B9';
series_years['Tribeca_2013'] = 'B9';
series_years['Tribeca_2014'] = 'B9';
series_years['Tribeca_2009'] = 'B9';
series_years['Tribeca_2010'] = 'B9';
series_years['WRX_2017'] = 'V1';
series_years['WRX_2018'] = 'V1';
series_years['WRX_2019'] = 'V1';
series_years['WRX_2020'] = 'V1';
series_years['WRX_2015'] = 'V1';
series_years['WRX_2016'] = 'V1';
series_years['WRX_2022'] = 'V1|V2';
series_years['WRX_2023'] = 'V2';
series_years['WRX_2021'] = 'V1';
series_years['WRX_2014'] = 'V1';
series_years['XV_2018'] = 'G5X';
series_years['XV_2019'] = 'G5X';
series_years['XV_2020'] = 'G5X';
series_years['XV_2013'] = 'G4X';
series_years['XV_2014'] = 'G4X';
series_years['XV_2015'] = 'G4X';
series_years['XV_2012'] = 'G4X';
series_years['XV_2016'] = 'G4X';
series_years['XV_2017'] = 'G4X|G5X';
series_years['XV_2021'] = 'G5X';
series_years['XV_2022'] = 'G5X';
series_years['Alto_1995'] = 'SH410';
series_years['Alto_1996'] = 'SH410';
series_years['Alto_1997'] = 'SH410';
series_years['Alto_1998'] = 'SH410';
series_years['Alto_2009'] = 'GF';
series_years['Alto_2010'] = 'GF';
series_years['Alto_2011'] = 'GF';
series_years['Alto_2012'] = 'GF';
series_years['Alto_2013'] = 'GF';
series_years['Alto_2014'] = 'GF';
series_years['APV_2005'] = 'GC416';
series_years['APV_2006'] = 'GC416';
series_years['APV_2007'] = 'GC416';
series_years['APV_2008'] = 'GC416';
series_years['APV_2009'] = 'GC416';
series_years['APV_2010'] = 'GC416';
series_years['APV_2011'] = 'GC416';
series_years['APV_2012'] = 'GC416';
series_years['APV_2013'] = 'GC416';
series_years['APV_2014'] = 'GC416';
series_years['APV_2015'] = 'GC416';
series_years['APV_2016'] = 'GC416';
series_years['APV_2017'] = 'GC416';
series_years['Baleno_1999'] = 'SY416/SY418';
series_years['Baleno_2000'] = 'SY416/SY418';
series_years['Baleno_2001'] = 'SY416/SY418';
series_years['Baleno_2016'] = 'EW';
series_years['Baleno_2017'] = 'EW';
series_years['Baleno_2018'] = 'EW';
series_years['Baleno_2019'] = 'EW';
series_years['Baleno_1995'] = 'SY416/SY418';
series_years['Baleno_1996'] = 'SY416/SY418';
series_years['Baleno_1997'] = 'SY416/SY418';
series_years['Baleno_1998'] = 'SY416/SY418';
series_years['Baleno_2020'] = 'EW';
series_years['Baleno_2021'] = 'EW';
series_years['Baleno_2022'] = 'EW';
series_years['Carry_1999'] = 'GA413';
series_years['Carry_2000'] = 'GA413';
series_years['Carry_2001'] = 'GA413';
series_years['Carry_2002'] = 'GA413';
series_years['Carry_2003'] = 'GA413';
series_years['Carry_2004'] = 'GA413';
series_years['Carry_2005'] = 'GA413';
series_years['Grand Vitara_2014'] = 'JT';
series_years['Grand Vitara_2015'] = 'JT';
series_years['Grand Vitara_2016'] = 'JT';
series_years['Grand Vitara_2017'] = 'JT';
series_years['Grand Vitara_2018'] = 'JT';
series_years['Grand Vitara_2013'] = 'JT';
series_years['Grand Vitara_2011'] = 'JT';
series_years['Grand Vitara_2012'] = 'JT';
series_years['Grand Vitara_1998'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_1999'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_2000'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_2001'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_2002'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_2003'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_2004'] = 'SQ416/SQ420/SQ625';
series_years['Grand Vitara_2005'] = 'JT|SQ416/SQ420/SQ625';
series_years['Grand Vitara_2008'] = 'JT';
series_years['Grand Vitara_2009'] = 'JT';
series_years['Grand Vitara_2010'] = 'JT';
series_years['Grand Vitara_2019'] = 'JT';
series_years['Grand Vitara_2020'] = 'JT';
series_years['Grand Vitara_2006'] = 'JT';
series_years['Grand Vitara_2007'] = 'JT';
series_years['Ignis_2000'] = 'RG413';
series_years['Ignis_2001'] = 'RG413';
series_years['Ignis_2002'] = 'RG413';
series_years['Ignis_2003'] = 'RG413';
series_years['Ignis_2004'] = 'RG413';
series_years['Ignis_2005'] = 'RG413';
series_years['Ignis_2020'] = 'MF';
series_years['Ignis_2021'] = 'MF';
series_years['Ignis_2022'] = 'MF';
series_years['Ignis_2023'] = 'MF';
series_years['Ignis_2024'] = 'MF';
series_years['Ignis_2025'] = 'MF';
series_years['Ignis_2017'] = 'MF';
series_years['Ignis_2018'] = 'MF';
series_years['Ignis_2019'] = 'MF';
series_years['Jimny_2021'] = 'JB74';
series_years['Jimny_2022'] = 'JB74';
series_years['Jimny_2023'] = 'JB74';
series_years['Jimny_2024'] = 'JB74';
series_years['Jimny_2025'] = 'JB74';
series_years['Jimny_2018'] = 'JB74';
series_years['Jimny_2019'] = 'JB74';
series_years['Jimny_2020'] = 'JB74';
series_years['Jimny_1998'] = 'SN413';
series_years['Jimny_1999'] = 'SN413';
series_years['Jimny_2000'] = 'SN413';
series_years['Jimny_2001'] = 'SN413';
series_years['Jimny_2002'] = 'SN413';
series_years['Jimny_2003'] = 'SN413';
series_years['Jimny_2004'] = 'SN413';
series_years['Jimny_2005'] = 'SN413';
series_years['Jimny_2006'] = 'SN413';
series_years['Jimny_2007'] = 'SN413';
series_years['Jimny_2008'] = 'SN413';
series_years['Jimny_2009'] = 'SN413';
series_years['Jimny_2010'] = 'SN413';
series_years['Jimny_2011'] = 'SN413';
series_years['Jimny_2012'] = 'SN413';
series_years['Jimny_2013'] = 'SN413';
series_years['Jimny_2014'] = 'SN413';
series_years['Jimny_2015'] = 'SN413';
series_years['Jimny_2016'] = 'SN413';
series_years['Jimny_2017'] = 'SN413';
series_years['Kizashi_2013'] = 'FR';
series_years['Kizashi_2014'] = 'FR';
series_years['Kizashi_2015'] = 'FR';
series_years['Kizashi_2016'] = 'FR';
series_years['Kizashi_2017'] = 'FR';
series_years['Kizashi_2010'] = 'FR';
series_years['Kizashi_2011'] = 'FR';
series_years['Kizashi_2012'] = 'FR';
series_years['Liana_2004'] = 'RC';
series_years['Liana_2005'] = 'RC';
series_years['Liana_2006'] = 'RC';
series_years['Liana_2007'] = 'RC';
series_years['Liana_2001'] = 'RC';
series_years['Liana_2002'] = 'RC';
series_years['Liana_2003'] = 'RC';
series_years['S-Cross_2013'] = 'JY';
series_years['S-Cross_2014'] = 'JY';
series_years['S-Cross_2015'] = 'JY';
series_years['S-Cross_2016'] = 'JY';
series_years['S-Cross_2017'] = 'JY';
series_years['S-Cross_2018'] = 'JY';
series_years['S-Cross_2019'] = 'JY';
series_years['S-Cross_2020'] = 'JY';
series_years['S-Cross_2021'] = 'JY';
series_years['S-Cross_2022'] = 'JY';
series_years['S-Cross_2023'] = 'JY';
series_years['S-Cross_2024'] = 'JY';
series_years['S-Cross_2025'] = 'JY';
series_years['Sierra_1996'] = 'SJ413|SJ80';
series_years['Sierra_1997'] = 'SJ80';
series_years['Sierra_1998'] = 'SJ80';
series_years['Sierra_1981'] = 'SJ413';
series_years['Sierra_1982'] = 'SJ413';
series_years['Sierra_1983'] = 'SJ413';
series_years['Sierra_1984'] = 'SJ413';
series_years['Sierra_1985'] = 'SJ413';
series_years['Sierra_1986'] = 'SJ413';
series_years['Sierra_1987'] = 'SJ413';
series_years['Sierra_1988'] = 'SJ413';
series_years['Sierra_1989'] = 'SJ413';
series_years['Sierra_1990'] = 'SJ413';
series_years['Sierra_1991'] = 'SJ413';
series_years['Sierra_1992'] = 'SJ413';
series_years['Sierra_1993'] = 'SJ413';
series_years['Sierra_1994'] = 'SJ413';
series_years['Sierra_1995'] = 'SJ413';
series_years['Swift_2005'] = 'EZ';
series_years['Swift_2006'] = 'EZ';
series_years['Swift_2007'] = 'EZ';
series_years['Swift_2013'] = 'FZ';
series_years['Swift_2014'] = 'FZ';
series_years['Swift_2015'] = 'FZ';
series_years['Swift_2009'] = 'EZ';
series_years['Swift_2010'] = 'EZ';
series_years['Swift_2011'] = 'EZ|FZ';
series_years['Swift_1984'] = 'SWIFT';
series_years['Swift_1985'] = 'GC|SWIFT';
series_years['Swift_2018'] = 'AZ';
series_years['Swift_2019'] = 'AZ';
series_years['Swift_2020'] = 'AZ';
series_years['Swift_1989'] = 'SF413/SF310';
series_years['Swift_1990'] = 'SF413/SF310';
series_years['Swift_1991'] = 'SF413/SF310';
series_years['Swift_1992'] = 'SF413/SF310';
series_years['Swift_1993'] = 'SF413/SF310';
series_years['Swift_1994'] = 'SF413/SF310';
series_years['Swift_1995'] = 'SF413/SF310';
series_years['Swift_1996'] = 'SF413/SF310';
series_years['Swift_1997'] = 'SF413/SF310';
series_years['Swift_1998'] = 'SF413/SF310';
series_years['Swift_1999'] = 'SF413/SF310';
series_years['Swift_2021'] = 'AZ';
series_years['Swift_2022'] = 'AZ';
series_years['Swift_2023'] = 'AZ';
series_years['Swift_2012'] = 'EZ|FZ';
series_years['Swift_2017'] = 'AZ|FZ';
series_years['Swift_1986'] = 'GC';
series_years['Swift_1987'] = 'GC';
series_years['Swift_1988'] = 'GC';
series_years['Swift_2008'] = 'EZ';
series_years['Swift_2016'] = 'FZ';
series_years['SX4_2010'] = 'GY';
series_years['SX4_2011'] = 'GY';
series_years['SX4_2012'] = 'GY';
series_years['SX4_2008'] = 'GY';
series_years['SX4_2009'] = 'GY';
series_years['SX4_2013'] = 'GY';
series_years['SX4_2014'] = 'GY';
series_years['SX4_2015'] = 'GY';
series_years['SX4_2007'] = 'GY';
series_years['Vitara_1995'] = 'SE416/SV420|SV620';
series_years['Vitara_1996'] = 'SE416/SV420|SV620';
series_years['Vitara_1997'] = 'SE416/SV420|SV620';
series_years['Vitara_1998'] = 'SE416/SV420|SV620';
series_years['Vitara_2019'] = 'LY|LY Series II';
series_years['Vitara_2020'] = 'LY Series II';
series_years['Vitara_2021'] = 'LY Series II';
series_years['Vitara_2022'] = 'LY Series II';
series_years['Vitara_2023'] = 'LY Series II';
series_years['Vitara_1988'] = 'SE416/SV420';
series_years['Vitara_1989'] = 'SE416/SV420';
series_years['Vitara_1990'] = 'SE416/SV420';
series_years['Vitara_1991'] = 'SE416/SV420';
series_years['Vitara_1992'] = 'SE416/SV420';
series_years['Vitara_1993'] = 'SE416/SV420';
series_years['Vitara_1994'] = 'SE416/SV420';
series_years['Vitara_2015'] = 'LY';
series_years['Vitara_2016'] = 'LY';
series_years['Vitara_2017'] = 'LY';
series_years['Vitara_2018'] = 'LY';
series_years['X90_1996'] = 'SZ416';
series_years['X90_1997'] = 'SZ416';
series_years['X90_1998'] = 'SZ416';
series_years['XL-7_2001'] = 'JA627';
series_years['XL-7_2002'] = 'JA627';
series_years['XL-7_2003'] = 'JA627';
series_years['XL-7_2004'] = 'JA627';
series_years['XL-7_2005'] = 'JA627';
series_years['4 Runner / Surf_1991'] = 'LN130/RN130/YN130/VZN130|LN130R/RN130R/YN130R/VZN130R';
series_years['4 Runner / Surf_1992'] = 'LN130R/RN130R/YN130R/VZN130R';
series_years['4 Runner / Surf_1993'] = 'LN130R/RN130R/YN130R/VZN130R';
series_years['4 Runner / Surf_1994'] = 'LN130R/RN130R/YN130R/VZN130R';
series_years['4 Runner / Surf_1995'] = 'LN130R/RN130R/YN130R/VZN130R';
series_years['4 Runner / Surf_1996'] = 'LN130R/RN130R/YN130R/VZN130R|VZN130';
series_years['4 Runner / Surf_1997'] = 'LN130R/RN130R/YN130R/VZN130R|VZN130';
series_years['4 Runner / Surf_1998'] = 'VZN130';
series_years['4 Runner / Surf_1999'] = 'VZN130';
series_years['4 Runner / Surf_2000'] = 'VZN130';
series_years['4 Runner / Surf_2001'] = 'VZN130';
series_years['4 Runner / Surf_2002'] = 'VZN130';
series_years['4 Runner / Surf_2003'] = 'VZN130';
series_years['4 Runner / Surf_2004'] = 'VZN130';
series_years['4 Runner / Surf_2005'] = 'VZN130';
series_years['4 Runner / Surf_2006'] = 'VZN130';
series_years['4 Runner / Surf_2007'] = 'VZN130';
series_years['4 Runner / Surf_2008'] = 'VZN130';
series_years['4 Runner / Surf_2009'] = 'VZN130';
series_years['4 Runner / Surf_2010'] = 'VZN130';
series_years['4 Runner / Surf_2011'] = 'VZN130';
series_years['4 Runner / Surf_2012'] = 'VZN130';
series_years['4 Runner / Surf_2013'] = 'VZN130';
series_years['4 Runner / Surf_2014'] = 'VZN130';
series_years['4 Runner / Surf_2015'] = 'VZN130';
series_years['4 Runner / Surf_2016'] = 'VZN130';
series_years['4 Runner / Surf_2017'] = 'VZN130';
series_years['4 Runner / Surf_2018'] = 'VZN130';
series_years['4 Runner / Surf_2019'] = 'VZN130';
series_years['4 Runner / Surf_2020'] = 'VZN130';
series_years['4 Runner / Surf_2021'] = 'VZN130';
series_years['4 Runner / Surf_2022'] = 'VZN130';
series_years['4 Runner / Surf_2023'] = 'VZN130';
series_years['4 Runner / Surf_2024'] = 'VZN130';
series_years['4 Runner / Surf_2025'] = 'VZN130';
series_years['4 Runner / Surf_1989'] = 'LN130/RN130/YN130/VZN130';
series_years['4 Runner / Surf_1990'] = 'LN130/RN130/YN130/VZN130';
series_years['86_2017'] = 'ZN6';
series_years['86_2018'] = 'ZN6';
series_years['86_2019'] = 'ZN6';
series_years['86_2020'] = 'ZN6';
series_years['86_2021'] = 'ZN6';
series_years['86_2015'] = 'ZN6';
series_years['86_2016'] = 'ZN6';
series_years['86_2012'] = 'ZN6';
series_years['86_2013'] = 'ZN6';
series_years['86_2014'] = 'ZN6';
series_years['Aurion_2006'] = 'GSV40R';
series_years['Aurion_2007'] = 'GSV40R';
series_years['Aurion_2008'] = 'GSV40R';
series_years['Aurion_2009'] = 'GSV40R';
series_years['Aurion_2010'] = 'GSV40R';
series_years['Aurion_2011'] = 'GSV40R';
series_years['Aurion_2012'] = 'GSV40R|GSV50R';
series_years['Aurion_2015'] = 'GSV50R';
series_years['Aurion_2016'] = 'GSV50R';
series_years['Aurion_2017'] = 'GSV50R';
series_years['Aurion_2013'] = 'GSV50R';
series_years['Aurion_2014'] = 'GSV50R';
series_years['Avalon_2003'] = 'MCX10R';
series_years['Avalon_2004'] = 'MCX10R';
series_years['Avalon_2005'] = 'MCX10R';
series_years['Avalon_2000'] = 'MCX10R';
series_years['Avalon_2001'] = 'MCX10R';
series_years['Avalon_2002'] = 'MCX10R';
series_years['Avensis Verso_2001'] = 'ACM20R';
series_years['Avensis Verso_2002'] = 'ACM20R';
series_years['Avensis Verso_2003'] = 'ACM20R|ACM21R';
series_years['Avensis Verso_2004'] = 'ACM21R';
series_years['Avensis Verso_2005'] = 'ACM21R';
series_years['Avensis Verso_2006'] = 'ACM21R';
series_years['Avensis Verso_2007'] = 'ACM21R';
series_years['Avensis Verso_2008'] = 'ACM21R';
series_years['Avensis Verso_2009'] = 'ACM21R';
series_years['Camry_2015'] = 'ASV50R';
series_years['Camry_2016'] = 'ASV50R';
series_years['Camry_2017'] = 'ASV50R|ASV70R|AXVH71R|GSV70R';
series_years['Camry_2005'] = 'ACV36R|MCV36R';
series_years['Camry_2006'] = 'ACV36R|ACV40R|MCV36R';
series_years['Camry_1992'] = 'SDV10R/VDV10R/VZV10R|SV20/SV21/SV22/VZV21';
series_years['Camry_1993'] = 'SDV10R/VDV10R/VZV10R';
series_years['Camry_1994'] = 'SDV10R/VDV10R/VZV10R';
series_years['Camry_1995'] = 'SDV10R/VDV10R/VZV10R';
series_years['Camry_1996'] = 'SDV10R/VDV10R/VZV10R';
series_years['Camry_1997'] = 'MCV20R/SXV20R|SDV10R/VDV10R/VZV10R';
series_years['Camry_1983'] = 'SV11';
series_years['Camry_1984'] = 'SV11';
series_years['Camry_1985'] = 'SV11';
series_years['Camry_1986'] = 'SV11';
series_years['Camry_1987'] = 'SV11|SV20/SV21/SV22/VZV21';
series_years['Camry_2009'] = 'ACV40R';
series_years['Camry_2010'] = 'ACV40R|AHV40R';
series_years['Camry_2011'] = 'ACV40R|AHV40R|ASV50R';
series_years['Camry_2018'] = 'ASV70R|AXVH71R|GSV70R';
series_years['Camry_2019'] = 'ASV70R|AXVH71R|GSV70R';
series_years['Camry_2020'] = 'ASV70R|AXVH71R|GSV70R';
series_years['Camry_2021'] = 'ASV70R|AXVA70R|AXVH70R|AXVH71R|GSV70R';
series_years['Camry_2022'] = 'AXVA70R|AXVH70R|AXVH71R';
series_years['Camry_2023'] = 'AXVA70R|AXVH70R|AXVH71R';
series_years['Camry_2024'] = 'AXVA70R|AXVH70R|AXVH71R|AXVH80R';
series_years['Camry_2025'] = 'AXVH70R|AXVH71R|AXVH80R';
series_years['Camry_2012'] = 'ASV50R';
series_years['Camry_2013'] = 'ASV50R';
series_years['Camry_2014'] = 'ASV50R';
series_years['Camry_2002'] = 'ACV36R|MCV20R/SXV20R|MCV36R';
series_years['Camry_2003'] = 'ACV36R|MCV36R';
series_years['Camry_2004'] = 'ACV36R|MCV36R';
series_years['Camry_1998'] = 'MCV20R/SXV20R';
series_years['Camry_1999'] = 'MCV20R/SXV20R';
series_years['Camry_2000'] = 'MCV20R/SXV20R';
series_years['Camry_2001'] = 'MCV20R/SXV20R';
series_years['Camry_2008'] = 'ACV40R';
series_years['Camry_2026'] = 'AXVH80R';
series_years['Camry_2027'] = 'AXVH80R';
series_years['Camry_2028'] = 'AXVH80R';
series_years['Camry_2029'] = 'AXVH80R';
series_years['Camry_2030'] = 'AXVH80R';
series_years['Camry_2031'] = 'AXVH80R';
series_years['Camry_2032'] = 'AXVH80R';
series_years['Camry_2033'] = 'AXVH80R';
series_years['Camry_2034'] = 'AXVH80R';
series_years['Camry_2035'] = 'AXVH80R';
series_years['Camry_2036'] = 'AXVH80R';
series_years['Camry_2037'] = 'AXVH80R';
series_years['Camry_2038'] = 'AXVH80R';
series_years['Camry_2039'] = 'AXVH80R';
series_years['Camry_2040'] = 'AXVH80R';
series_years['Camry_2041'] = 'AXVH80R';
series_years['Camry_2042'] = 'AXVH80R';
series_years['Camry_2043'] = 'AXVH80R';
series_years['Camry_2044'] = 'AXVH80R';
series_years['Camry_2045'] = 'AXVH80R';
series_years['Camry_2046'] = 'AXVH80R';
series_years['Camry_2047'] = 'AXVH80R';
series_years['Camry_2048'] = 'AXVH80R';
series_years['Camry_2049'] = 'AXVH80R';
series_years['Camry_2050'] = 'AXVH80R';
series_years['Camry_2051'] = 'AXVH80R';
series_years['Camry_2052'] = 'AXVH80R';
series_years['Camry_2053'] = 'AXVH80R';
series_years['Camry_2054'] = 'AXVH80R';
series_years['Camry_2055'] = 'AXVH80R';
series_years['Camry_2056'] = 'AXVH80R';
series_years['Camry_2057'] = 'AXVH80R';
series_years['Camry_2058'] = 'AXVH80R';
series_years['Camry_2059'] = 'AXVH80R';
series_years['Camry_2060'] = 'AXVH80R';
series_years['Camry_2061'] = 'AXVH80R';
series_years['Camry_2062'] = 'AXVH80R';
series_years['Camry_2063'] = 'AXVH80R';
series_years['Camry_2064'] = 'AXVH80R';
series_years['Camry_2065'] = 'AXVH80R';
series_years['Camry_2066'] = 'AXVH80R';
series_years['Camry_2067'] = 'AXVH80R';
series_years['Camry_2068'] = 'AXVH80R';
series_years['Camry_2069'] = 'AXVH80R';
series_years['Camry_2070'] = 'AXVH80R';
series_years['Camry_2071'] = 'AXVH80R';
series_years['Camry_2072'] = 'AXVH80R';
series_years['Camry_2073'] = 'AXVH80R';
series_years['Camry_2074'] = 'AXVH80R';
series_years['Camry_2075'] = 'AXVH80R';
series_years['Camry_2076'] = 'AXVH80R';
series_years['Camry_2077'] = 'AXVH80R';
series_years['Camry_2078'] = 'AXVH80R';
series_years['Camry_2079'] = 'AXVH80R';
series_years['Camry_2080'] = 'AXVH80R';
series_years['Camry_2081'] = 'AXVH80R';
series_years['Camry_2082'] = 'AXVH80R';
series_years['Camry_2083'] = 'AXVH80R';
series_years['Camry_2084'] = 'AXVH80R';
series_years['Camry_2085'] = 'AXVH80R';
series_years['Camry_2086'] = 'AXVH80R';
series_years['Camry_2087'] = 'AXVH80R';
series_years['Camry_2088'] = 'AXVH80R';
series_years['Camry_2089'] = 'AXVH80R';
series_years['Camry_2090'] = 'AXVH80R';
series_years['Camry_2091'] = 'AXVH80R';
series_years['Camry_2092'] = 'AXVH80R';
series_years['Camry_2093'] = 'AXVH80R';
series_years['Camry_2094'] = 'AXVH80R';
series_years['Camry_2095'] = 'AXVH80R';
series_years['Camry_2096'] = 'AXVH80R';
series_years['Camry_2097'] = 'AXVH80R';
series_years['Camry_2098'] = 'AXVH80R';
series_years['Camry_2099'] = 'AXVH80R';
series_years['Camry_2100'] = 'AXVH80R';
series_years['Camry_1988'] = 'SV20/SV21/SV22/VZV21';
series_years['Camry_1989'] = 'SV20/SV21/SV22/VZV21';
series_years['Camry_1990'] = 'SV20/SV21/SV22/VZV21';
series_years['Camry_1991'] = 'SV20/SV21/SV22/VZV21';
series_years['Camry_2007'] = 'ACV40R';
series_years['Camry Hybrid_2012'] = 'AVV50R';
series_years['Camry Hybrid_2013'] = 'AVV50R';
series_years['Camry Hybrid_2014'] = 'AVV50R';
series_years['Camry Hybrid_2015'] = 'AVV50R';
series_years['Camry Hybrid_2016'] = 'AVV50R';
series_years['Camry Hybrid_2017'] = 'AVV50R';
series_years['Celica_1985'] = 'RA60/SA63/RA65|ST162';
series_years['Celica_1986'] = 'ST162';
series_years['Celica_1987'] = 'ST162';
series_years['Celica_1988'] = 'ST162';
series_years['Celica_1989'] = 'ST162|ST184/ST185';
series_years['Celica_1993'] = 'ST184/ST185|ST204R/ST205R';
series_years['Celica_1994'] = 'ST184/ST185|ST204R/ST205R';
series_years['Celica_1995'] = 'ST204R/ST205R';
series_years['Celica_1996'] = 'ST204R/ST205R';
series_years['Celica_1997'] = 'ST204R/ST205R';
series_years['Celica_1998'] = 'ST204R/ST205R';
series_years['Celica_1999'] = 'ST204R/ST205R|ZZT231R';
series_years['Celica_1990'] = 'ST184/ST185';
series_years['Celica_1991'] = 'ST184/ST185';
series_years['Celica_1992'] = 'ST184/ST185';
series_years['Celica_2000'] = 'ZZT231R';
series_years['Celica_2001'] = 'ZZT231R';
series_years['Celica_2002'] = 'ZZT231R';
series_years['Celica_2003'] = 'ZZT231R';
series_years['Celica_2004'] = 'ZZT231R';
series_years['Celica_2005'] = 'ZZT231R';
series_years['Celica_1981'] = 'RA60/SA63/RA65';
series_years['Celica_1982'] = 'RA60/SA63/RA65';
series_years['Celica_1983'] = 'RA60/SA63/RA65';
series_years['Celica_1984'] = 'RA60/SA63/RA65';
series_years['C-HR_2020'] = 'NGX10R|NGX50R|ZYX10R';
series_years['C-HR_2021'] = 'NGX10R|NGX50R|ZYX10R';
series_years['C-HR_2022'] = 'NGX10R|NGX50R|ZYX10R';
series_years['C-HR_2023'] = 'NGX10R|NGX50R|ZYX10R';
series_years['C-HR_2024'] = 'NGX10R|NGX50R|ZYX10R';
series_years['C-HR_2016'] = 'NGX10R|NGX50R';
series_years['C-HR_2017'] = 'NGX10R|NGX50R';
series_years['C-HR_2018'] = 'NGX10R|NGX50R';
series_years['C-HR_2019'] = 'NGX10R|NGX50R|ZYX10R';
series_years['Corolla_1989'] = 'AE82|AE90/AE92/AE93/AE94|AE95R';
series_years['Corolla_1990'] = 'AE90/AE92/AE93/AE94|AE95R';
series_years['Corolla_1991'] = 'AE90/AE92/AE93/AE94|AE95R';
series_years['Corolla_1992'] = 'AE90/AE92/AE93/AE94|AE95R';
series_years['Corolla_1993'] = 'AE90/AE92/AE93/AE94|AE95R';
series_years['Corolla_1994'] = 'AE101R/AE102R|AE90/AE92/AE93/AE94|AE95R';
series_years['Corolla_1995'] = 'AE101R/AE102R';
series_years['Corolla_1996'] = 'AE101R/AE102R';
series_years['Corolla_1997'] = 'AE101R/AE102R';
series_years['Corolla_1998'] = 'AE101R/AE102R|AE112R';
series_years['Corolla_1999'] = 'AE101R/AE102R|AE112R';
series_years['Corolla_2022'] = 'MZEA12R';
series_years['Corolla_2023'] = 'MZEA12R';
series_years['Corolla_2024'] = 'MZEA12R';
series_years['Corolla_2009'] = 'ZRE152R';
series_years['Corolla_2010'] = 'ZRE152R|ZRE153R';
series_years['Corolla_2011'] = 'ZRE152R|ZRE153R';
series_years['Corolla_2012'] = 'ZRE152R|ZRE153R|ZRE182R';
series_years['Corolla_2004'] = 'ZZE122R|ZZE123R';
series_years['Corolla_2005'] = 'ZZE122R|ZZE123R';
series_years['Corolla_2006'] = 'ZZE122R|ZZE123R';
series_years['Corolla_2016'] = 'ZRE172R|ZRE182R|ZWE186R';
series_years['Corolla_2017'] = 'ZRE172R|ZRE182R|ZWE186R';
series_years['Corolla_2018'] = 'MZEA12R|ZRE172R|ZRE182R|ZWE186R';
series_years['Corolla_1986'] = 'AE80/AE82|AE82';
series_years['Corolla_1987'] = 'AE82';
series_years['Corolla_1988'] = 'AE82';
series_years['Corolla_2015'] = 'ZRE172R|ZRE182R';
series_years['Corolla_2007'] = 'ZRE152R|ZZE122R';
series_years['Corolla_2008'] = 'ZRE152R';
series_years['Corolla_2019'] = 'MZEA12R|ZRE172R';
series_years['Corolla_2020'] = 'MZEA12R';
series_years['Corolla_2021'] = 'MZEA12R';
series_years['Corolla_2013'] = 'ZRE152R|ZRE153R|ZRE172R|ZRE182R';
series_years['Corolla_2014'] = 'ZRE172R|ZRE182R';
series_years['Corolla_2025'] = 'MZEA12R';
series_years['Corolla_2003'] = 'ZZE122R|ZZE123R';
series_years['Corolla_1974'] = 'KE30/KE35/KE36';
series_years['Corolla_1975'] = 'KE30/KE35/KE36';
series_years['Corolla_1976'] = 'KE30/KE35/KE36';
series_years['Corolla_1977'] = 'KE30/KE35/KE36';
series_years['Corolla_1978'] = 'KE30/KE35/KE36';
series_years['Corolla_1981'] = 'KE70';
series_years['Corolla_1982'] = 'KE70';
series_years['Corolla_1983'] = 'KE70|KE70/AE71';
series_years['Corolla_1985'] = 'AE80/AE82|KE70/AE71';
series_years['Corolla_2000'] = 'AE112R';
series_years['Corolla_2001'] = 'AE112R|ZZE122R';
series_years['Corolla_1984'] = 'KE70/AE71';
series_years['Corolla_2002'] = 'ZZE122R';
series_years['Corolla Cross_2022'] = 'MXGA10R';
series_years['Corolla Cross_2023'] = 'MXGA10R';
series_years['Corolla Cross_2024'] = 'MXGA10R';
series_years['Corolla Cross Hybrid_2022'] = 'MXGH10R|MXGH15R';
series_years['Corolla Cross Hybrid_2023'] = 'MXGH10R|MXGH15R';
series_years['Corolla Cross Hybrid_2024'] = 'MXGH10R|MXGH15R';
series_years['Corolla Hybrid_2019'] = 'ZWE211R';
series_years['Corolla Hybrid_2020'] = 'ZWE211R';
series_years['Corolla Hybrid_2021'] = 'ZWE211R';
series_years['Corolla Hybrid_2022'] = 'ZWE211R';
series_years['Corolla Hybrid_2023'] = 'ZWE211R';
series_years['Corolla Hybrid_2024'] = 'ZWE211R';
series_years['Corolla Hybrid_2025'] = 'ZWE211R';
series_years['Corolla Hybrid_2018'] = 'ZWE211R';
series_years['Corona_1974'] = 'RT104';
series_years['Corona_1975'] = 'RT104';
series_years['Corona_1976'] = 'RT104';
series_years['Corona_1977'] = 'RT104';
series_years['Corona_1978'] = 'RT104';
series_years['Corona_1979'] = 'RT104|XT130';
series_years['Corona_1980'] = 'XT130';
series_years['Corona_1981'] = 'XT130';
series_years['Corona_1982'] = 'XT130';
series_years['Corona_1983'] = 'ST141/RT142|XT130';
series_years['Corona_1984'] = 'ST141/RT142';
series_years['Corona_1985'] = 'ST141/RT142';
series_years['Corona_1986'] = 'ST141/RT142';
series_years['Corona_1987'] = 'ST141/RT142';
series_years['Cressida_1984'] = 'MX73';
series_years['Cressida_1985'] = 'MX73';
series_years['Cressida_1986'] = 'MX73';
series_years['Cressida_1987'] = 'MX73';
series_years['Cressida_1988'] = 'MX73|MX83';
series_years['Cressida_1989'] = 'MX83';
series_years['Cressida_1990'] = 'MX83';
series_years['Cressida_1991'] = 'MX83';
series_years['Cressida_1992'] = 'MX83';
series_years['Cressida_1993'] = 'MX83';
series_years['Dyna_1996'] = '100/150/200';
series_years['Dyna_1997'] = '100/150/200';
series_years['Dyna_1998'] = '100/150/200';
series_years['Dyna_1999'] = '100/150/200';
series_years['Dyna_2000'] = '100/150/200';
series_years['Dyna_2001'] = '100/150/200';
series_years['Dyna_2002'] = '100/150/200';
series_years['Echo_2002'] = 'NCP10R/NCP13R|NCP12R';
series_years['Echo_2003'] = 'NCP10R/NCP13R|NCP12R';
series_years['Echo_2004'] = 'NCP10R/NCP13R|NCP12R';
series_years['Echo_2005'] = 'NCP10R/NCP13R|NCP12R';
series_years['Echo_1999'] = 'NCP10R/NCP13R|NCP12R';
series_years['Echo_2000'] = 'NCP10R/NCP13R|NCP12R';
series_years['Echo_2001'] = 'NCP10R/NCP13R|NCP12R';
series_years['FJ Cruiser_2010'] = 'GSJ15R';
series_years['FJ Cruiser_2011'] = 'GSJ15R';
series_years['FJ Cruiser_2012'] = 'GSJ15R';
series_years['FJ Cruiser_2013'] = 'GSJ15R';
series_years['FJ Cruiser_2014'] = 'GSJ15R';
series_years['FJ Cruiser_2015'] = 'GSJ15R';
series_years['FJ Cruiser_2016'] = 'GSJ15R';
series_years['Fortuner_2020'] = 'GUN156R';
series_years['Fortuner_2021'] = 'GUN156R';
series_years['Fortuner_2022'] = 'GUN156R';
series_years['Fortuner_2015'] = 'GUN156R';
series_years['Fortuner_2016'] = 'GUN156R';
series_years['Fortuner_2017'] = 'GUN156R';
series_years['Fortuner_2018'] = 'GUN156R';
series_years['Fortuner_2019'] = 'GUN156R';
series_years['Fortuner_2023'] = 'GUN156R';
series_years['Fortuner_2024'] = 'GUN156R';
series_years['Fortuner_2025'] = 'GUN156R';
series_years['GR86_2022'] = 'ZN8';
series_years['GR86_2023'] = 'ZN8';
series_years['GR86_2024'] = 'ZN8';
series_years['Granvia_2019'] = 'GDH303R';
series_years['Granvia_2020'] = 'GDH303R';
series_years['Granvia_2021'] = 'GDH303R';
series_years['Hiace_2019'] = 'GDH300R|GDH320R|GRH300R|GRH320R|TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2020'] = 'GDH300R|GDH320R|GRH300R|GRH320R';
series_years['Hiace_2021'] = 'GDH300R|GDH320R|GRH300R|GRH320R';
series_years['Hiace_1983'] = 'YH20|YH50/YH60';
series_years['Hiace_1984'] = 'YH50/YH60';
series_years['Hiace_1985'] = 'YH50/YH60';
series_years['Hiace_1986'] = 'YH50/YH60';
series_years['Hiace_1987'] = 'YH50/YH60';
series_years['Hiace_1988'] = 'YH50/YH60';
series_years['Hiace_1989'] = 'RZH / LH10#|YH50/YH60';
series_years['Hiace_1990'] = 'RZH / LH10#';
series_years['Hiace_1991'] = 'RZH / LH10#';
series_years['Hiace_1992'] = 'RZH / LH10#';
series_years['Hiace_1993'] = 'RZH / LH10#';
series_years['Hiace_1994'] = 'RZH / LH10#';
series_years['Hiace_1995'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_1996'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_1997'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_1998'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_1999'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_2000'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_2001'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_2002'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_2003'] = 'RCH12R/RCH22R|RZH / LH10#';
series_years['Hiace_2004'] = 'RZH / LH10#';
series_years['Hiace_2005'] = 'RZH / LH10#|TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2006'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2007'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2008'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2009'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2010'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2011'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2012'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2013'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2014'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2015'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2016'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2017'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2018'] = 'TRH / KDH / SLWB 20#/22#|TRH201R / KDH200/201/220R LWB';
series_years['Hiace_2022'] = 'GDH300R|GDH320R';
series_years['Hiace_2023'] = 'GDH300R|GDH320R';
series_years['Hiace_2024'] = 'GDH300R|GDH320R';
series_years['Hiace_2025'] = 'GDH300R|GDH320R';
series_years['Hiace_1977'] = 'YH20';
series_years['Hiace_1978'] = 'YH20';
series_years['Hiace_1979'] = 'YH20';
series_years['Hiace_1980'] = 'YH20';
series_years['Hiace_1981'] = 'YH20';
series_years['Hiace_1982'] = 'YH20';
series_years['Hilux_2015'] = 'GGN120R|GGN125R|GGN15R|GGN25R|GUN122R|GUN123R|GUN125R|GUN126R|GUN136R|KUN16R|KUN26R|TGN121R|TGN16R';
series_years['Hilux_2016'] = 'GGN120R|GGN125R|GUN122R|GUN123R|GUN125R|GUN126R|GUN136R|TGN121R';
series_years['Hilux_2017'] = 'GGN120R|GGN125R|GUN122R|GUN123R|GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2018'] = 'GUN122R|GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2019'] = 'GUN122R|GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2020'] = 'GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2001'] = 'KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174';
series_years['Hilux_2002'] = 'KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174|VZN167R|VZN172R';
series_years['Hilux_1978'] = 'RN20/RN25|RN40/LN40/RN30|RN46/LN46/RN30';
series_years['Hilux_1979'] = 'RN40/LN40/RN30|RN46/LN46/RN30';
series_years['Hilux_1980'] = 'RN40/LN40/RN30|RN46/LN46/RN30';
series_years['Hilux_1981'] = 'RN40/LN40/RN30|RN46/LN46/RN30';
series_years['Hilux_1982'] = 'RN40/LN40/RN30|RN46/LN46/RN30';
series_years['Hilux_1983'] = 'RN40/LN40/RN30|RN46/LN46/RN30|RN50/YN56/YN58/LN56|YN63/LN65';
series_years['Hilux_2003'] = 'KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174|VZN167R|VZN172R';
series_years['Hilux_2004'] = 'KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174|VZN167R|VZN172R';
series_years['Hilux_2005'] = 'GGN15R|GGN25R|KUN16R|KUN26R|KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174|TGN16R|VZN167R|VZN172R';
series_years['Hilux_2008'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2009'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2010'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2011'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2021'] = 'GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2022'] = 'GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2023'] = 'GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_2024'] = 'GUN125R|GUN126R|GUN135R|GUN136R|TGN121R';
series_years['Hilux_1997'] = 'LN147R|LN167R|LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 |RZN147R|RZN149R|RZN169R';
series_years['Hilux_1998'] = 'LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174';
series_years['Hilux_1999'] = 'KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174';
series_years['Hilux_2000'] = 'KZN165R|LN147R|LN167R|LN172R|RZN147R|RZN149R|RZN154|RZN169R|RZN174';
series_years['Hilux_2012'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2013'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2014'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_1975'] = 'RN20/RN25';
series_years['Hilux_1976'] = 'RN20/RN25';
series_years['Hilux_1977'] = 'RN20/RN25';
series_years['Hilux_1988'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 |RN50/YN56/YN58/LN56|YN63/LN65';
series_years['Hilux_1989'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1990'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1991'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1992'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1993'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1994'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1995'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_1996'] = 'LN85R/LN86R/RN85R/RN90R/YN85R|RN105 RN110 YN106 LN106 LN107 ';
series_years['Hilux_2006'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_2007'] = 'GGN15R|GGN25R|KUN16R|KUN26R|TGN16R';
series_years['Hilux_1984'] = 'RN50/YN56/YN58/LN56|YN63/LN65';
series_years['Hilux_1985'] = 'RN50/YN56/YN58/LN56|YN63/LN65';
series_years['Hilux_1986'] = 'RN50/YN56/YN58/LN56|YN63/LN65';
series_years['Hilux_1987'] = 'RN50/YN56/YN58/LN56|YN63/LN65';
series_years['Hilux_2025'] = 'GUN126R';
series_years['Kluger_2016'] = 'GSU50R|GSU55R';
series_years['Kluger_2017'] = 'GSU50R|GSU55R';
series_years['Kluger_2018'] = 'GSU50R|GSU55R';
series_years['Kluger_2019'] = 'GSU50R|GSU55R';
series_years['Kluger_2022'] = 'AXUH78R|GSU70R|GSU75R|TXUA70R|TXUA75R';
series_years['Kluger_2023'] = 'AXUH78R|TXUA70R|TXUA75R';
series_years['Kluger_2024'] = 'AXUH78R|TXUA70R|TXUA75R';
series_years['Kluger_2013'] = 'GSU40R|GSU45R|GSU50R|GSU55R';
series_years['Kluger_2014'] = 'GSU50R|GSU55R';
series_years['Kluger_2015'] = 'GSU50R|GSU55R';
series_years['Kluger_2021'] = 'AXUH78R|GSU70R|GSU75R';
series_years['Kluger_2025'] = 'AXUH78R';
series_years['Kluger_2007'] = 'GSU40R|MCU28R';
series_years['Kluger_2008'] = 'GSU40R';
series_years['Kluger_2009'] = 'GSU40R';
series_years['Kluger_2010'] = 'GSU40R|GSU45R';
series_years['Kluger_2011'] = 'GSU40R|GSU45R';
series_years['Kluger_2012'] = 'GSU40R|GSU45R';
series_years['Kluger_2003'] = 'MCU28R';
series_years['Kluger_2004'] = 'MCU28R';
series_years['Kluger_2005'] = 'MCU28R';
series_years['Kluger_2006'] = 'MCU28R';
series_years['Landcruiser_2011'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2012'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2009'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2010'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2013'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2014'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2015'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2016'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2007'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R|UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2008'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_1990'] = '60 SERIES|70 SERIES|75 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1991'] = '70 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1992'] = '70 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1993'] = '70 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1994'] = '70 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1995'] = '70 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1998'] = '100 SERIES|FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1999'] = '100 SERIES|FZJ75R/HZJ75R|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2000'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2001'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2002'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2003'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2004'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2005'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2006'] = '100 SERIES|FZJ78R/HZJ78R/HDJ78R|FZJ79R/HZJ79R/HDJ79R';
series_years['Landcruiser_2017'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2018'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2019'] = 'UZJ200|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2020'] = 'VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2021'] = 'FJA300R|VDJ200|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_2022'] = 'FJA300R|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_1984'] = '40 SERIES|60 SERIES|70 SERIES|75 SERIES';
series_years['Landcruiser_1985'] = '60 SERIES|70 SERIES|75 SERIES';
series_years['Landcruiser_1986'] = '60 SERIES|70 SERIES|75 SERIES';
series_years['Landcruiser_1987'] = '60 SERIES|70 SERIES|75 SERIES';
series_years['Landcruiser_1988'] = '60 SERIES|70 SERIES|75 SERIES';
series_years['Landcruiser_1989'] = '60 SERIES|70 SERIES|75 SERIES';
series_years['Landcruiser_2023'] = 'FJA300R|VDJ76R|VDJ78R|VDJ79R';
series_years['Landcruiser_1996'] = 'FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_1997'] = 'FZJ75R/HZJ75R|FZJ80R/HDJ80R/HZJ80R';
series_years['Landcruiser_2024'] = 'FJA300R';
series_years['Landcruiser_2025'] = 'FJA300R';
series_years['Landcruiser_1960'] = '40 SERIES';
series_years['Landcruiser_1961'] = '40 SERIES';
series_years['Landcruiser_1962'] = '40 SERIES';
series_years['Landcruiser_1963'] = '40 SERIES';
series_years['Landcruiser_1964'] = '40 SERIES';
series_years['Landcruiser_1965'] = '40 SERIES';
series_years['Landcruiser_1966'] = '40 SERIES';
series_years['Landcruiser_1967'] = '40 SERIES';
series_years['Landcruiser_1968'] = '40 SERIES';
series_years['Landcruiser_1969'] = '40 SERIES';
series_years['Landcruiser_1970'] = '40 SERIES';
series_years['Landcruiser_1971'] = '40 SERIES';
series_years['Landcruiser_1972'] = '40 SERIES';
series_years['Landcruiser_1973'] = '40 SERIES';
series_years['Landcruiser_1974'] = '40 SERIES';
series_years['Landcruiser_1975'] = '40 SERIES';
series_years['Landcruiser_1976'] = '40 SERIES';
series_years['Landcruiser_1977'] = '40 SERIES';
series_years['Landcruiser_1978'] = '40 SERIES';
series_years['Landcruiser_1979'] = '40 SERIES';
series_years['Landcruiser_1980'] = '40 SERIES|60 SERIES';
series_years['Landcruiser_1981'] = '40 SERIES|60 SERIES';
series_years['Landcruiser_1982'] = '40 SERIES|60 SERIES';
series_years['Landcruiser_1983'] = '40 SERIES|60 SERIES';
series_years['Landcruiser Prado_2017'] = 'GDJ150R|GRJ150R|KDJ150R';
series_years['Landcruiser Prado_2018'] = 'GDJ150R|GRJ150R';
series_years['Landcruiser Prado_2019'] = 'GDJ150R';
series_years['Landcruiser Prado_2020'] = 'GDJ150R';
series_years['Landcruiser Prado_2015'] = 'GDJ150R|GRJ150R|KDJ150R';
series_years['Landcruiser Prado_2016'] = 'GDJ150R|GRJ150R|KDJ150R';
series_years['Landcruiser Prado_2009'] = 'GRJ150R|KDJ150R|KDJ155R|RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2010'] = 'GRJ150R|KDJ150R|KDJ155R';
series_years['Landcruiser Prado_2011'] = 'GRJ150R|KDJ150R|KDJ155R';
series_years['Landcruiser Prado_2012'] = 'GRJ150R|KDJ150R|KDJ155R';
series_years['Landcruiser Prado_2013'] = 'GRJ150R|KDJ150R|KDJ155R';
series_years['Landcruiser Prado_2014'] = 'GRJ150R|KDJ150R';
series_years['Landcruiser Prado_2024'] = 'GDJ150R|GDJ251R';
series_years['Landcruiser Prado_2025'] = 'GDJ251R';
series_years['Landcruiser Prado_2021'] = 'GDJ150R';
series_years['Landcruiser Prado_2022'] = 'GDJ150R';
series_years['Landcruiser Prado_2023'] = 'GDJ150R';
series_years['Landcruiser Prado_1996'] = 'KZJ95R/RZJ95R/VZJ95R';
series_years['Landcruiser Prado_1997'] = 'KZJ95R/RZJ95R/VZJ95R';
series_years['Landcruiser Prado_1998'] = 'KZJ95R/RZJ95R/VZJ95R';
series_years['Landcruiser Prado_1999'] = 'KZJ95R/RZJ95R/VZJ95R';
series_years['Landcruiser Prado_2000'] = 'KZJ95R/RZJ95R/VZJ95R';
series_years['Landcruiser Prado_2001'] = 'KZJ95R/RZJ95R/VZJ95R';
series_years['Landcruiser Prado_2002'] = 'KZJ95R/RZJ95R/VZJ95R|RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2003'] = 'RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2004'] = 'RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2005'] = 'RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2006'] = 'RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2007'] = 'RZJ120R / GRJ120R / KDJ120R';
series_years['Landcruiser Prado_2008'] = 'RZJ120R / GRJ120R / KDJ120R';
series_years['Lexcen_1993'] = 'T4|VP';
series_years['Lexcen_1994'] = 'T4';
series_years['Lexcen_1995'] = 'T4';
series_years['Lexcen_1996'] = 'T4';
series_years['Lexcen_1997'] = 'T4';
series_years['Lexcen_1989'] = 'VN';
series_years['Lexcen_1990'] = 'VN';
series_years['Lexcen_1991'] = 'VN|VP';
series_years['Lexcen_1992'] = 'VP';
series_years['Liteace_1986'] = 'KM3/YM3';
series_years['Liteace_1987'] = 'KM3/YM3';
series_years['Liteace_1988'] = 'KM3/YM3';
series_years['Liteace_1989'] = 'KM3/YM3';
series_years['Liteace_1990'] = 'KM3/YM3';
series_years['Liteace_1991'] = 'KM3/YM3';
series_years['Liteace_1992'] = 'KM3/YM3';
series_years['MR2_1987'] = 'AW11';
series_years['MR2_1988'] = 'AW11';
series_years['MR2_1989'] = 'AW11|SW20R';
series_years['MR2_1999'] = 'SW20R|ZZW30R';
series_years['MR2_2000'] = 'ZZW30R';
series_years['MR2_2001'] = 'ZZW30R';
series_years['MR2_2002'] = 'ZZW30R';
series_years['MR2_2003'] = 'ZZW30R';
series_years['MR2_2004'] = 'ZZW30R';
series_years['MR2_2005'] = 'ZZW30R';
series_years['MR2_1990'] = 'SW20R';
series_years['MR2_1991'] = 'SW20R';
series_years['MR2_1992'] = 'SW20R';
series_years['MR2_1993'] = 'SW20R';
series_years['MR2_1994'] = 'SW20R';
series_years['MR2_1995'] = 'SW20R';
series_years['MR2_1996'] = 'SW20R';
series_years['MR2_1997'] = 'SW20R';
series_years['MR2_1998'] = 'SW20R';
series_years['Paseo_1991'] = 'EL44R/EL54R';
series_years['Paseo_1992'] = 'EL44R/EL54R';
series_years['Paseo_1993'] = 'EL44R/EL54R';
series_years['Paseo_1994'] = 'EL44R/EL54R';
series_years['Paseo_1995'] = 'EL44R/EL54R';
series_years['Paseo_1996'] = 'EL44R/EL54R';
series_years['Paseo_1997'] = 'EL44R/EL54R';
series_years['Paseo_1998'] = 'EL44R/EL54R';
series_years['Paseo_1999'] = 'EL44R/EL54R';
series_years['Prius_2009'] = 'NHW20R|ZVW30R';
series_years['Prius_2010'] = 'ZVW30R';
series_years['Prius_2011'] = 'ZVW30R';
series_years['Prius_2012'] = 'ZVW30R';
series_years['Prius_2013'] = 'ZVW30R';
series_years['Prius_2014'] = 'ZVW30R';
series_years['Prius_2015'] = 'ZVW30R';
series_years['Prius_2016'] = 'ZVW30R|ZVW50';
series_years['Prius_2018'] = 'ZVW50|ZVW50R';
series_years['Prius_2019'] = 'ZVW50R';
series_years['Prius_2020'] = 'ZVW50R';
series_years['Prius_2021'] = 'ZVW50R';
series_years['Prius_2022'] = 'ZVW50R';
series_years['Prius_2000'] = 'NHW11R';
series_years['Prius_2001'] = 'NHW11R';
series_years['Prius_2002'] = 'NHW11R';
series_years['Prius_2003'] = 'NHW11R|NHW20R';
series_years['Prius_2017'] = 'ZVW50';
series_years['Prius_2004'] = 'NHW20R';
series_years['Prius_2005'] = 'NHW20R';
series_years['Prius_2006'] = 'NHW20R';
series_years['Prius_2007'] = 'NHW20R';
series_years['Prius_2008'] = 'NHW20R';
series_years['Prius-C_2011'] = 'NHP10R';
series_years['Prius-C_2012'] = 'NHP10R';
series_years['Prius-C_2013'] = 'NHP10R';
series_years['Prius-C_2014'] = 'NHP10R';
series_years['Prius-C_2015'] = 'NHP10R';
series_years['Prius-C_2016'] = 'NHP10R';
series_years['Prius-C_2017'] = 'NHP10R';
series_years['Prius-V_2015'] = 'ZVW40R';
series_years['Prius-V_2016'] = 'ZVW40R';
series_years['Prius-V_2017'] = 'ZVW40R';
series_years['Prius-V_2018'] = 'ZVW40R';
series_years['Prius-V_2019'] = 'ZVW40R';
series_years['Prius-V_2020'] = 'ZVW40R';
series_years['Prius-V_2021'] = 'ZVW40R';
series_years['Prius-V_2012'] = 'ZVW40R';
series_years['Prius-V_2013'] = 'ZVW40R';
series_years['Prius-V_2014'] = 'ZVW40R';
series_years['RAV4_2000'] = 'ACA20R/ACA21R/ACA22R/ACA23R|SXA10R/SXA11R';
series_years['RAV4_2001'] = 'ACA20R/ACA21R/ACA22R/ACA23R';
series_years['RAV4_2002'] = 'ACA20R/ACA21R/ACA22R/ACA23R';
series_years['RAV4_2003'] = 'ACA20R/ACA21R/ACA22R/ACA23R';
series_years['RAV4_2004'] = 'ACA20R/ACA21R/ACA22R/ACA23R';
series_years['RAV4_2005'] = 'ACA20R/ACA21R/ACA22R/ACA23R|ACA33/GSA33';
series_years['RAV4_1994'] = 'SXA10R/SXA11R';
series_years['RAV4_1995'] = 'SXA10R/SXA11R';
series_years['RAV4_1996'] = 'SXA10R/SXA11R';
series_years['RAV4_1997'] = 'SXA10R/SXA11R';
series_years['RAV4_1998'] = 'SXA10R/SXA11R';
series_years['RAV4_1999'] = 'SXA10R/SXA11R';
series_years['RAV4_2006'] = 'ACA33/GSA33';
series_years['RAV4_2007'] = 'ACA33/GSA33';
series_years['RAV4_2008'] = 'ACA33/ACA38|ACA33/GSA33|ACA33/GSA33/ACA38';
series_years['RAV4_2012'] = 'ACA33/ACA38|ACA33/GSA33/ACA38|ALA49/ASA44/ZSA42';
series_years['RAV4_2013'] = 'ALA49/ASA44/ZSA42';
series_years['RAV4_2014'] = 'ALA49/ASA44/ZSA42';
series_years['RAV4_2015'] = 'ALA49/ASA44/ZSA42|ALA49R';
series_years['RAV4_2019'] = 'ALA49/ASA44/ZSA42|ALA49R|AXAA54R|AXAH52R|AXAH54R|MXAA52R';
series_years['RAV4_2020'] = 'AXAA54R|AXAH52R|AXAH54R|MXAA52R';
series_years['RAV4_2021'] = 'AXAA54R|AXAH52R|AXAH54R|MXAA52R';
series_years['RAV4_2022'] = 'AXAA54R|AXAH52R|AXAH54R|MXAA52R';
series_years['RAV4_2023'] = 'AXAA54R|AXAH52R|AXAH54R|MXAA52R';
series_years['RAV4_2024'] = 'AXAA54R|AXAH52R|AXAH54R|MXAA52R';
series_years['RAV4_2025'] = 'AXAA54R|AXAH52R|AXAH54R';
series_years['RAV4_2016'] = 'ALA49/ASA44/ZSA42|ALA49R';
series_years['RAV4_2017'] = 'ALA49/ASA44/ZSA42|ALA49R';
series_years['RAV4_2018'] = 'ALA49/ASA44/ZSA42|ALA49R';
series_years['RAV4_2009'] = 'ACA33/ACA38|ACA33/GSA33/ACA38';
series_years['RAV4_2010'] = 'ACA33/ACA38|ACA33/GSA33/ACA38';
series_years['RAV4_2011'] = 'ACA33/ACA38|ACA33/GSA33/ACA38';
series_years['Rukus_2010'] = 'AZE151R';
series_years['Rukus_2011'] = 'AZE151R';
series_years['Rukus_2012'] = 'AZE151R';
series_years['Rukus_2013'] = 'AZE151R';
series_years['Rukus_2014'] = 'AZE151R';
series_years['Rukus_2015'] = 'AZE151R';
series_years['Sprinter_2022'] = 'WDB907';
series_years['Sprinter_2023'] = 'WDB907';
series_years['Sprinter_2024'] = 'WDB907';
series_years['Sprinter_2025'] = 'WDB907';
series_years['Sprinter_2011'] = 'WDB906';
series_years['Sprinter_2012'] = 'WDB906';
series_years['Sprinter_2013'] = 'WDB906';
series_years['Sprinter_2018'] = 'WDB906|WDB907';
series_years['Sprinter_2019'] = 'WDB906|WDB907';
series_years['Sprinter_2020'] = 'WDB907';
series_years['Sprinter_2006'] = '208/308/311/313/413/316/416/61|WDB906';
series_years['Sprinter_2007'] = 'WDB906';
series_years['Sprinter_1998'] = '308D/312D/412D|AE102R';
series_years['Sprinter_1999'] = '308D/312D/412D|AE102R';
series_years['Sprinter_2000'] = '208/308/311/313/413/316/416/61|308D/312D/412D';
series_years['Sprinter_2010'] = 'WDB906';
series_years['Sprinter_2014'] = 'WDB906';
series_years['Sprinter_2015'] = 'WDB906';
series_years['Sprinter_2016'] = 'WDB906';
series_years['Sprinter_2017'] = 'WDB906';
series_years['Sprinter_2009'] = 'WDB906';
series_years['Sprinter_1994'] = 'AE102R';
series_years['Sprinter_1995'] = 'AE102R';
series_years['Sprinter_1996'] = 'AE102R';
series_years['Sprinter_1997'] = 'AE102R';
series_years['Sprinter_2008'] = 'WDB906';
series_years['Sprinter_2021'] = 'WDB907';
series_years['Sprinter_2001'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2002'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2003'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2004'] = '208/308/311/313/413/316/416/61';
series_years['Sprinter_2005'] = '208/308/311/313/413/316/416/61';
series_years['Starlet_1996'] = 'EP91R';
series_years['Starlet_1997'] = 'EP91R';
series_years['Starlet_1998'] = 'EP91R';
series_years['Starlet_1999'] = 'EP91R';
series_years['Supra_2020'] = 'GR';
series_years['Supra_2021'] = 'GR';
series_years['Supra_2022'] = 'GR';
series_years['Supra_1993'] = 'JZA70|JZA80';
series_years['Supra_1994'] = 'JZA70|JZA80';
series_years['Supra_1995'] = 'JZA70|JZA80';
series_years['Supra_1996'] = 'JZA70|JZA80';
series_years['Supra_1997'] = 'JZA70|JZA80';
series_years['Supra_1998'] = 'JZA70|JZA80';
series_years['Supra_1999'] = 'JZA70|JZA80';
series_years['Supra_2000'] = 'JZA70|JZA80';
series_years['Supra_2001'] = 'JZA70|JZA80';
series_years['Supra_2002'] = 'JZA70|JZA80';
series_years['Supra_2023'] = 'GR';
series_years['Supra_2024'] = 'GR';
series_years['Supra_2025'] = 'GR';
series_years['Supra_1976'] = 'MA70/MA71';
series_years['Supra_1977'] = 'MA70/MA71';
series_years['Supra_1978'] = 'JZA70|MA70/MA71';
series_years['Supra_1979'] = 'JZA70|MA70/MA71';
series_years['Supra_1980'] = 'JZA70|MA70/MA71';
series_years['Supra_1981'] = 'JZA70|MA70/MA71';
series_years['Supra_1982'] = 'JZA70|MA70/MA71';
series_years['Supra_1983'] = 'JZA70|MA70/MA71';
series_years['Supra_1984'] = 'JZA70|MA70/MA71';
series_years['Supra_1985'] = 'JZA70|MA70/MA71';
series_years['Supra_1986'] = 'JZA70|MA70/MA71';
series_years['Supra_1987'] = 'JZA70|MA70/MA71';
series_years['Supra_1988'] = 'JZA70|MA70/MA71';
series_years['Supra_1989'] = 'JZA70|MA70/MA71';
series_years['Supra_1990'] = 'JZA70|MA70/MA71';
series_years['Supra_1991'] = 'JZA70|MA70/MA71';
series_years['Supra_1992'] = 'JZA70|MA70/MA71';
series_years['Supra_2019'] = 'GR';
series_years['Tarago_2000'] = 'ACR30R|TCR10R/TCR11R';
series_years['Tarago_2001'] = 'ACR30R';
series_years['Tarago_2002'] = 'ACR30R';
series_years['Tarago_2003'] = 'ACR30R';
series_years['Tarago_2004'] = 'ACR30R';
series_years['Tarago_2005'] = 'ACR30R';
series_years['Tarago_1990'] = 'TCR10R/TCR11R';
series_years['Tarago_1991'] = 'TCR10R/TCR11R';
series_years['Tarago_1992'] = 'TCR10R/TCR11R';
series_years['Tarago_1993'] = 'TCR10R/TCR11R';
series_years['Tarago_1994'] = 'TCR10R/TCR11R';
series_years['Tarago_1995'] = 'TCR10R/TCR11R';
series_years['Tarago_1996'] = 'TCR10R/TCR11R';
series_years['Tarago_1997'] = 'TCR10R/TCR11R';
series_years['Tarago_1998'] = 'TCR10R/TCR11R';
series_years['Tarago_1999'] = 'TCR10R/TCR11R';
series_years['Tarago_1982'] = 'YR20/YR21/YR22';
series_years['Tarago_1983'] = 'YR20/YR21/YR22';
series_years['Tarago_1984'] = 'YR20/YR21/YR22';
series_years['Tarago_1985'] = 'YR20/YR21/YR22';
series_years['Tarago_1986'] = 'YR20/YR21/YR22';
series_years['Tarago_1987'] = 'YR20/YR21/YR22';
series_years['Tarago_1988'] = 'YR20/YR21/YR22';
series_years['Tarago_2006'] = 'ACR50R/GSR50R';
series_years['Tarago_2007'] = 'ACR50R/GSR50R';
series_years['Tarago_2008'] = 'ACR50R/GSR50R';
series_years['Tarago_2009'] = 'ACR50R/GSR50R';
series_years['Tarago_2010'] = 'ACR50R/GSR50R';
series_years['Tarago_2011'] = 'ACR50R/GSR50R';
series_years['Tarago_2012'] = 'ACR50R/GSR50R';
series_years['Tarago_2013'] = 'ACR50R/GSR50R';
series_years['Tarago_2014'] = 'ACR50R/GSR50R';
series_years['Tarago_2015'] = 'ACR50R/GSR50R';
series_years['Tarago_2016'] = 'ACR50R/GSR50R';
series_years['Tarago_2017'] = 'ACR50R/GSR50R';
series_years['Tarago_2018'] = 'ACR50R/GSR50R';
series_years['Tarago_2019'] = 'ACR50R/GSR50R';
series_years['Townace_1997'] = 'KR42R/SR40R/YR22R';
series_years['Townace_1998'] = 'KR42R/SR40R/YR22R';
series_years['Townace_1999'] = 'KR42R/SR40R/YR22R';
series_years['Townace_2000'] = 'KR42R/SR40R/YR22R';
series_years['Townace_2001'] = 'KR42R/SR40R/YR22R';
series_years['Townace_1992'] = 'YR22R/YR39R';
series_years['Townace_1993'] = 'YR22R/YR39R';
series_years['Townace_1994'] = 'YR22R/YR39R';
series_years['Townace_1995'] = 'YR22R/YR39R';
series_years['Townace_1996'] = 'YR22R/YR39R';
series_years['Toyota Forklift_1960'] = 'TOYOTA';
series_years['Toyota Forklift_1961'] = 'TOYOTA';
series_years['Toyota Forklift_1962'] = 'TOYOTA';
series_years['Toyota Forklift_1963'] = 'TOYOTA';
series_years['Toyota Forklift_1964'] = 'TOYOTA';
series_years['Toyota Forklift_1965'] = 'TOYOTA';
series_years['Toyota Forklift_1966'] = 'TOYOTA';
series_years['Toyota Forklift_1967'] = 'TOYOTA';
series_years['Toyota Forklift_1968'] = 'TOYOTA';
series_years['Toyota Forklift_1969'] = 'TOYOTA';
series_years['Toyota Forklift_1970'] = 'TOYOTA';
series_years['Toyota Forklift_1971'] = 'TOYOTA';
series_years['Toyota Forklift_1972'] = 'TOYOTA';
series_years['Toyota Forklift_1973'] = 'TOYOTA';
series_years['Toyota Forklift_1974'] = 'TOYOTA';
series_years['Toyota Forklift_1975'] = 'TOYOTA';
series_years['Toyota Forklift_1976'] = 'TOYOTA';
series_years['Toyota Forklift_1977'] = 'TOYOTA';
series_years['Toyota Forklift_1978'] = 'TOYOTA';
series_years['Toyota Forklift_1979'] = 'TOYOTA';
series_years['Toyota Forklift_1980'] = 'TOYOTA';
series_years['Toyota Forklift_1981'] = 'TOYOTA';
series_years['Toyota Forklift_1982'] = 'TOYOTA';
series_years['Toyota Forklift_1983'] = 'TOYOTA';
series_years['Toyota Forklift_1984'] = 'TOYOTA';
series_years['Toyota Forklift_1985'] = 'TOYOTA';
series_years['Toyota Forklift_1986'] = 'TOYOTA';
series_years['Toyota Forklift_1987'] = 'TOYOTA';
series_years['Toyota Forklift_1988'] = 'TOYOTA';
series_years['Toyota Forklift_1989'] = 'TOYOTA';
series_years['Toyota Forklift_1990'] = 'TOYOTA';
series_years['Toyota Forklift_1991'] = 'TOYOTA';
series_years['Toyota Forklift_1992'] = 'TOYOTA';
series_years['Toyota Forklift_1993'] = 'TOYOTA';
series_years['Toyota Forklift_1994'] = 'TOYOTA';
series_years['Toyota Forklift_1995'] = 'TOYOTA';
series_years['Toyota Forklift_1996'] = 'TOYOTA';
series_years['Toyota Forklift_1997'] = 'TOYOTA';
series_years['Toyota Forklift_1998'] = 'TOYOTA';
series_years['Toyota Forklift_1999'] = 'TOYOTA';
series_years['Toyota Forklift_2000'] = 'TOYOTA';
series_years['Toyota Forklift_2001'] = 'TOYOTA';
series_years['Toyota Forklift_2002'] = 'TOYOTA';
series_years['Toyota Forklift_2003'] = 'TOYOTA';
series_years['Toyota Forklift_2004'] = 'TOYOTA';
series_years['Toyota Forklift_2005'] = 'TOYOTA';
series_years['Toyota Forklift_2006'] = 'TOYOTA';
series_years['Toyota Forklift_2007'] = 'TOYOTA';
series_years['Toyota Forklift_2008'] = 'TOYOTA';
series_years['Toyota Forklift_2009'] = 'TOYOTA';
series_years['Toyota Forklift_2010'] = 'TOYOTA';
series_years['Toyota Forklift_2011'] = 'TOYOTA';
series_years['Toyota Forklift_2012'] = 'TOYOTA';
series_years['Toyota Forklift_2013'] = 'TOYOTA';
series_years['Toyota Forklift_2014'] = 'TOYOTA';
series_years['Toyota Forklift_2015'] = 'TOYOTA';
series_years['Toyota Forklift_2016'] = 'TOYOTA';
series_years['Toyota Forklift_2017'] = 'TOYOTA';
series_years['Toyota Forklift_2018'] = 'TOYOTA';
series_years['Toyota Forklift_2019'] = 'TOYOTA';
series_years['Toyota Forklift_2020'] = 'TOYOTA';
series_years['Toyota Forklift_2021'] = 'TOYOTA';
series_years['Toyota Forklift_2022'] = 'TOYOTA';
series_years['Toyota Forklift_2023'] = 'TOYOTA';
series_years['Toyota Forklift_2024'] = 'TOYOTA';
series_years['Toyota Forklift_2025'] = 'TOYOTA';
series_years['Toyota Truck_1984'] = 'BU3/BU4|BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1985'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1986'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1987'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1988'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1989'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1990'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1991'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1992'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1993'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1994'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1995'] = 'BU6/BU7/BU8/BU9';
series_years['Toyota Truck_1979'] = 'BU3/BU4';
series_years['Toyota Truck_1980'] = 'BU3/BU4';
series_years['Toyota Truck_1981'] = 'BU3/BU4';
series_years['Toyota Truck_1982'] = 'BU3/BU4';
series_years['Toyota Truck_1983'] = 'BU3/BU4';
series_years['Yaris_2014'] = 'NCP130 |NCP131|NCP93R';
series_years['Yaris_2015'] = 'NCP130 |NCP131|NCP93R';
series_years['Yaris_2016'] = 'NCP130 |NCP131|NCP93R';
series_years['Yaris_2017'] = 'NCP130 |NCP131';
series_years['Yaris_2020'] = 'GXPA16R|MXPA10R|MXPH10R|NCP130 |NCP131';
series_years['Yaris_2021'] = 'GXPA16R|MXPA10R|MXPH10R';
series_years['Yaris_2022'] = 'GXPA16R|MXPA10R|MXPH10R';
series_years['Yaris_2023'] = 'GXPA16R|MXPA10R|MXPH10R';
series_years['Yaris_2024'] = 'GXPA16R|MXPA10R|MXPH10R';
series_years['Yaris_2025'] = 'GXPA16R|MXPA10R|MXPH10R';
series_years['Yaris_2005'] = 'NCP90R|NCP91R';
series_years['Yaris_2006'] = 'NCP90R|NCP91R|NCP93R';
series_years['Yaris_2007'] = 'NCP90R|NCP91R|NCP93R';
series_years['Yaris_2008'] = 'NCP90R|NCP91R|NCP93R';
series_years['Yaris_2009'] = 'NCP90R|NCP91R|NCP93R';
series_years['Yaris_2010'] = 'NCP90R|NCP91R|NCP93R';
series_years['Yaris_2011'] = 'NCP130 |NCP131|NCP90R|NCP91R|NCP93R';
series_years['Yaris_2018'] = 'NCP130 |NCP131';
series_years['Yaris_2019'] = 'NCP130 |NCP131';
series_years['Yaris_2012'] = 'NCP130 |NCP131|NCP93R';
series_years['Yaris_2013'] = 'NCP130 |NCP131|NCP93R';
series_years['Yaris Cross_2020'] = 'MXPB10R|MXPJ10R|MXPJ15R';
series_years['Yaris Cross_2021'] = 'MXPB10R|MXPJ10R|MXPJ15R';
series_years['Yaris Cross_2022'] = 'MXPB10R|MXPJ10R|MXPJ15R';
series_years['Yaris Cross_2023'] = 'MXPB10R|MXPJ10R|MXPJ15R';
series_years['Yaris Cross_2024'] = 'MXPB10R|MXPJ10R|MXPJ15R';
series_years['Yaris Cross_2025'] = 'MXPB10R|MXPJ10R|MXPJ15R';
series_years['Amarok_2012'] = '2H';
series_years['Amarok_2016'] = '2H';
series_years['Amarok_2017'] = '2H';
series_years['Amarok_2011'] = '2H';
series_years['Amarok_2020'] = '2H';
series_years['Amarok_2021'] = '2H';
series_years['Amarok_2018'] = '2H';
series_years['Amarok_2019'] = '2H';
series_years['Amarok_2014'] = '2H';
series_years['Amarok_2015'] = '2H';
series_years['Amarok_2022'] = '2H|NF';
series_years['Amarok_2013'] = '2H';
series_years['Amarok_2023'] = 'NF';
series_years['Amarok_2024'] = 'NF';
series_years['Amarok_2025'] = 'NF';
series_years['Arteon_2017'] = '3H';
series_years['Arteon_2018'] = '3H';
series_years['Arteon_2019'] = '3H';
series_years['Arteon_2020'] = '3H';
series_years['Arteon_2021'] = '3H';
series_years['Arteon_2022'] = '3H';
series_years['Arteon_2023'] = '3H';
series_years['Arteon_2024'] = '3H';
series_years['Arteon_2025'] = '3H';
series_years['Beetle_2005'] = '1Y/9C';
series_years['Beetle_2006'] = '1Y/9C';
series_years['Beetle_2007'] = '1Y/9C';
series_years['Beetle_2008'] = '1Y/9C';
series_years['Beetle_2009'] = '1Y/9C';
series_years['Beetle_2010'] = '1Y/9C';
series_years['Beetle_2011'] = '1Y/9C';
series_years['Beetle_2000'] = '1Y/9C';
series_years['Beetle_2001'] = '1Y/9C';
series_years['Beetle_2002'] = '1Y/9C';
series_years['Beetle_2003'] = '1Y/9C';
series_years['Beetle_2004'] = '1Y/9C';
series_years['Beetle_2013'] = '1L';
series_years['Beetle_2014'] = '1L';
series_years['Beetle_2015'] = '1L';
series_years['Beetle_2016'] = '1L';
series_years['Bora_1999'] = 'TYPE 4';
series_years['Bora_2000'] = 'TYPE 4';
series_years['Bora_2001'] = 'TYPE 4';
series_years['Bora_2002'] = 'TYPE 4';
series_years['Bora_2003'] = 'TYPE 4';
series_years['Bora_2004'] = 'TYPE 4';
series_years['Bora_2005'] = 'TYPE 4';
series_years['Caddy_2005'] = '2K';
series_years['Caddy_2006'] = '2K';
series_years['Caddy_2007'] = '2K';
series_years['Caddy_2008'] = '2K';
series_years['Caddy_2009'] = '2K';
series_years['Caddy_2010'] = '2K';
series_years['Caddy_2011'] = '2K';
series_years['Caddy_2012'] = '2K';
series_years['Caddy_2013'] = '2K';
series_years['Caddy_2014'] = '2K';
series_years['Caddy_2015'] = '2K';
series_years['Caddy_2021'] = '2K|5';
series_years['Caddy_2022'] = '5';
series_years['Caddy_2016'] = '2K';
series_years['Caddy_2017'] = '2K';
series_years['Caddy_2018'] = '2K';
series_years['Caddy_2019'] = '2K';
series_years['Caddy_2020'] = '2K';
series_years['Caddy_2023'] = '5';
series_years['Caddy_2024'] = '5';
series_years['Caddy_2025'] = '5';
series_years['Caravelle_1993'] = 'T4';
series_years['Caravelle_1994'] = 'T4';
series_years['Caravelle_1995'] = 'T4';
series_years['Caravelle_1996'] = 'T4';
series_years['Caravelle_1997'] = 'T4';
series_years['Caravelle_1998'] = 'T4';
series_years['Caravelle_1999'] = 'T4';
series_years['Caravelle_2000'] = 'T4';
series_years['Caravelle_2001'] = 'T4';
series_years['Caravelle_2002'] = 'T4';
series_years['Caravelle_2003'] = 'T4';
series_years['Caravelle_2004'] = 'T4';
series_years['Caravelle_2005'] = 'T4';
series_years['Caravelle_2006'] = 'T4';
series_years['Caravelle_2007'] = 'T4';
series_years['Caravelle_2008'] = 'T4|T5';
series_years['Caravelle_2015'] = 'T5|T6';
series_years['Caravelle_2016'] = 'T6';
series_years['Caravelle_2017'] = 'T6';
series_years['Caravelle_2018'] = 'T6';
series_years['Caravelle_2019'] = 'T6';
series_years['Caravelle_2020'] = 'T6';
series_years['Caravelle_2021'] = 'T6';
series_years['Caravelle_2022'] = 'T6';
series_years['Caravelle_2023'] = 'T6';
series_years['Caravelle_2024'] = 'T6';
series_years['Caravelle_2025'] = 'T6';
series_years['Caravelle_2009'] = 'T5';
series_years['Caravelle_2010'] = 'T5';
series_years['Caravelle_2011'] = 'T5';
series_years['Caravelle_2012'] = 'T5';
series_years['Caravelle_2013'] = 'T5';
series_years['Caravelle_2014'] = 'T5';
series_years['Crafter_2010'] = '2EZ|2F';
series_years['Crafter_2011'] = '2EZ|2F';
series_years['Crafter_2008'] = '2EZ|2F';
series_years['Crafter_2009'] = '2EZ|2F';
series_years['Crafter_2015'] = '2EZ|2F';
series_years['Crafter_2016'] = '2EZ|2F';
series_years['Crafter_2017'] = '2EZ|2F|SY';
series_years['Crafter_2013'] = '2EZ';
series_years['Crafter_2012'] = '2EZ|2F';
series_years['Crafter_2014'] = '2EZ|2F';
series_years['Crafter_2007'] = '2EZ|2F';
series_years['Crafter_2021'] = 'SY|SZ';
series_years['Crafter_2022'] = 'SY|SZ';
series_years['Crafter_2018'] = 'SY|SZ';
series_years['Crafter_2019'] = 'SY|SZ';
series_years['Crafter_2020'] = 'SY|SZ';
series_years['Crafter_2023'] = 'SY|SZ';
series_years['Crafter_2024'] = 'SY|SZ';
series_years['Crafter_2025'] = 'SY|SZ';
series_years['Eos_2007'] = '1F';
series_years['Eos_2008'] = '1F';
series_years['Eos_2009'] = '1F';
series_years['Eos_2010'] = '1F';
series_years['Eos_2011'] = '1F';
series_years['Eos_2012'] = '1F';
series_years['Eos_2013'] = '1F';
series_years['Eos_2014'] = '1F';
series_years['Golf_2006'] = 'MK 5';
series_years['Golf_2007'] = 'MK 5';
series_years['Golf_2008'] = 'MK 5';
series_years['Golf_2009'] = 'A6|MK 5';
series_years['Golf_2014'] = 'A6|A7';
series_years['Golf_2012'] = 'A6';
series_years['Golf_1998'] = '1J|MK 3';
series_years['Golf_1999'] = '1J';
series_years['Golf_2000'] = '1J';
series_years['Golf_2001'] = '1J';
series_years['Golf_2002'] = '1J';
series_years['Golf_2003'] = '1J';
series_years['Golf_2004'] = '1J|MK 5';
series_years['Golf_2017'] = 'A7';
series_years['Golf_2018'] = 'A7';
series_years['Golf_2013'] = 'A6|A7';
series_years['Golf_2015'] = 'A6|A7';
series_years['Golf_2011'] = 'A6';
series_years['Golf_2022'] = 'MK8';
series_years['Golf_2020'] = 'A7';
series_years['Golf_2021'] = 'A7|MK8';
series_years['Golf_1994'] = 'MK 3';
series_years['Golf_1995'] = 'MK 3';
series_years['Golf_1996'] = 'MK 3';
series_years['Golf_1997'] = 'MK 3';
series_years['Golf_2023'] = 'MK8';
series_years['Golf_2024'] = 'MK8';
series_years['Golf_2025'] = 'MK8';
series_years['Golf_2016'] = 'A6|A7';
series_years['Golf_2019'] = 'A7';
series_years['Golf_2010'] = 'A6';
series_years['Golf_2005'] = 'MK 5';
series_years['Golf Alltrack_2018'] = 'A7';
series_years['Golf Alltrack_2019'] = 'A7';
series_years['Golf Alltrack_2020'] = 'A7';
series_years['Golf Alltrack_2021'] = 'A7';
series_years['Golf Alltrack_2017'] = 'A7';
series_years['Golf Alltrack_2015'] = 'A7';
series_years['Golf Alltrack_2016'] = 'A7';
series_years['Jetta_2014'] = '1B';
series_years['Jetta_2015'] = '1B';
series_years['Jetta_2011'] = '1B|1KM';
series_years['Jetta_2007'] = '1KM';
series_years['Jetta_2008'] = '1KM';
series_years['Jetta_2009'] = '1KM';
series_years['Jetta_2013'] = '1B';
series_years['Jetta_2006'] = '1KM';
series_years['Jetta_2012'] = '1B';
series_years['Jetta_2016'] = '1B';
series_years['Jetta_2017'] = '1B';
series_years['Jetta_2018'] = '1B';
series_years['Jetta_2010'] = '1KM';
series_years['LT_2003'] = '2D';
series_years['LT_2004'] = '2D';
series_years['LT_2005'] = '2D';
series_years['LT_2006'] = '2D';
series_years['Multivan_2010'] = 'T5';
series_years['Multivan_2011'] = 'T5';
series_years['Multivan_2012'] = 'T5';
series_years['Multivan_2013'] = 'T5';
series_years['Multivan_2014'] = 'T5';
series_years['Multivan_2015'] = 'T5|T6';
series_years['Multivan_2016'] = 'T6';
series_years['Multivan_2017'] = 'T6';
series_years['Multivan_2018'] = 'T6';
series_years['Multivan_2019'] = 'T6';
series_years['Multivan_2020'] = 'T6';
series_years['Multivan_2004'] = 'T5';
series_years['Multivan_2005'] = 'T5';
series_years['Multivan_2006'] = 'T5';
series_years['Multivan_2007'] = 'T5';
series_years['Multivan_2008'] = 'T5';
series_years['Multivan_2009'] = 'T5';
series_years['Passat_2012'] = '3C';
series_years['Passat_2013'] = '3C';
series_years['Passat_2021'] = 'B8';
series_years['Passat_2022'] = 'B8';
series_years['Passat_2017'] = 'B8';
series_years['Passat_2018'] = 'B8';
series_years['Passat_2009'] = '3C';
series_years['Passat_2010'] = '3C';
series_years['Passat_2011'] = '3C';
series_years['Passat_2015'] = '3C|B8';
series_years['Passat_2016'] = 'B8';
series_years['Passat_1998'] = 'B5';
series_years['Passat_1999'] = 'B5';
series_years['Passat_2000'] = 'B5';
series_years['Passat_2014'] = '3C';
series_years['Passat_2007'] = '3C';
series_years['Passat_2008'] = '3C';
series_years['Passat_2006'] = '3C|B5';
series_years['Passat_2023'] = 'B8';
series_years['Passat_2024'] = 'B8';
series_years['Passat_2019'] = 'B8';
series_years['Passat_2020'] = 'B8';
series_years['Passat_2001'] = 'B5';
series_years['Passat_2002'] = 'B5';
series_years['Passat_2003'] = 'B5';
series_years['Passat_2004'] = 'B5';
series_years['Passat_2005'] = 'B5';
series_years['Passat Alltrack_2016'] = 'B8';
series_years['Passat Alltrack_2017'] = 'B8';
series_years['Passat Alltrack_2022'] = 'B8';
series_years['Passat Alltrack_2023'] = 'B8';
series_years['Passat Alltrack_2024'] = 'B8';
series_years['Passat Alltrack_2021'] = 'B8';
series_years['Passat Alltrack_2018'] = 'B8';
series_years['Passat Alltrack_2019'] = 'B8';
series_years['Passat CC_2013'] = '3CC';
series_years['Passat CC_2014'] = '3CC';
series_years['Passat CC_2009'] = '3CC';
series_years['Passat CC_2010'] = '3CC';
series_years['Passat CC_2011'] = '3CC';
series_years['Passat CC_2012'] = '3CC';
series_years['Passat CC_2015'] = '3CC';
series_years['Passat CC_2016'] = '3CC';
series_years['Passat CC_2017'] = '3CC';
series_years['Passat CC_2018'] = '3CC';
series_years['Passat CC_2019'] = '3CC';
series_years['Passat CC_2020'] = '3CC';
series_years['Passat CC_2021'] = '3CC';
series_years['Polo_2018'] = '6R|AW';
series_years['Polo_2019'] = 'AW';
series_years['Polo_2013'] = '6R';
series_years['Polo_2014'] = '6R';
series_years['Polo_2023'] = 'AW';
series_years['Polo_2024'] = 'AW';
series_years['Polo_2025'] = 'AW';
series_years['Polo_2012'] = '6R';
series_years['Polo_2022'] = 'AW';
series_years['Polo_2010'] = '6R|9N';
series_years['Polo_2015'] = '6R';
series_years['Polo_2016'] = '6R';
series_years['Polo_2005'] = '9N';
series_years['Polo_2006'] = '9N';
series_years['Polo_2007'] = '9N';
series_years['Polo_2008'] = '9N';
series_years['Polo_2009'] = '9N';
series_years['Polo_2000'] = '6N';
series_years['Polo_2001'] = '6N';
series_years['Polo_2011'] = '6R';
series_years['Polo_2017'] = '6R';
series_years['Polo_2020'] = 'AW';
series_years['Polo_2021'] = 'AW';
series_years['Polo_2002'] = '9N';
series_years['Polo_2003'] = '9N';
series_years['Polo_2004'] = '9N';
series_years['Polo_1996'] = '6N';
series_years['Polo_1997'] = '6N';
series_years['Polo_1998'] = '6N';
series_years['Polo_1999'] = '6N';
series_years['Scirocco_2012'] = '1S';
series_years['Scirocco_2013'] = '1S';
series_years['Scirocco_2015'] = '1S';
series_years['Scirocco_2016'] = '1S';
series_years['Scirocco_2017'] = '1S';
series_years['Scirocco_2014'] = '1S';
series_years['Scirocco_2011'] = '1S';
series_years['T-Cross_2020'] = 'C1';
series_years['T-Cross_2021'] = 'C1';
series_years['T-Cross_2022'] = 'C1';
series_years['T-Cross_2023'] = 'C1';
series_years['T-Cross_2024'] = 'C1';
series_years['T-Cross_2025'] = 'C1';
series_years['Tiguan_2010'] = '5N';
series_years['Tiguan_2011'] = '5N';
series_years['Tiguan_2022'] = '5N';
series_years['Tiguan_2023'] = '5N';
series_years['Tiguan_2008'] = '5N';
series_years['Tiguan_2009'] = '5N';
series_years['Tiguan_2019'] = '5N';
series_years['Tiguan_2020'] = '5N';
series_years['Tiguan_2012'] = '5N';
series_years['Tiguan_2016'] = '5N';
series_years['Tiguan_2017'] = '5N';
series_years['Tiguan_2021'] = '5N';
series_years['Tiguan_2015'] = '5N';
series_years['Tiguan_2013'] = '5N';
series_years['Tiguan_2018'] = '5N';
series_years['Tiguan_2014'] = '5N';
series_years['Tiguan Allspace_2018'] = '5N';
series_years['Tiguan Allspace_2019'] = '5N';
series_years['Tiguan Allspace_2020'] = '5N';
series_years['Tiguan Allspace_2022'] = '5N';
series_years['Tiguan Allspace_2023'] = '5N';
series_years['Tiguan Allspace_2021'] = '5N';
series_years['Touareg_2011'] = '7P';
series_years['Touareg_2004'] = '7L';
series_years['Touareg_2005'] = '7L';
series_years['Touareg_2006'] = '7L';
series_years['Touareg_2015'] = '7P';
series_years['Touareg_2016'] = '7P';
series_years['Touareg_2017'] = '7P';
series_years['Touareg_2018'] = '7P';
series_years['Touareg_2019'] = '7P|CR';
series_years['Touareg_2020'] = 'CR';
series_years['Touareg_2021'] = 'CR';
series_years['Touareg_2022'] = 'CR';
series_years['Touareg_2023'] = 'CR';
series_years['Touareg_2024'] = 'CR';
series_years['Touareg_2025'] = 'CR';
series_years['Touareg_2009'] = '7L';
series_years['Touareg_2010'] = '7L';
series_years['Touareg_2007'] = '7L';
series_years['Touareg_2008'] = '7L';
series_years['Touareg_2013'] = '7P';
series_years['Touareg_2014'] = '7P';
series_years['Touareg_2012'] = '7P';
series_years['Transporter_2020'] = 'T6|T6.1';
series_years['Transporter_2021'] = 'T6.1';
series_years['Transporter_2022'] = 'T6.1';
series_years['Transporter_2023'] = 'T6.1';
series_years['Transporter_2024'] = 'T6.1';
series_years['Transporter_2025'] = 'T6.1';
series_years['Transporter_2004'] = 'T4|T5';
series_years['Transporter_2005'] = 'T5';
series_years['Transporter_2006'] = 'T5';
series_years['Transporter_2007'] = 'T5';
series_years['Transporter_2008'] = 'T5';
series_years['Transporter_2009'] = 'T5';
series_years['Transporter_2010'] = 'T5';
series_years['Transporter_2011'] = 'T5';
series_years['Transporter_2012'] = 'T5';
series_years['Transporter_2013'] = 'T5';
series_years['Transporter_2014'] = 'T5';
series_years['Transporter_2015'] = 'T5|T6';
series_years['Transporter_2016'] = 'T6';
series_years['Transporter_2017'] = 'T6';
series_years['Transporter_1992'] = 'T4';
series_years['Transporter_1993'] = 'T4';
series_years['Transporter_1994'] = 'T4';
series_years['Transporter_1995'] = 'T4';
series_years['Transporter_1996'] = 'T4';
series_years['Transporter_1997'] = 'T4';
series_years['Transporter_1998'] = 'T4';
series_years['Transporter_1999'] = 'T4';
series_years['Transporter_2000'] = 'T4';
series_years['Transporter_2001'] = 'T4';
series_years['Transporter_2002'] = 'T4';
series_years['Transporter_2003'] = 'T4';
series_years['Transporter_2018'] = 'T6';
series_years['Transporter_2019'] = 'T6';
series_years['T-Roc_2022'] = 'A1';
series_years['T-Roc_2023'] = 'A1';
series_years['T-Roc_2020'] = 'A1';
series_years['T-Roc_2021'] = 'A1';
series_years['Up!_2012'] = 'AA';
series_years['Up!_2013'] = 'AA';
series_years['Up!_2014'] = 'AA';
series_years['240 / 242 / 244 / 245_1979'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1980'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1981'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1982'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1983'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1984'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1985'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1986'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1987'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1988'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1989'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1990'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1991'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1992'] = '240/242/244/245';
series_years['240 / 242 / 244 / 245_1993'] = '240/242/244/245';
series_years['740 / 760_1983'] = '740/760|B230E';
series_years['740 / 760_1984'] = '740/760|B230E';
series_years['740 / 760_1985'] = '740/760|B230E';
series_years['740 / 760_1986'] = '740/760|B230E';
series_years['740 / 760_1987'] = '740/760|B230E';
series_years['740 / 760_1988'] = '740/760|B230E';
series_years['740 / 760_1989'] = '740/760|B230E';
series_years['740 / 760_1990'] = '740/760|B230E';
series_years['850_1992'] = '850';
series_years['850_1993'] = '850';
series_years['850_1994'] = '850';
series_years['850_1995'] = '850';
series_years['850_1996'] = '850';
series_years['850_1997'] = '850';
series_years['940 / 960 / S90_1990'] = '940/960';
series_years['940 / 960 / S90_1991'] = '940/960';
series_years['940 / 960 / S90_1992'] = '940/960';
series_years['940 / 960 / S90_1993'] = '940/960';
series_years['940 / 960 / S90_1994'] = '940/960';
series_years['C30_2007'] = 'M SERIES';
series_years['C30_2008'] = 'M SERIES';
series_years['C30_2009'] = 'M SERIES';
series_years['C30_2010'] = 'M SERIES';
series_years['C30_2011'] = 'M SERIES';
series_years['C30_2012'] = 'M SERIES';
series_years['C30_2013'] = 'M SERIES';
series_years['S40_2004'] = 'M Series';
series_years['S40_2005'] = 'M Series';
series_years['S40_2006'] = 'M Series';
series_years['S40_2010'] = 'M Series';
series_years['S40_2011'] = 'M Series';
series_years['S40_2012'] = 'M Series';
series_years['S40_2009'] = 'M Series';
series_years['S40_2007'] = 'M Series';
series_years['S40_2008'] = 'M Series';
series_years['S40_2013'] = 'M Series';
series_years['S60_2010'] = 'F SERIES';
series_years['S60_2011'] = 'F SERIES';
series_years['S60_2000'] = 'MK2';
series_years['S60_2001'] = 'MK2';
series_years['S60_2002'] = 'MK2';
series_years['S60_2003'] = 'MK2';
series_years['S60_2004'] = 'MK2';
series_years['S60_2005'] = 'MK2';
series_years['S60_2006'] = 'MK2';
series_years['S60_2007'] = 'MK2';
series_years['S60_2008'] = 'MK2';
series_years['S60_2009'] = 'MK2';
series_years['S60_2014'] = 'F SERIES';
series_years['S60_2015'] = 'F SERIES';
series_years['S60_2016'] = 'F SERIES';
series_years['S60_2017'] = 'F SERIES';
series_years['S60_2012'] = 'F SERIES';
series_years['S60_2013'] = 'F SERIES';
series_years['S60_2018'] = 'F SERIES';
series_years['S60_2019'] = 'F SERIES';
series_years['S70 / V70 / C70_2007'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2008'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2009'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2010'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2011'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2012'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2013'] = 'BW|M SERIES';
series_years['S70 / V70 / C70_2014'] = 'BW';
series_years['S70 / V70 / C70_2015'] = 'BW';
series_years['S70 / V70 / C70_2016'] = 'BW';
series_years['S70 / V70 / C70_1997'] = 'MK1';
series_years['S70 / V70 / C70_1998'] = 'MK1';
series_years['S70 / V70 / C70_1999'] = 'MK1';
series_years['S70 / V70 / C70_2000'] = 'MK1';
series_years['S70 / V70 / C70_2001'] = 'MK1';
series_years['S70 / V70 / C70_2002'] = 'MK1';
series_years['S70 / V70 / C70_2003'] = 'MK1';
series_years['S70 / V70 / C70_2004'] = 'MK1';
series_years['S70 / V70 / C70_2006'] = 'M SERIES';
series_years['S80_1998'] = 'MK1/MK2';
series_years['S80_1999'] = 'MK1/MK2';
series_years['S80_2000'] = 'MK1/MK2';
series_years['S80_2001'] = 'MK1/MK2';
series_years['S80_2002'] = 'MK1/MK2';
series_years['S80_2003'] = 'MK1/MK2';
series_years['S80_2004'] = 'MK1/MK2';
series_years['S80_2005'] = 'MK1/MK2';
series_years['V40_2014'] = 'M Series';
series_years['V40_2015'] = 'M Series';
series_years['V40_2016'] = 'M Series';
series_years['V40_2017'] = 'M Series';
series_years['V40_2018'] = 'M Series';
series_years['V40_2013'] = 'M Series';
series_years['V40_1997'] = 'Phase I/II';
series_years['V40_1998'] = 'Phase I/II';
series_years['V40_1999'] = 'Phase I/II';
series_years['V40_2000'] = 'Phase I/II';
series_years['V40_2001'] = 'Phase I/II';
series_years['V40_2002'] = 'Phase I/II';
series_years['V40_2003'] = 'Phase I/II';
series_years['V40_2004'] = 'Phase I/II';
series_years['V40 Cross Country_2015'] = 'M Series';
series_years['V40 Cross Country_2016'] = 'M Series';
series_years['V40 Cross Country_2017'] = 'M Series';
series_years['V40 Cross Country_2018'] = 'M Series';
series_years['V40 Cross Country_2013'] = 'M Series';
series_years['V40 Cross Country_2014'] = 'M Series';
series_years['V50_2004'] = 'MK2 ';
series_years['V50_2005'] = 'MK2 ';
series_years['V50_2006'] = 'MK2 ';
series_years['V50_2007'] = 'MK2 ';
series_years['V50_2008'] = 'MK2 ';
series_years['V50_2009'] = 'MK2 ';
series_years['V50_2010'] = 'MK2 ';
series_years['V50_2011'] = 'MK2 ';
series_years['V50_2012'] = 'MK2 ';
series_years['V60_2012'] = 'F SERIES';
series_years['V60_2013'] = 'F SERIES';
series_years['V60_2014'] = 'F SERIES';
series_years['V60_2011'] = 'F SERIES';
series_years['V60_2017'] = 'F SERIES';
series_years['V60_2018'] = 'F SERIES';
series_years['V60_2019'] = 'Z Series';
series_years['V60_2020'] = 'Z Series';
series_years['V60_2021'] = 'Z Series';
series_years['V60_2016'] = 'F SERIES';
series_years['V60_2015'] = 'F SERIES';
series_years['Volvo Truck_1960'] = 'VOLVO';
series_years['Volvo Truck_1961'] = 'VOLVO';
series_years['Volvo Truck_1962'] = 'VOLVO';
series_years['Volvo Truck_1963'] = 'VOLVO';
series_years['Volvo Truck_1964'] = 'VOLVO';
series_years['Volvo Truck_1965'] = 'VOLVO';
series_years['Volvo Truck_1966'] = 'VOLVO';
series_years['Volvo Truck_1967'] = 'VOLVO';
series_years['Volvo Truck_1968'] = 'VOLVO';
series_years['Volvo Truck_1969'] = 'VOLVO';
series_years['Volvo Truck_1970'] = 'VOLVO';
series_years['Volvo Truck_1971'] = 'VOLVO';
series_years['Volvo Truck_1972'] = 'VOLVO';
series_years['Volvo Truck_1973'] = 'VOLVO';
series_years['Volvo Truck_1974'] = 'VOLVO';
series_years['Volvo Truck_1975'] = 'VOLVO';
series_years['Volvo Truck_1976'] = 'VOLVO';
series_years['Volvo Truck_1977'] = 'VOLVO';
series_years['Volvo Truck_1978'] = 'VOLVO';
series_years['Volvo Truck_1979'] = 'VOLVO';
series_years['Volvo Truck_1980'] = 'VOLVO';
series_years['Volvo Truck_1981'] = 'VOLVO';
series_years['Volvo Truck_1982'] = 'VOLVO';
series_years['Volvo Truck_1983'] = 'VOLVO';
series_years['Volvo Truck_1984'] = 'VOLVO';
series_years['Volvo Truck_1985'] = 'VOLVO';
series_years['Volvo Truck_1986'] = 'VOLVO';
series_years['Volvo Truck_1987'] = 'VOLVO';
series_years['Volvo Truck_1988'] = 'VOLVO';
series_years['Volvo Truck_1989'] = 'VOLVO';
series_years['Volvo Truck_1990'] = 'VOLVO';
series_years['Volvo Truck_1991'] = 'VOLVO';
series_years['Volvo Truck_1992'] = 'VOLVO';
series_years['Volvo Truck_1993'] = 'VOLVO';
series_years['Volvo Truck_1994'] = 'VOLVO';
series_years['Volvo Truck_1995'] = 'VOLVO';
series_years['Volvo Truck_1996'] = 'VOLVO';
series_years['Volvo Truck_1997'] = 'VOLVO';
series_years['Volvo Truck_1998'] = 'VOLVO';
series_years['Volvo Truck_1999'] = 'VOLVO';
series_years['Volvo Truck_2000'] = 'VOLVO';
series_years['Volvo Truck_2001'] = 'VOLVO';
series_years['Volvo Truck_2002'] = 'VOLVO';
series_years['Volvo Truck_2003'] = 'VOLVO';
series_years['Volvo Truck_2004'] = 'VOLVO';
series_years['Volvo Truck_2005'] = 'VOLVO';
series_years['Volvo Truck_2006'] = 'VOLVO';
series_years['Volvo Truck_2007'] = 'VOLVO';
series_years['Volvo Truck_2008'] = 'VOLVO';
series_years['Volvo Truck_2009'] = 'VOLVO';
series_years['Volvo Truck_2010'] = 'VOLVO';
series_years['Volvo Truck_2011'] = 'VOLVO';
series_years['Volvo Truck_2012'] = 'VOLVO';
series_years['Volvo Truck_2013'] = 'VOLVO';
series_years['Volvo Truck_2014'] = 'VOLVO';
series_years['Volvo Truck_2015'] = 'VOLVO';
series_years['Volvo Truck_2016'] = 'VOLVO';
series_years['Volvo Truck_2017'] = 'VOLVO';
series_years['Volvo Truck_2018'] = 'VOLVO';
series_years['Volvo Truck_2019'] = 'VOLVO';
series_years['Volvo Truck_2020'] = 'VOLVO';
series_years['Volvo Truck_2021'] = 'VOLVO';
series_years['Volvo Truck_2022'] = 'VOLVO';
series_years['Volvo Truck_2023'] = 'VOLVO';
series_years['Volvo Truck_2024'] = 'VOLVO';
series_years['Volvo Truck_2025'] = 'VOLVO';
series_years['XC40_2018'] = 'XZ';
series_years['XC40_2021'] = 'XZ';
series_years['XC40_2022'] = 'XZ';
series_years['XC40_2020'] = 'XZ';
series_years['XC40_2019'] = 'XZ';
series_years['XC40_2023'] = 'XZ';
series_years['XC40_2024'] = 'XZ';
series_years['XC40_2025'] = 'XZ';
series_years['XC60_2012'] = 'DZ';
series_years['XC60_2016'] = 'DZ';
series_years['XC60_2017'] = 'DZ|UZ';
series_years['XC60_2011'] = 'DZ';
series_years['XC60_2013'] = 'DZ';
series_years['XC60_2014'] = 'DZ';
series_years['XC60_2018'] = 'UZ';
series_years['XC60_2019'] = 'UZ';
series_years['XC60_2021'] = 'UZ';
series_years['XC60_2022'] = 'UZ';
series_years['XC60_2020'] = 'UZ';
series_years['XC60_2009'] = 'DZ';
series_years['XC60_2010'] = 'DZ';
series_years['XC60_2015'] = 'DZ';
series_years['XC70_2007'] = 'BZ|MK2-1/MK2-II';
series_years['XC70_2008'] = 'BZ';
series_years['XC70_2009'] = 'BZ';
series_years['XC70_2010'] = 'BZ';
series_years['XC70_2011'] = 'BZ';
series_years['XC70_2003'] = 'MK2-1/MK2-II';
series_years['XC70_2004'] = 'MK2-1/MK2-II';
series_years['XC70_2005'] = 'MK2-1/MK2-II';
series_years['XC70_2006'] = 'MK2-1/MK2-II';
series_years['XC90_2017'] = 'L Series';
series_years['XC90_2018'] = 'L Series';
series_years['XC90_2019'] = 'L Series';
series_years['XC90_2020'] = 'L Series';
series_years['XC90_2021'] = 'L Series';
series_years['XC90_2008'] = 'P28';
series_years['XC90_2009'] = 'P28';
series_years['XC90_2015'] = 'L Series|P28';
series_years['XC90_2016'] = 'L Series';
series_years['XC90_2007'] = 'P28';
series_years['XC90_2010'] = 'P28';
series_years['XC90_2006'] = 'P28';
series_years['XC90_2003'] = 'P28';
series_years['XC90_2004'] = 'P28';
series_years['XC90_2005'] = 'P28';
series_years['XC90_2011'] = 'P28';
series_years['XC90_2012'] = 'P28';
series_years['XC90_2013'] = 'P28';
series_years['XC90_2014'] = 'P28';

                                  